{
  "schemaVersion": 1,
  "updated": "2026-10-18",
  "site": "https://workspace369.com",
  "areas": {
    "billing": "Billing & payments",
    "proposals": "Proposals & contracts",
    "clients": "Clients & CRM",
    "inbox": "Inbox & calls",
    "scheduling": "Calendar & booking",
    "work": "Projects, tasks & time",
    "automations": "Workflows",
    "ai": "Workspace AI",
    "portal": "Client portal",
    "workspace": "Workspace & team"
  },
  "releases": [
    {
      "slug": "2026-11-04-send-email-from-your-own-app-with-the-email-api",
      "date": "2026-11-04",
      "title": "Send email from your own app with the Workspace369 email API",
      "seoTitle": "Email API for Your Own App",
      "summary": "Owners and admins can create send-only email API keys, so your own app or website sends email from a verified domain with one API call. Each send uses your email credits.",
      "areas": [
        "inbox",
        "automations"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a large amber key lying across a sealed envelope, with a smaller teal envelope flying away on an amber ribbon, beside the Email API keys page listing two keys and two inboxes."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Send email from your own app with the Workspace369 email API",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "email-api",
          "title": "Let your own app or website send email from your verified domain",
          "body": [
            "Workspace369 now has an email API. Your own app or website can send an email from an inbox on your verified custom email domain with one call to POST https://mcp.workspace369.com/v1/email/messages. The request names the inbox it sends from, one recipient, a subject and a text or HTML body, and attachments are allowed. The call carries an email API key as a bearer token, and an optional Idempotency-Key header makes a retry safe.",
            "Workspace owners and admins with AI connections access create the keys in Settings → Integrations → For developers → Email API keys. Create key asks for a name, such as Booking site, and lets you limit the key to chosen inboxes or leave it on Any inbox. The key is shown once, so copy it into your server's secrets. It can only send email, and it should never go in website or phone app code. Creating a key can ask you to sign in again first. Each key in the list shows whether it is on Any inbox or limited to some inboxes, and when it was last used, and Revoke in its menu stops any app using it from sending right away.",
            "Below the keys, Inboxes for the API lists the active inboxes on your own domain, each with its inb_ ID to use as from.inbox_id. Copy ID copies it. An inbox whose domain isn't verified yet is marked Domain not verified and can't send. Each email sent through the API uses your email credits and a little of your plan's AI usage, and a send is refused with a clear error when the workspace has no email credits left or has run out of AI usage. It works on any plan that can use a verified custom email domain, which is Cadet and above."
          ],
          "highlights": [
            "Create send-only email API keys, shown once, limited to chosen inboxes or any inbox",
            "Copy an inbox's inb_ ID for from.inbox_id",
            "Revoke a key and the app using it stops sending right away"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/keys-page.webp",
            "width": 1600,
            "height": 825,
            "alt": "The Email API keys page in Workspace369 listing two keys, Invoice mailer limited to 1 inbox and Booking site on any inbox, and below them the inboxes hello@studio.example and billing@studio.example with their inb_ IDs and a Copy ID button, one showing Copied."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/keys-page-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The Email API keys page with the Invoice mailer and Booking site keys, a Create key row, and the inboxes hello@studio.example and billing@studio.example with their inb_ IDs and copy icons, one showing a check mark."
          },
          "whereToFind": "Settings → Integrations → For developers → Email API keys",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Send email with the Workspace369 API",
              "href": "https://docs.workspace369.com/v/2026.3/build-with-ai/send-email-with-the-workspace369-api/"
            },
            {
              "label": "Add addresses on your custom email domain",
              "href": "/changelog/2026-10-31-add-addresses-on-your-custom-email-domain"
            },
            {
              "label": "The Builder API on every plan",
              "href": "/changelog/2026-11-03-builder-api-on-every-plan"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "The Email API keys page in Workspace369. Create key is pressed, a key name is typed and one inbox is chosen, the key is shown once, and an inbox ID is copied.",
            "caption": "Create a send-only key limited to one inbox, copy it once, then copy an inbox ID. Example data.",
            "duration": "PT14S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Settings, Email API keys",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-phone-light.webm",
                "poster": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-04-send-email-from-your-own-app-with-the-email-api/emailapi-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Who can create email API keys?",
          "a": "Workspace owners and admins with AI connections access. In Settings → Integrations → For developers → Email API keys, choose Create key, name it and copy the key. It is shown only once."
        },
        {
          "q": "Which address does the email API send from?",
          "a": "From an inbox on your own verified domain, such as hello@studio.example. The request names the inbox with its inb_ ID, which you can copy from Inboxes for the API on the same page."
        },
        {
          "q": "Does the email API use my email credits?",
          "a": "Yes. Each email sent through the API uses your email credits and a little of your plan's AI usage. A send is refused with an error when the workspace has no email credits left or has run out of AI usage."
        },
        {
          "q": "Can I limit a key to one inbox?",
          "a": "Yes. When you create a key, leave it on Any inbox or pick the inboxes it can send from. A key limited to one inbox can't send from the others."
        },
        {
          "q": "What if an email API key leaks?",
          "a": "Open the key's menu in Email API keys and choose Revoke. Apps using it stop sending right away, and you can create a new key for them."
        },
        {
          "q": "Which plans include the email API?",
          "a": "Any plan that can use a verified custom email domain: Cadet, Voyager, Specialist, Commander and Enterprise. The inbox you send from must be on a verified domain."
        }
      ]
    },
    {
      "slug": "2026-11-03-save-your-terms-and-edit-them-from-the-invoice",
      "date": "2026-11-03",
      "title": "Save your terms once and edit them right from the invoice",
      "seoTitle": "Save and Edit Terms and Conditions",
      "summary": "Keep your payment, cancellation and warranty terms in Settings, attach them to invoices and proposals, and edit them without leaving the invoice.",
      "areas": [
        "billing"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a stack of agreement pages with an ochre ribbon and a seafoam check seal, beside two renders of the Terms & conditions page and the terms editor on a phone."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Save and edit your terms and conditions with Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "terms-library",
          "title": "Keep your terms in one place",
          "body": [
            "Open Settings → Sales → Invoices → Terms & conditions and choose New terms. Give the terms a name and add sections: each shows as a heading with its text, and you can drag the sections to reorder them. If your terms already live in a document, set Format to PDF file and attach the PDF instead.",
            "Under Use by default you can make a set the default for new invoices, and another the default for new proposals. Only one set can be the default for each, and you can still change the terms on every document. Changes show on every invoice and proposal that uses those terms. Terms are on every plan. They are on the web app now and come to the iPhone app with its next update."
          ],
          "highlights": [
            "Written sections you can reorder, or a PDF file",
            "One default for new invoices and one for new proposals",
            "A change shows on every invoice and proposal that uses the terms"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-library.webp",
            "width": 1600,
            "height": 825,
            "alt": "The Terms & conditions page in Workspace369 Settings listing Standard terms, Monthly retainer terms and Master services agreement, with the New terms button and Default tags."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-library-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The Terms & conditions page on an iPhone with the New terms button, a search field and three saved terms with their Default tags."
          },
          "whereToFind": "Settings → Sales → Invoices → Terms & conditions",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Invoices",
              "href": "/features/invoices"
            },
            {
              "label": "Create, send and track an invoice guide",
              "href": "https://docs.workspace369.com/v/2026.3/finance/create-send-track-invoice/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "The Terms & conditions page in Workspace369. New terms is pressed, a name and two sections are typed, the set is made the default for new invoices and saved, and it appears at the top of the list.",
            "caption": "Add a name and two sections, make the terms the default for new invoices and save. Example data.",
            "duration": "PT15S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Settings, Terms & conditions",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-phone-light.webm",
                "poster": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "edit-terms-on-invoice",
          "title": "Edit your terms from the invoice",
          "body": [
            "On an invoice, open More and pick your terms in the Terms row. The menu now has Edit followed by the name of the terms you picked. It opens the terms beside the invoice (a sheet on a phone), so you can fix a clause without leaving the invoice. Save, and the invoice shows the new text.",
            "The same menu has New terms and Manage in Settings. Terms are on every plan. They are on the web app now and come to the iPhone app with its next update."
          ],
          "highlights": [
            "Edit opens the terms beside the invoice",
            "New terms and Manage in Settings are in the same menu",
            "The invoice shows the changed text after you save"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-invoice-edit.webp",
            "width": 1600,
            "height": 826,
            "alt": "An invoice in Workspace369 with the terms editor open beside it for Standard terms: the Payment and Cancellations sections with drag grips, the Use by default switches and a Save button."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/terms-invoice-menu-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The Terms menu open as a sheet on an iPhone, listing saved terms with Standard terms checked, then New terms, Edit Standard terms and Manage in Settings."
          },
          "whereToFind": "Invoices → an invoice → More → Terms → Edit",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Invoices",
              "href": "/features/invoices"
            },
            {
              "label": "Create, send and track an invoice guide",
              "href": "https://docs.workspace369.com/v/2026.3/finance/create-send-track-invoice/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "An invoice in Workspace369. The Terms menu is opened and Edit is chosen, a sentence is added to the Payment section and saved, and the invoice shows the changed terms.",
            "caption": "Open the Terms menu, choose Edit, add a sentence and save. The invoice shows the new text. Example data.",
            "duration": "PT14S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Invoices, New invoice",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-phone-light.webm",
                "poster": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-03-save-your-terms-and-edit-them-from-the-invoice/termsinvoice-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Which plans include saved terms and conditions?",
          "a": "Every plan: Cadet, Voyager, Specialist, Commander and Enterprise."
        },
        {
          "q": "Where do I find my saved terms?",
          "a": "Settings → Sales → Invoices → Terms & conditions. You can also open them from an invoice: More → Terms → Manage in Settings."
        },
        {
          "q": "Can my terms be a PDF file?",
          "a": "Yes. Set Format to PDF file and attach one PDF, or write the terms as sections that show as headings with their text."
        },
        {
          "q": "What happens to my invoices when I change or delete terms?",
          "a": "A change shows on every invoice and proposal that uses those terms. If you delete terms, the invoices and proposals that use them stop showing them."
        },
        {
          "q": "Can I choose which terms new invoices start with?",
          "a": "Yes. One set can be the default for new invoices and one for new proposals. You can still change the terms on each document."
        }
      ]
    },
    {
      "slug": "2026-11-04-redesigned-client-profile",
      "date": "2026-11-04",
      "title": "A redesigned client profile on phone, tablet and desktop",
      "seoTitle": "Redesigned Client Profile and Record Page",
      "summary": "Client profiles now lead with the client. On a phone, Call, Email and SMS sit under the name; on tablet and desktop, fields sit left and records right.",
      "areas": [
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-04-redesigned-client-profile/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a client record card with a portrait and call, email and message buttons beside fanned folders, next to the redesigned client profile on a phone in light and dark."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The redesigned client profile in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "phone-client-profile",
          "title": "On a phone, the client and how to reach them come first",
          "body": [
            "Open a client on your phone and the profile starts with the client: their photo or initials, full name, company and when the record was last updated. Tap the photo to change the name or picture. Right under the name are Call, Email and SMS buttons, so reaching the client takes one tap. Each button shows only when the client has that kind of contact, so a client with no phone number gets no Call or SMS. Call always offers Call using phone, which opens your device's dialer, on every plan. Sending texts from Workspace369 starts on Voyager: on Cadet, SMS opens the message composer, and sending shows an upgrade prompt.",
            "Next come the numbers: open invoices, proposals, the next visit and active projects. Tap one to open that list. Below them are the client's latest records, such as invoices, schedules, projects, proposals, documents, notes and contracts, and for a business client its contact persons, now shown once. Then come the client's own fields, with each label above its value, so neither gets cut off when your phone uses large text, followed by tags and notes.",
            "It is on every plan, on the web app now, and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Call, Email and SMS one tap under the client's name (texting from Voyager)",
            "Open invoices, proposals, next visit and active projects, each opening its list",
            "Field labels sit above their values, readable at large text sizes"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-04-redesigned-client-profile/phone-panel.webp",
            "width": 1600,
            "height": 1000,
            "alt": "Two phone screens of the client profile: Maya Chen of Lumen Labs with Call, Email and SMS buttons and four number tiles, and the client's fields with each label above its value."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-04-redesigned-client-profile/phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "Phone client profile for Maya Chen of Lumen Labs: Call, Email and SMS buttons, tiles for open invoices, proposals, next visit and active projects, and the latest invoices."
          },
          "whereToFind": "Clients → a client",
          "appRoute": "/clients",
          "plans": "all",
          "links": [
            {
              "label": "Calls, texts and email with clients",
              "href": "/features/communications"
            },
            {
              "label": "Clients and CRM guide",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/clients-and-crm/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "Screen recording: on desktop, Maya Chen's client record page moves from Overview to the Invoices and Projects tables and back; on the phone, her profile scrolls from Call, Email and SMS through the numbers, records, fields, tags and notes.",
            "caption": "The record page on desktop, and the phone profile from top to bottom. Example data.",
            "duration": "PT11S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Client profile",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-phone-light.webm",
                "poster": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-04-redesigned-client-profile/profile-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "client-record-page",
          "title": "On tablet and desktop, the client profile is a record page",
          "body": [
            "On a tablet or desktop, the client profile now works like a record page. The client's own fields sit in a column on the left: contact and business details, which you can edit in place if you can edit clients, contact persons for a business client, tags, and when the record was last updated. Everything linked to the client sits on the right, one tab at a time.",
            "The tab row starts with Overview, then Invoices, Proposals, Schedules, Projects, Contracts, Documents and Notes, plus Contact Persons for a business client. It wraps onto a second line instead of scrolling sideways, so no tab is ever out of view. Overview opens with one line of numbers, Open invoices, Proposals, Next visit and Active Projects, and each one opens its tab.",
            "Invoices, Proposals, Schedules and Projects fill the page as tables with their columns side by side: name or title, status and date, plus time and location for schedules, progress for projects, and amount for invoices and proposals when you can see prices. Those four tabs have View All for the full list and a pager past 25 rows, and each tab has its add button when you are allowed to create. It is on every plan, on the web app now, and comes to the iPad app with its next update."
          ],
          "highlights": [
            "Client fields on the left, linked records on the right",
            "Overview first, and the tab row wraps so every tab stays in view",
            "Invoices, Proposals, Schedules and Projects as full-height tables"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-04-redesigned-client-profile/desktop.webp",
            "width": 1600,
            "height": 826,
            "alt": "Desktop client record page for Maya Chen: client fields in a left column, and the Invoices tab as a table with name, status, date and amount for four invoices."
          },
          "imagePhone": null,
          "whereToFind": "Clients → a client",
          "appRoute": "/clients",
          "plans": "all",
          "links": [
            {
              "label": "Client management software",
              "href": "/solutions/client-management-software"
            },
            {
              "label": "Clients and CRM guide",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/clients-and-crm/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "What changed on the client profile on a phone?",
          "a": "It now opens with the client's photo, name and company, then Call, Email and SMS buttons, then open invoices, proposals, next visit and active projects, then the client's latest records, then the client's fields with each label above its value, then tags and notes."
        },
        {
          "q": "Can I call, email or text a client from their profile?",
          "a": "Yes. On a phone, Call, Email and SMS sit under the client's name when the client has a number or email. Call using phone opens your device's dialer on every plan. Sending texts from Workspace369 starts on Voyager; on Cadet, sending shows an upgrade prompt."
        },
        {
          "q": "What does the client profile look like on a tablet or desktop?",
          "a": "It is a record page: the client's fields in a column on the left and a tab row on the right with Overview, Invoices, Proposals, Schedules, Projects, Contracts, Documents and Notes, plus Contact Persons for a business client."
        },
        {
          "q": "Which plans include the redesigned client profile?",
          "a": "Every plan: Cadet, Voyager, Specialist, Commander and Enterprise."
        },
        {
          "q": "Is the new client profile in the iPhone and iPad apps?",
          "a": "It is on the web app now and comes to the iPhone and iPad apps with their next update."
        }
      ]
    },
    {
      "slug": "2026-11-02-reports-on-the-shared-report-page",
      "date": "2026-11-02",
      "title": "Accounting reports move to one clear report page",
      "seoTitle": "Accounting Reports on One Clear Page",
      "summary": "Profit & Loss, Balance Sheet, aging, tax, budget and profitability reports now share one report page, with chips along the top and Export CSV.",
      "areas": [
        "billing"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper report sheet with a bar chart and an export tray with an amber arrow, beside a Statement table listing operating revenue and expense accounts with current and previous figures."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The new accounting report page in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "statements-report-page",
          "title": "Statements open on the new report page",
          "body": [
            "Profit & Loss, Balance Sheet, Cash Flow Statement, Trial Balance and General Ledger now share one report page. There is no Generate button: a statement reads when it opens, and reads again when you change a chip along the top, such as Period, Cost center, Compare or Account. The page starts with one sentence about the result, for example how much of your revenue you kept as net income, then up to four figures, then the statement as quiet rows with totals under a rule.",
            "Where a report has a Compare chip, such as Profit & Loss, it adds a Previous period column. The Balance Sheet uses an As of chip in place of a period and says when it is out of balance, and by how much. The General Ledger asks you to pick an account with the Account chip, then lists that account's entries with Money in, Money out and Balance. The Trial Balance ends with Balanced or Out of Balance.",
            "Export CSV is a button at the top of the report, and on the statements Export PDF and Help are in the ⋯ menu. From Reports on a tablet or desktop, a statement opens in place with Reports at the top to go back; on a phone it opens as its own page. Statements are on Commander and Enterprise. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "No Generate button: statements read when they open",
            "One sentence first, then up to four figures, then the statement",
            "Period, Cost center, Compare, As of and Account chips",
            "Export CSV at the top, Export PDF and Help in the ⋯ menu"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Finance → Reports → Profit & Loss",
          "appRoute": "/reports",
          "plans": [
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Accounting",
              "href": "/features/accounting"
            },
            {
              "label": "Reports home",
              "href": "/changelog/2026-10-29-reports-home"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "The Profit & Loss report in Workspace369 with Period, Cost center and Compare chips and Export CSV. Last month is chosen, Previous period is compared, and the statement scrolls.",
            "caption": "Pick Last month, compare it with the previous period and scroll the statement. Example data.",
            "duration": "PT11S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Reports, Profit & Loss",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-phone-light.webm",
                "poster": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-02-reports-on-the-shared-report-page/statement-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "aging-and-tax-report-page",
          "title": "AR Aging, AP Aging and Tax Summary on the same page",
          "body": [
            "AR Aging now uses the same page. It shows To collect, Overdue and Over 90 days, with an Aging chip, a Project chip when you have more than one project, and client search above the table. Bulk reminders, PDF and CSV export, and the per-invoice actions to view, send a reminder or record a payment are all still there for people allowed to use them. Bulk reminders are on tablet and desktop.",
            "AP Aging shows To pay, Overdue, Due in 7 days and Over 90 days by vendor, with an As of chip, and tapping a vendor shows its bills. On a phone each vendor is a two-line row with its total and how late it is, such as 1–30 days late or Not yet due.",
            "Tax Summary has a Period chip and three figures: Tax collected, Tax paid and Net tax liability, with Credit (overpaid) under it when you paid more than you collected. Two tables list the tax From invoices and From bills and expenses. Export CSV is new on AP Aging and Tax Summary. AR Aging is on Specialist, Commander and Enterprise; AP Aging and Tax Summary are on Commander and Enterprise. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "AR Aging: To collect, Overdue and Over 90 days",
            "AP Aging: To pay, Overdue, Due in 7 days and Over 90 days",
            "Tax Summary: Tax collected, Tax paid and Net tax liability",
            "Export CSV on AP Aging and Tax Summary"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Finance → Reports → AR Aging",
          "appRoute": "/reports",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Dashboards and reports",
              "href": "/features/analytics"
            },
            {
              "label": "Reports now open with your key figures",
              "href": "/changelog/2026-11-01-reports-hub-at-a-glance"
            }
          ]
        },
        {
          "id": "budget-and-profitability-report-page",
          "title": "Budget vs Actual and profitability reports on the report page",
          "body": [
            "Budget vs Actual has a Period chip and a Budget chip that shows all lines, only lines over budget, or only lines with no budget. A sentence says how far actuals are over or under the period's budget, then tiles for Budget, Spent, Over budget and Lines over sit above a table of Category, Budget, Spent, Difference and Used with a Total row. Difference reads, for example, $688 over, On budget or $120 under. Edit budget sits beside Export CSV and asks before you go back to Reports with unsaved changes.",
            "Customer Profitability, Job Profitability and Service Profitability get a Period chip, tiles for revenue, costs, gross profit and margin (Service Profitability shows units sold in place of gross profit), and a table with the name pinned, sortable columns, search above it and a Total row. The drill-down under each row is kept. Without cost-rate access, Customer Profitability shows a margin band and Job Profitability says Margin hidden. Export CSV is new on all four.",
            "Customer Profitability and Job Profitability are on Specialist, Commander and Enterprise. Budget vs Actual and Service Profitability are on Commander and Enterprise. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Budget vs Actual: Budget, Spent, Over budget and Lines over",
            "Difference reads $688 over, On budget or $120 under",
            "Customer, Job and Service Profitability with sortable columns",
            "Export CSV on all four reports"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Finance → Reports → Budget vs Actual",
          "appRoute": "/reports",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Accounting",
              "href": "/features/accounting"
            },
            {
              "label": "Reports home",
              "href": "/changelog/2026-10-29-reports-home"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Do the accounting statements in Workspace369 have a Generate button now?",
          "a": "No. Profit & Loss, Balance Sheet, Cash Flow Statement, Trial Balance and General Ledger read when they open and read again when you change a chip such as Period, Compare or Account."
        },
        {
          "q": "Which accounting reports moved to the new report page?",
          "a": "Profit & Loss, Balance Sheet, Cash Flow Statement, Trial Balance, General Ledger, AR Aging, AP Aging, Tax Summary, Budget vs Actual, and Customer, Job and Service Profitability."
        },
        {
          "q": "Which plans include these reports?",
          "a": "AR Aging, Customer Profitability and Job Profitability are on Specialist, Commander and Enterprise. The other reports listed here are on Commander and Enterprise."
        },
        {
          "q": "How do I export a report from the new page?",
          "a": "Use the Export CSV button at the top of the report. On the statements, Export PDF and Help are in the ⋯ menu."
        },
        {
          "q": "Can I compare a statement with an earlier period?",
          "a": "Yes, where the report has a Compare chip, such as Profit & Loss. It adds a Previous period column. The Balance Sheet uses an As of chip instead."
        },
        {
          "q": "Is the new report page on the iPhone app?",
          "a": "It is on the web app now and comes to the iPhone app with its next update."
        }
      ]
    },
    {
      "slug": "2026-11-02-set-up-my-pipeline-starter",
      "date": "2026-11-02",
      "title": "New workspaces get a Set up my pipeline starter in AI chat",
      "seoTitle": "Set Up My Pipeline Starter in AI Chat",
      "summary": "In a new workspace, AutoPilot chat offers Set up my pipeline in place of Review my workspace. Its request asks the AI to change nothing until you say yes.",
      "areas": [
        "ai",
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper chat bubble leading up stepping stones to an amber flag, beside the AI chat home screen with a Set up my pipeline shortcut and a prompt asking for suggested stages and fields."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The Set up my pipeline starter in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "set-up-my-pipeline-starter",
          "title": "Set up my pipeline, a starter for new workspaces",
          "body": [
            "Open AI AutoPilot → Chat in a brand-new workspace and the starters on the Chat home now include Set up my pipeline in place of Review my workspace. A new workspace has nothing to review yet, so the starter helps you build your sales pipeline instead.",
            "Tap it and the message box fills with a request: help set up your sales pipeline, suggest stages and fields that fit your business, show them to you, and change nothing until you say yes. A starter never sends the message by itself, so you can edit the request first. Read what the AI suggests, change what you like, and say yes when it fits.",
            "Once your workspace has some clients, invoices or projects, Review my workspace comes back. Task AI keeps its own board starters. Chat is on every plan, and the AI can get things wrong, so check the suggested stages and fields before you agree. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Set up my pipeline replaces Review my workspace in a new workspace",
            "The message box fills in, and nothing is sent until you send it",
            "The request asks the AI to change nothing until you say yes"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "AI AutoPilot → Chat",
          "appRoute": "/ai/chat",
          "plans": "all",
          "links": [
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            },
            {
              "label": "CRM setup with AI",
              "href": "/changelog/2026-10-31-crm-setup-with-ai-and-faster-email-reading"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "The AI AutoPilot chat home in a new workspace. Set up my pipeline is tapped and the message box fills with a request to suggest stages and fields and change nothing until yes.",
            "caption": "Tap Set up my pipeline and the message box fills in, ready to edit before you send it. Example data.",
            "duration": "PT9S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "AI AutoPilot, Chat",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-phone-light.webm",
                "poster": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-02-set-up-my-pipeline-starter/starter-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "What is Set up my pipeline in Workspace369?",
          "a": "A starter in AI AutoPilot → Chat for new workspaces. It fills the message box with a request to suggest pipeline stages and fields that fit your business."
        },
        {
          "q": "Does Set up my pipeline change my CRM straight away?",
          "a": "No. The request asks the AI to show its suggestion and change nothing until you say yes. A starter also never sends the message by itself."
        },
        {
          "q": "Who sees the Set up my pipeline starter?",
          "a": "New workspaces. Once you have some clients, invoices or projects, Review my workspace comes back in its place."
        },
        {
          "q": "Which plans have the Set up my pipeline starter?",
          "a": "Chat is on every plan: Cadet, Voyager, Specialist, Commander and Enterprise. The starter is on the web app now and comes to the iPhone app with its next update."
        }
      ]
    },
    {
      "slug": "2026-11-02-sell-memberships-and-check-members-in",
      "date": "2026-11-02",
      "title": "Sell memberships and check members in",
      "seoTitle": "Sell Memberships and Check Members In",
      "summary": "Create membership types, sell them with a pay link through your own Stripe, check members in at the front desk, and let members see their pass in the client portal.",
      "areas": [
        "billing",
        "clients",
        "portal"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of fanned membership pass cards with punched holes and an amber check mark in front of an open archway, beside a render of a member's pass with its QR code."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Sell memberships and check members in with Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "membership-types",
          "title": "Build membership types from presets",
          "body": [
            "Open Clients → Memberships and choose New membership. Start from a preset: Unlimited, Minutes, Visit pack, Credits or Family, with Unlimited tanning, Salon membership, Coworking and Day pass under More presets. Then give the type a Name and set What's included, Billing and At the door.",
            "What's included holds what a member gets: unlimited visits, minutes, visits or credits, with optional refills. Billing sets how the type is charged, with a sign-up fee, a commitment and what happens after a failed payment. At the door sets Freezes and Guest passes, and on Specialist and up, what a member must do Before first visit. A preview of the client's pass updates as you type, and Save type keeps it.",
            "Memberships are on Cadet and up. The Family preset is on Voyager and up. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Presets for gyms, studios, tanning, salons, coworking and day passes",
            "What's included, Billing and At the door in one editor",
            "A live preview of the client's pass while you build"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/membership-types.webp",
            "width": 1600,
            "height": 827,
            "alt": "The New membership editor in Workspace369 with the preset cards Unlimited, Minutes, Visit pack, Credits, Family and More presets, a What's included row and a preview of the client's pass beside it."
          },
          "imagePhone": null,
          "whereToFind": "Clients → Memberships → New membership",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Payments",
              "href": "/features/payments"
            },
            {
              "label": "Create a membership plan guide",
              "href": "https://docs.workspace369.com/v/2026.3/finance/create-a-membership-plan/"
            }
          ]
        },
        {
          "id": "sell-with-pay-link",
          "title": "Sell a membership with a pay link",
          "body": [
            "Open a client, use the ⋯ menu and choose Sell membership. Pick the membership, then under How they pay choose Pay link and press Sell. The sheet says Pay link ready and Copy Link puts the link on your clipboard, so you can send it the way you usually do. The membership starts when the client pays. (Changed Nov 2: before you press Sell, the sheet shows First charge, with any setup fee, and Then, with what the client pays next and from when, or when the membership ends. Dates count from the day the client pays.) (Changed Nov 3: after Sell, the sheet shows Text message, Email, Show QR code and Copy Link, with when the link expires. Text message and Email open Workspace369's message window with the link filled in, and nothing goes out until you press Send; texting starts on Voyager. If a link expires before the client pays, open the pending member and press Resend link. The Members list has a Pending filter.)",
            "The payment is billed through your own Stripe account, so connect Stripe first. Nothing is sent automatically, so the client gets the link only when you send it. Selling is on Cadet and up. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Client ⋯ menu → Sell membership → Pay link → Sell → Copy Link",
            "Billed through your own Stripe account",
            "You send the link; the app sends nothing to the client",
            "Changed Nov 2: First charge and Then show before you press Sell"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Clients → a client → ⋯ menu → Sell membership",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Payments",
              "href": "/features/payments"
            },
            {
              "label": "Create a membership plan guide",
              "href": "https://docs.workspace369.com/v/2026.3/finance/create-a-membership-plan/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "The Memberships members tab in Workspace369 with the Sell membership dialog. A membership is chosen, Sell is pressed and a pay link appears with a Copy Link button.",
            "caption": "Choose a membership, press Sell and copy the pay link to send to the member. Example data.",
            "duration": "PT10S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Clients, Memberships",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-phone-light.webm",
                "poster": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/sell-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "member-screen",
          "title": "See a member’s pass and payments, and change their plan",
          "body": [
            "Open Clients → Memberships, pick a member and their screen shows the member’s real pass, with Show pass to open it, and their Payments, each marked Paid. Change plan sits with the other actions. Choose the new plan and the screen shows what happens first: an upgrade starts now and charges the card on file the difference for the rest of the period, and a downgrade starts at the next renewal with nothing charged now. Only plans on the same schedule, currency and payment provider are offered.",
            "(Changed Nov 3: Change plan now needs its own permission.) Change plan is now its own permission, Change member plans, under Clients in a team member’s permissions. Admins have it. Existing Managers lose Change plan until an admin turns it on. Memberships are on Cadet and up. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "The member’s pass and Payments on their screen",
            "Change plan shows what is charged before you confirm",
            "Changed Nov 3: Change plan is its own permission; admins have it, Managers need it turned on"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/member-screen.webp",
            "width": 1600,
            "height": 840,
            "alt": "A member screen in Workspace369 for Nora Whitfield on an 8 classes a month membership, with the Change plan, Adjust balance, Refund and Cancel membership buttons, a balance bar, a Pass section with Show pass, and a Payments list of three paid memberships."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-02-sell-memberships-and-check-members-in/member-screen-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The same member screen on an iPhone with the Change plan button at the top, the balance, the Pass section with Show pass and the Payments list."
          },
          "whereToFind": "Clients → Memberships → a member",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Payments",
              "href": "/features/payments"
            },
            {
              "label": "Create a membership plan guide",
              "href": "https://docs.workspace369.com/v/2026.3/finance/create-a-membership-plan/"
            }
          ]
        },
        {
          "id": "front-desk-check-in",
          "title": "Check members in at the desk",
          "body": [
            "Open Clients → Check-in. Check people in with Camera by scanning a member's pass, with Scanner for a handheld scanner, or with Search by name. The screen says Ready for the next member until someone arrives, and Today lists the day's check-ins. The owner can always check members in; staff check-in is on Voyager and up.",
            "Each member has a pass with a QR code, so they can show it at the front desk. Multi-location membership rules are on Commander and up. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Camera, Scanner and Search at the front desk",
            "A QR pass for every member",
            "Staff check-in on Voyager and up; the owner can always check in"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Clients → Check-in",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "CRM for yoga and Pilates studios",
              "href": "/solutions/crm-for-yoga-and-pilates-studios"
            },
            {
              "label": "CRM for gyms and boutique fitness",
              "href": "/solutions/crm-for-gyms-and-boutique-fitness"
            }
          ]
        },
        {
          "id": "members-in-the-portal",
          "title": "Members see their membership and pass in the portal",
          "body": [
            "When a client has a membership, their client portal shows a Membership and pass section: the plan and its status, the QR code to show at the front desk, what's left in each balance, and Recent visits.",
            "Under Manage, members can freeze when the type allows it, update their card, or cancel. Members can't buy a membership from the portal; you sell it from the client's ⋯ menu. The Membership and pass section shows only for clients who have a membership. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "A Membership and pass section with the QR code and balances",
            "Freeze membership when the type allows, Update card, Cancel membership",
            "Selling stays with you, not in the portal"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "The client portal → Membership and pass",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Memberships in the client portal guide",
              "href": "https://docs.workspace369.com/v/2026.3/finance/memberships-in-the-client-portal/"
            }
          ]
        },
        {
          "id": "check-ins-report",
          "title": "See check-ins in the Check-ins report",
          "body": [
            "Open Finance → Reports and choose Check-ins, in the Memberships & check-ins group. It shows busy times and check-ins per day, and you can look at 7, 30 or 90 days, or set a custom range. The same report is on the Report tab of the Check-in screen. The location comparison report is on Commander and up. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Finance → Reports → Check-ins",
            "Busy times and check-ins per day",
            "7, 30, 90 days or a custom range"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Finance → Reports → Check-ins",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Analytics",
              "href": "/features/analytics"
            },
            {
              "label": "CRM for gyms and boutique fitness",
              "href": "/solutions/crm-for-gyms-and-boutique-fitness"
            }
          ]
        },
        {
          "id": "programs-and-sessions-report",
          "title": "See how your programs run in Programs & Sessions",
          "body": [
            "Open Finance → Reports and choose Programs & Sessions. The tiles show Sessions, Show-up rate and Group calls held for the range you pick. By coach lists one-to-one sessions, no-shows and show-up for each coach, and By tier shows Members, Left and Joined for each program tier.",
            "Monthly revenue shows to the owner and admins only. Members who pay in a different currency from their program are noted but not added to the revenue. The report is on Voyager and up. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Sessions, Show-up rate and Group calls held",
            "By coach and By tier breakdowns",
            "Monthly revenue shows to the owner and admins only"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Finance → Reports → Programs & Sessions",
          "appRoute": null,
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Coaching business software",
              "href": "/solutions/coaching-business-software"
            },
            {
              "label": "Programs & Sessions report guide",
              "href": "https://docs.workspace369.com/v/2026.3/finance/programs-and-sessions-report/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "How do I create a membership type?",
          "a": "Go to Clients → Memberships and choose New membership. Start from a preset, then set What's included, Billing and At the door, and choose Save type."
        },
        {
          "q": "How do I sell a membership to a client?",
          "a": "Open the client, use the ⋯ menu, choose Sell membership, pick the membership and Pay link, then press Sell and Copy Link. The membership starts when they pay. Workspace369 sends nothing to the client, so you send the link the way you usually do."
        },
        {
          "q": "Can members buy a membership in the client portal?",
          "a": "No. You sell memberships from the client's ⋯ menu. Members see their membership and pass in the portal, and can update their card or cancel, and freeze when the type allows."
        },
        {
          "q": "How do I check a member in?",
          "a": "Open Clients → Check-in and use Camera, Scanner or Search. The owner can always check members in; staff check-in is on Voyager and up."
        },
        {
          "q": "Which plans include memberships and the Programs & Sessions report?",
          "a": "Memberships are on Cadet and up. Staff check-in and the Family preset are on Voyager and up, and so is the Programs & Sessions report. Multi-location membership rules are on Commander and up."
        },
        {
          "q": "Who can change a member’s plan?",
          "a": "Change plan is now a separate permission. Admins have it; Managers need an admin to grant it. An admin turns on Change member plans under Clients in the team member’s permissions."
        }
      ],
      "updated": "2026-11-04"
    },
    {
      "slug": "2026-11-02-webhooks-for-new-clients-and-stage-changes",
      "date": "2026-11-02",
      "title": "Webhooks for new clients and stage changes",
      "seoTitle": "Client Webhooks: Created and Stage Changed",
      "summary": "Webhooks can now tell Zapier, Make, n8n or your own server when a client is created or moves to a new pipeline stage. On every plan, on the web app now.",
      "areas": [
        "clients",
        "automations"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper bell sending three arrows to three plugs, beside the new webhook event list with Created and Stage changed selected for Clients."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Client webhooks in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "client-webhook-events",
          "title": "Send a webhook when a client is created or changes stage",
          "body": [
            "Settings → Webhooks now has a Clients group with two events: Created and Stage changed. Tick Created and your tool hears about every new client. Tick Stage changed and it hears each time a client moves to another stage of your pipeline, so a Zapier, Make or n8n flow can add the person to your email tool, post in Slack or start a handoff the moment a lead moves on.",
            "Stages are the ones you set up in Settings → Clients → Stages and see as columns on the pipeline board, so a webhook can follow a lead from its first stage to the last. Open an existing webhook, or choose New webhook, and tick the events you want next to the others, such as invoices and proposals.",
            "The Clients group is offered to team members who can see every client. Someone limited to their own clients, or without access to Clients, does not see it, and a webhook that already has client events keeps the group so those events can be taken off.",
            "Client webhooks are on every plan, and they are on the web app now and come to the iPhone app with its next update."
          ],
          "highlights": [
            "Created and Stage changed events",
            "Follows the stages on your pipeline board",
            "Offered to members who can see every client",
            "On every plan"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Settings → Webhooks → New webhook → Clients",
          "appRoute": "/settings/webhooks",
          "plans": "all",
          "links": [
            {
              "label": "Webhooks",
              "href": "/integrations/webhooks"
            },
            {
              "label": "Webhooks reference",
              "href": "https://docs.workspace369.com/v/2026.3/build-with-ai/webhooks-reference/"
            },
            {
              "label": "Pipeline board and Leads report",
              "href": "/changelog/2026-11-01-crm-pipeline-board-and-leads-report"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "The New webhook screen in Workspace369 scrolling to the Clients group, where the Created and Stage changed events are ticked.",
            "caption": "Tick Created and Stage changed in the Clients group of a new webhook. Example data.",
            "duration": "PT11S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Settings, Webhooks",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-phone-light.webm",
                "poster": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-02-webhooks-for-new-clients-and-stage-changes/webhooks-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Which client events can a Workspace369 webhook send?",
          "a": "Two: Created, when a new client is added, and Stage changed, when a client moves to another pipeline stage. Both are in the Clients group of Settings → Webhooks."
        },
        {
          "q": "Which plans include client webhooks?",
          "a": "Every plan: Cadet, Voyager, Specialist, Commander and Enterprise. Webhooks themselves come with every plan."
        },
        {
          "q": "Where do I turn on client webhooks?",
          "a": "Go to Settings → Webhooks, open a webhook or choose New webhook, and tick Created or Stage changed in the Clients group."
        },
        {
          "q": "Why don't I see the Clients group in Webhooks?",
          "a": "It is offered only to team members who can see every client. Members limited to their own clients, or without access to Clients, don't see it."
        },
        {
          "q": "Do client webhooks follow my pipeline stages?",
          "a": "Yes. Stage changed fires when a client moves to another stage, using the stages you set in Settings → Clients → Stages and see on the pipeline board."
        },
        {
          "q": "Are client webhooks in the iPhone app?",
          "a": "They are on the web app now and come to the iPhone app with its next update."
        }
      ]
    },
    {
      "slug": "2026-11-01-crm-pipeline-board-and-leads-report",
      "date": "2026-11-01",
      "title": "Pipeline board, more pipelines and a Leads report for your CRM",
      "seoTitle": "CRM Pipeline Board and Leads Report",
      "summary": "See every lead on a pipeline board, run more than one pipeline, and read a Leads report on what wins and why. Webhooks now list their Recent deliveries.",
      "areas": [
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of three paper board columns with an amber card moving between them and a small bar chart, beside a render of the pipeline board's New inquiries column with four lead cards."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The CRM pipeline board and Leads report in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "pipeline-board",
          "title": "See every lead on a pipeline board",
          "body": [
            "Clients now has a Board view next to Table and Follow-ups. Each lead stage is a column that shows its leads, a total value and its win chance, and new inquiries from Requests wait in their own New inquiries column until you move them. Drag a lead to the next stage, or drag it onto the Won or Lost strip that appears while you drag. You can also right-click a lead to move it, mark it won or lost, edit its value or set an expected close date.",
            "A strip across the top shows Open pipeline, Weighted (value times each stage's win chance), Won in the current month and the win rate of closed leads over 90 days. The win chance for each stage is set in Settings → Clients → Stages. Totals only add deals in your workspace currency; deals in other currencies are listed separately, so currencies are never added together.",
            "Each lead has a Deal section in its quick view with its value, which can come from a proposal or the form, an expected close date and its source. Mark lost asks for a reason, and Mark won does too once you have won reasons set up; picking one is always optional. Won reasons and Lost reasons are lists you edit in Settings → Clients → Stages, and the reasons feed the Leads report below. Won and Lost both offer Undo, and a Deal won or Deal lost workflow trigger can start the follow-up for you.",
            "The board is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Drag leads between stages, or onto Won and Lost",
            "Open pipeline, Weighted, Won in the current month and win rate at a glance",
            "Optional won and lost reasons you edit in settings",
            "Totals never add different currencies together"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board.webp",
            "width": 1440,
            "height": 560,
            "alt": "The Clients Board on desktop with the Client projects pipeline: totals for Open pipeline, Weighted, Won in October and the 90-day win rate, then columns for New inquiries, Kickoff call and Scope agreed holding lead cards with values."
          },
          "imagePhone": null,
          "whereToFind": "Clients → Board",
          "appRoute": "/clients",
          "plans": "all",
          "links": [
            {
              "label": "Client management software",
              "href": "/solutions/client-management-software"
            },
            {
              "label": "Clients and CRM guide",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/clients-and-crm/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "The Leads pipeline board in Workspace369 with four stage columns. A lead card is dragged from Discovery to Proposal sent, and the column totals and weighted value update.",
            "caption": "Drag a lead card to another stage and the board updates its totals. Example data.",
            "duration": "PT10S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Leads, Pipeline board",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-phone-light.webm",
                "poster": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/board-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "multiple-pipelines",
          "title": "Run more than one pipeline",
          "body": [
            "If you sell more than one kind of work, give each its own pipeline with its own stages. The Pipeline menu on the board lists your pipelines with how many leads are open in each, and has Manage pipelines… and New pipeline. In Settings → Clients → Stages the lead stages are grouped by pipeline, each with its own rename and delete options and an Add stage row, and the stages after the sale stay in one shared group.",
            "Choose Move to pipeline… on a lead to move it to another pipeline's first stage, and pick which pipeline a form's new leads go to with Send new leads to in the form's settings. The Client stage changed, Deal won and Deal lost workflow triggers get a Pipeline option, so a workflow can run for one pipeline or any of them.",
            "Adding more than one pipeline is on Voyager, Specialist, Commander and Enterprise. How many your plan includes is shown in the app when you add one; on Cadet, New pipeline shows a lock and opens the upgrade dialog. Downgrading deletes nothing: the pipelines you already have stay, you just can't add another until your plan includes it.",
            "More pipelines are on the web app now and come to the iPhone app with its next update."
          ],
          "highlights": [
            "Own stages for each kind of work",
            "Move a lead between pipelines, with Undo",
            "Route form leads to a pipeline",
            "Workflows can run for one pipeline or any"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Clients → Board → Pipeline → New pipeline",
          "appRoute": "/clients",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Compare plans",
              "href": "/pricing"
            },
            {
              "label": "Clients and CRM guide",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/clients-and-crm/"
            }
          ]
        },
        {
          "id": "leads-report",
          "title": "A Leads report: what wins, what drops out and why",
          "body": [
            "Finance → Reports now has a Leads group with a Leads report, so you can see which sources turn into paid work. It opens with one sentence, such as \"40 inquiries became 9 wins worth $61,700. Referral wins most.\", then four tiles: Inquiries, Won value, Win rate and First reply, the median time to your first answer.",
            "Below the tiles, Where leads drop out shows how many leads reached each stage, Why leads are won and Why leads are lost count the reasons you picked on the board, and Sources, ranked by money won shows which lead source brings the most paid work. On Specialist and up, a By owner table shows the same for each team member. Choose Last 30 days, Last 90 days or This year, and use Export CSV to take the numbers into a spreadsheet.",
            "Money columns are in your workspace currency and are only shown to team members who can see prices. The report is for members who can see all clients. On Cadet the Leads card stays in Reports with a Voyager tag, and tapping it opens the upgrade sheet.",
            "The Leads report is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Inquiries, Won value, Win rate and First reply",
            "Where leads drop out, and why deals are won and lost",
            "Sources ranked by money won",
            "Last 30 days, Last 90 days or This year, with CSV export"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/report.webp",
            "width": 1440,
            "height": 1330,
            "alt": "The Leads report on desktop for the last 90 days: a headline sentence, tiles for Inquiries, Won value, Win rate and First reply, then Where leads drop out, Why leads are lost, Sources ranked by money won and By owner (By owner is on Specialist and up)."
          },
          "imagePhone": null,
          "whereToFind": "Finance → Reports → Leads",
          "appRoute": "/reports",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Dashboards and reports",
              "href": "/features/analytics"
            },
            {
              "label": "Lead sources from the client form",
              "href": "/changelog/2026-11-01-add-lead-sources-from-the-client-form"
            },
            {
              "label": "Clients and CRM guide",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/clients-and-crm/"
            }
          ]
        },
        {
          "id": "webhook-recent-deliveries",
          "title": "See if your webhooks are getting through",
          "body": [
            "Open a webhook in Settings and a Recent deliveries list shows the latest events sent to that endpoint, newest first, with Show more for the rest. Each row names the event, such as Invoices · Paid, says when it was sent and how many attempts it took, and carries a Delivered, Failed or Skipped tag.",
            "A failed row says \"Tried n times. It won't be sent again.\" Open a failed or skipped row to read why, for example that the endpoint is gone, refused the request or could not be reached. That tells you whether a Zap was turned off or your own server needs a fix. Seeing deliveries needs the permission to manage webhooks.",
            "Recent deliveries are on the web app now and come to the iPhone app with its next update."
          ],
          "highlights": [
            "Delivered, Failed and Skipped tags",
            "A plain reason for every failed or skipped delivery",
            "Newest first, with Show more"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-crm-pipeline-board-and-leads-report/deliveries.webp",
            "width": 1600,
            "height": 622,
            "alt": "The Recent deliveries list on a webhook: Invoices Paid delivered 4 minutes ago, Bookings Created failed after 6 tries, Requests Created skipped, and Invoices Paid delivered after 3 attempts, with Show more."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Webhooks → open a webhook",
          "appRoute": "/settings/webhooks",
          "plans": "all",
          "links": [
            {
              "label": "Webhooks",
              "href": "/integrations/webhooks"
            },
            {
              "label": "Webhooks reference",
              "href": "https://docs.workspace369.com/v/2026.3/build-with-ai/webhooks-reference/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "What is the pipeline board in Workspace369?",
          "a": "A Board view in Clients where each lead stage is a column. Drag a lead between stages or onto Won or Lost, and see Open pipeline, Weighted, Won in the current month and win rate at the top. It is on every plan."
        },
        {
          "q": "Which plans can add more than one pipeline?",
          "a": "Voyager, Specialist, Commander and Enterprise. The app shows how many your plan includes when you add one. On Cadet, New pipeline is locked and opens the upgrade dialog."
        },
        {
          "q": "Where is the Leads report and which plans include it?",
          "a": "Go to Finance → Reports → Leads. It is on Voyager, Specialist, Commander and Enterprise. On Cadet the card stays in Reports with a Voyager tag."
        },
        {
          "q": "What does the Leads report show?",
          "a": "Four tiles (Inquiries, Won value, Win rate and First reply), where leads drop out, why deals are won and lost, your sources ranked by money won and, on Specialist and up, a By owner table, for the last 30 days, the last 90 days or this year, with a CSV export."
        },
        {
          "q": "Do I have to give a reason when I mark a lead won or lost?",
          "a": "No, the reason is optional. You edit the lists of won and lost reasons in Settings → Clients → Stages, and the Leads report counts them."
        },
        {
          "q": "How do I see whether a webhook was delivered?",
          "a": "Open the webhook in Settings → Webhooks. Recent deliveries lists the latest events with a Delivered, Failed or Skipped tag, and failed or skipped rows explain why."
        }
      ]
    },
    {
      "slug": "2026-11-01-refund-a-card-payment-from-the-invoice",
      "date": "2026-11-01",
      "title": "Refund a card payment straight from the invoice",
      "seoTitle": "Refund a Card Payment from the Invoice",
      "summary": "Owners and admins can now refund all or part of a Stripe card payment from the invoice it paid, choose whether the invoice stays paid, and follow the refund to the card.",
      "areas": [
        "billing"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a bank card with an amber arrow looping back and a torn receipt, beside a render of an invoice payment marked Refund pending and a refund confirmation."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Refund a card payment from the invoice in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "invoice-card-refunds",
          "title": "Refund a card payment from the invoice",
          "body": [
            "Open an invoice, go to its Payment tab and open the ⋯ menu on a card payment taken through Stripe. Choose Refund…, and in the Refund payment sheet check the summary of the payment and how much can be refunded, then pick Full or Part of it. The money goes back to the card the client used.",
            "Under On the invoice, choose what happens to it: Credit note · invoice stays paid keeps it paid and records the refund on a credit note, or Client owes the amount again makes the invoice due again so payment reminders can go out. Pick a reason (Requested by the client, Duplicate payment, Fraudulent payment or Other reason) and confirm with Refund and the amount. Your choice takes effect once Stripe confirms the refund. An invoice paid through a pay link keeps it paid with a credit note, unless you choose Client owes the amount again. Processing fees aren't returned.",
            "The payment then shows Refund pending, Refunded with the amount, or Refund failed, in which case nothing was refunded. For a payment you recorded by hand, the same menu opens Record a refund, which records that you paid the client back outside Workspace369 without moving money. Only owners and admins can refund, on every plan. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Full or partial refunds from the invoice's Payment tab",
            "Keep the invoice paid with a credit note, or make it due again",
            "Refund pending, Refunded and Refund failed on the payment row"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/invoice-card-refunds.webp",
            "width": 1600,
            "height": 826,
            "alt": "The Refund payment dialog in Workspace369 over a paid invoice, with Part of it chosen, 1200 entered, Credit note selected under On the invoice and a Refund $1,200.00 button."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/invoice-card-refunds-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "On a phone, the Refund payment sheet with Part of it chosen, 1200 entered, Credit note and invoice stays paid selected, a reason of Requested by the client and a Refund $1,200.00 button."
          },
          "whereToFind": "Invoices → an invoice → Payment → a payment's ⋯ menu → Refund…",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Online payments",
              "href": "/features/payments"
            },
            {
              "label": "Refund a card payment guide",
              "href": "https://docs.workspace369.com/v/2026.3/finance/refund-a-card-payment/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "Screen recording of an invoice Payment tab: the more menu on a card payment opens Refund, Part of it is chosen, 1200 is typed, the invoice stays paid with a credit note, and the payment shows Refund pending.",
            "caption": "Refund part of a card payment from the invoice's Payment tab and keep the invoice paid with a credit note. Example data.",
            "duration": "PT13S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Invoices",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-phone-light.webm",
                "poster": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-01-refund-a-card-payment-from-the-invoice/refund-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Can I refund a card payment from an invoice in Workspace369?",
          "a": "Yes. Open the invoice's Payment tab, open the ⋯ menu on a card payment taken through Stripe and choose Refund…. The money goes back to the card the client used."
        },
        {
          "q": "Can I refund only part of a payment?",
          "a": "Yes. Choose Part of it and enter the amount, or Full to refund the whole payment."
        },
        {
          "q": "Does the invoice stay paid after a refund?",
          "a": "You choose. Credit note · invoice stays paid keeps it paid and records the refund on a credit note. Client owes the amount again makes it due again, so payment reminders can go out. A pay link invoice stays paid with a credit note unless you choose Client owes the amount again."
        },
        {
          "q": "Who can refund a payment, and on which plans?",
          "a": "Owners and admins, on every plan."
        },
        {
          "q": "Are processing fees returned when I refund?",
          "a": "No. Processing fees aren't returned."
        }
      ]
    },
    {
      "slug": "2026-11-01-reports-hub-at-a-glance",
      "date": "2026-11-01",
      "title": "Reports now opens with your key figures",
      "seoTitle": "Reports Now Opens With Your Figures",
      "summary": "The Reports page now starts with an At a glance strip of net income, cash, owed to you and to pay on Commander and up, then lists every report in a quiet two-column index.",
      "areas": [
        "billing",
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a round gauge dial with an amber needle in front of two report folders and four tiles, beside a render of the Reports page At a glance figures."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The new Reports page in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "reports-hub-at-a-glance",
          "title": "Reports opens with your key figures",
          "body": [
            "The Reports page now has a Reports title with a Find a report search beside it. Under it, an At a glance strip shows four figures: Net income, Cash, Owed to you and To pay. Each figure opens its report: Profit & Loss, Balance Sheet, AR Aging and AP Aging. The strip appears when two or more of those reports are open on your plan, so a single figure never stands alone. The strip needs Profit & Loss and the Balance Sheet, which are on Commander and up; on other plans Reports opens on the index.",
            "Below the strip, the page is a quiet index with one row per report: its name, a one-line description and its figure where it has one, then a chevron to open it. On a desktop the rows run in two columns. On a phone they run in one column, with the figure under the name. When two or more reports in a group aren't on your plan, they fold into one row that opens Unlock, and Coming later is a single quiet line at the bottom of the page.",
            "It is on the web app now and comes to the iPhone app with its next update. Which individual reports you can open depends on your plan and your role."
          ],
          "highlights": [
            "At a glance: Net income, Cash, Owed to you and To pay",
            "Each figure opens its report",
            "One row per report, two columns on desktop and one on a phone",
            "Locked reports fold into one row that opens Unlock"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reports-hub.webp",
            "width": 2400,
            "height": 784,
            "alt": "The Reports page on desktop in light and dark: a Reports title with a Find a report box, an At a glance strip with Net income, Cash, Owed to you and To pay figures, and a two-column index of reports such as Profit & Loss, Balance Sheet, AR Aging and AP Aging with their figures."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reports-hub-phone.webp",
            "width": 780,
            "height": 1389,
            "alt": "The Reports page on a phone at larger text in light and dark: the At a glance strip with four figures, then one report per row with its figure under the name."
          },
          "whereToFind": "Finance → Reports",
          "appRoute": "/reports",
          "plans": "all",
          "links": [
            {
              "label": "Dashboards and reports",
              "href": "/features/analytics"
            },
            {
              "label": "Accounting",
              "href": "/features/accounting"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "Screen recording of the Reports hub: the At a glance strip shows net income, cash and what is owed, the page scrolls, Net income is opened and Profit & Loss is generated.",
            "caption": "On Commander and up, Reports opens with an At a glance strip of net income, cash and what is owed. Example data.",
            "duration": "PT15S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Reports",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-phone-light.webm",
                "poster": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-01-reports-hub-at-a-glance/reportshub-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "customize-dashboard-opens-home-editor",
          "title": "Customize Dashboard opens Home's editor",
          "body": [
            "In Settings, Customize Dashboard in Appearance now takes you to Home with the editor open. On the web and on a tablet the editor opens in place on Home. On a phone it opens the Customize panel. If your workspace has locked Home, you see the message that your Home is set by your workspace and to ask an admin to change it.",
            "It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Settings → Appearance → Customize Dashboard opens Home's editor",
            "On a phone it opens the Customize panel"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Settings → Appearance → Customize Dashboard",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Dashboards and reports",
              "href": "/features/analytics"
            },
            {
              "label": "AI chat",
              "href": "/features/ai-chat"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which plans include the new Reports page?",
          "a": "Every plan can open Reports. Which individual reports you can open depends on your plan and your role."
        },
        {
          "q": "Where do I find my key figures?",
          "a": "Go to Finance → Reports. The At a glance strip at the top shows Net income, Cash, Owed to you and To pay, and each figure opens its report."
        },
        {
          "q": "Why don't I see the At a glance strip?",
          "a": "It needs two or more of its reports open on your plan, which means Commander and up, and it shows only for people who are allowed to see accounting reports."
        },
        {
          "q": "What happens to reports my plan doesn't include?",
          "a": "Two or more of them in the same group fold into one row on the Reports page, and tapping it opens Unlock. A single one keeps its own row."
        },
        {
          "q": "Where did Customize Dashboard in Settings go?",
          "a": "It is still in Settings → Appearance. It now opens Home with the editor on, in place on the web and a tablet, and as the Customize panel on a phone."
        }
      ]
    },
    {
      "slug": "2026-11-03-builder-api-on-every-plan",
      "date": "2026-11-03",
      "title": "The Builder API now comes with every plan",
      "seoTitle": "Builder API on Every Plan",
      "summary": "The Builder API, the REST API at /v1, and its REST hooks now work on every plan from Cadet up, including the trial once your card is saved.",
      "areas": [
        "automations"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-03-builder-api-on-every-plan/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "A navy release-notes plate titled Builder API on Every Plan, with the Workflows area label and the release date."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The Builder API on every Workspace369 plan",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "builder-api-every-plan",
          "title": "Call Workspace369 from your own code on any plan",
          "body": [
            "The Builder API lets your own app, script or AI coding agent read and write your workspace over HTTPS at /v1, and REST hooks at /v1/hooks tell your tools when something changes. Until now it started on Specialist. It now works on Cadet, Voyager, Specialist, Commander and Enterprise, the same as webhooks and AI connections.",
            "Trials get it too once the card is saved. A workspace without a plan can't call it. Calls count toward your plan's monthly AI usage. There's no new setting for it: once the workspace owner turns on AI connections in Settings, the Builder API works on any plan."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builder-api-create.webp",
            "width": 1600,
            "height": 825,
            "alt": "The Create personal access token dialog in Workspace369 with permission chips (workspace:read, clients:read and invoices:read selected) and an Expiry choice with 90 days selected, opened from Settings → AI connections."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builder-api-created-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The token-created dialog on an iPhone, with the new token shown once with a Copy this now warning, then the server URL and a Core CRM tools only URL."
          },
          "whereToFind": "Settings → AI connections",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Integrations",
              "href": "/integrations"
            },
            {
              "label": "Call Workspace369 over HTTP (Builder API)",
              "href": "https://docs.workspace369.com/v/2026.3/build-with-ai/call-workspace369-over-http-builder-api/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "The AI connections page in Workspace369. Create token is pressed, a name and permissions are chosen, and the new access key is shown once with a link to the Setup guide.",
            "caption": "Create an access key for your own code, choose what it can do, and copy it once. Example data.",
            "duration": "PT14S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Settings, AI connections",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-phone-light.webm",
                "poster": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-03-builder-api-on-every-plan/builderapi-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Which plans include the Builder API?",
          "a": "Every plan: Cadet, Voyager, Specialist, Commander and Enterprise. It used to start on Specialist."
        },
        {
          "q": "Does the trial include the Builder API?",
          "a": "Yes, once the card is saved. A workspace without a plan can't call it."
        },
        {
          "q": "Are REST hooks included too?",
          "a": "Yes. REST hooks at /v1/hooks come with the Builder API on every plan, the same as webhooks."
        },
        {
          "q": "Do Builder API calls use my AI usage?",
          "a": "Yes. Calls count toward your plan's monthly AI usage, like the rest of your AI connections."
        }
      ]
    },
    {
      "slug": "2026-11-01-merge-lead-sources-custom-accent-colours",
      "date": "2026-11-01",
      "title": "Merge lead sources, pick any accent color, and see when a portal can't open",
      "seoTitle": "Merge Lead Sources and Pick Any Accent Color",
      "summary": "Merge one lead source into another, set a custom hex accent color in Appearance, and see a notice when you share a portal with a client who has no email to sign in with.",
      "areas": [
        "clients",
        "workspace",
        "portal"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of two paper streams merging into one with three round color swatches, beside a render of the Lead sources list."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Merge lead sources, custom accent colors and portal sign-in warnings in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "merge-lead-sources",
          "title": "Merge one lead source into another",
          "body": [
            "Open Settings → Clients → Leads and use the ⋯ menu on a lead source. Choose Merge into…, pick the source it should fold into, and continue. A confirm dialog then says how many clients move, for example “12 clients move from “Podcast” to “Google”, and “Podcast” is removed. This can't be undone.” Choose Merge to finish. The lead list, the Clients list and the client form refresh afterwards.",
            "Merge into… shows only to members who can edit and delete lead sources and edit clients, and only when the workspace has another source to merge into. With rename and delete already there, this finishes the set for tidying lead sources, so a duplicate or retired source can be folded into the one you keep. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Merge into… is in each lead source's ⋯ menu",
            "The confirm dialog says how many clients move before anything changes",
            "A merged source is removed and can't be brought back"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/merge-lead-sources.webp",
            "width": 1600,
            "height": 826,
            "alt": "The Leads settings page in Workspace369 with a confirmation dialog asking to merge the lead source Podcast into Google, saying 12 clients move and Podcast is removed, with Merge and Cancel."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/merge-lead-sources-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "On a phone, the confirmation asking Merge Podcast into Google, which says 12 clients move and Podcast is removed and can't be undone, with red Merge and Cancel buttons."
          },
          "whereToFind": "Settings → Clients → Leads → ⋯ menu → Merge into…",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Client management software",
              "href": "/solutions/client-management-software"
            },
            {
              "label": "Clients and CRM guide",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/clients-and-crm/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "Screen recording of the Leads settings: the more menu on the Podcast lead source opens Merge into, Google is chosen as the source to keep, the merge is confirmed, and Podcast leaves the list.",
            "caption": "Choose Merge into… on a lead source, pick the source to keep and confirm, and the merged source leaves the list. Example data.",
            "duration": "PT11S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Leads",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-phone-light.webm",
                "poster": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/mergeleads-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "custom-accent-color",
          "title": "Pick any accent color, not just the presets",
          "body": [
            "In Settings → Appearance, the Accent color row now ends with Custom color. Choose it and a picker opens under the row with a hex field, a saturation and brightness area and a hue slider. The color previews across the app while you pick it. Save keeps it and Discard puts the old one back, the same as the presets. The accent changes how Workspace369 looks for you, not what your clients see.",
            "Type six hex digits, such as #2B6CB0. Anything else shows “Use a 6-digit hex code, like #2B6CB0.” and the color can't be saved until it is fixed. A readability line warns when the color is hard to read in light or dark mode and offers a darker or lighter shade.",
            "Two things in Appearance got simpler. The Right-to-left layout row now shows only when the language you chose is written right to left, and the Classic and New Home switch is gone because New Home is the only home. The custom accent is on every plan. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Custom color is the last option in the Accent color list",
            "Live preview; Save keeps it and Discard restores the old accent",
            "Right-to-left layout shows only for right-to-left languages"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Settings → Appearance → Accent color → Custom color",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Workspace themes, dark mode and accent colors",
              "href": "/features/themes"
            },
            {
              "label": "Workspace setup guide",
              "href": "https://docs.workspace369.com/v/2026.3/getting-started/workspace-setup/"
            }
          ]
        },
        {
          "id": "portal-no-email-notice",
          "title": "Know when a client can't open their portal",
          "body": [
            "The client portal signs people in with a one-time code sent by email. When you open Client portal on a client and neither the client nor their contact people have an email address that can receive mail, the share sheet now starts with a notice: “Can't sign in to this portal yet”. It explains that no code can be sent, so the link won't open for them. If the address on file is the problem, the notice quotes it back.",
            "If you can edit clients, the notice has an email field and Save email, so you can add the address right there and the client can sign in. Members who can't edit clients see the explanation only. Nothing is sent when you save. One address that works is enough, so the notice appears only when none of the client's addresses can receive mail.",
            "Only members who can share clients see the Client portal button, and the notice appears in the client portal sheet. It applies on every plan. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "A plain notice at the top of the share sheet: Can't sign in to this portal yet",
            "Add the client's email in place with Save email, if you can edit clients",
            "Shown only when none of the client's addresses can receive mail"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/portal-no-email-notice.webp",
            "width": 1600,
            "height": 1720,
            "alt": "The Share sheet for a client in Workspace369 opens with the notice Can't sign in to this portal yet, an email address field and a Save email button above the private link."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-merge-lead-sources-custom-accent-colours/portal-no-email-notice-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "On a phone, the client Share sheet starts with the notice Can't sign in to this portal yet, a Client's email address field and Save email, then the private link and Copy link."
          },
          "whereToFind": "Clients → a client → Client portal",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Clients and CRM guide",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/clients-and-crm/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "How do I merge two lead sources?",
          "a": "Go to Settings → Clients → Leads, open the ⋯ menu on the source you want to remove, choose Merge into…, pick the source to keep and continue. The confirm dialog says how many clients move; choose Merge to finish."
        },
        {
          "q": "Can a merged lead source be restored?",
          "a": "No. The merged source is removed and the confirm dialog says it can't be undone."
        },
        {
          "q": "Who sees Merge into… on a lead source?",
          "a": "Members who can edit and delete lead sources and edit clients, and only when there is another lead source to merge into."
        },
        {
          "q": "Can I use my own hex color as the accent?",
          "a": "Yes. In Settings → Appearance, choose Custom color at the end of the Accent color list and enter six hex digits such as #2B6CB0. Save keeps it and Discard restores the old accent."
        },
        {
          "q": "Why is the Right-to-left layout row missing in Appearance?",
          "a": "It now shows only when the language you chose is written right to left. For other languages the Language group is just the Language row."
        },
        {
          "q": "What happens if I share a portal with a client who has no email?",
          "a": "The share sheet says “Can't sign in to this portal yet”, because the portal sends a sign-in code by email. If you can edit clients you can add their email there with Save email."
        }
      ]
    },
    {
      "slug": "2026-11-01-custom-labels-on-client-emails-and-phones",
      "date": "2026-11-01",
      "title": "Give a client's emails and phone numbers your own labels",
      "seoTitle": "Custom Labels on Client Emails and Phones",
      "summary": "Label any email or phone on a client with your own words, like Assistant or Billing desk. The label shows on the client page and in the invoice editor instead of Other.",
      "areas": [
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of four paper tags on a ring, one amber tag being written on with a pencil, beside a new client form on a phone with an email labelled Assistant."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Custom labels on client emails and phones in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "contact-labels",
          "title": "Label a client's emails and phone numbers your way",
          "body": [
            "Open the New client form, or Edit client info on a client. Each email and phone row has a type menu with Home, Work, Personal and Other. The last item in that menu is Custom label. Choose it, type a name such as Assistant or Billing desk, and save. The row now carries that label. Labels you have already used on the same client are listed in the menu too, so the next row is one tap.",
            "The client page shows your label on the contact row, and the invoice editor's email and phone pickers show it too, where they used to say Other. Edit an email or phone inline on the client page and the label stays with the new address. Pick a fixed type such as Work, or remove the row, and the label is cleared.",
            "The same labels are visible to AI assistants connected through MCP, so they can tell a client's assistant from the client. Anyone allowed to edit clients can add labels, on every plan. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Custom label is the last item in each email and phone type menu",
            "Shown on the client page and in the invoice editor instead of Other",
            "Inline edits keep the label; choosing a fixed type clears it"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Clients → Add Client → Email or Phone type menu → Custom label",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Client management software",
              "href": "/solutions/client-management-software"
            },
            {
              "label": "Clients and CRM guide",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/clients-and-crm/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "Screen recording of the New client form: the email type menu opens, Custom label is chosen, Assistant is typed and saved, and the email row now shows Assistant.",
            "caption": "Choose Custom label in an email type menu, type a name, and the row carries it. Example data.",
            "duration": "PT10S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Client form",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-phone-light.webm",
                "poster": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-01-custom-labels-on-client-emails-and-phones/contactlabel-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Can I give a client's email or phone number my own label?",
          "a": "Yes. In the New client form or Edit client info, open the type menu on an email or phone row and choose Custom label, then type a name such as Assistant or Billing desk."
        },
        {
          "q": "Where does a custom label show up?",
          "a": "On the client page's contact rows and in the invoice editor's email and phone pickers, in place of Other."
        },
        {
          "q": "What happens to the label if I change the address or the type?",
          "a": "Editing the address inline keeps the label. Choosing a fixed type such as Work clears it, and removing the row drops it."
        },
        {
          "q": "Which plans include custom contact labels?",
          "a": "Every plan. Team members who are allowed to edit clients can add them."
        }
      ]
    },
    {
      "slug": "2026-11-01-add-lead-sources-from-the-client-form",
      "date": "2026-11-01",
      "title": "Add a lead source while you create a client, and see your current plan",
      "seoTitle": "Add a Lead Source from the Client Form",
      "summary": "Type a new lead source in the client form and it is created and selected on the spot. The plans screen now marks your current plan and shows whether you pay monthly or yearly.",
      "areas": [
        "clients",
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a signpost with four paper arrows, one new amber arrow being added, beside the client form's Lead Source menu open on a phone, listing Google, Referral, Podcast, Social Media and Webinar."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Add a lead source from the client form in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "lead-source-in-client-form",
          "title": "Add a lead source while you create a client",
          "body": [
            "Open the New client form, or Edit client info on a client, and type a name in the Lead Source search. If no lead source has that name yet, the menu shows Create \"your name\". Choose it and the lead source is created and selected on the client, so you never have to leave the form to add one. If a lead source with that name already exists, in any capitalisation, that one is selected instead, so you don't end up with duplicates.",
            "The lead source is created the moment you choose it, even if you then close the form without saving the client. If that happens, you can remove it in Settings → Leads. Only team members who are allowed to add lead sources (the Settings → Leads permission) see the Create row. Everyone else keeps the list to pick from.",
            "Tags now work the same way across clients: a tag you type on the New client form is saved to your workspace's tag list, so the tag picker offers it on the next client.",
            "Adding a lead source from the client form works on every plan; the Leads report, which shows which sources turn into paid work, is on Voyager, Specialist, Commander and Enterprise. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Type a new lead source and create it in place",
            "An existing name in any case is matched, never duplicated",
            "Only members who can add lead sources see the Create row",
            "Tags typed on a new client are saved to your tag list"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/lead-source.webp",
            "width": 1600,
            "height": 1000,
            "alt": "The Lead Source field in the client form on two phones, light and dark, with Referral from Anna typed in the search and a Create \"Referral from Anna\" row under it."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/lead-source-phone.webp",
            "width": 780,
            "height": 440,
            "alt": "The Lead Source field in the client form on a phone with Referral from Anna typed in the search and a Create \"Referral from Anna\" row under it."
          },
          "whereToFind": "Clients → Add Client → Lead Source",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Client management software",
              "href": "/solutions/client-management-software"
            },
            {
              "label": "Clients and CRM guide",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/clients-and-crm/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "Screen recording of the New client form: a name is filled in, a new lead source called Trade show is typed in the Lead Source search, and the Create row adds and selects it.",
            "caption": "Type a new lead source in the New client form and it is created and selected. Example data.",
            "duration": "PT10S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Client form",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-phone-light.webm",
                "poster": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-01-add-lead-sources-from-the-client-form/leadsource-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "current-plan-badge",
          "title": "See your current plan at a glance",
          "body": [
            "On the plans screen, your own plan's card now carries a CURRENT PLAN label and a highlighted border, and the button under it is greyed out as Your plan. A line below the button says how you pay: Monthly plan, Yearly plan or Lifetime licence, and while you are on a trial it also shows when the trial ends.",
            "The screen also opens on your own billing interval, so a member on a monthly plan sees monthly plans first and a member on a yearly plan sees yearly ones. Switch the interval and your plan keeps its label, with the real Switch button for the other period.",
            "Find it in Settings → Plan, then Change plan. It is the same for every plan, on the web app now. The iPhone app gets it in its next update."
          ],
          "highlights": [
            "A CURRENT PLAN label and highlight on your plan's card",
            "Monthly plan, Yearly plan or Lifetime licence under the button",
            "The screen opens on your own billing interval"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Settings → Plan → Change plan",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Compare plans",
              "href": "/pricing"
            },
            {
              "label": "Plans, seats and your subscription",
              "href": "https://docs.workspace369.com/v/2026.3/admin/plans-seats-and-subscription/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I add a new lead source from the client form?",
          "a": "Yes. In the New client form or Edit client info, type a name in the Lead Source search. If it isn't listed, choose Create \"your name\" and it is created and selected."
        },
        {
          "q": "What if a lead source with that name already exists?",
          "a": "The existing one is selected instead, whatever the capitalisation, so you don't get duplicates."
        },
        {
          "q": "Who can create a lead source from the client form?",
          "a": "Team members who are allowed to add lead sources, the Settings → Leads permission. Everyone else keeps the list to pick from."
        },
        {
          "q": "How can I see which plan I am on?",
          "a": "Open Settings → Plan → Change plan. Your plan's card has a CURRENT PLAN label and a highlight, and a line under the button says Monthly plan, Yearly plan or Lifetime licence."
        }
      ]
    },
    {
      "slug": "2026-11-01-add-emails-to-your-crm-and-import-proposals",
      "date": "2026-11-01",
      "title": "Add emails to your CRM with AI, and import proposals and client lists",
      "seoTitle": "Add an Email Sender to Your CRM with AI",
      "summary": "AI turns an email from someone new into a client, a note and a follow-up you review first. Rebuild an old proposal from a PDF, or import clients from a screenshot.",
      "areas": [
        "clients",
        "ai",
        "inbox",
        "proposals"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a card-file box with an amber contact card and a document under a magnifying glass, beside the Add to CRM panel filled in from an email."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Add an email to your CRM with AI in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "inbox-add-to-crm",
          "title": "Add an email's sender to your CRM with AI",
          "body": [
            "Open an email from someone new and choose Add to CRM from its menu. Workspace369 reads the email and suggests a new prospect with the sender's name, phone and company, a short note that sums up the email, and a follow-up to remind you to reply. If the sender's email is already on a client, the note and follow-up go on that client and their details stay as they are. If only a phone number matches, you choose whether to add to that client or create a new one.",
            "You review everything before it is saved: edit the details, leave out the note or the follow-up, or add the client only. Reading the email counts toward your AI usage once, and adding is free. If the email looks like spam or a scam, nothing is added and nothing is charged. The AI can get things wrong, so check the details before you add them.",
            "Find it in Communications → Emails, in the menu of an email you received. People who can use the inbox and add clients can use it, on Cadet, Voyager, Specialist, Commander and Enterprise. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "A client, a note and a follow-up from one email",
            "Matches senders already in your CRM by email",
            "Review before anything is saved",
            "Spam is never added or charged"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-review.webp",
            "width": 1600,
            "height": 1350,
            "alt": "Add to CRM on desktop next to the inbox and an email from Tomas Hartley about ceramic coating for four vans: a new prospect with name, email, phone and company, a note that sums up the email, and the follow-up Send Tomas a quote for the van fleet, due Wed, Nov 4, above Add to CRM."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-review-phone.webp",
            "width": 780,
            "height": 2324,
            "alt": "The Add to CRM review on a phone: New prospect Tomas Hartley of Hartley Courier Co., the note from the email, the follow-up due Wed, Nov 4, and Add to CRM with Used 1 email read, Adding is free."
          },
          "whereToFind": "Communications → Emails → an email's menu → Add to CRM",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            },
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Emails inbox opens an email from Tomas Hartley asking about ceramic coating for four delivery vans. The message's menu lists Reply, Reply all, Forward, Comments and Add to CRM; Add to CRM reads the email and suggests a new prospect with contact details, a note from the email and a follow-up due Wed, Nov 4. Add to CRM is pressed and the screen confirms Tomas Hartley is in your CRM.",
            "caption": "Choose Add to CRM on an email, check the suggested client, note and follow-up, then add them. Example text; results vary. Example data.",
            "duration": "PT7S",
            "large": {
              "title": "Emails",
              "sub": "Ceramic coating and monthly detailing for our vans",
              "width": 1280,
              "height": 660,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-phone-light.webm",
                "poster": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/crm-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "proposal-import",
          "title": "Import a proposal from a PDF or photo",
          "body": [
            "Switching from HoneyBook, Dubsado or another tool? Choose Import a proposal and add a PDF or a photo of a proposal you sent clients, up to 10 MB. Workspace369 rebuilds it as a proposal template, with its sections and line items, and you can tell it where the file came from to help it read the layout.",
            "Before you save, Things to check points out what needs a look, such as a tax rate to set on the line items or prices in another currency, and you can remove any part you don't want. Photos and logos aren't imported. The file is read once and then deleted, and nothing is saved until you choose Save as template. It counts toward your AI usage once, and only when the proposal could be read.",
            "Find it when you pick a template for a new proposal, under Templates in your proposal settings, and on Proposals before you have any. People allowed to manage proposal templates can use it, on Cadet, Voyager, Specialist, Commander and Enterprise. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "PDF, PNG or JPEG up to 10 MB",
            "Rebuilt as a template you review",
            "Things to check before you save",
            "The file is deleted after reading"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/proposal-import.webp",
            "width": 1600,
            "height": 1125,
            "alt": "Import a proposal on desktop for Calloway-Wedding-Proposal.pdf: Things to check lists images not imported, a 5% tax to set on line items and prices read as CAD, and What we rebuilt shows Cover, Header, About us, Pricing, Totals and Timeline above Save as template."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/proposal-import-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The Import a proposal review on a phone, with the template name Calloway wedding photography, Things to check and the first rebuilt sections, Cover and Header."
          },
          "whereToFind": "Proposals → New Proposal → pick a template → Import a proposal",
          "appRoute": "/proposals",
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Proposals and quotes",
              "href": "/features/quoting"
            },
            {
              "label": "Switch from HoneyBook",
              "href": "/switch/honeybook"
            }
          ]
        },
        {
          "id": "screenshot-import",
          "title": "Import clients from a screenshot",
          "body": [
            "In AI Import, choose Import from a screenshot and upload a screenshot or photo of your client list, from another app or a spreadsheet, as PNG, JPEG, WebP, HEIC or PDF. Workspace369 reads the clients from it and opens the same review step as a file import, so you check every client before anything is added.",
            "Rows it can't read, and rows that repeat, are left out and counted, so you know what to add by hand. Reading the screenshot uses AI usage only when clients come back from it, and the import itself uses AI usage too, like any AI Import.",
            "Find it in Clients → Import data. People allowed to import clients can use it, on Cadet, Voyager, Specialist, Commander and Enterprise. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "PNG, JPEG, WebP, HEIC or PDF",
            "Same review step as a file import",
            "Unreadable and repeated rows are counted",
            "Reading is charged only when clients come back"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/screenshot-import.webp",
            "width": 1600,
            "height": 1125,
            "alt": "The AI Import review on desktop after Read 6 from your screenshot: 6 records parsed, each marked Will create new client with name, email, phone and company, above Commit 6 records."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-add-emails-to-your-crm-and-import-proposals/screenshot-import-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The same screenshot import review on a phone, with the notice Read 6 from your screenshot and the first clients, Priya Raman of Raman Bakery and Marcus Bell."
          },
          "whereToFind": "Clients → Import data → Import from a screenshot",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Switch from Dubsado",
              "href": "/switch/dubsado"
            },
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can Workspace369 add an email's sender to my CRM?",
          "a": "Yes. Open the email, choose Add to CRM from its menu, and AI suggests a client, a short note and a follow-up. You review them, then add. Nothing is saved before that."
        },
        {
          "q": "What happens if the sender is already a client?",
          "a": "Workspace369 matches them by email address. The note and follow-up are added to that client, and their details stay as they are. If only the phone number matches, you choose between adding to that client and creating a new one."
        },
        {
          "q": "Can I import my proposals from HoneyBook or Dubsado?",
          "a": "Yes. Choose Import a proposal and add a PDF or photo of a proposal you sent. It is rebuilt as a template you review, and nothing is saved until you choose Save as template."
        },
        {
          "q": "Can I import clients from a screenshot?",
          "a": "Yes. In AI Import, choose Import from a screenshot and upload an image or PDF of your client list. You review every client before anything is added."
        },
        {
          "q": "Which plans include these AI features?",
          "a": "Cadet, Voyager, Specialist, Commander and Enterprise. Each one counts toward your monthly AI usage, and spam emails or files that can't be read aren't charged."
        }
      ]
    },
    {
      "slug": "2026-11-01-booking-link-texts-and-top-bar-save",
      "date": "2026-11-01",
      "title": "Text new leads and missed callers your booking link, and save from the top bar",
      "seoTitle": "Text Your Booking Link to Leads and Callers",
      "summary": "Workflows can now text a lead or a missed caller your booking page link, and the full-page task and accounting create screens save from a top bar.",
      "areas": [
        "automations",
        "work"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a speech bubble holding a calendar page with an amber day and a paper chain link, beside a render of a workflow that texts new leads a booking link."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Text your booking link to new leads and missed callers in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "booking-link-texts",
          "title": "Text new leads and missed callers your booking link",
          "body": [
            "Two new starter templates do it for you. In Workflows, choose New workflow and open Leads for Text new leads your booking link: it starts on New lead, only continues when SMS consent is Yes, and sends one text that greets the lead by name, thanks them for reaching out to your business, gives your booking link and ends with \"Reply STOP to opt out.\" Open Inbox for Text missed callers your booking link: it starts on Call missed and texts the caller a link to book a time. Pick Use template and you get a draft you can edit before it goes live.",
            "To put the link in any message of your own, open Insert variable in a step and choose Booking page link from the Workspace group. It fills in the public link of your live default booking page, or your only live page. With two live pages and no default, or none at all, a step that uses it is not sent and the run tells you why.",
            "SMS consent is also a new filter on the New lead, Lead status changed, Lead assigned and Lead converted to client triggers, with Yes and No to choose from. It matches the SMS consent box on your forms, so a lead who did not tick it does not match a Yes filter. Text steps need Voyager or above, and the booking link needs a booking page, so these templates are for Specialist, Commander and Enterprise; on a lower plan they show the plan lock. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Two templates: one for new leads, one for missed callers",
            "Booking page link in the Workspace group of Insert variable",
            "SMS consent filter on four lead triggers"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Workflows → New workflow → Leads or Inbox → Use template",
          "appRoute": "/workflows",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Workflow automation",
              "href": "/features/automation"
            },
            {
              "label": "Build, test and activate a workflow",
              "href": "https://docs.workspace369.com/v/2026.3/automation/build-test-activate-workflow/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "Screen recording of Workflows: New workflow is pressed, the Text new leads your booking link template is chosen and Use template opens the draft with an SMS consent filter and a text step.",
            "caption": "Choose the booking-link template when you start a new workflow and the draft opens with its SMS consent filter. Example data.",
            "duration": "PT14S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Workflows",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-phone-light.webm",
                "poster": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/bookinglink-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "task-top-bar-save",
          "title": "Create a task from the top bar",
          "body": [
            "The full-page New task screen now saves from a bar at the top. On a computer it shows the breadcrumb, such as Tasks / your board / New task, with Create another, Cancel and Create task beside it, and ⌘↵ (Ctrl ↵ on Windows) saves from the keyboard. On a phone the bar reads Cancel, the title and Create. A task you are creating can't be cancelled while it is saving. It is on every plan, on the web app now, and comes to the iPhone app with its next update."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/task-top-bar-save.webp",
            "width": 1600,
            "height": 950,
            "alt": "The full-page New task screen in Workspace369 on a computer, with Tasks / Launch plan / New task, Create another, Cancel and Create task in a bar at the top."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-booking-link-texts-and-top-bar-save/task-top-bar-save-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The New task screen on a phone with Cancel, the title New task and a Create button in the bar at the top, above the Task title field and the Status and Priority rows."
          },
          "whereToFind": "Tasks → New task",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Schedule",
              "href": "/features/schedule"
            },
            {
              "label": "Projects, tasks and scheduling",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/projects-tasks-scheduling/"
            }
          ]
        },
        {
          "id": "accounting-top-bar-save",
          "title": "Save bills, vendors, fixed assets and journal entries from the top bar",
          "body": [
            "The Accounting create screens for a bill, a vendor, a fixed asset and a journal entry now save from the same top bar. On a computer it shows the breadcrumb, such as Accounting / Create Bill, with Cancel and the main button beside it, and ⌘↵ (Ctrl ↵ on Windows) saves. On a phone the bar reads Cancel, the title and the main button. The save buttons at the end of the bill, vendor and fixed asset forms are gone. These screens are on Commander and Enterprise. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Accounting → Bills, Vendors, Fixed Assets or Journal Entries → add one",
          "appRoute": null,
          "plans": [
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Accounting",
              "href": "/features/accounting"
            },
            {
              "label": "Expenses",
              "href": "/features/expenses"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "How do I text a new lead my booking link?",
          "a": "In Workflows choose New workflow, open Leads and use Text new leads your booking link. It runs when a new lead arrives and sends one text, only when the lead's SMS consent is Yes."
        },
        {
          "q": "How do I text someone who calls and I miss them?",
          "a": "Use the Text missed callers your booking link template under Inbox in New workflow. It starts on Call missed and texts the caller a link to book a time."
        },
        {
          "q": "Which plans can send the booking link by text?",
          "a": "Specialist, Commander and Enterprise. Text steps need Voyager or above and booking pages start at Specialist, so a lower plan shows the plan lock on these templates."
        },
        {
          "q": "What does the SMS consent filter match?",
          "a": "The SMS consent box on your forms. The filter is on New lead, Lead status changed, Lead assigned and Lead converted to client, and a lead who did not tick the box does not match Yes."
        },
        {
          "q": "Where do I find the Booking page link variable?",
          "a": "In a workflow step, open Insert variable and look in the Workspace group for Booking page link."
        },
        {
          "q": "Can I save a new task or bill from the keyboard?",
          "a": "Yes. On a computer New task saves with ⌘↵, or Ctrl ↵ on Windows, on every plan. On Commander and Enterprise the bill, vendor, fixed asset and journal entry screens save the same way."
        }
      ]
    },
    {
      "slug": "2026-11-01-import-projects-with-their-tasks",
      "date": "2026-11-01",
      "title": "Import projects, and any tasks, from Dubsado, HoneyBook and more",
      "seoTitle": "Import Projects and Tasks from Dubsado",
      "summary": "AI Import now brings in projects as a sixth data type: each project arrives with its client, dates and budget, plus any tasks in the file, after you review it.",
      "areas": [
        "work",
        "ai"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of an open cardboard box tipping out three paper project folders with checklist slips, beside the Import projects review step listing three projects with their tasks."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Import projects with their tasks in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "import-projects",
          "title": "Import projects with their tasks",
          "body": [
            "Switching from Dubsado, HoneyBook or another tool? AI Import now brings in projects as well as clients, products, invoices, proposals and expenses. Open Clients → Import data, choose Projects, and upload a CSV or Excel projects export from Dubsado, HoneyBook, Bonsai, 17hats, Moxie or a spreadsheet. AI suggests the tool it came from and the data type, and you can correct either before the import starts.",
            "Each project is read with its client, status, dates and budget, and any tasks in the file become the project's to-dos. Tasks come across when the file has a Tasks column or one row per task, and a Dubsado projects export usually has none. In a Dubsado export, Lead reads as Planning, Job as In Progress and Archived: Yes as archived. A client you already have is linked to its projects, and a new client is created when there is no match. Very long task lists are trimmed, and the review step flags a project when that happens.",
            "The review step shows one card per project: its name, client, status and dates, budget and number of tasks, with an Archived tag where it applies. Switch a project off to leave it out, or edit its name or budget, and nothing is saved until you import. When it finishes, View Projects opens your project list. Like every import it uses AI usage, and you need permission to import and to create projects. It is on all plans, on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Projects is the sixth data type in Import data",
            "Tasks in the file become the project's to-dos",
            "Dubsado Lead and Job map to Planning and In Progress, and archived projects stay archived"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-desktop-light-review.webp",
            "width": 1600,
            "height": 826,
            "alt": "The Import data review step listing three projects, each with its client, dates, budget and task count, and a Commit 3 records button."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-phone-light-review.webp",
            "width": 780,
            "height": 1696,
            "alt": "The Import data review step on a phone, showing project cards with client, dates, budget and task count above a Commit 3 records button."
          },
          "whereToFind": "Clients → Import data → Projects",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Switch from Dubsado",
              "href": "/switch/dubsado"
            },
            {
              "label": "Switch from HoneyBook",
              "href": "/switch/honeybook"
            },
            {
              "label": "Projects, tasks and scheduling guide",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/projects-tasks-scheduling/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "Screen recording of AI Import: Projects is picked as the sixth type, a projects file is uploaded and detected, and three projects (with tasks from a Tasks column) are reviewed and committed.",
            "caption": "Import a projects export, review each project with its client, dates, budget and tasks, then commit them. Example data.",
            "duration": "PT15S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Import data",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-phone-light.webm",
                "poster": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-01-import-projects-with-their-tasks/projectsimport-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Can I import projects from Dubsado or HoneyBook into Workspace369?",
          "a": "Yes. In Clients → Import data choose Projects and upload a CSV or Excel projects export from Dubsado, HoneyBook, Bonsai, 17hats, Moxie or a spreadsheet. You review every project before anything is saved."
        },
        {
          "q": "What happens to the tasks in my projects file?",
          "a": "Tasks in the file become the project's to-dos, when the file has a Tasks column or one row per task. The review step flags a project whose task list was trimmed."
        },
        {
          "q": "Does an imported project link to my existing clients?",
          "a": "A client you already have is linked to its projects, and a new client is created when there is no match. Each review card shows the client before you import."
        },
        {
          "q": "Which plans include project import, and what does it need?",
          "a": "Import is on every plan and uses your AI usage like any AI Import. You need permission to import and to create projects."
        },
        {
          "q": "How are Dubsado statuses and archived projects handled?",
          "a": "In a Dubsado export Lead reads as Planning and Job as In Progress, and a project marked Archived: Yes imports as archived. Each card shows its status and dates for you to check."
        }
      ]
    },
    {
      "slug": "2026-11-01-try-a-sample-client-proposal-and-invoice",
      "date": "2026-11-01",
      "title": "Try a sample client, proposal and invoice, and remove them in one tap",
      "seoTitle": "Try a Sample Client, Proposal and Invoice",
      "summary": "On the first-client step of a new trial, one tap adds a sample client, draft proposal and draft invoice to explore, and Home removes them in one tap when you are ready.",
      "areas": [
        "workspace",
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of three paper cards, a contact, a document and a receipt, each with a peel-off sticker corner, beside the Try a sample card and the sample data banner with Remove sample data."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Try sample data in Workspace369 and remove it in one tap",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "sample-client-proposal-invoice",
          "title": "A sample client, proposal and invoice to explore",
          "body": [
            "No client to bill yet? The first-client step now has a No client handy? Try a sample card above the form. One tap adds a sample client, a draft proposal and a draft invoice, closes setup and opens the sample proposal in the editor, so you can see the app working before you have anyone to bill. The step opens by itself once after the card step of a free trial that has no clients, and you can reach it later from Add your first client on Home. The sample card shows whenever the workspace has no clients and you can create clients, proposals and invoices.",
            "The sample client is Riverside Bakery (sample), saved with your own email address, so anything you send to it reaches only you. The proposal, Website refresh (sample), has a Homepage design line and a Monthly care plan as an optional extra, and the invoice, Website deposit (sample), is a draft deposit. Every record is marked (sample), and none of them counts as finishing a setup step.",
            "While any sample record exists, Home shows a You're exploring sample data banner with Remove sample data. One tap removes the sample client, proposal and invoice, with a message when it is done. A sample client you renamed, or built real work on, stays as yours. One that was sent and accepted or paid stays too, and the message tells you to delete it from its list. It is on all plans, on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Try a sample sits above the form on the first-client step",
            "The sample client uses your own email address, so sends reach only you",
            "Remove sample data on Home clears it in one tap"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-desktop-light-step.webp",
            "width": 1600,
            "height": 826,
            "alt": "The Add your first client step with a No client handy? Try a sample card above the client form."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-phone-light-step.webp",
            "width": 780,
            "height": 1696,
            "alt": "The Add your first client step on a phone with the No client handy? Try a sample card above the client form."
          },
          "whereToFind": "Home → Add your first client → Try a sample; Home → Remove sample data",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Client onboarding software",
              "href": "/solutions/client-onboarding-software"
            },
            {
              "label": "Workspace setup guide",
              "href": "https://docs.workspace369.com/v/2026.3/getting-started/workspace-setup/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "Screen recording of the first-client setup step: Try a sample adds a sample client, proposal and invoice, then Remove sample data on Home takes them away again.",
            "caption": "Try a sample client, proposal and invoice from the first-client step, then remove them from Home in one tap. Example data.",
            "duration": "PT10S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Sample data",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-phone-light.webm",
                "poster": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-01-try-a-sample-client-proposal-and-invoice/sampledata-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "What does Try a sample add to my workspace?",
          "a": "A sample client called Riverside Bakery (sample), a draft proposal called Website refresh (sample) and a draft invoice called Website deposit (sample). Each is marked (sample), and the sample proposal opens in the editor."
        },
        {
          "q": "Will the sample client get emails I send?",
          "a": "The sample client is saved with your own email address, so anything you send to it reaches only you."
        },
        {
          "q": "Who sees the sample card?",
          "a": "It shows on the first-client step when your workspace has no clients and you can create clients, proposals and invoices. The step opens by itself once after the card step of a free trial."
        },
        {
          "q": "How do I remove the sample data?",
          "a": "While sample records exist, Home shows a banner with Remove sample data. One tap removes them. A sample client you renamed or built real work on stays, and one that was sent and accepted or paid stays and has to be deleted from its list."
        },
        {
          "q": "Does the sample count as setting up my workspace?",
          "a": "No. Sample records never complete a setup step such as your first client, a sent proposal or your first invoice."
        }
      ]
    },
    {
      "slug": "2026-10-31-turn-notes-into-follow-ups",
      "date": "2026-10-31",
      "title": "Turn a client note into follow-ups and tasks",
      "seoTitle": "Turn Notes into Follow-ups and Tasks",
      "summary": "Workspace369 can read a client note, or text you paste in, and suggest follow-ups and tasks. You tick, edit and date them, then add them in one step.",
      "areas": [
        "clients",
        "ai",
        "work"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a lined notepad with three paper sticky notes and an amber bell, beside the Follow-ups from notes panel listing suggested follow-ups and tasks to tick."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Turn a client note into follow-ups and tasks in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "notes-to-follow-ups",
          "title": "Turn a client note into follow-ups and tasks",
          "body": [
            "Yes, Workspace369 can turn meeting notes into follow-ups and tasks. Choose a note on a client, or paste in a call summary, and AI reads it and suggests follow-ups to get back to the client and tasks for you or your team. Nothing is added until you choose it.",
            "Every suggestion is a row you can tick or untick, with a title and a date you can change. Pick the board the tasks go to, then choose Add. When it is done you see what happened, such as 4 added, 1 already there, so pressing Add again on the same list does not create duplicates.",
            "Reading the notes uses your monthly AI usage once, and the AI can get things wrong, so check the list before you add it. Adding the items uses no AI usage.",
            "On a client's Notes tab, choose the sparkle button on a note, or open a note's menu and choose Turn into follow-ups and tasks. To use text that is not in a note, open the client's More actions menu and choose Follow-ups from pasted text. You need permission to view clients, and adding tasks also needs permission to create tasks. It is on Cadet, Voyager, Specialist, Commander and Enterprise, on the web app now, and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "A sparkle button on every client note",
            "Tick, edit and date each suggestion",
            "Choose the board for the tasks",
            "Cadet plan and up"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups.webp",
            "width": 1600,
            "height": 826,
            "alt": "Follow-ups from notes on desktop, from the note Check-in call with Dana Ruiz for Maple Row Physio: three follow-ups with email and call dates, tasks below, Tasks go to Client work, and Add 5 items."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The same Follow-ups from notes screen on a phone in dark mode, with ticked follow-ups, their dates and Add 5 items at the bottom."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, a client's Notes tab lists a meeting note. The sparkle button is chosen and Follow-ups from notes reads the note. It lists three follow-ups and two tasks with dates. One follow-up is unticked, Add 4 items is chosen, and the result reads 4 added.",
            "caption": "Choose the sparkle on a note, untick what you don't want, then add the rest. Example text; results vary. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Client notes",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-phone-light.webm",
                "poster": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Clients → a client → Notes → the sparkle on a note",
          "appRoute": "/clients",
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Client follow-ups",
              "href": "/tutorials/client-follow-ups"
            },
            {
              "label": "Tasks",
              "href": "/tutorials/tasks"
            },
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can Workspace369 turn meeting notes into tasks?",
          "a": "Yes. Choose the sparkle button on a client note, and AI suggests follow-ups and tasks from it. You tick, edit and date the ones you want, pick a board, and choose Add."
        },
        {
          "q": "Can I turn pasted text into follow-ups?",
          "a": "Yes. Open the client's More actions menu and choose Follow-ups from pasted text, paste a call summary, meeting notes or an email thread, and choose Find next steps."
        },
        {
          "q": "Does turning notes into follow-ups use AI usage?",
          "a": "Reading the notes uses your monthly AI usage once. Adding the items you chose uses none. The AI can get things wrong, so check the list before you add it."
        },
        {
          "q": "Which plans can turn notes into follow-ups and tasks?",
          "a": "Cadet, Voyager, Specialist, Commander and Enterprise, on the web app now. The iPhone app gets it with its next update."
        },
        {
          "q": "Does it add anything before I choose?",
          "a": "No. Nothing is added until you choose Add. Pressing Add again on the same list reports those items as already there. Reading the note again gives a new list, so check it for items you already added."
        }
      ]
    },
    {
      "slug": "2026-10-31-crm-setup-with-ai-and-faster-email-reading",
      "date": "2026-10-31",
      "title": "Set up your CRM with AI, and read through your email faster",
      "seoTitle": "Set Up Your CRM with AI",
      "summary": "Describe your business and AI suggests pipeline stages, client fields and lead sources you edit before saving. Emails now steps from one email to the next.",
      "areas": [
        "clients",
        "ai",
        "inbox"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of four rising paper columns holding cards under an amber star, beside the Set up your CRM screen on a phone, showing suggested pipeline stages."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Set up your CRM with AI in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "crm-setup",
          "title": "Set up your whole CRM with AI",
          "body": [
            "Describe your business in a sentence or two, for example a mobile car detailing service that gets leads from Instagram and referrals, or start from one of the examples. Workspace369 suggests pipeline stages, client fields and lead sources to match. You can rename, remove or add any of them, and nothing is saved until you choose Apply to my CRM.",
            "Anything your CRM already has is marked Already in your CRM and skipped, so applying never changes or deletes what you have. You can change all of it later in settings. The suggestion uses your monthly AI usage, and the AI can get things wrong, so check the list before you apply. Applying uses no AI usage.",
            "Find it in your workspace setup, on the Add your first client step, under Set up your whole CRM with AI. Owners and admins can use it, and so can team members allowed to manage stages, client fields and lead sources. It is on Cadet, Voyager, Specialist, Commander and Enterprise, on the web app now, and comes to the iPhone app with its next update. (Changed Nov 1: you can also open it any time from Settings → Clients → Stages and follow-ups, and on a computer from the menu on a stage tab in the Clients list.)"
          ],
          "highlights": [
            "Stages, fields and lead sources from one description",
            "Edit everything before it is saved",
            "Never changes or deletes what you have",
            "Cadet plan and up",
            "Changed Nov 1: also in Settings → Clients → Stages and follow-ups"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup.webp",
            "width": 1600,
            "height": 1000,
            "alt": "Set up your CRM on desktop for a mobile car detailing description: suggested stages Quote sent, Booked, Detailed, Repeat customer and Lost beside the existing Lead stage, client fields such as Vehicle type, and 12 new, 4 already there above Apply to my CRM."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The same CRM setup review on a phone, with the stages grouped under Lead, Client and Closed and Apply to my CRM at the bottom."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Set up your CRM page opens. The Car detailing example fills the description and Preview reads it. The proposal lists pipeline stages with Lead marked as already in the CRM, client fields such as Vehicle type, and lead sources. One lead source is removed, Apply to my CRM is chosen, and Your CRM is set up lists what was created and what was already there.",
            "caption": "Describe your business, review the suggested stages, fields and lead sources, then apply. Example text; results vary. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Set up your CRM",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-phone-light.webm",
                "poster": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/crm-setup-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Your setup → Add your first client → Set up your whole CRM with AI",
          "appRoute": "/account-setup",
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            },
            {
              "label": "Leads from your website",
              "href": "/tutorials/leads-from-your-website"
            }
          ]
        },
        {
          "id": "emails-reading",
          "title": "Read through your email faster",
          "body": [
            "Open an email and your folders, search and Compose stay where they were. Step to the newer or older email with the arrows at the top, which also show where you are, such as 3 of 12. On a computer, j and k move between emails, e archives, # moves to Trash and Esc goes back to the list.",
            "Archive and Delete now act at once, with Undo on the notice, and take you straight to the next email. Spam has a Not spam button for one email or many, and Trash has Empty Trash for people allowed to delete emails for good. Drafts and Scheduled look like the rest of your inbox, and switching tabs and opening emails is smoother.",
            "Nothing changes about your plan or your mail. It is on the web app now and comes to the iPhone app with its next update. Keyboard shortcuts work on a computer only."
          ],
          "highlights": [
            "Next and previous email from the reader",
            "j, k, e, # and Esc on a computer",
            "Archive and Delete with Undo",
            "Not spam and Empty Trash"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/emails-reading.webp",
            "width": 1600,
            "height": 1000,
            "alt": "Emails on desktop with the list narrowed on the left and an open email on the right, with up and down arrows and 1 of 12 at the top of the reader."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-31-crm-setup-with-ai-and-faster-email-reading/emails-reading-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "An open email on a phone with back, newer and older arrows and archive, delete, mark unread and flag buttons along the top."
          },
          "whereToFind": "Communications → Emails → open an email",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            },
            {
              "label": "Inbox tutorial",
              "href": "/tutorials/inbox"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can AI set up my CRM in Workspace369?",
          "a": "Yes. Describe your business and Workspace369 suggests pipeline stages, client fields and lead sources. You edit them, then choose Apply to my CRM. Nothing is saved before that."
        },
        {
          "q": "Will setting up my CRM with AI change what I already have?",
          "a": "No. Anything already in your CRM is marked and skipped. Applying only adds new stages, fields and lead sources, and never changes or deletes existing ones."
        },
        {
          "q": "Which plans can set up the CRM with AI?",
          "a": "Cadet, Voyager, Specialist, Commander and Enterprise. The suggestion uses your monthly AI usage; applying it doesn't."
        },
        {
          "q": "Does Workspace369 Emails have keyboard shortcuts?",
          "a": "Yes, on a computer. With an email open, j and k move to the next or previous email, e archives, # moves it to Trash and Esc goes back to the list."
        },
        {
          "q": "Can I empty the Trash in Workspace369 Emails?",
          "a": "Yes. Trash has an Empty Trash button for people whose role allows deleting emails for good."
        }
      ],
      "updated": "2026-11-02"
    },
    {
      "slug": "2026-10-31-ai-lead-score",
      "date": "2026-10-31",
      "title": "AI lead scoring labels new requests hot, warm or cold",
      "seoTitle": "AI Lead Scoring for New Requests",
      "summary": "Workspace369 can now label new requests hot, warm or cold with a short reason, so you reply to the best leads first. Signing in on the web is faster too.",
      "areas": [
        "clients",
        "ai"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-31-ai-lead-score/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of three paper request envelopes stepping down, marked with an amber flame, a warm sun and a cool snowflake, beside a phone render of a request marked Hot with Why this score."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "AI lead scoring in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "lead-score",
          "title": "AI lead scoring on new requests",
          "body": [
            "Turn on Score new leads with AI under Lead scoring in your Requests settings, and new requests get a Hot, Warm or Cold label with a score out of 5. The Requests list shows it in a new Score column, and on a phone the label sits on each row. Open a request to see Why this score: a one-line summary and the reasons behind it.",
            "Describe your ideal customer, for example agencies looking for a full website redesign, and leads are scored against it. Without it, they are scored on how clear and complete they are. Obvious spam is marked cold by built-in rules and uses no AI usage. Every other score uses your monthly AI usage. If it runs out, new requests stay Not scored until you top up. The AI can be wrong, so treat the label as a guide.",
            "Lead scoring is off until you turn it on, and it scores requests that arrive after that. It is on Voyager, Specialist, Commander and Enterprise. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Hot, warm or cold on new requests",
            "Why this score in one line",
            "Score against your ideal customer",
            "Spam marked cold without AI usage"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-31-ai-lead-score/lead-score.webp",
            "width": 1600,
            "height": 712,
            "alt": "The Requests list on desktop with the new Score column: Maya Okafor and Daniel Park marked Hot, Priya Nair Warm, Elena Rossi Cold and Sam Whitfield Not scored."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "A request from Maya Okafor on a phone at larger text, with Why this score: Hot, Score 5 of 5, a one-line summary and three reasons."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Requests list shows Hot, Warm and Cold labels. Maya Okafor's Website redesign request opens to Why this score: Hot, Score 5 of 5, Ready to start a website redesign and knows what she wants, with the reasons Clear scope and timeline, Budget given and Wants to start in March. Then it closes back to the list.",
            "caption": "New requests get a hot, warm or cold label, and Why this score shows the reasons. Example text; results vary. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Requests",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-phone-light.webm",
                "poster": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-31-ai-lead-score/lead-score-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings → Requests → Lead scoring",
          "appRoute": "/settings/requests",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Leads from your website",
              "href": "/tutorials/leads-from-your-website"
            },
            {
              "label": "Workspace AI tutorial",
              "href": "/tutorials/workspace-ai"
            }
          ]
        },
        {
          "id": "faster-sign-in",
          "title": "Faster sign-in on the web",
          "body": [
            "Signing in on the web now gets you to Home much sooner. A wait during sign-in is gone and the app loads several things at once. In our tests on a regular 4G connection, Home was ready in under 4 seconds instead of about 12."
          ],
          "highlights": [
            "Home ready sooner after sign-in",
            "No change to how you sign in"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "app.workspace369.com → Sign in",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Mobile and web apps",
              "href": "/features/mobile-app"
            },
            {
              "label": "Workspace369 help docs",
              "href": "https://docs.workspace369.com/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "What is AI lead scoring in Workspace369?",
          "a": "It labels new requests hot, warm or cold with a score out of 5 and a one-line reason, so you can reply to the most promising leads first. Open a request to see Why this score."
        },
        {
          "q": "Which Workspace369 plans include AI lead scoring?",
          "a": "Voyager, Specialist, Commander and Enterprise. On Cadet the setting shows a lock with the plan that includes it."
        },
        {
          "q": "Does AI lead scoring use my AI usage?",
          "a": "Yes. Each scored request uses your monthly AI usage. Obvious spam is marked cold by built-in rules and uses none. If it runs out, new requests stay Not scored until you top up."
        },
        {
          "q": "Can I tell the AI who my ideal customer is?",
          "a": "Yes. Add a short description under Who is your ideal customer? in Settings → Requests → Lead scoring, and new leads are scored against it. It is optional."
        },
        {
          "q": "Does lead scoring score requests I already have?",
          "a": "No. It scores requests that arrive after you turn it on. Older requests show Not scored."
        }
      ]
    },
    {
      "slug": "2026-10-31-october-2026-roundup",
      "date": "2026-10-31",
      "title": "October 2026: Flash Pay, a new proposal builder, deeper booking and AI in your CRM",
      "seoTitle": "Workspace369 October 2026 Updates",
      "summary": "Flash Pay, retainers and more ways for clients to pay; a new proposal builder with packages; deeper online booking; and CRM tools with AI lead scoring and setup.",
      "areas": [
        "billing",
        "proposals",
        "scheduling",
        "clients",
        "ai",
        "inbox",
        "automations",
        "portal",
        "workspace",
        "work"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-31-october-2026-roundup/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a month calendar with tabs, an envelope, coins, a bell, speech bubbles and an amber flame, beside a render of a proposal with packages."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Workspace369 October 2026 updates",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "payments-flash-pay-retainers",
          "title": "Get paid more ways: Flash Pay, payment methods, tips, retainers and autopay",
          "body": [
            "Flash Pay takes a payment on the spot with a QR code or a pay link, and every payment becomes a paid invoice. In Online payments you choose which payment methods clients see through your Stripe account, and you can override them on a single invoice. Clients can add a tip when they pay an invoice online, and tips on in-person Flash Pay card payments are now kept with the payment.",
            "Retainers run as an hour bank, a fixed monthly fee or a prepaid deposit with a live hours meter, and recurring invoices can go on card autopay your client agrees to. After a client pays, they see your note and next-step buttons under the confirmation. You can also void an invoice that was sent but never paid.",
            "Finance → Reports now lists every report in one place, with search."
          ],
          "highlights": [
            "Flash Pay by QR code or pay link",
            "Payment methods per workspace and per invoice",
            "Retainers with a live hours meter",
            "A thank-you note and next steps after payment"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-18-flash-pay/qr-code.webp",
            "width": 1600,
            "height": 1000,
            "alt": "Flash Pay's QR screen in light and dark mode: Apex Auto Spa, Scan to pay, a large QR code above $120.00 and the line Apple Pay, Google Pay or card."
          },
          "imagePhone": null,
          "whereToFind": "Flash Pay in the sidebar; Settings → Online payments → Payment methods; Retainers in the sidebar; Finance → Reports",
          "appRoute": "/flash-pay",
          "plans": "all",
          "links": [
            {
              "label": "Payments",
              "href": "/features/payments"
            },
            {
              "label": "Flash Pay",
              "href": "/changelog/2026-10-18-flash-pay"
            },
            {
              "label": "More ways for clients to pay",
              "href": "/changelog/2026-10-17-more-ways-for-clients-to-pay"
            },
            {
              "label": "Retainers and recurring autopay",
              "href": "/changelog/2026-10-11-retainers-and-recurring-autopay"
            },
            {
              "label": "After-payment page",
              "href": "/changelog/2026-10-21-after-payment-page"
            },
            {
              "label": "Invoice tips",
              "href": "/changelog/2026-10-25-one-time-booking-links-and-invoice-tips"
            },
            {
              "label": "Tips on bookings and Flash Pay",
              "href": "/changelog/2026-10-30-booking-and-flash-pay-tips"
            },
            {
              "label": "Reports home",
              "href": "/changelog/2026-10-29-reports-home"
            }
          ],
          "motion": {
            "layout": "tablet-phone",
            "alt": "On an iPad and an iPhone, Flash Pay opens at 0 dollars, 8, 5 and 00 are tapped to make 85 dollars, and Show QR code opens a QR code for Northstar Studio with Waiting for payment. The screen then shows Payment received for 97.75 dollars from Maya Chen, with a 12.75 dollar tip, invoice 26-142 and New client saved.",
            "caption": "Type the amount, show the QR code, and see Payment received when the customer pays. Example data.",
            "duration": "PT7S",
            "large": {
              "width": 1280,
              "height": 894,
              "light": {
                "mp4": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-light.mp4",
                "webm": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-light.webm",
                "poster": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-dark.mp4",
                "webm": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-dark.webm",
                "poster": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-light.webm",
                "poster": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "no-show-fees-booking-tips",
          "title": "No-show fees and tips for online bookings",
          "body": [
            "Services that take a deposit or full payment can keep the client's card at booking. When an online booking is marked as a no-show, or the client cancels after your cancel notice, you charge the fee they agreed to right from the appointment. Clients can also add a tip when they pay for a booking online."
          ],
          "highlights": [
            "Save card at booking",
            "Charge no-show fee from the appointment",
            "Tips on online bookings"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-29-no-show-fees/save-card.webp",
            "width": 1120,
            "height": 500,
            "alt": "The Save card at booking switch turned on, with Flat amount selected and a no-show fee of 25 US dollars, and a note that you charge it yourself from the appointment."
          },
          "imagePhone": null,
          "whereToFind": "Catalog → open a service → Online Booking → Configure booking; Calendar → open the booking → ⋯ → Charge no-show fee",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "No-show fees",
              "href": "/changelog/2026-10-29-no-show-fees"
            },
            {
              "label": "Tips on bookings and Flash Pay",
              "href": "/changelog/2026-10-30-booking-and-flash-pay-tips"
            }
          ]
        },
        {
          "id": "proposals-builder-packages",
          "title": "A new proposal builder, pick-one packages and Write with AI",
          "body": [
            "The proposal editor has a cleaner toolbar and an easier block picker, and an AI app connected to Workspace369, such as Claude or ChatGPT, can build or restyle a proposal for you. You can offer good, better and best packages your client picks from, and Write with AI drafts a proposal's introduction, scope and line items.",
            "Contract templates have Proposal total and Proposal deposit merge fields, and proposals in Hebrew or Arabic now read right to left, including in the Proposal Builder. A workflow can also make a proposal from a template and email it to the client."
          ],
          "highlights": [
            "Pick-one packages",
            "Write with AI for proposals",
            "Design proposals with your AI assistant",
            "Right to left in Hebrew and Arabic"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/proposal-packages.webp",
            "width": 1600,
            "height": 1200,
            "alt": "The proposal editor on desktop: Scope & investment with Website: Starter, Growth and Signature as options in a Website package, Growth tagged Website · Default, and a total of $8,500.00 that counts only the default."
          },
          "imagePhone": null,
          "whereToFind": "Proposals → open a proposal",
          "appRoute": "/proposals",
          "plans": "all",
          "links": [
            {
              "label": "Proposals",
              "href": "/features/quoting"
            },
            {
              "label": "New proposal builder",
              "href": "/changelog/2026-10-04-proposal-builder"
            },
            {
              "label": "Packages and Write with AI",
              "href": "/changelog/2026-10-26-proposal-packages-and-write-with-ai"
            },
            {
              "label": "Proposals in Hebrew and Arabic",
              "href": "/changelog/2026-10-30-proposals-hebrew-arabic"
            },
            {
              "label": "Send proposal workflow step",
              "href": "/changelog/2026-10-30-workflow-send-proposal-booking-setup"
            }
          ]
        },
        {
          "id": "proposal-covers",
          "title": "Pick a cover for your proposal",
          "body": [
            "Choose a cover from ready-made banner designs or upload your own image. The cover shows at the top of the proposal your client opens and on its PDF."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers.webp",
            "width": 1438,
            "height": 1548,
            "alt": "The Choose a cover dialog: Templates and Images tabs, twelve ready-made banners including Sage Arches, Terracotta Studio, Coastal Layers and Midnight Orbit, and an Upload image button."
          },
          "imagePhone": null,
          "whereToFind": "Proposals → open a proposal → Choose a cover",
          "appRoute": "/proposals",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Proposals",
              "href": "/features/quoting"
            },
            {
              "label": "New proposal builder",
              "href": "/changelog/2026-10-04-proposal-builder"
            }
          ]
        },
        {
          "id": "booking-all-plans",
          "title": "Google events, Meet on every plan, no-show status and services on events",
          "body": [
            "See your Google Calendar events next to your bookings, read-only and visible only to you. Google Meet is available to every workspace, and connecting Google Calendar connects Meet too.",
            "When a client doesn't turn up, set the appointment to No-show, and start a workflow from it. Calendar events also have a Services & products row, so you can say what an appointment is for."
          ],
          "highlights": [
            "Google Calendar events in your calendar",
            "Google Meet on every plan",
            "No-show status on appointments"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/google-events-week.webp",
            "width": 1600,
            "height": 1025,
            "alt": "A week in the Workspace369 calendar with Google events such as Dentist, Gym and School pickup shown next to client meetings like a discovery call and a proposal review."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Integrations → Google Calendar; Calendar → open an appointment",
          "appRoute": "/settings/integrations",
          "plans": "all",
          "links": [
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            },
            {
              "label": "Google events and Meet",
              "href": "/changelog/2026-10-14-google-events-meet-email-domains-and-sms-templates"
            },
            {
              "label": "No-shows and booking limits",
              "href": "/changelog/2026-10-23-booking-limits-and-no-shows"
            },
            {
              "label": "Services on calendar events",
              "href": "/changelog/2026-10-26-proposal-packages-and-write-with-ai"
            }
          ]
        },
        {
          "id": "booking-specialist",
          "title": "Deeper online booking: approval by day, team members, limits, one-time links and a clearer setup",
          "body": [
            "Bookings can need your approval only on the days you pick, and booking pages tag times Instant or Request. Clients can choose their team member, with each person's own service length, and embedded booking can record where new clients came from.",
            "Services get a weekly limit per teammate and bookable dates, a buffer before each booking, and one-time booking links that work once. Configure booking is regrouped so the essentials come first, and guided setup can make your booking page in one step."
          ],
          "highlights": [
            "Approval on the days you pick",
            "Clients choose their team member",
            "Weekly limit and bookable dates",
            "One-time booking links and a buffer before bookings"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-days.webp",
            "width": 1050,
            "height": 540,
            "alt": "The Approval setting for a bookable service on desktop: On these days is chosen, Sun and Sat are selected, a note says bookings on these days wait for your approval and other days book instantly, and Blackout dates sits below."
          },
          "imagePhone": null,
          "whereToFind": "Catalog → open a service → Online Booking → Configure booking; Settings → Booking pages",
          "appRoute": "/settings/booking-pages",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Approval by day",
              "href": "/changelog/2026-10-21-booking-approval-by-day"
            },
            {
              "label": "Booking team members",
              "href": "/changelog/2026-10-02-booking-team-members-and-portal-preview"
            },
            {
              "label": "Booking limits",
              "href": "/changelog/2026-10-23-booking-limits-and-no-shows"
            },
            {
              "label": "One-time links and buffer",
              "href": "/changelog/2026-10-25-one-time-booking-links-and-invoice-tips"
            },
            {
              "label": "Clearer Configure booking",
              "href": "/changelog/2026-10-30-workflow-send-proposal-booking-setup"
            },
            {
              "label": "Booking page in setup",
              "href": "/changelog/2026-10-24-setup-booking-page-and-starter-proposal"
            }
          ]
        },
        {
          "id": "crm-ai",
          "title": "Set up your CRM with AI and turn client notes into follow-ups",
          "body": [
            "Describe your business in a sentence or two and Workspace369 suggests pipeline stages, client fields and lead sources you edit before saving. Choose a note on a client, or paste in a call summary, and AI suggests follow-ups and tasks you tick, edit and date before adding them in one step.",
            "You can also bring your data over with AI Import, which now recognizes HoneyBook, Dubsado, Bonsai, 17hats and Moxie exports."
          ],
          "highlights": [
            "CRM setup with AI",
            "Client notes into follow-ups and tasks",
            "AI Import from five more tools"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-31-turn-notes-into-follow-ups/notes-followups.webp",
            "width": 1600,
            "height": 826,
            "alt": "Follow-ups from notes on desktop, from the note Check-in call with Dana Ruiz for Maple Row Physio: three follow-ups with email and call dates, tasks below, Tasks go to Client work, and Add 5 items."
          },
          "imagePhone": null,
          "whereToFind": "Clients → a client → Notes; Workspace setup → Add your first client",
          "appRoute": "/clients",
          "plans": "all",
          "links": [
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            },
            {
              "label": "CRM setup with AI",
              "href": "/changelog/2026-10-31-crm-setup-with-ai-and-faster-email-reading"
            },
            {
              "label": "Notes into follow-ups",
              "href": "/changelog/2026-10-31-turn-notes-into-follow-ups"
            },
            {
              "label": "AI Import and review requests",
              "href": "/changelog/2026-10-23-review-requests-and-imports"
            }
          ]
        },
        {
          "id": "lead-scoring",
          "title": "AI lead scoring labels new requests hot, warm or cold",
          "body": [
            "Turn on Score new leads with AI in your Requests settings and new requests get a Hot, Warm or Cold label with a short reason, so you reply to the best leads first."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-31-ai-lead-score/lead-score.webp",
            "width": 1600,
            "height": 712,
            "alt": "The Requests list on desktop with the new Score column: Maya Okafor and Daniel Park marked Hot, Priya Nair Warm, Elena Rossi Cold and Sam Whitfield Not scored."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Requests → Lead scoring",
          "appRoute": "/settings/requests",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Leads from your website",
              "href": "/tutorials/leads-from-your-website"
            },
            {
              "label": "AI lead score",
              "href": "/changelog/2026-10-31-ai-lead-score"
            }
          ]
        },
        {
          "id": "autopilot-chat-approvals-chatgpt",
          "title": "AutoPilot chat, approvals for connected AI apps and the ChatGPT plugin",
          "body": [
            "AutoPilot chat has a new look with private chats you can rename, pin and delete, and buttons under its answers for the next step. Messages that Claude, ChatGPT or another connected AI app wants to send wait for your approval.",
            "OpenAI approved and published the Workspace369 plugin for ChatGPT, so you can find it in ChatGPT and connect it."
          ],
          "highlights": [
            "Private, pinnable AutoPilot chats",
            "Approve what a connected AI app sends",
            "Workspace369 plugin in ChatGPT"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat.webp",
            "width": 1120,
            "height": 770,
            "alt": "AutoPilot chat with demo data: the question What's my recurring revenue, and what's at risk this month?, a finished steps row, and an answer with a real table of clients, reasons and amounts at risk."
          },
          "imagePhone": null,
          "whereToFind": "Sidebar → AI AutoPilot → Chat; Settings → Approvals",
          "appRoute": "/ai/chat",
          "plans": "all",
          "links": [
            {
              "label": "Workspace369 MCP",
              "href": "/integrations/mcp"
            },
            {
              "label": "AutoPilot chat redesign",
              "href": "/changelog/2026-10-07-autopilot-chat-redesign"
            },
            {
              "label": "AI approvals",
              "href": "/changelog/2026-10-16-ai-approvals-linkable-settings-new-home"
            },
            {
              "label": "ChatGPT plugin",
              "href": "/changelog/2026-10-30-workspace369-plugin-for-chatgpt"
            }
          ]
        },
        {
          "id": "inbox-email",
          "title": "Client emails in your brand, a calmer Emails inbox and AI writing help",
          "body": [
            "Invoice reminders, proposals, receipts and e-signature emails go out in your workspace's look from your mailbox, with a richer signature editor and a reply box with a real Send button. Emails has a new look with folders in one row, a preview line on every email and one-click archive, and you can step from one email to the next.",
            "The email composer gets AI writing help to draft, improve, shorten or change the tone with Undo, a default sender inbox for each team member, and a bigger composer with full screen. Connecting your own email domain is now three steps."
          ],
          "highlights": [
            "Branded client emails and a signature editor",
            "A quieter Emails list and reader",
            "AI writing help in the composer"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance.webp",
            "width": 1549,
            "height": 1575,
            "alt": "Settings, Email appearance for the demo workspace Apex Auto Spa: Send as Branded or Plain text, eight email layouts with Branded Band selected, Alignment Left or Centered, Logo position Top, Signature or None, and a live preview of an invoice email with a View invoice button."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Email, SMS & phone; Communications → Emails",
          "appRoute": "/communications/inbox",
          "plans": "all",
          "links": [
            {
              "label": "Inbox and communications",
              "href": "/features/communications"
            },
            {
              "label": "Client emails in your brand",
              "href": "/changelog/2026-10-18-client-emails-in-your-brand"
            },
            {
              "label": "Emails redesign",
              "href": "/changelog/2026-10-30-emails-redesign"
            },
            {
              "label": "Read email faster",
              "href": "/changelog/2026-10-31-crm-setup-with-ai-and-faster-email-reading"
            },
            {
              "label": "AI writing help",
              "href": "/changelog/2026-10-29-email-composer-ai-writing-help"
            },
            {
              "label": "Email domain setup",
              "href": "/changelog/2026-10-14-google-events-meet-email-domains-and-sms-templates"
            }
          ]
        },
        {
          "id": "sms-templates",
          "title": "Reusable text messages with a default for each message type",
          "body": [
            "Save texts you send often, with fields that fill in for each client, and see a phone-bubble preview. Choose the text that opens when you text an invoice or other message type."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/sms-templates.webp",
            "width": 1600,
            "height": 1226,
            "alt": "The SMS templates page: a default text for invoice, proposal and appointment texts and request replies, a Browse starters button, and saved templates such as Invoice ready and Appointment reminder with their fields."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Email, SMS & phone → Phone & SMS → SMS templates",
          "appRoute": "/settings/communications",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Inbox and communications",
              "href": "/features/communications"
            },
            {
              "label": "SMS templates",
              "href": "/changelog/2026-10-14-google-events-meet-email-domains-and-sms-templates"
            }
          ]
        },
        {
          "id": "workflows-webhooks",
          "title": "Workflows with decisions, drafts and project triggers, and webhooks on every plan",
          "body": [
            "Workflows get a Check a condition step, waits and business hours, and a live workflow keeps a draft you can test and publish. A new Project completed trigger starts a workflow when a project is done, a Send proposal step emails a proposal, and a workflow can email your review page link after each appointment.",
            "Webhooks now come with every plan, so you can send signed notifications to Zapier, Make, n8n or your own server."
          ],
          "highlights": [
            "Decisions, waits and drafts",
            "Project completed trigger",
            "Ask for a review workflow",
            "Webhooks on every plan"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks.webp",
            "width": 1600,
            "height": 1000,
            "alt": "Settings, Webhooks on desktop for a Cadet workspace: one active Zapier catch-hook endpoint, the count 1 of 50 and a New webhook button."
          },
          "imagePhone": null,
          "whereToFind": "Workflows in the sidebar; Settings → Integrations → Webhooks",
          "appRoute": "/workflows",
          "plans": "all",
          "links": [
            {
              "label": "Workflow Automations",
              "href": "/features/automation"
            },
            {
              "label": "Workflow decisions and drafts",
              "href": "/changelog/2026-10-01-workflows-decisions-and-device-drafts"
            },
            {
              "label": "Project workflows",
              "href": "/changelog/2026-10-25-one-time-booking-links-and-invoice-tips"
            },
            {
              "label": "Review requests",
              "href": "/changelog/2026-10-23-review-requests-and-imports"
            },
            {
              "label": "Webhooks on every plan",
              "href": "/changelog/2026-10-27-webhooks-on-every-plan"
            },
            {
              "label": "Send proposal step",
              "href": "/changelog/2026-10-30-workflow-send-proposal-booking-setup"
            }
          ]
        },
        {
          "id": "portal-messages-styling",
          "title": "Messages on the client portal, and an easier way to style it",
          "body": [
            "Show the Messages module and clients can read their email conversation with you on the portal and reply there, and the reply lands in your Inbox. Set your portal's accent color with a readability check and choose a default theme."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/portal-styling.webp",
            "width": 1154,
            "height": 1990,
            "alt": "Settings, Client portal, Brand tab for the demo workspace Apex Auto Spa: eight looks, the workspace logo, a brand color with a readability warning and Use a darker shade, a palette of seven themes with Corporate selected, and Browse all 35 themes."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Client portal",
          "appRoute": "/settings/client-portal",
          "plans": "all",
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Portal appointments and messages",
              "href": "/changelog/2026-10-30-client-portal-appointments-messages"
            },
            {
              "label": "Portal preview and styling",
              "href": "/changelog/2026-10-02-booking-team-members-and-portal-preview"
            }
          ]
        },
        {
          "id": "portal-appointments",
          "title": "Appointments on the client portal",
          "body": [
            "Show the Appointments module on your client portal and each client sees their own upcoming bookings with you. They can open a booking to reschedule or cancel it within your booking policy."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-30-client-portal-appointments-messages/appointments.webp",
            "width": 1600,
            "height": 1041,
            "alt": "A client portal for Priya Nair showing Appointments: a physiotherapy session and a sports massage at 48 Harbour Street, a video check-in with a Join button and an initial assessment awaiting confirmation, each with Reschedule or cancel."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Channels → Client portal → Clients → Modules → Appointments",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Portal appointments and messages",
              "href": "/changelog/2026-10-30-client-portal-appointments-messages"
            }
          ]
        },
        {
          "id": "hide-powered-by",
          "title": "Hide the Powered by Workspace369 credit",
          "body": [
            "Commander and Enterprise can remove the Powered by Workspace369 line from client portals and booking pages, so clients see only your brand."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-30-client-portal-appointments-messages/hide-powered-by.webp",
            "width": 1600,
            "height": 218,
            "alt": "The Footer section of the client portal’s Brand settings on desktop, with Hide “Powered by Workspace369” switched on and the note that it removes the line from client portals and booking pages."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Channels → Client portal → Brand → Footer",
          "appRoute": null,
          "plans": [
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Portal appointments and messages",
              "href": "/changelog/2026-10-30-client-portal-appointments-messages"
            }
          ]
        },
        {
          "id": "home-setup-unlock",
          "title": "A new Home, guided setup, linkable settings and clearer plan prompts",
          "body": [
            "The new Home puts overdue, waiting and to-sign figures at the top, with an Ask bar for AutoPilot and today's plan, and it is now the default on the web. Guided setup on Home takes a new workspace from empty to its first invoice one step at a time, and each workspace you belong to can have its own light or dark mode and accent color.",
            "Every Settings page on the web has its own address you can bookmark. Locked features now show a preview and the plan that includes them, and unsaved work is kept on your device so you can recover it. Signing in on the web is also faster."
          ],
          "highlights": [
            "The new Home is the default",
            "Guided setup and a theme per workspace",
            "Locked features explain themselves",
            "Interrupted work kept on your device"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-new-home-default/new-home.webp",
            "width": 1600,
            "height": 880,
            "alt": "The new Workspace369 Home on desktop: overdue, waiting and to-sign figures with an AutoPilot summary, the Ask bar with suggested questions, five items that need attention, and today’s schedule."
          },
          "imagePhone": null,
          "whereToFind": "Home; Settings → Appearance",
          "appRoute": "/settings/appearance",
          "plans": "all",
          "links": [
            {
              "label": "Themes and appearance",
              "href": "/features/themes"
            },
            {
              "label": "New Home is the default",
              "href": "/changelog/2026-10-30-new-home-default"
            },
            {
              "label": "Linkable settings and new Home",
              "href": "/changelog/2026-10-16-ai-approvals-linkable-settings-new-home"
            },
            {
              "label": "Guided setup and themes",
              "href": "/changelog/2026-10-08-guided-setup-and-per-workspace-themes"
            },
            {
              "label": "Upgrade prompts and safer drafts",
              "href": "/changelog/2026-10-19-upgrade-prompts-and-safer-drafts"
            },
            {
              "label": "Setup builds your booking page",
              "href": "/changelog/2026-10-24-setup-booking-page-and-starter-proposal"
            },
            {
              "label": "Device drafts",
              "href": "/changelog/2026-10-01-workflows-decisions-and-device-drafts"
            },
            {
              "label": "Faster sign-in",
              "href": "/changelog/2026-10-31-ai-lead-score"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "What's new in Workspace369 in October 2026?",
          "a": "Flash Pay, retainers and more payment methods, a new proposal builder with packages, deeper online booking with no-show fees, Google Meet on every plan, and AI in the CRM with lead scoring and setup."
        },
        {
          "q": "Can I take a payment in person with Workspace369?",
          "a": "Yes. Flash Pay is on every plan: type an amount, show a QR code or send a pay link, and the customer pays by Apple Pay, Google Pay or card. Each payment becomes a paid invoice."
        },
        {
          "q": "Can I charge a no-show fee for online bookings?",
          "a": "Yes, on Specialist and up. Save the client's card at booking, then charge the fee they agreed to from the appointment when it is a no-show or a late cancel."
        },
        {
          "q": "Can my client choose between proposal packages?",
          "a": "Yes, on every plan. Offer good, better and best options on a proposal and your client picks one. Write with AI can also draft the introduction, scope and line items."
        },
        {
          "q": "Does Workspace369 score leads with AI?",
          "a": "Yes, on Voyager and up. Turn on Score new leads with AI in Requests settings and new requests get a Hot, Warm or Cold label with a short reason."
        },
        {
          "q": "Are webhooks available on every plan?",
          "a": "Yes. Webhooks now come with every plan, starting with Cadet, so you can send signed notifications to Zapier, Make, n8n or your own server."
        }
      ]
    },
    {
      "slug": "2026-10-31-add-addresses-on-your-custom-email-domain",
      "date": "2026-10-31",
      "title": "Add addresses on your custom email domain, including send-only ones",
      "seoTitle": "Add Email Addresses on Your Custom Domain",
      "summary": "A new short Add address flow for a verified custom domain, with send-only addresses, inbox.yourdomain receiving that sends as you@yourdomain, and simpler domain setup.",
      "areas": [
        "inbox"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a tall paper mailbox with a smaller mailbox branching off it and an amber envelope flying between them, beside the Add an address step with a name and an address on a custom domain."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Add an address on your custom email domain in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "add-domain-address",
          "title": "Add an address on your custom domain",
          "body": [
            "Once your custom email domain is verified, adding an address is a short flow. In Domains & connections, open your domain and choose Add channel on its Addresses tab; a domain with no address yet offers Add address as its next step. A domain set up to send only skips step 1 and goes straight to the address. Step 1 asks what the address will do: Send and receive, where customers write to it and you answer from your Workspace369 inbox, or Send only, where you send from your domain and replies go to your usual mailbox.",
            "Step 2 is a name only your team sees and the part before the @, with a domain switcher, and it spells out what will happen: who customers write to, what the address sends as, and where replies land. When your domain's own mail stays with Google Workspace or Microsoft 365, mail is received on inbox.yourdomain. Customers keep writing to hello@studio.example, you forward that mailbox to hello@inbox.studio.example, and the address sends as hello@studio.example, with replies coming back to the inbox subdomain. The flow gives forwarding steps for Gmail, Outlook or another provider, and you don't need to change your MX records. Step 3 sets the sender name and inbox color and previews how the email looks to your customer and to your team.",
            "Domain setup changed too. Only send from this domain skips the receiving record altogether: the domain shows as Active with Sends only, and Turn on receiving adds it later. Receiving on inbox.yourdomain is the default, so nobody has to move their main MX records. While you check DNS, the page rechecks itself, and when the domain has no DMARC record the last step suggests a monitoring-only one that doesn't change how your email works. Adding addresses needs inbox settings edit access. A first custom domain is on Cadet and above; a second domain or an extra receive hostname needs Specialist. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Add address opens a short flow: purpose, address, look (the purpose step is skipped on a send-only domain)",
            "Mail is received on inbox.yourdomain while the address sends as you@yourdomain",
            "Send only for a domain that only needs to send, with Turn on receiving later"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-desktop-light-address.webp",
            "width": 1600,
            "height": 825,
            "alt": "The Add an address step on a custom domain showing the name, the address and how mail to the address reaches the inbox."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-phone-light-address.webp",
            "width": 780,
            "height": 1696,
            "alt": "The Add an address step on a phone showing the name, the address and how mail to the address reaches the inbox."
          },
          "whereToFind": "Settings → Email, SMS & phone → Email → Domains & connections → your domain → Addresses → Add channel",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            },
            {
              "label": "Inbox overview guide",
              "href": "https://docs.workspace369.com/v/2026.3/communication/inbox-overview/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "Screen recording of a verified custom domain: Add address opens a short flow where a name and address are chosen, the look is set, and the new address is added.",
            "caption": "Add an address on a verified custom domain in a short flow, choosing send and receive or send only. Example data.",
            "duration": "PT15S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Domains & connections",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-phone-light.webm",
                "poster": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-31-add-addresses-on-your-custom-email-domain/domainaddress-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Can I add hello@ on my own domain if my main mail stays with Google Workspace?",
          "a": "Yes. Mail is received on inbox.yourdomain: customers keep writing to hello@studio.example, you forward it to hello@inbox.studio.example, and the address sends as hello@studio.example. You don't need to change your MX records."
        },
        {
          "q": "What is a send-only address?",
          "a": "A send-only address sends from your domain, and replies go to your usual mailbox instead of the Workspace369 inbox. Turn on receiving later from the domain's page."
        },
        {
          "q": "Where do I add an address?",
          "a": "In Settings → Email, SMS & phone → Email → Domains & connections, open your verified domain and, on its Addresses tab, choose Add channel. A domain with no address yet offers Add address as its next step."
        },
        {
          "q": "Which plans can add addresses on a custom domain?",
          "a": "A first custom domain is on Cadet and above. A second domain or an extra receive hostname needs Specialist, and you need inbox settings edit access."
        },
        {
          "q": "Does the domain check update on its own?",
          "a": "Yes. While the check step is open the page rechecks your DNS itself, then stops once the records are found."
        }
      ]
    },
    {
      "slug": "2026-10-30-workspace369-plugin-for-chatgpt",
      "date": "2026-10-30",
      "title": "Workspace369 is now an approved plugin in ChatGPT",
      "seoTitle": "Workspace369 Plugin for ChatGPT",
      "summary": "OpenAI approved and published the Workspace369 plugin for ChatGPT. Connect it to ask about clients, draft invoices and proposals, and plan your week from ChatGPT.",
      "areas": [
        "ai"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a paper speech bubble with an amber puzzle piece clicking into place and a plug and cable below, beside the Approvals list on a phone, with an invoice approved from ChatGPT."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The Workspace369 plugin for ChatGPT",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "chatgpt-plugin",
          "title": "Find Workspace369 in ChatGPT and connect it",
          "body": [
            "OpenAI has reviewed and approved the Workspace369 plugin, and it is now published for ChatGPT. Find Workspace369 in ChatGPT, connect it, sign in with your Workspace369 account, pick the workspace and choose Approve access. It can take a little while to show up for everyone; if you don't see it yet, look again later.",
            "Once it's connected, ChatGPT can look up clients and their history, draft invoices and proposals with real line items, create and update projects and tasks, check availability and schedule events, log time and expenses, record payments, look through your inbox and search your knowledge base. Try asking which invoices are overdue and which client owes you the most, or how much unbilled time you've logged on your active projects.",
            "It works with your own permissions, so ChatGPT can only see and do what your account can. Anything that sends to a client, such as an invoice, email, text or contract, waits for your approval in Workspace369 unless you turn on Send without asking for that app. An owner or admin turns on Allow AI connections once in Settings → AI connections. The plugin is included on every Workspace369 plan, and each request counts toward your plan's AI usage."
          ],
          "highlights": [
            "Approved and published for ChatGPT",
            "Clients, invoices, proposals, projects, calendar and time",
            "Your own permissions; sends wait for your approval",
            "Included on every plan"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "In ChatGPT, find Workspace369 and connect it. In Workspace369: Settings → AI connections",
          "appRoute": "/settings/ai-connections",
          "plans": "all",
          "links": [
            {
              "label": "Workspace369 MCP and AI connections",
              "href": "/integrations/mcp"
            },
            {
              "label": "Workspace369 plugin for ChatGPT",
              "href": "/blog/workspace369-chatgpt-plugin"
            },
            {
              "label": "Workspace AI tutorial",
              "href": "/tutorials/workspace-ai"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, Settings, Approvals lists a request from ChatGPT to send invoice 26-14 to Maya Okafor. It is opened, showing the email, and Approve and send is chosen. The request moves to Recent as Done.",
            "caption": "When ChatGPT asks to send something, it waits in Approvals until you approve it. Example data.",
            "duration": "PT9S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Approvals",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-phone-light.webm",
                "poster": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-30-workspace369-plugin-for-chatgpt/chatgptapprovals-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Is there a Workspace369 plugin for ChatGPT?",
          "a": "Yes. OpenAI approved and published the Workspace369 plugin for ChatGPT on October 30, 2026. Find Workspace369 in ChatGPT, connect it and sign in with your Workspace369 account."
        },
        {
          "q": "How do I connect Workspace369 to ChatGPT?",
          "a": "An owner or admin first turns on Allow AI connections in Workspace369 under Settings → AI connections. Then find Workspace369 in ChatGPT, connect it, sign in, pick your workspace and choose Approve access."
        },
        {
          "q": "What can ChatGPT do in my Workspace369 workspace?",
          "a": "Look up clients and their history, draft invoices and proposals, create and update projects and tasks, check availability and schedule events, log time and expenses, record payments, look through your inbox and search your knowledge base."
        },
        {
          "q": "Can ChatGPT send invoices or emails without asking me?",
          "a": "No. Anything that sends to a client waits for your approval in Workspace369, unless you turn on Send without asking for that app. ChatGPT also only sees and does what your own account can."
        },
        {
          "q": "Which Workspace369 plans include the ChatGPT plugin?",
          "a": "Every plan, from Cadet to Enterprise. Each request ChatGPT makes counts toward your plan’s AI usage."
        }
      ]
    },
    {
      "slug": "2026-10-30-emails-redesign",
      "date": "2026-10-30",
      "title": "A calmer Emails inbox, with one-click archive and a simpler reader",
      "seoTitle": "A Calmer, Faster Emails Inbox",
      "summary": "Emails has a new look: folders in one row, a preview line on every email, Archive and Mark read on hover, and threads that end in a simple Reply box.",
      "areas": [
        "inbox"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-30-emails-redesign/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a paper magnifying glass over an open envelope with a letter, beside the redesigned Emails inbox on a phone, with a preview line under every subject."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The new Emails inbox in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "emails-list",
          "title": "A quieter list with one-click actions",
          "body": [
            "Emails now opens with your folders in one row of tabs, with search and Compose email on the same row. Counts show only where they need you, such as unread mail in Inbox. On a computer, each email is one line: the sender's initials, the subject and a grey preview of the message, with the time on the right. Unread emails have a dot and a bolder line.",
            "On a computer, point at an email to archive it or mark it read in one click, without opening it. The checkbox appears when you point at a row; on touch screens, tap the sender's initials to select, then use the actions bar. Security warnings such as Suspicious now show in the list on a computer too. In the iPhone app, from its next update, folders are tabs that scroll sideways, with a button for the full folder list."
          ],
          "highlights": [
            "Folders, search and Compose in one row",
            "A preview line on every email",
            "Archive or Mark read on hover",
            "Suspicious warnings in the desktop list"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-emails-redesign/list.webp",
            "width": 1600,
            "height": 1000,
            "alt": "The Emails list on a computer: folder tabs Inbox, Sent, Drafts, Scheduled, Snoozed, Flagged, Spam, Archive and Trash in one row with Search all emails and Compose email. Each email is one line with the sender's initials, subject and a grey preview. One row shows Archive and Mark read on hover, and an Account notice email carries a Suspicious warning."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-30-emails-redesign/list-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The Emails list in the phone layout coming to the iPhone app: folder tabs that scroll sideways, Search all emails, mailbox chips and emails with a preview."
          },
          "whereToFind": "Communications → Emails",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            },
            {
              "label": "Inbox tutorial",
              "href": "/tutorials/inbox"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Emails inbox lists threads with All, Primary, Support and Billing filters. On the desktop an email is archived from its row and an Archived notice appears; then the Re: Homepage revisions: round 2 feedback thread from Maya Okafor opens with an older message folded, and Reply opens a reply to maya@fernlane.example.",
            "caption": "Archive an email from the list, open a thread and start a reply. Example data.",
            "duration": "PT9S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Emails",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-30-emails-redesign/emails-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-30-emails-redesign/emails-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-30-emails-redesign/emails-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-emails-redesign/emails-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-emails-redesign/emails-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-30-emails-redesign/emails-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-30-emails-redesign/emails-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-30-emails-redesign/emails-phone-light.webm",
                "poster": "/images/release-notes/2026-10-30-emails-redesign/emails-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-emails-redesign/emails-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-emails-redesign/emails-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-30-emails-redesign/emails-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "emails-reader",
          "title": "Threads that fold older messages and end in a Reply box",
          "body": [
            "An open thread now starts with its subject, then how many messages it has and who is in it, for example 4 messages · Maya Okafor, You. Older messages fold into one line, Show 1 earlier message, that you can open when you need them.",
            "At the bottom, a Reply to field with the sender's name starts your reply, with Reply all and Forward beside it. The reply composer lines up its To, CC and BCC fields and matches the app's other inputs. It's on the web app now, and the iPhone app gets the new look with its next update."
          ],
          "highlights": [
            "Message count and who's in the thread",
            "Older messages fold into one line",
            "A simple Reply box at the bottom"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-emails-redesign/reader.webp",
            "width": 1600,
            "height": 1000,
            "alt": "An email thread on a computer titled Re: Homepage revisions: round 2 feedback, with 4 messages · Maya Okafor, You, a Show 1 earlier message line, the latest message open with two attachments, and a Reply to Maya Okafor field with Reply all and Forward."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-30-emails-redesign/reader-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The same thread on a phone with the heading, the message count, the folded earlier message and the Reply to Maya Okafor bar with Reply all and Forward."
          },
          "whereToFind": "Communications → Emails → open an email",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            },
            {
              "label": "Connect your email",
              "href": "/tutorials/connect-your-email"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "What changed in the Workspace369 Emails inbox?",
          "a": "Folders sit in one row of tabs with search and Compose, every email shows a preview line, and on a computer you can archive an email or mark it read by pointing at it. Threads fold older messages into one line and end in a simple Reply box."
        },
        {
          "q": "Can I archive an email without opening it?",
          "a": "Yes. On a computer, point at an email in the list and click Archive or Mark read. On a tablet's touch screen, tap the sender's initials to select it and use the actions bar."
        },
        {
          "q": "Which plans have the new Emails inbox?",
          "a": "Every plan. The redesign changes how Emails looks and works; it adds no new limits and changes no data."
        },
        {
          "q": "Is the new Emails look on the iPhone app?",
          "a": "It's on the web app now. The iPhone app gets it, including the phone layout, with its next update."
        }
      ]
    },
    {
      "slug": "2026-10-30-client-portal-appointments-messages",
      "date": "2026-10-30",
      "title": "Appointments and messages on the client portal, and hide the Powered by credit",
      "seoTitle": "Client Portal Appointments and Messages",
      "summary": "Clients can see and reschedule their bookings and message you from the client portal, and Commander and Enterprise can hide the Powered by Workspace369 credit.",
      "areas": [
        "portal",
        "scheduling"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-30-client-portal-appointments-messages/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of an arched doorway holding a calendar page and a speech bubble, beside a phone render of a client portal Appointments list for a physio client."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Client portal appointments and messages in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "portal-appointments",
          "title": "Appointments on the client portal",
          "body": [
            "Show the Appointments module on your client portal and each client sees their own upcoming bookings with you: the date, time, place and status. They can open a booking to reschedule or cancel it within your booking policy, and video bookings with a meeting link have a Join button. Nobody sees anyone else’s bookings.",
            "Appointments is hidden until you show it. The list fills from your online bookings, which come with the Specialist, Commander and Enterprise plans."
          ],
          "highlights": [
            "Clients see their own upcoming bookings",
            "Reschedule or cancel from the portal",
            "Join button on video bookings",
            "Hidden until you show it"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-client-portal-appointments-messages/appointments.webp",
            "width": 1600,
            "height": 1041,
            "alt": "A client portal for Priya Nair showing Appointments: a physiotherapy session and a sports massage at 48 Harbour Street, a video check-in with a Join button and an initial assessment awaiting confirmation, each with Reschedule or cancel."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-30-client-portal-appointments-messages/appointments-phone.webp",
            "width": 780,
            "height": 1640,
            "alt": "The same Appointments list on a phone, with dates on the left and Reschedule or cancel under the bookings."
          },
          "whereToFind": "Settings → Channels → Client portal → Clients → Modules → Appointments",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            }
          ]
        },
        {
          "id": "portal-messages",
          "title": "Messages on the client portal",
          "body": [
            "Show the Messages module and clients can read their email conversation with you on the portal and reply there. A reply lands in your Inbox in the same conversation, just as an email from the client would. Internal notes never show on the portal."
          ],
          "highlights": [
            "Clients read and reply on the portal",
            "Replies land in your Inbox conversation",
            "Internal notes stay private"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Settings → Channels → Client portal → Clients → Modules → Messages",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Client portal tutorial",
              "href": "/tutorials/client-portal"
            },
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            }
          ]
        },
        {
          "id": "hide-powered-by",
          "title": "Hide the Powered by Workspace369 credit",
          "body": [
            "Commander and Enterprise can now remove the “Powered by Workspace369” line from client portals and booking pages, so clients see only your brand. Turn on Hide “Powered by Workspace369” under Footer in the client portal’s Brand settings.",
            "The booking widget you embed on your own website keeps its credit."
          ],
          "highlights": [
            "Removes the credit from portals and booking pages",
            "Commander and Enterprise",
            "One switch under Footer"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-client-portal-appointments-messages/hide-powered-by.webp",
            "width": 1600,
            "height": 218,
            "alt": "The Footer section of the client portal’s Brand settings on desktop, with Hide “Powered by Workspace369” switched on and the note that it removes the line from client portals and booking pages."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-30-client-portal-appointments-messages/hide-powered-by-phone.webp",
            "width": 780,
            "height": 520,
            "alt": "The same Footer switch on a phone, turned on."
          },
          "whereToFind": "Settings → Channels → Client portal → Brand → Footer → Hide “Powered by Workspace369”",
          "appRoute": null,
          "plans": [
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Themes and branding",
              "href": "/features/themes"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can clients see their bookings in the Workspace369 client portal?",
          "a": "Yes. Show the Appointments module in Settings → Channels → Client portal → Clients → Modules, and each client sees their own upcoming bookings and can reschedule or cancel them within your booking policy. The list fills from online bookings (Specialist, Commander, Enterprise)."
        },
        {
          "q": "Which plans have Appointments on the client portal?",
          "a": "The client portal is on every plan, but the Appointments list fills from online bookings, which come with Specialist, Commander and Enterprise."
        },
        {
          "q": "Can clients message me from the client portal?",
          "a": "Yes. Show the Messages module and clients can read their email conversation with you and reply on the portal. Replies land in your Inbox in the same conversation."
        },
        {
          "q": "Can I remove “Powered by Workspace369” from my client portal?",
          "a": "On Commander and Enterprise, yes. Turn on Hide “Powered by Workspace369” under Footer in Settings → Channels → Client portal → Brand. It removes the line from client portals and booking pages."
        },
        {
          "q": "Does hiding the credit remove it from the booking widget on my website?",
          "a": "No. The booking widget you embed on your own website keeps its Powered by Workspace369 credit. Client portals and booking pages on Workspace369 drop it."
        }
      ]
    },
    {
      "slug": "2026-10-30-workflow-send-proposal-booking-setup",
      "date": "2026-10-30",
      "title": "Workflows can send a proposal, and booking setup is easier to scan",
      "seoTitle": "Send Proposals from Workflows",
      "summary": "A workflow can now make a proposal from a template and email it to the client, and a service’s booking settings are regrouped so the essentials come first.",
      "areas": [
        "automations",
        "proposals",
        "scheduling"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of three linked round nodes marked with a document, a calendar and an envelope, ending in an amber paper plane carrying a document, beside the workflow step menu with Send proposal."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Send proposal workflow step in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "workflow-send-proposal",
          "title": "Send proposal step in workflows",
          "body": [
            "Add a Send proposal step to a workflow and it makes a proposal from the template you pick for the run’s client, then emails it to them. It’s in the Document group of the add-step menu on triggers that have a client. The New lead trigger doesn’t offer it."
          ],
          "highlights": [
            "Makes a proposal from your template",
            "Emails it to the run’s client",
            "On triggers that have a client"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/send-proposal.webp",
            "width": 640,
            "height": 680,
            "alt": "A workflow on desktop with the Client created trigger and a Welcome email step, and the add-step menu open below it listing Messages, Tasks and people, Document with Send contract and Send proposal, and Flow."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/send-proposal-phone.webp",
            "width": 390,
            "height": 844,
            "alt": "The Add a step sheet on a phone for a Client created trigger, with Send proposal listed under Send contract."
          },
          "whereToFind": "Workflows → open a workflow → add a step → Document → Send proposal",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Workflow automation",
              "href": "/features/automation"
            },
            {
              "label": "Proposals and quotes",
              "href": "/features/quoting"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, a workflow with the Client created trigger and a Welcome email step. The add button is chosen and Send proposal is picked in the add-step menu. Its panel opens, the Template box is opened and Brand sprint is chosen.",
            "caption": "Add a Send proposal step to a workflow, then pick the proposal template it sends. Example data.",
            "duration": "PT9S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Workflows",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-phone-light.webm",
                "poster": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/wfproposal-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "booking-configurator",
          "title": "A clearer Configure booking page",
          "body": [
            "A service’s Configure booking page has a cleaner layout. A What clients see line sums up the booking under the main switch, and Appointment basics and Hosts and routing stay open. Payments and deposits, bookable dates, availability, client controls, notifications and reminders, intake questions and public instructions sit under Rules and details, each folded into one row that shows its current setting.",
            "Every setting works as before, and nothing about your existing bookings changes."
          ],
          "highlights": [
            "The essentials stay open",
            "Each section shows its current setting",
            "What clients see in one line"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-workflow-send-proposal-booking-setup/configure-booking.webp",
            "width": 780,
            "height": 1620,
            "alt": "The Configure booking page for a Deep tissue massage service: Accept public bookings on, What clients see reading 1h, in person, deposit required, 2 blocked dates, Appointment basics and Hosts and routing open, and Rules and details folded into rows such as Payments and deposits, Deposit 25%, and Availability, Buffers 10 / 15 min, 60 day window."
          },
          "imagePhone": null,
          "whereToFind": "Product Catalog → open a service → Online booking → Configure booking",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Set up a service for online booking",
              "href": "https://docs.workspace369.com/v/2026.3/scheduling/configure-a-service-for-online-booking/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can a Workspace369 workflow send a proposal automatically?",
          "a": "Yes. Add a Send proposal step and the workflow makes a proposal from the template you pick for the run’s client and emails it to them."
        },
        {
          "q": "Which workflow triggers offer the Send proposal step?",
          "a": "Triggers that have a client, under Document in the add-step menu. The New lead trigger doesn’t offer it."
        },
        {
          "q": "Which plans have the Send proposal step?",
          "a": "Every plan. Workflows and proposals are on all Workspace369 plans."
        },
        {
          "q": "Did the booking settings change when the Configure booking page was redesigned?",
          "a": "No. Every setting works as before. The page is regrouped so Appointment basics and Hosts and routing stay open and the other sections sit under Rules and details, each showing its current setting."
        }
      ]
    },
    {
      "slug": "2026-10-30-new-home-default",
      "date": "2026-10-30",
      "title": "The new Home is now the default on the web",
      "seoTitle": "The New Home Is Now the Default",
      "summary": "On the web, everyone now opens to the new Home: what’s overdue, what needs you and today’s plan in one place. (Changed Oct 31: it’s now the only Home.)",
      "areas": [
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-30-new-home-default/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a small paper house with a warm lit open door, beside the new Home on a phone, showing overdue invoices, proposals waiting for a reply and a document to sign."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The new Home in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "new-home-default",
          "title": "The new Home opens for everyone",
          "body": [
            "The new Home is now the default for everyone, including people who already used the classic Home. It puts overdue, waiting and to-sign figures at the top, with an Ask bar for AutoPilot, a list of what needs your attention and today’s plan underneath.",
            "When this shipped you could still pick Classic Home in Settings → Appearance or the Home Customize menu. (Changed Oct 31: the new Home is now the only Home, and the switch is gone.) It’s live on the web now, and the iPhone app gets it with its next update."
          ],
          "highlights": [
            "The new Home is the default on the web",
            "Existing members get it too",
            "Changed Oct 31: the new Home is now the only Home",
            "In the iPhone app with its next update"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-new-home-default/new-home.webp",
            "width": 1600,
            "height": 880,
            "alt": "The new Workspace369 Home on desktop: overdue, waiting and to-sign figures with an AutoPilot summary, the Ask bar with suggested questions, five items that need attention, and today’s schedule."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-30-new-home-default/new-home-phone.webp",
            "width": 780,
            "height": 1640,
            "alt": "The new Home on a phone at large text size: overdue, awaiting-reply and to-sign figures, an AutoPilot summary, and the first items that need attention."
          },
          "whereToFind": "Home",
          "appRoute": "/settings/appearance",
          "plans": "all",
          "links": [
            {
              "label": "Dashboards and reports",
              "href": "/features/analytics"
            },
            {
              "label": "AI chat",
              "href": "/features/ai-chat"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the new Home opens for Maya with 3,200 dollars overdue, 23,800 dollars waiting on a reply and an AutoPilot summary. On the desktop the Period menu opens on This month and the page scrolls through Needs your attention, Today, Money, Tasks, This week, Where money went and Projects. On the iPhone, Show 2 more opens all five items, then it scrolls to Today and Money.",
            "caption": "Home opens with what is overdue, what is waiting and what needs you today. Example text; results vary. Example data.",
            "duration": "PT9S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Home",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-30-new-home-default/home-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-30-new-home-default/home-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-30-new-home-default/home-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-new-home-default/home-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-new-home-default/home-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-30-new-home-default/home-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-30-new-home-default/home-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-30-new-home-default/home-phone-light.webm",
                "poster": "/images/release-notes/2026-10-30-new-home-default/home-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-new-home-default/home-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-new-home-default/home-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-30-new-home-default/home-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Is the new Home on every Workspace369 plan?",
          "a": "Yes. The new Home is the default for everyone on the web, whatever the plan."
        },
        {
          "q": "Can I go back to the classic Home?",
          "a": "Not any more. When this shipped you could switch back in Settings → Appearance. Since Oct 31 the new Home is the only Home for everyone."
        },
        {
          "q": "I already used the classic Home. Will I see the new one?",
          "a": "Yes. On the web, the new Home is now the default for everyone, including people who already used the classic Home. The phone apps get it with their next update."
        },
        {
          "q": "What does the new Home show?",
          "a": "Overdue, waiting and to-sign figures at the top, an Ask bar for AutoPilot, a list of what needs your attention and today’s plan."
        },
        {
          "q": "When does the iPhone app get the new Home?",
          "a": "It’s live on the web now. The iPhone app gets it with its next update."
        }
      ]
    },
    {
      "slug": "2026-10-30-booking-and-flash-pay-tips",
      "date": "2026-10-30",
      "title": "Tips on online bookings and Flash Pay card payments",
      "seoTitle": "Tips on Online Bookings and Flash Pay",
      "summary": "Clients can add a tip when they pay for a booking online, and tips on in-person Flash Pay card payments are now kept with the payment.",
      "areas": [
        "scheduling",
        "billing"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a periwinkle paper tip jar with a blank label and coins dropping in, beside the booking checkout Add a tip choices with a 15 percent tip selected."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Booking and Flash Pay tips in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "booking-tips",
          "title": "Tips on online bookings",
          "body": [
            "Clients can now add a tip when they pay for a booking online. The tip shows when you have turned on Tips at checkout, the same switch that offers tips on invoices, and only on services that take the full price online. Bookings that take a deposit don’t offer a tip.",
            "The tip is its own Tip line in the payment summary and goes to your tips income, so the service price stays the same."
          ],
          "highlights": [
            "Clients add a tip when they pay online",
            "Uses the same Tips at checkout switch as invoices",
            "Only on services paid in full online",
            "The tip is its own line"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/booking-tip.webp",
            "width": 716,
            "height": 780,
            "alt": "The Add a tip step on a booking page: 10, 15 and 20 percent buttons with 15 percent selected, Custom and No tip, and a summary with a 90 dollar service price, a 13 dollar 50 tip and 103 dollars 50 to pay."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/booking-tip-phone.webp",
            "width": 540,
            "height": 740,
            "alt": "A booking checkout on a phone: Add a tip with 15% ($22.50) selected, then Service price $150, Tip $22.50 and Total to pay $172.50 above the Pay and book button. Example data."
          },
          "whereToFind": "Settings → Online payments → Payment methods → Invoices → Tips at checkout",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Payments",
              "href": "/features/payments"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, a client books a 150 dollar Design consultation: they enter their name, email and phone, tap 15 percent under Add a tip, and the summary shows a 150 dollar service price, a 22 dollar 50 tip and 172 dollars 50 to pay, with Pay and book ready.",
            "caption": "The tip is its own line, so the service price stays the same. Example data.",
            "duration": "PT7S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Booking page",
              "sub": "Alder & Finch Studio",
              "light": {
                "mp4": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-phone-light.webm",
                "poster": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-30-booking-and-flash-pay-tips/tips-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "flash-pay-tips",
          "title": "Flash Pay card payments keep the tip",
          "body": [
            "When a customer adds a tip to a card payment you take in person with Flash Pay, the tip is now kept with the payment. Payments taken before this update aren’t changed. Flash Pay is on every plan."
          ],
          "highlights": [
            "Tips on in-person card payments are kept",
            "Earlier payments stay as they were"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Settings → Invoices → Flash Pay",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Payments",
              "href": "/features/payments"
            },
            {
              "label": "Invoices",
              "href": "/features/invoices"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans have tips on online bookings?",
          "a": "Specialist, Commander and Enterprise, the plans with online booking. Flash Pay tips are on every plan."
        },
        {
          "q": "How do I let clients tip when they book online?",
          "a": "Turn on Tips at checkout in Settings → Online payments → Payment methods → Invoices. It’s the same switch that offers tips on invoices. Tips show only on services that take the full price online."
        },
        {
          "q": "Can clients tip on a booking that takes a deposit?",
          "a": "No. Bookings that take a deposit don’t offer a tip."
        },
        {
          "q": "Does a tip change the price of the booking?",
          "a": "No. The tip is its own Tip line and goes to your tips income, so the service price stays the same. The client pays the tip on top."
        },
        {
          "q": "Are tips on Flash Pay card payments kept?",
          "a": "Yes. A tip a customer adds to an in-person Flash Pay card payment is now kept with the payment. Earlier payments aren’t changed."
        }
      ],
      "updated": "2026-10-31"
    },
    {
      "slug": "2026-10-30-proposals-hebrew-arabic",
      "date": "2026-10-30",
      "title": "Proposals in Hebrew and Arabic now read right to left",
      "seoTitle": "Right-to-Left Proposals in Hebrew and Arabic",
      "summary": "Proposals in Hebrew or Arabic now read right to left on the page your client opens, and the Proposal Builder mirrors when the app is in Hebrew or Arabic.",
      "areas": [
        "proposals"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of three paper pages with a curved arrow sweeping right to left, beside a proposal in Arabic on a phone, reading right to left."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Right-to-left proposals in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "proposals-right-to-left",
          "title": "Proposals that read right to left",
          "body": [
            "When your workspace’s document language is Hebrew or Arabic, the proposal page your client opens now reads right to left. The title, the two parties, your message and the line items all mirror, and the page is marked with the proposal’s language. Set it once in Settings → General → Regional → Document language.",
            "The direction follows your workspace’s document language, not the client’s browser, so every client sees the proposal the same way, and proposals in English stay left to right. Section labels such as Prepared for and Total stay in English, and PDFs and emails are unchanged. On narrow phone screens, line items in the classic layout now stack."
          ],
          "highlights": [
            "Hebrew and Arabic read right to left",
            "Follows your document language",
            "English proposals stay left to right",
            "Classic line items stack on narrow phones"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/proposal-rtl.webp",
            "width": 1100,
            "height": 1000,
            "alt": "A Hebrew proposal page reading right to left: the title, Prepared for and Prepared by, the message and the line items with shekel amounts all mirrored, with the totals block and amounts on the left."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/proposal-rtl-phone.webp",
            "width": 780,
            "height": 1440,
            "alt": "An Arabic proposal on a phone at larger text, reading right to left from the title and both parties to the message."
          },
          "whereToFind": "Settings → General → Regional → Document language",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Proposals and quoting",
              "href": "/features/quoting"
            },
            {
              "label": "Proposals step by step",
              "href": "/tutorials/proposals-step-by-step"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, a Hebrew proposal from a design studio to a bakery reads right to left: the title, the two parties and the message are right-aligned, then the page scrolls through four Hebrew line items with shekel prices to a total of 8,800 shekels and the Accept proposal button. Labels such as From, Line items and Total stay in English. The dark versions show the white proposal on a dark page background.",
            "caption": "A Hebrew proposal reads right to left on the page your client opens, with prices the right way round. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Proposal",
              "sub": "369.dev",
              "light": {
                "mp4": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-phone-light.webm",
                "poster": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/rtl-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "proposal-builder-right-to-left",
          "title": "The Proposal Builder in Hebrew and Arabic",
          "body": [
            "When the app itself is in Hebrew or Arabic, the Proposal Builder now reads right to left too. The header, the two parties, the line items, the totals and the design panel all mirror, and email addresses and phone numbers still read left to right. Change the app’s language in Settings → You → Appearance → Language.",
            "Choosing the client now works the way it does on invoices. Recent clients come first, search covers your whole workspace, and you can create a new client without leaving the proposal if you’re allowed to add clients. On a computer or tablet the list opens under the client’s name, and on a phone it opens as a sheet. Line items and totals keep the same amounts in every language. It is on every plan, on the web app now, and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "The builder mirrors in Hebrew and Arabic",
            "Recent clients first, same as invoices",
            "Create a client from the proposal",
            "Same totals in every language"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/builder-client-menu.webp",
            "width": 1434,
            "height": 1470,
            "alt": "The Proposal Builder in Hebrew on a computer: the header and the proposal read right to left, and the client menu under Prepared for lists Recent clients first, then all clients, with a search field at the top. Example data."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-30-proposals-hebrew-arabic/builder-rtl-phone.webp",
            "width": 780,
            "height": 1480,
            "alt": "The Proposal Builder in Arabic on a phone at larger text: the top bar with Send and Preview, then the proposal title and both parties aligned to the right."
          },
          "whereToFind": "Proposals → open a proposal",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Proposals and quoting",
              "href": "/features/quoting"
            },
            {
              "label": "Proposals step by step",
              "href": "/tutorials/proposals-step-by-step"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans can send proposals in Hebrew or Arabic?",
          "a": "Every plan. Proposals read right to left on any plan once the workspace’s document language is Hebrew or Arabic."
        },
        {
          "q": "How do I make my proposals read right to left?",
          "a": "Set your workspace’s document language to Hebrew or Arabic in Settings → General → Regional → Document language. The proposal page your client opens then reads right to left."
        },
        {
          "q": "Does the direction follow my client’s browser language?",
          "a": "No. It follows your workspace’s document language, so every client sees the proposal the same way. Proposals in English stay left to right."
        },
        {
          "q": "Are proposal PDFs and emails right to left too?",
          "a": "No. This update covers the proposal page your client opens. PDFs and emails are unchanged, and labels such as Prepared for and Total stay in English."
        },
        {
          "q": "What changed for proposal line items on phones?",
          "a": "In the classic layout, line items now stack on narrow phone screens."
        },
        {
          "q": "Does the Proposal Builder work in Hebrew and Arabic?",
          "a": "Yes. When the app is in Hebrew or Arabic, the builder reads right to left: the header, parties, line items, totals and design panel all mirror. Amounts and totals stay the same in every language."
        }
      ],
      "updated": "2026-10-31"
    },
    {
      "slug": "2026-10-29-reports-home",
      "date": "2026-10-29",
      "title": "One Reports home for every report",
      "seoTitle": "All Your Business Reports in One Place",
      "summary": "Finance → Reports now lists every report in one place, with search and, where your plan includes them, headline figures on the main accounting reports.",
      "areas": [
        "billing"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-29-reports-home/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of five paper chart tiles, horizontal bars, a ring, a line and a pie, beside the Reports home on a phone, with a Find a report search and report cards."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The Reports home in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "reports-home",
          "title": "Every report in one place",
          "body": [
            "Reports now has its own place under Finance in the sidebar. It lists every report by group, with a search box to find one by name. The Accounting group shows eight reports first, with Show all for the rest. Four of them show a headline figure on the card when your books have data: net income on Profit & Loss, cash on the Balance Sheet, what clients owe you on AR Aging and what you owe on AP aging. Other cards show a short description. AR Aging is on Specialist and up, and Profit & Loss, the Balance Sheet and AP aging on Commander and Enterprise.",
            "Reports that live elsewhere in the app, like Inbox analytics, Page analytics and Time reports, are linked at the bottom so you can open them from the same page. The Reports button in Accounting now opens this page too, and reports your plan doesn't include show a lock with the plan that includes them. Bookings and Team time are listed as coming later and can't be opened yet."
          ],
          "highlights": [
            "Every report in one list",
            "Search reports by name",
            "Headline figures on four accounting reports",
            "Links to inbox, page and time reports"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-29-reports-home/reports-home.webp",
            "width": 2304,
            "height": 1620,
            "alt": "The Reports home on desktop: a Find a report search, eight Accounting cards (Profit & Loss with 11,725 dollars net income, Balance Sheet, AR Aging, AP aging and four more) with Show all 13, a Coming later group with Bookings and Team time, and Also in the app links to Inbox analytics, Campaign results, Page analytics and Time reports."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-29-reports-home/reports-home-phone.webp",
            "width": 780,
            "height": 1712,
            "alt": "The Reports home on a phone at larger text: the search box and Accounting cards, with figures on Profit & Loss, Balance Sheet, AR Aging and AP aging."
          },
          "whereToFind": "Finance → Reports",
          "appRoute": "/reports",
          "plans": "all",
          "links": [
            {
              "label": "Dashboards and reports",
              "href": "/features/analytics"
            },
            {
              "label": "Accounting",
              "href": "/features/accounting"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, on a plan with full Accounting, the Reports page under Finance shows the heading Every report in one place and a Find a report box. The Accounting group starts with four cards that show a figure: Profit & Loss with 11,725 dollars net income, Balance Sheet with 64,218 dollars in cash, AR Aging with 7,940 dollars owed to you and AP aging with 2,311 dollars to pay, then cards with a short description. On the desktop, typing prof in the search box narrows the list to the profit reports, then Show all 13 opens the rest of the Accounting reports. On the iPhone the cards stack in one column and Show all 13 opens the full list.",
            "caption": "Every report in one place, shown on a plan with full Accounting. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Reports",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-29-reports-home/reports-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-29-reports-home/reports-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-29-reports-home/reports-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-29-reports-home/reports-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-29-reports-home/reports-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-29-reports-home/reports-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-29-reports-home/reports-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-29-reports-home/reports-phone-light.webm",
                "poster": "/images/release-notes/2026-10-29-reports-home/reports-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-29-reports-home/reports-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-29-reports-home/reports-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-29-reports-home/reports-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans include the Reports home?",
          "a": "Every plan. Reports that your plan doesn't include show a lock with the plan that includes them."
        },
        {
          "q": "Where do I find all my reports?",
          "a": "Go to Finance → Reports in the sidebar. It lists every report by group, and the Reports button in Accounting now opens this page too."
        },
        {
          "q": "Can I search for a report by name?",
          "a": "Yes. The Reports page has a search box to find a report by name."
        },
        {
          "q": "Which reports show a headline figure on the card?",
          "a": "Four accounting reports show one when your books have data: net income on Profit & Loss, cash on the Balance Sheet, what clients owe you on AR Aging (Specialist and up) and what you owe on AP aging. Profit & Loss, the Balance Sheet and AP aging are on Commander and Enterprise."
        },
        {
          "q": "Can I open reports like Inbox analytics from Reports?",
          "a": "Yes. Inbox analytics, Page analytics and Time reports are linked at the bottom of the page so you can open them from there."
        },
        {
          "q": "Are Bookings and Team time reports available?",
          "a": "They are listed as coming later and can't be opened yet."
        }
      ]
    },
    {
      "slug": "2026-10-29-no-show-fees",
      "date": "2026-10-29",
      "updated": "2026-10-30",
      "title": "No-show fees for online bookings",
      "seoTitle": "No-Show Fees for Online Booking",
      "summary": "Keep the client's card when they book, then charge the no-show or late-cancel fee they agreed to, right from the appointment.",
      "areas": [
        "scheduling",
        "billing"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-29-no-show-fees/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a calendar page with a credit card clipped on and an hourglass, beside the Charge no-show fee confirmation on a phone."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "No-show fees in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "save-card-at-booking",
          "title": "Save card at booking",
          "body": [
            "Services that take a deposit or full payment when clients book can now keep the client's card for a no-show fee. The workspace owner turns on Save card at booking in the service's Payments and deposits settings, then sets a flat amount, or a percentage of the price with an optional maximum.",
            "Clients see the fee and agree to it before they pay. Each booking keeps the fee its client was shown, so changing the fee later doesn't change bookings already made. The owner accepts the no-show fee terms once, the first time it's turned on."
          ],
          "highlights": [
            "Flat amount or a percentage of the price",
            "Optional maximum for a percentage fee",
            "Clients agree to the fee before they pay",
            "Each booking keeps the fee its client saw"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-29-no-show-fees/save-card.webp",
            "width": 1120,
            "height": 500,
            "alt": "The Save card at booking switch turned on, with Flat amount selected and a no-show fee of 25 US dollars, and a note that you charge it yourself from the appointment."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-29-no-show-fees/save-card-phone.webp",
            "width": 780,
            "height": 790,
            "alt": "Save card at booking on a phone at larger text: the switch on, Flat amount, a 25 dollar no-show fee and the accepted terms line."
          },
          "motion": {
            "layout": "tablet-phone",
            "alt": "In a service’s Configure booking page on an iPad and an iPhone, the options open, Save card at booking is switched on under Payments & Deposits, and a 25 dollar no-show fee is typed in.",
            "caption": "Open the booking options, switch on Save card at booking and type the fee. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 894,
              "light": {
                "mp4": "/images/release-notes/2026-10-29-no-show-fees/save-card-ipad-light.mp4",
                "webm": "/images/release-notes/2026-10-29-no-show-fees/save-card-ipad-light.webm",
                "poster": "/images/release-notes/2026-10-29-no-show-fees/save-card-ipad-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-29-no-show-fees/save-card-ipad-dark.mp4",
                "webm": "/images/release-notes/2026-10-29-no-show-fees/save-card-ipad-dark.webm",
                "poster": "/images/release-notes/2026-10-29-no-show-fees/save-card-ipad-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-29-no-show-fees/save-card-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-29-no-show-fees/save-card-phone-light.webm",
                "poster": "/images/release-notes/2026-10-29-no-show-fees/save-card-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-29-no-show-fees/save-card-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-29-no-show-fees/save-card-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-29-no-show-fees/save-card-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Product Catalog → open a service → Online booking → Configure booking → Rules and details → Payments and deposits → Save card at booking",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Set up a service for online booking",
              "href": "https://docs.workspace369.com/v/2026.3/scheduling/configure-a-service-for-online-booking/"
            }
          ]
        },
        {
          "id": "charge-no-show-fee",
          "title": "Charge the fee from the appointment",
          "body": [
            "When an online booking is marked as a no-show, or the client cancels after your cancel notice, open it in the calendar and choose Charge no-show fee from the ⋯ menu. Before anything is charged, Workspace369 shows the amount, the reason and the card saved at booking.",
            "An invoice is recorded for every charge, so it shows up with the client's other payments. Only people who can record invoice payments see the action, and a fee that has already been charged can't be charged again. If the card is declined, you can try again later."
          ],
          "highlights": [
            "One action from the appointment",
            "Shows the amount, reason and card first",
            "An invoice is recorded for the charge",
            "One fee per booking, never double-charged"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-29-no-show-fees/charge-fee.webp",
            "width": 1080,
            "height": 570,
            "alt": "The Charge no-show fee dialog: the appointment is marked as a no-show, charge 25 dollars to Visa ending 4242, the card saved at booking, with Charge and Cancel buttons."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-29-no-show-fees/charge-fee-phone.webp",
            "width": 780,
            "height": 780,
            "alt": "The Charge no-show fee dialog on a phone, with the amount, the saved Visa card and a Charge 25 dollars button."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, a Physio assessment marked No-show is opened from the calendar, its ⋯ menu shows Charge no-show fee, the dialog shows 25 dollars to the saved Visa card, and Charge 25 dollars ends on Fee charged: $25.00.",
            "caption": "Open the booking's ⋯ menu, choose Charge no-show fee, and check the amount and card before you charge. Example data.",
            "duration": "PT8S",
            "large": {
              "title": "Calendar",
              "sub": "Physio assessment · No-show",
              "width": 1280,
              "height": 660,
              "light": {
                "mp4": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-phone-light.webm",
                "poster": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-29-no-show-fees/charge-cal-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Calendar → open the booking → ⋯ → Charge no-show fee",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online payments",
              "href": "/features/payments"
            },
            {
              "label": "Invoices and payments guide",
              "href": "https://docs.workspace369.com/v/2026.3/finance/invoices-and-payments/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans include no-show fees?",
          "a": "Specialist, Commander and Enterprise. Both parts, saving the card at booking and charging the fee, are on those plans."
        },
        {
          "q": "Who can turn on no-show fees for a service?",
          "a": "The workspace owner, in the service’s Payments and deposits settings. The owner accepts the no-show fee terms once, the first time it’s turned on."
        },
        {
          "q": "Do clients agree to the no-show fee before they book?",
          "a": "Yes. Clients see the fee and agree to it before they pay, and each booking keeps the fee its client was shown, even if you change it later."
        },
        {
          "q": "Can I charge a no-show fee on a booking that took no payment?",
          "a": "No. The fee is charged to the card saved at booking, so it works on services that take a deposit or full payment online."
        },
        {
          "q": "What if the client’s card is declined?",
          "a": "You can try again later from the same appointment. A fee that has already been charged can’t be charged again."
        },
        {
          "q": "Does a no-show fee show up in my invoices?",
          "a": "Yes. An invoice is recorded for every charge, so it shows up with the client’s other payments."
        }
      ]
    },
    {
      "slug": "2026-10-29-email-composer-ai-writing-help",
      "date": "2026-10-29",
      "updated": "2026-11-04",
      "title": "AI writing help in the email composer and your own default sender",
      "seoTitle": "AI Writing Help in the Email Composer",
      "summary": "Draft, improve, shorten or change the tone of an email with AI, undo any change, choose the inbox your new emails start from, and write in a bigger composer with full screen.",
      "areas": [
        "inbox",
        "ai"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a quill writing on a page with an undo arrow, beside the email composer's AI menu with Write for me, Improve writing and tone choices."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "AI writing help in the Workspace369 email composer",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "composer-ai",
          "title": "AI writing help: draft, edit and change the tone, with Undo",
          "body": [
            "The ✨ Write with AI button in the email composer now opens a full set of writing tools. Write for me drafts the email for you, and fills in the subject if it's empty. Under Edit your draft you can pick Improve writing, Fix spelling and grammar, Make shorter or Make longer, and under Change tone you can make it Friendly, Professional or Direct. On a phone the button shows just the ✨ icon, and the same actions open in a sheet. The edits need some text to work on, so they light up once you've started writing.",
            "After each change a bar reads Done, with the action's name, and offers Undo and Try again. Undo puts back exactly what you had, and Try again runs the same action again on your original text. The bar goes away as soon as you start typing, so Undo never throws away new writing. Your signature is kept out of the AI and added back after, so it's never doubled, and merge fields such as the client's first name stay in place. Writing help is on for every workspace unless an admin turns off Writing assistance in Inbox settings → Inbox AI assistance; when it's off, the Write with AI button doesn't show in the composer. It uses your workspace's AI usage like other AI features, and if you run out you'll see \"You've reached your AI usage limit\" with a way to add more. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Write for me drafts the email and its subject",
            "Improve, fix grammar, shorten or lengthen",
            "Friendly, Professional or Direct tone",
            "Undo or Try again after every change"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai.webp",
            "width": 1736,
            "height": 1616,
            "alt": "The email composer on desktop with the Write with AI menu open: Write for me, then Edit your draft with Improve writing, Fix spelling and grammar, Make shorter and Make longer, then Change tone with Friendly, Professional and Direct."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-phone.webp",
            "width": 780,
            "height": 1568,
            "alt": "The AI assist sheet on a phone with the same actions: Write for me, four edits and three tones."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and a phone, a new email from Fernhill Design to maya@lumen-studio.example with the subject Spring brand refresh: quote has a rough one-line body, hi maya, quote for the spring brand refresh is attached. can we start monday? thx, above the signature Jordan, Fernhill Design. On the desktop, Write with AI in the bottom toolbar opens a menu with Write for me, Edit your draft (Improve writing, Fix spelling and grammar, Make shorter, Make longer) and Change tone (Friendly, Professional, Direct). On a phone, the sparkle icon in the bottom toolbar opens an AI assist sheet with the same options. Picking Professional rewrites the body as: Hi Maya, Please find the quote for the spring brand refresh attached. Could we start on Monday? The signature stays the same below it. A bar above the text reads Done: Professional with Undo and Try again. Example text; results vary.",
            "caption": "Change the tone of a rough draft, with Undo one tap away. Example text; results vary. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "New Email",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-phone-light.webm",
                "poster": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-ai-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Any new email → Write with AI in the bottom toolbar (the ✨ icon on a phone)",
          "appRoute": "/communications/inbox",
          "plans": "all",
          "links": [
            {
              "label": "Communications",
              "href": "/features/communications"
            },
            {
              "label": "AI in your workspace",
              "href": "/tutorials/workspace-ai"
            }
          ]
        },
        {
          "id": "default-sender",
          "title": "Your own default sender inbox",
          "body": [
            "Each team member can now choose the inbox their new emails start from, without changing it for everyone else. Open the From menu in any new email: it lists every inbox you can send from with its name and address, tagged Your default and Team default, and Always send from, followed by the inbox's address, saves the one you picked as your default. You can also set it in Inbox settings → Inboxes → Your default sender, which only you see. Both appear once your workspace has two or more inboxes.",
            "A restored draft keeps the inbox it was written from. Otherwise new emails start from your default, then the team default. If your default inbox is removed or you lose access to it, new emails start from the team default again, or from your oldest inbox if there's no team default. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Pick your own default sender inbox",
            "From menu shows each inbox's name and address",
            "Your default and Team default tags",
            "Only you see your setting"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/default-sender.webp",
            "width": 1736,
            "height": 748,
            "alt": "The email composer's From menu, Send from: Apex Auto Spa tagged Team default and Maria at Apex tagged Your default with a check mark."
          },
          "imagePhone": null,
          "whereToFind": "Any new email → From menu, or Inbox settings → Inboxes → Your default sender",
          "appRoute": "/communications/inbox",
          "plans": "all",
          "links": [
            {
              "label": "Communications",
              "href": "/features/communications"
            },
            {
              "label": "Inbox tutorial",
              "href": "/tutorials/inbox"
            }
          ]
        },
        {
          "id": "bigger-composer",
          "title": "A bigger composer with full screen",
          "body": [
            "In the web app on a computer or tablet, the email composer now opens as a wide window in the middle of the screen instead of a narrow panel on the right, so your message has room and the From address shows in full. The full screen button next to Close, or ⌘/Ctrl+Shift+F, fills the window and keeps your message in one easy-to-read column, and the composer remembers your choice on that device.",
            "⌘/Ctrl+Enter sends the email whenever the Send button would. On a phone, and in the iPhone app, the composer keeps the layout you know. (Changed Nov 3: in the web app on a phone, the message now uses the full width of the screen and the formatting buttons show only while you're typing. The iPhone app gets this with its next update. See the note A tidier New email window.)"
          ],
          "highlights": [
            "Opens wide in the middle of the screen",
            "Full screen with ⌘/Ctrl+Shift+F",
            "⌘/Ctrl+Enter to send",
            "Built for computers and tablets"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-29-email-composer-ai-writing-help/composer-full-screen.webp",
            "width": 2760,
            "height": 1680,
            "alt": "The email composer in full screen: the From, To, Bcc and Subject fields and the message in one centred column, with Write with AI and Send Email along the bottom."
          },
          "imagePhone": null,
          "whereToFind": "Any new email in the web app on a computer or tablet → the full screen button next to Close",
          "appRoute": "/communications/inbox",
          "plans": "all",
          "links": [
            {
              "label": "Communications",
              "href": "/features/communications"
            },
            {
              "label": "AI in your workspace",
              "href": "/tutorials/workspace-ai"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Does Workspace369 have AI writing help for emails?",
          "a": "Yes. The Write with AI button in the email composer can draft an email for you, improve it, fix spelling and grammar, make it shorter or longer, or change the tone to Friendly, Professional or Direct."
        },
        {
          "q": "Which plans include AI writing help in the email composer?",
          "a": "Every plan. It is on for every workspace unless an admin turns off Writing assistance in Inbox settings → Inbox AI assistance."
        },
        {
          "q": "Can I undo a change the AI makes to my email?",
          "a": "Yes. After each change a bar offers Undo, which puts back exactly what you had, and Try again, which runs the same action again on your original text. The bar goes away as soon as you start typing, so Undo never throws away new writing."
        },
        {
          "q": "Does the AI write over my email signature?",
          "a": "No. Your signature is kept out of the AI and added back afterwards, so it is never doubled, and merge fields such as the client's first name stay in place."
        },
        {
          "q": "Can each team member choose which inbox their new emails send from?",
          "a": "Yes. Open the From menu in a new email and choose Always send from, or set it in Inbox settings → Inboxes → Your default sender. Only you see your setting, and the option appears once your workspace has two or more inboxes."
        },
        {
          "q": "Can I write emails in a bigger window or full screen?",
          "a": "Yes, in the web app on a computer or tablet. The composer opens as a wide window, and the full screen button next to Close, or ⌘/Ctrl+Shift+F, fills the window."
        }
      ]
    },
    {
      "slug": "2026-10-27-webhooks-on-every-plan",
      "date": "2026-10-27",
      "title": "Webhooks now come with every plan",
      "seoTitle": "Webhooks on Every Plan",
      "summary": "Send signed webhooks to Zapier, Make, n8n or your own server on every plan, starting with Cadet. The Builder API stays on Specialist and up. (Changed Nov 3: now every plan.)",
      "areas": [
        "automations"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-27-webhooks-on-every-plan/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of an amber paper hook catching envelopes and lightning bolts above three connected nodes, beside the Webhooks screen on a phone, listing one active endpoint."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Webhooks on every Workspace369 plan",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "webhooks-every-plan",
          "title": "Webhooks on every plan, from Cadet up",
          "body": [
            "Webhooks used to start on Specialist. They now come with every plan, so a Cadet or Voyager workspace can send a signed notification to another tool whenever something happens, such as an invoice being paid, a proposal accepted or a new lead coming in.",
            "Open Settings, then Webhooks, choose New webhook, paste the URL your tool gave you and pick the events it should receive. That is all Zapier, Make and n8n need for a catch-hook trigger. Each delivery is signed with a secret you can rotate, so your endpoint can check it came from Workspace369, and a workspace can have up to 50 webhooks.",
            "The Builder API, the REST API at /v1 that lets your own code and tools such as Zapier call Workspace369 with a personal access token, stays on Specialist and up. (Changed Nov 3: now every plan.)"
          ],
          "highlights": [
            "Every plan, starting with Cadet",
            "Works as a Zapier, Make or n8n catch-hook trigger",
            "Signed deliveries with a secret you can rotate",
            "Up to 50 webhooks per workspace"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks.webp",
            "width": 1600,
            "height": 1000,
            "alt": "Settings, Webhooks on desktop for a Cadet workspace: one active Zapier catch-hook endpoint, the count 1 of 50 and a New webhook button."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-phone.webp",
            "width": 780,
            "height": 1280,
            "alt": "The Webhooks page on a phone at large text: the Zapier endpoint marked Active, 1 of 50 endpoints, and New webhook under it."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and a phone, in a Cadet workspace, the Webhooks page starts with No webhooks yet. New webhook opens a form: the endpoint URL https://hooks.fernhill-design.example/w369 is typed in, then under Events, Paid is picked under Invoices and Accepted under Proposals, and the counter reads 2 selected. Create webhook shows a Signing secret dialog with a masked secret and Copy and Done. After Done, the list shows the new endpoint with 2 events, Invoices and Proposals, and an Active label.",
            "caption": "Add a signed webhook on Cadet: pick the events, copy the secret once, and it’s active. Example data.",
            "duration": "PT6S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Webhooks",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-phone-light.webm",
                "poster": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-27-webhooks-on-every-plan/webhooks-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings → Webhooks → New webhook",
          "appRoute": "/settings/webhooks",
          "plans": "all",
          "links": [
            {
              "label": "Webhooks",
              "href": "/integrations/webhooks"
            },
            {
              "label": "Webhooks reference",
              "href": "https://docs.workspace369.com/v/2026.3/build-with-ai/webhooks-reference/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans include webhooks?",
          "a": "Every plan, starting with Cadet. Webhooks used to start on Specialist."
        },
        {
          "q": "Can I use Workspace369 webhooks with Zapier, Make or n8n?",
          "a": "Yes. Create a webhook, paste the URL your tool gave you and pick the events it should receive. That is all Zapier, Make and n8n need for a catch-hook trigger."
        },
        {
          "q": "Where do I set up a webhook in Workspace369?",
          "a": "Go to Settings → Webhooks and choose New webhook. Pick the events you want, such as an invoice being paid, a proposal accepted or a new lead."
        },
        {
          "q": "Are Workspace369 webhooks signed?",
          "a": "Yes. Each delivery is signed with a secret you can rotate, so your endpoint can check the request came from Workspace369."
        },
        {
          "q": "How many webhooks can I have?",
          "a": "A workspace can have up to 50 webhooks."
        },
        {
          "q": "Is the Builder API also on every plan?",
          "a": "No. The Builder API, the REST API at /v1, stays on Specialist and up. Only webhooks moved to every plan. (Changed Nov 3: now every plan.)"
        }
      ],
      "updated": "2026-11-03"
    },
    {
      "slug": "2026-10-26-proposal-packages-and-write-with-ai",
      "date": "2026-10-26",
      "title": "Pick-one proposal packages, Write with AI for proposals and services on calendar events",
      "seoTitle": "Proposal Packages and Write with AI",
      "summary": "Offer good, better and best packages your client picks from, draft a proposal with AI, put proposal totals in contracts and show services on calendar events.",
      "areas": [
        "proposals",
        "ai",
        "scheduling"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of three paper gift boxes in small, medium and large sizes, the middle one with an amber bow, beside a proposal on a phone with three website packages and one selected."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Proposal packages and Write with AI in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "proposal-packages",
          "title": "Pick-one packages: let your client choose good, better or best",
          "body": [
            "You can now offer alternatives on a proposal, such as Starter, Growth and Signature versions of a website, and let your client pick one. In the proposal editor, open a line item's ⋯ menu and choose Offer as package option…, then name a new package or add the line to one you already have. Each option shows the package name and a radio button. The filled radio is the default option, the one the proposal opens with, and Make default option in the ⋯ menu changes it. Only the default counts toward the totals you see in the editor.",
            "On the proposal page, each option is tagged with the package name and Choose one, and the default is already picked. When your client picks another option, the subtotal, discount, tax and total update to match, and so does a deposit set as a percentage; a fixed deposit stays the same amount. The options they didn't pick are dimmed rather than crossed out. Their choice goes with the proposal when they accept it and when they pay the deposit. Packages sit alongside optional add-ons, so one proposal can have both. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Group alternatives into a named package",
            "Choose the default option the proposal opens with",
            "Totals, and a percentage deposit, follow the client's pick",
            "Works alongside optional add-ons"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/proposal-packages.webp",
            "width": 1600,
            "height": 1200,
            "alt": "The proposal editor on desktop: Scope & investment with Website: Starter, Growth and Signature as options in a Website package, Growth tagged Website · Default, and a total of $8,500.00 that counts only the default."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/proposal-packages-phone.webp",
            "width": 780,
            "height": 1280,
            "alt": "The client's proposal page on a phone: Website: Starter, Growth and Signature each with a radio button and a Website · Choose one tag, Signature picked, the other two dimmed, and the total updated to $11,300.00."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and a phone, a client's proposal page lists Discovery and content plan at $1,200.00, then three options each tagged Website · Choose one: Website: Starter at $2,400.00, Website: Growth at $4,800.00 and Website: Signature at $8,900.00. Growth is picked by default, so the subtotal for 2 items is $6,000.00, tax at 10% is $600.00 and the total is $6,600.00. The client picks Signature instead, and the subtotal changes to $10,100.00, tax to $1,010.00 and the total to $11,110.00, in the table and in the bar with Ask, Decline and Accept proposal.",
            "caption": "Your client picks the package; the total updates before they accept. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Proposal",
              "sub": "369.dev",
              "light": {
                "mp4": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-phone-light.webm",
                "poster": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/pkg-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Proposals → open a proposal → a line item's ⋯ menu → Offer as package option…",
          "appRoute": "/proposals",
          "plans": "all",
          "links": [
            {
              "label": "Proposals and quoting",
              "href": "/features/quoting"
            },
            {
              "label": "Proposals step by step",
              "href": "/tutorials/proposals-step-by-step"
            }
          ]
        },
        {
          "id": "write-with-ai",
          "title": "Write with AI: draft a proposal's introduction, scope and line items",
          "body": [
            "The proposal editor has a new Write with AI button, in the top bar on desktop and in the ⋯ menu on a phone. Choose the proposal's client first. Then add notes on what the proposal should cover if you like, for example the project, the timing and the tone, and leave Suggest line items from your products and services on to get suggested lines. Write with AI drafts an introduction and a scope of work from the client, the linked project, the proposal's title and your notes.",
            "Nothing is added straight away. You review the draft first: edit each section's title and text, and untick any suggested line item you don't want. Suggested lines come from your own products and services, at your catalogue prices. When you choose Add to proposal, the sections are added as new text blocks just below the pricing, ahead of your other content, and the lines you kept are added to your line items, without changing anything already there, and one Undo takes the whole draft back out. Choose Discard to add nothing.",
            "Write with AI uses your workspace's monthly AI usage, like Ask AI, and the button shows for team members who can edit proposals and use AI. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Introduction and scope of work from the client, project and your notes",
            "Suggested line items from your own catalogue, at your prices",
            "Review and edit before anything is added",
            "One Undo removes the whole draft"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/write-with-ai.webp",
            "width": 1600,
            "height": 2120,
            "alt": "The Write with AI review on desktop in dark mode: an editable Introduction and Scope of work, three suggested line items from the catalogue, each ticked, and the Add to proposal and Discard buttons."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/write-with-ai-phone.webp",
            "width": 780,
            "height": 2420,
            "alt": "The Write with AI review on a phone at large text in dark mode: the drafted Introduction and Scope of work, ready to edit, three suggested line items, and Add to proposal."
          },
          "whereToFind": "Proposals → open a draft proposal → Write with AI",
          "appRoute": "/proposals",
          "plans": "all",
          "links": [
            {
              "label": "Proposals and quoting",
              "href": "/features/quoting"
            },
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            }
          ]
        },
        {
          "id": "proposal-merge-fields",
          "title": "Put the proposal total and deposit in a contract",
          "body": [
            "Contract templates have two new merge fields, Proposal total and Proposal deposit, at the bottom of the Merge field menu in the template editor. When you attach the contract to a proposal, your client signs it right after they accept, and the fields fill in with the accepted proposal's total and its deposit, in the proposal's currency. The deposit follows the proposal's deposit setting and shows $0.00 when there is no deposit.",
            "These fields only fill in on a contract attached to a proposal. If you send a contract that uses them on its own, Workspace369 asks you to send it from its proposal or remove those fields, so a client never signs a contract with a blank amount. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Proposal total and Proposal deposit merge fields",
            "Filled in from the accepted proposal",
            "Never sent with a blank amount"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/proposal-merge-fields.webp",
            "width": 1600,
            "height": 900,
            "alt": "The contract template editor on desktop with the Merge field menu open: Proposal total and Proposal deposit in their own group at the bottom, and both fields listed under Merge fields used."
          },
          "imagePhone": null,
          "whereToFind": "Contracts → Templates → open a template → Merge field → Proposal total",
          "appRoute": "/contracts",
          "plans": "all",
          "links": [
            {
              "label": "Contracts and e-signature",
              "href": "/features/contracts"
            },
            {
              "label": "Proposals and quoting",
              "href": "/features/quoting"
            }
          ]
        },
        {
          "id": "services-on-events",
          "title": "Services and products on calendar events",
          "body": [
            "Calendar events have a new Services & products row. Add one or more items from your product and service catalogue to say what an appointment is for, and they show on the event across the calendar views and in the event preview. Bookings made on your booking page show the booked service on their own.",
            "To choose what events show, open Display options on the calendar and turn Services & products, Client and Team on or off under Show on events. Your choice is saved on each device. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Pick services and products from your catalogue",
            "Shown on events in every calendar view",
            "Choose to show services, client and team on events"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-26-proposal-packages-and-write-with-ai/services-on-events.webp",
            "width": 1600,
            "height": 1384,
            "alt": "The event editor on desktop for a Homepage copy review with Maple Row Dental, with Website copywriting and Brand strategy session added in the Services & products row."
          },
          "imagePhone": null,
          "whereToFind": "Calendar → open an event → Services & products",
          "appRoute": "/calendar",
          "plans": "all",
          "links": [
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            },
            {
              "label": "Products and services",
              "href": "/features/products"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I offer my client good, better and best options on a proposal?",
          "a": "Yes. In the proposal editor, open a line item's ⋯ menu and choose Offer as package option…, then name a package or add the line to an existing one. Your client picks one option on the proposal page."
        },
        {
          "q": "What happens to the total when my client picks a different package?",
          "a": "The subtotal, discount, tax and total update to match their pick, and so does a deposit set as a percentage. A fixed deposit stays the same amount."
        },
        {
          "q": "Can AI write a proposal for me in Workspace369?",
          "a": "Yes. Write with AI drafts an introduction and a scope of work from the client, the linked project, the proposal's title and your notes, and can suggest line items from your own products and services at your catalogue prices."
        },
        {
          "q": "Does Write with AI change my proposal without asking?",
          "a": "No. You review the draft first, edit each section and untick any line item you don't want. Nothing is added until you choose Add to proposal, and one Undo removes the whole draft."
        },
        {
          "q": "Which plans include proposal packages and Write with AI?",
          "a": "Every plan. Write with AI uses your workspace's monthly AI usage, like Ask AI."
        },
        {
          "q": "Can a contract show the proposal total and deposit?",
          "a": "Yes. Contract templates have Proposal total and Proposal deposit merge fields, filled in from the accepted proposal when the contract is attached to it. If you send a contract that uses them on its own, Workspace369 asks you to send it from its proposal or remove them."
        }
      ]
    },
    {
      "slug": "2026-10-25-one-time-booking-links-and-invoice-tips",
      "date": "2026-10-25",
      "updated": "2026-10-27",
      "title": "One-time booking links, tips at invoice checkout and project workflows",
      "seoTitle": "One-Time Booking Links and Invoice Tips",
      "summary": "Send a booking link that works once, keep time free before each booking, let clients add a tip when they pay an invoice, and start workflows when a project is done.",
      "areas": [
        "scheduling",
        "billing",
        "automations"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a paper ticket tied with a ribbon bow, with an amber stub torn off, beside the One-time links screen on a phone, with a Create one-time link button."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "One-time booking links, invoice tips and project workflows in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "one-time-links",
          "title": "Booking links that work once",
          "body": [
            "Share & embed on a booking page has a new option, One-time links. Type who the link is for if you like, for example a client's name, then create it and copy it. Each link books one appointment and then stops working, and a link nobody uses expires after 30 days. For safety the link is shown only once, so copy it right away. If you lose it, revoke it and create another.",
            "Links for this page lists every link as Unused with the date it expires, Used with the date, Expired or Revoked. You can revoke an unused link, and it stops working right away. If a booking made with a link is never paid, for example the client leaves checkout, the link works again, while a paid, declined or cancelled booking keeps it used.",
            "To keep a page private, turn on Only bookable through one-time links in the page's Publishing settings. The page and its embeds then take bookings only from a one-time link you create, anyone else sees that the booking link is no longer available, and the page is kept out of search results. Only the workspace owner and admins can create and revoke one-time links. Booking pages take bookings on the Specialist, Commander and Enterprise plans. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Each link books once, then stops working",
            "Unused links expire after 30 days",
            "Revoke an unused link any time",
            "Optional: a page that books only through one-time links"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/one-time-links.webp",
            "width": 1600,
            "height": 1080,
            "alt": "Share & embed on desktop with One-time links open: a Who it's for field, Create one-time link, a new link for Priya Patel with Copy, and Links for this page showing Unused, Used, Expired and Revoked links."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/one-time-links-phone.webp",
            "width": 780,
            "height": 2150,
            "alt": "One-time links on a phone at large text: the new link for Priya Patel with a Copy button and a note that it can't be shown again, then two unused links with Revoke, a used link, an expired one and a revoked one."
          },
          "whereToFind": "Settings → Booking pages → open a page → Share & embed → One-time links",
          "appRoute": "/settings/booking-pages",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        },
        {
          "id": "buffer-and-reminders",
          "title": "A buffer before each booking, and reminders you pick as chips",
          "body": [
            "A booking page's Booking rules now has Buffer before each booking, above the buffer after. It keeps free time before every appointment booked on that page: none, 5, 10, 15, 30 or 60 minutes. Leave it on Service default and each service keeps its own buffer before.",
            "In a service's booking settings, Reminders are now chips instead of a list of minutes: 7 days, 2 days, 1 day, 3 hours, 1 hour, 30 min and 15 min. Pick one or more, or tap Other to add your own in minutes, hours or days, up to 7 days. A service always keeps at least one reminder. Both are on the web app now and come to the iPhone app with its next update."
          ],
          "highlights": [
            "Buffer before: none, 5, 10, 15, 30 or 60 minutes",
            "Reminder chips from 15 minutes to 7 days",
            "Your own reminder with Other"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/booking-reminders.webp",
            "width": 1600,
            "height": 1125,
            "alt": "A service's Online Booking settings on desktop: Availability Controls with Buffer before and Buffer after, and Reminders as chips from 7 days to 15 min with 1 day and 1 hour picked, plus Other."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/buffer-before-phone.webp",
            "width": 780,
            "height": 1500,
            "alt": "A booking page's Booking rules on a phone at large text: Instant booking picked, Verify client email on, and Buffer before each booking set to 10 min above Buffer after each booking."
          },
          "whereToFind": "Settings → Booking pages → open a page → Booking rules → Buffer before each booking",
          "appRoute": "/settings/booking-pages",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        },
        {
          "id": "invoice-tips",
          "title": "Let clients add a tip when they pay an invoice",
          "body": [
            "Clients can now add a tip when they pay an invoice online. Turn on Tips at checkout under Invoices in Settings → Online payments → Payment methods; it stays off until you do. Tip amounts sets your three tip buttons, each a whole percentage from 1 to 100 (10, 15 and 20% to start), whether they are a percent of the amount before tax or of the total with tax, and whether clients can enter their own amount.",
            "When the client pays the full balance on the invoice page, they see Add a tip: your three buttons, each with its amount, Custom when you let clients enter their own amount, and No tip. No tip is picked to start. The payment summary adds the tip as its own line and shows the new total due. Tips are not offered on a partial payment.",
            "The invoice total and the receipt stay the same. On plans with Accounting (Specialist and up), the tip is booked as its own Tips income. When you refund a tipped card payment, the refund dialog shows the tip and how much you can refund while keeping it. The tip settings are on the web app now and come to the iPhone app with its next update."
          ],
          "highlights": [
            "Off until you turn it on",
            "Three tip buttons, your own amount and No tip",
            "Invoice total stays the same",
            "Tips booked as their own income with Accounting"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invoice-tips.webp",
            "width": 1600,
            "height": 1000,
            "alt": "Payment methods on desktop with Tips at checkout turned on under Invoices, and the Tip amounts row showing 10% · 15% · 20% as a percent of the amount before tax."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invoice-tips-phone.webp",
            "width": 780,
            "height": 1800,
            "alt": "The Tip amounts editor on a phone at large text: three tip buttons at 10, 15 and 20 percent, Percent of set to Amount before tax, and Clients can enter their own amount turned on."
          },
          "whereToFind": "Settings → Online payments → Payment methods → Invoices → Tips at checkout",
          "appRoute": "/settings/online-payments",
          "plans": "all",
          "links": [
            {
              "label": "Online payments",
              "href": "/features/payments"
            },
            {
              "label": "Invoices",
              "href": "/features/invoices"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, a client opens a 1,200 dollar invoice from a garden studio, taps Pay Now, then taps 15 percent under Add a tip. The amount due changes to 1,380 dollars, with a 180 dollar Tip line on desktop and \"1,200 dollars plus 180 dollars tip\" on the phone, and the Pay button updates to match. The card form is left out of the clip.",
            "caption": "The client picks a tip at checkout and the amount due updates before they pay. Example data.",
            "duration": "PT7S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Invoice payment",
              "sub": "369.dev",
              "light": {
                "mp4": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-phone-light.webm",
                "poster": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/invtip-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "project-workflows",
          "title": "Workflows that start when a project is done, and a Create project step",
          "body": [
            "Workflows have a new Projects trigger, Project completed. It runs each time a project's status changes to Completed, or only once per project if you set it to, and it can use the project's name, number and status, plus the client when the project is linked to one. Its Only continue if filter can check the project's earlier status, priority, type, tags, budget, start, due and completed dates, and its client. Use it to thank the client, send them your review link or tell your team.",
            "A new Create project step works with any trigger. Give the project a name, which can include variables such as the client's name, pick the status it starts in, and choose whether to link the client. You can also stop the workflow if the project can't be created. For example, a Proposal accepted or Lead converted to client workflow can create the client's project for you. The step needs permission to create projects. Both are on the web app now and come to the iPhone app with its next update."
          ],
          "highlights": [
            "Project completed trigger with the project and client details",
            "Filter on the project's status, priority, tags, budget and dates",
            "Create project step on any trigger",
            "Project name with variables and a starting status"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/project-workflows.webp",
            "width": 1600,
            "height": 1000,
            "alt": "Two phone renders side by side: the Create project step with Website for Client name as the project name, In Progress status and Link the client on, and the Project status list from Planning to Cancelled."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-25-one-time-booking-links-and-invoice-tips/project-workflows-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The Create project step on a phone at large text: Project name with a Client name variable, Project status In Progress, Link the client on, and Stop the workflow if the project can't be created off."
          },
          "whereToFind": "Workflows → open a workflow → trigger → Projects → Project completed",
          "appRoute": "/workflows",
          "plans": "all",
          "links": [
            {
              "label": "Workflow automation",
              "href": "/features/automation"
            },
            {
              "label": "Workflows tutorial",
              "href": "/tutorials/workflows"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans include one-time booking links?",
          "a": "Specialist, Commander and Enterprise, the plans where booking pages take bookings. Only the workspace owner and admins can create and revoke them."
        },
        {
          "q": "How do I create a one-time booking link?",
          "a": "Open Settings → Booking pages, open a page, then Share & embed → One-time links. Optionally type who it's for, create it and copy it right away, because the link is shown only once."
        },
        {
          "q": "How long does a one-time booking link last?",
          "a": "Each link books one appointment and then stops working. A link nobody uses expires after 30 days. You can revoke an unused link, and it stops working right away."
        },
        {
          "q": "Can I make a booking page bookable only through one-time links?",
          "a": "Yes. Turn on Only bookable through one-time links in the page's Publishing settings. Others see the link is no longer available, and the page is kept out of search results."
        },
        {
          "q": "Which plans can let clients add a tip on an invoice?",
          "a": "Every plan. Tips at checkout is off until you turn it on under Settings → Online payments → Payment methods → Invoices."
        },
        {
          "q": "How do invoice tips work for the client?",
          "a": "Paying the full balance, the client sees Add a tip with your three buttons, Custom if you allow it, and No tip. The tip is its own line in the payment summary, and tips aren't offered on a partial payment."
        }
      ]
    },
    {
      "slug": "2026-10-24-setup-booking-page-and-starter-proposal",
      "date": "2026-10-24",
      "title": "Setup now builds your booking page and starts your first proposal from your services",
      "seoTitle": "Booking Page Setup and Starter Proposals",
      "summary": "Guided setup now makes a live booking page in one step and starts your first proposal from your services, and new AI access tokens show exactly where to paste them.",
      "areas": [
        "workspace",
        "scheduling",
        "proposals",
        "ai"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a calendar page unrolling with an amber flag and a starter document, beside the setup step Your booking page on a phone, with a service and a time picker."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Booking page setup and starter proposals in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "setup-booking-page",
          "title": "Make your booking page during setup",
          "body": [
            "Guided setup has a new step, Your booking page. For a new workspace it comes right after your first client, and if you pick scheduling as your goal it comes first. On one screen you say what people can book: up to three services, each 30, 60 or 90 minutes, with an optional price that is shown on the page. Then choose how you meet, by video, phone or in person, and when people can book: weekdays, or weekdays and Saturday, from 9 AM to 5 PM in your time zone.",
            "Create my page adds the services to your catalog with online booking turned on and creates your booking page with those hours. The step then shows the live link with Copy link, Share and Open page, ready for your bio, email signature or texts, and new bookings show up in your calendar. For a video service, the page tells clients you will send the link before you meet. You can change the services, hours and everything else later in Booking pages.",
            "If your workspace already has a booking page or bookable services, the step shows those instead of the form. Only the owner or an admin can make booking pages, so other teammates see a note and can skip the step. Booking pages take bookings on the Specialist, Commander and Enterprise plans. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Up to three services, 30, 60 or 90 minutes",
            "Video, phone or in person",
            "Weekdays or weekdays and Saturday, 9 AM to 5 PM",
            "Live link with Copy link, Share and Open page"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/booking-step.webp",
            "width": 1600,
            "height": 720,
            "alt": "The setup step on desktop after Create my page: Your booking page is live, a preview of Harbor & Pine Studio with Intro call and Brand strategy session and three times, the 369.dev link with Copy Link, and Share and Open page buttons."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/booking-step-phone.webp",
            "width": 780,
            "height": 2600,
            "alt": "The Your booking page step on a phone: a live preview on top, two services with 30, 60 or 90 minute lengths and an optional price, How do you meet set to Phone, and Mon to Sat 9:00 AM to 5:00 PM picked under When can people book."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and a phone, the Your booking page step of guided setup shows a live preview for Fernhill Design above the form. Brand consultation is typed in as a 60 min service with a price of $150, then Add another service adds Discovery call at 30 min with no price, and the preview fills in as each is added. Under How do you meet, Phone is picked, and under When can people book, Mon – Sat, 9:00 AM – 5:00 PM. Create my page shows Your booking page is live, with the preview tagged Live, the page link with Copy Link, and Share and Open page buttons.",
            "caption": "Say what people can book, how you meet and when, and your booking page is live. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Setup",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-phone-light.webm",
                "poster": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/setupbook-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Home → setup card → Your booking page",
          "appRoute": "/account-setup",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        },
        {
          "id": "starter-proposal",
          "title": "Start your first proposal from your services",
          "body": [
            "The first-proposal step in guided setup has a new way to start, Your services, picked for you when your catalog has services. Instead of a blank proposal, it opens a draft for your client that is named after a service you sell and lists your three newest active services as line items: the first one included, and the others as optional extras the client can tick.",
            "The draft also has a short How this works section that tells the client to review what is included, tick any extras they want and accept and sign to get started. A signature is required. When you can take card payments in Workspace369 and the included service has a price, the draft also asks for a 50% deposit on acceptance.",
            "Saved templates and A few line items work as before, and nothing goes to the client until you send it. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Draft built from your three newest services",
            "Extras the client can tick",
            "Signature required, deposit when you take card payments"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/starter-proposal.webp",
            "width": 1600,
            "height": 810,
            "alt": "The Send your first proposal setup step on desktop: Jane Doe picked under Who it's for, and Your services picked under Start from, listing Brand strategy session, Website audit and Monthly check-in."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/starter-proposal-phone.webp",
            "width": 780,
            "height": 2170,
            "alt": "The starter proposal on a phone as the client sees it: a Brand strategy session cover, the session included, Website audit and Monthly check-in as optional extras, a 50% deposit line and a How this works section."
          },
          "whereToFind": "Home → setup card → Send your first proposal → Your services",
          "appRoute": "/account-setup",
          "plans": "all",
          "links": [
            {
              "label": "Proposals and quotes",
              "href": "/features/quoting"
            },
            {
              "label": "Proposals tutorial",
              "href": "/tutorials/proposals-step-by-step"
            }
          ]
        },
        {
          "id": "token-use-it",
          "title": "New access tokens show where to use them",
          "body": [
            "When you create a personal access token for AI connections, the Token created dialog now has a Use it section. It shows your workspace's own MCP server address, a second address for the core CRM tools only, and a ready-to-paste Claude Code command that already holds your new token, plus a link to the setup guide.",
            "Every value has its own copy button. Addresses and the connection name in the command are specific to the workspace, so you can connect more than one workspace to the same AI app side by side.",
            "The token is still shown only once, so copy it before you press Done. If AI connections are off in the workspace, the dialog tells owners and admins to turn on Allow AI connections on the same page, and tells other members to ask the owner."
          ],
          "highlights": [
            "Workspace MCP address and core CRM address",
            "Ready-to-paste Claude Code command",
            "A copy button on every value"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/token-use-it.webp",
            "width": 1600,
            "height": 970,
            "alt": "The Token created dialog on desktop in dark mode: the token with a copy button, then a Use it section with the Server URL, the Core CRM tools only address, a ready Claude Code command and a Setup guide link."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-24-setup-booking-page-and-starter-proposal/token-use-it-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The Token created dialog on a phone in dark mode, scrolled to Use it: Server URL, Core CRM tools only and Claude Code command, each with its own copy button, above Copy token and Done."
          },
          "whereToFind": "Settings → AI connections → Personal access tokens → Create token",
          "appRoute": "/settings/ai-connections",
          "plans": "all",
          "links": [
            {
              "label": "AI connections (MCP)",
              "href": "/integrations/mcp"
            },
            {
              "label": "CRM MCP server guide",
              "href": "/blog/crm-mcp-server"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can Workspace369 set up my booking page for me?",
          "a": "Yes. Guided setup has a Your booking page step where you add up to three services of 30, 60 or 90 minutes, choose video, phone or in person, and pick weekday hours. Create my page then gives you a live link to copy, share or open."
        },
        {
          "q": "Which plans take bookings through a booking page?",
          "a": "Booking pages take bookings on the Specialist, Commander and Enterprise plans."
        },
        {
          "q": "Who can create a booking page during setup?",
          "a": "Only the owner or an admin. Other teammates see a note and can skip the step."
        },
        {
          "q": "Can setup start my first proposal from my services?",
          "a": "Yes. The first-proposal step has a Your services option that opens a draft with your three newest active services. The first is included and the others are optional extras your client can tick."
        },
        {
          "q": "Does the starter proposal go to my client automatically?",
          "a": "No. Nothing goes to the client until you send it. The draft requires a signature, and asks for a 50% deposit on acceptance when you can take card payments in Workspace369 and the included service has a price."
        },
        {
          "q": "Can I change my booking page services and hours after setup?",
          "a": "Yes. You can change the services, hours and everything else later in Booking pages. For a video service, the page tells clients you will send the link before you meet."
        }
      ]
    },
    {
      "slug": "2026-10-23-booking-limits-and-no-shows",
      "date": "2026-10-23",
      "updated": "2026-10-30",
      "title": "Mark no-shows, cap weekly bookings and set the dates a service can be booked",
      "seoTitle": "No-Shows, Weekly Limits and Booking Dates",
      "summary": "Mark an appointment as a no-show and start a workflow from it, cap how many bookings a teammate takes each week, and open a service for booking only between two dates.",
      "areas": [
        "scheduling",
        "automations"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a stack of calendar pages between two bookends, a rail of round tokens and one appointment card set aside, beside the Availability Controls settings with a Daily limit of 3 and a Weekly limit of 10."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "No-shows, weekly limits and bookable dates in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "no-show",
          "title": "Mark an appointment as a no-show",
          "body": [
            "When a client doesn’t turn up, open the appointment and set its status to No-show. It sits between Completed and Cancelled in the status menu and shows in red. On the calendar a no-show stays in place but is dimmed, and it no longer counts as an upcoming visit on the client’s record. You can also filter the calendar by it.",
            "Workflows have a new Calendar trigger, Appointment no-show, that runs when an appointment is marked as a no-show. Use it to email the client a link to rebook or to tell your team. Marking one visit of a repeating appointment runs it for that visit only, and undoing the mark runs nothing. Workflows that run before or after an appointment, such as Ask for a review, skip no-shows.",
            "It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "No-show status in red, between Completed and Cancelled",
            "Dimmed on the calendar, not counted as upcoming",
            "New workflow trigger: Appointment no-show"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/no-show.webp",
            "width": 1152,
            "height": 950,
            "alt": "An appointment preview on the desktop calendar with its status menu open: Confirmed is checked, followed by Tentative, Completed, No-show in red and Cancelled."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/no-show-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The appointment sheet on a phone with the Status list open: Confirmed, Tentative, Completed, No-show with a red dot and Cancelled."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the week of Oct 12 to 18 is open in the calendar. Brand consultation with Maya Okafor on Wednesday at 1:00 PM opens, its status changes from Confirmed to No-show from the list Confirmed, Tentative, Completed, No-show and Cancelled, a message confirms Event marked as No-show, and the booking stays on the calendar, dimmed.",
            "caption": "Mark an appointment as a no-show from its status menu, and it stays on your calendar, dimmed. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Calendar",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-phone-light.webm",
                "poster": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/noshow-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Calendar → open an appointment → status → No-show",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            },
            {
              "label": "Workflow automation",
              "href": "/features/automation"
            }
          ]
        },
        {
          "id": "weekly-limit",
          "title": "A weekly limit next to the daily one",
          "body": [
            "A bookable service could already cap bookings per day. It now has a Weekly limit too, right under Daily limit. The limit is per teammate: once someone has that many bookings in a week, counting all their appointments that week, not just this service’s, the booking page stops offering their times until the next week. Other hosts keep their times.",
            "Weeks run Monday to Sunday in your workspace time zone. Leave it empty or enter 0 for no weekly limit. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Weekly limit under Daily limit",
            "Counts each teammate’s appointments for the week",
            "Weeks run Monday to Sunday, 0 means no limit"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/weekly-limit.webp",
            "width": 1600,
            "height": 718,
            "alt": "Optional rules and automation for a bookable service on desktop: Availability Controls with buffers, slot interval, minimum notice, a 60-day booking window, a Daily limit of 3 and a Weekly limit of 10, beside Client Controls and Workflows."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/weekly-limit-phone.webp",
            "width": 780,
            "height": 1050,
            "alt": "Availability Controls on a phone, listing Buffer before, Buffer after, Slot interval, Minimum notice, Booking window, Daily limit 3 and Weekly limit 10, each limit marked 0 = none."
          },
          "whereToFind": "Product Catalog → open a service → Online booking → Configure booking → Rules and details → Availability → Weekly limit",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        },
        {
          "id": "bookable-dates",
          "title": "Bookable dates: a start and end for each service",
          "body": [
            "Set From and Until under Bookable dates to offer a service only for a season, a promotion or a limited run. Both dates are included and follow your workspace time zone. Leave From empty to start now, or Until empty for no end date.",
            "Outside those dates the booking page shows no times for the service, and a booking or reschedule into them is refused. Blackout dates still work inside the range for single days off. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "From and Until for each service",
            "No times offered outside the range",
            "Blackout dates still block single days"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/bookable-dates.webp",
            "width": 698,
            "height": 805,
            "alt": "The Hosts and Routing card for a bookable service on desktop: Approval set to Never, then Bookable dates From 11/2/2026 Until 3/31/2027, then Blackout dates 11/26/2026 and 12/25/2026."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-23-booking-limits-and-no-shows/bookable-dates-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "Hosts and Routing on a phone with Bookable dates From 11/2/2026 and Until 3/31/2027, each with a clear button, above two blackout dates."
          },
          "whereToFind": "Product Catalog → open a service → Online booking → Configure booking → Rules and details → Bookable dates",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which plans let me mark an appointment as a no-show?",
          "a": "All five plans: Cadet, Voyager, Specialist, Commander and Enterprise."
        },
        {
          "q": "How do I mark an appointment as a no-show?",
          "a": "Open the appointment on the Calendar and set its status to No-show. It sits between Completed and Cancelled in the status menu and shows in red."
        },
        {
          "q": "What does a no-show do to my calendar and workflows?",
          "a": "On the calendar it stays in place but dimmed, and no longer counts as an upcoming visit on the client's record. A new Appointment no-show workflow trigger runs when it's marked, for example to email a rebook link."
        },
        {
          "q": "Which plans have a weekly booking limit?",
          "a": "Specialist, Commander and Enterprise. It's per teammate and counts all their appointments that week. Once reached, the booking page stops offering their times until the next week."
        },
        {
          "q": "Where do I set the weekly limit?",
          "a": "Product Catalog → open a service → Online booking → Configure booking → Rules and details → Availability → Weekly limit. Leave it empty or enter 0 for no limit. Weeks run Monday to Sunday."
        },
        {
          "q": "How do I offer a service only between two dates?",
          "a": "Set From and Until under Bookable dates on Specialist, Commander or Enterprise. Both dates are included. Outside the range the booking page shows no times, and a booking or reschedule there is refused."
        }
      ]
    },
    {
      "slug": "2026-10-23-review-requests-and-imports",
      "date": "2026-10-23",
      "title": "Ask clients for reviews automatically, and import from five more tools",
      "seoTitle": "Review Requests and Imports From 5 More Tools",
      "summary": "Save your review page link once and let a workflow email it after each appointment, and bring your data over from HoneyBook, Dubsado, Bonsai, 17hats or Moxie with AI Import.",
      "areas": [
        "automations",
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-23-review-requests-and-imports/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of an envelope with a star and a clock, and folders gliding along a conveyor into one tidy stack, beside the AI Import step Confirm what we detected with the Source app list open on HoneyBook, Dubsado, Bonsai, 17hats, Moxie and GoHighLevel."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Review requests and imports from five more tools in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "review-link",
          "title": "A review link and an Ask for a review workflow",
          "body": [
            "Add your Google, Yelp or Facebook review page as the Review link in Settings › General › Contact. Use the full link, starting with https://. Workflows can then send it to clients with the new {{workspace.review_url}} variable, shown as Review link in the variable picker, in emails and, on Voyager and above, in text messages. If a workflow step uses it and no link is set, the step doesn’t send; its error tells you where to add the link, and you run the workflow again once it’s saved.",
            "There is a ready-made Ask for a review template under Calendar when you start a new workflow. Two hours after an appointment ends, it emails the client a short thank-you with your review link. It opens as a draft: pick the mailbox it sends from and switch it on. It skips appointments marked as a no-show.",
            "It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Review link in Settings › General",
            "{{workspace.review_url}} for workflow emails (and texts on Voyager and above)",
            "Ask for a review template, 2 hours after an appointment"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-23-review-requests-and-imports/review-link.webp",
            "width": 1140,
            "height": 369,
            "alt": "The Contact section of Settings › General on desktop: Email, Phone, Website, a Review link of https://reviews.apexautospa.example/leave-a-review, and Address."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-23-review-requests-and-imports/review-link-phone.webp",
            "width": 780,
            "height": 890,
            "alt": "The Contact section on a phone with Email, Phone, Website, the Review link https://reviews.apexautospa.example/leave-a-review and Address."
          },
          "whereToFind": "Settings → General → Contact → Review link",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Workflow automation",
              "href": "/features/automation"
            },
            {
              "label": "Workflows tutorial",
              "href": "/tutorials/workflows"
            }
          ]
        },
        {
          "id": "import-sources",
          "title": "AI Import recognizes HoneyBook, Dubsado, Bonsai, 17hats and Moxie",
          "body": [
            "Upload a CSV or Excel export from HoneyBook, Dubsado, Bonsai, 17hats or Moxie and AI Import now suggests the tool it came from, alongside GoHighLevel, Jobber and ServiceTitan. You can correct the source app before the import starts, and Import History shows it afterwards.",
            "Each import brings in one kind of record: clients, products, invoices, proposals or expenses. You review every row before anything is saved. Imports use your monthly AI usage, and expenses need Specialist or above.",
            "It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Five more source apps named on detection",
            "Source shown in Import History",
            "Review every row before it’s saved"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-23-review-requests-and-imports/import-sources.webp",
            "width": 1600,
            "height": 840,
            "alt": "The AI Import step Confirm what we detected on desktop, with Dubsado detected as the Source app and the list open on HoneyBook, Dubsado, Bonsai, 17hats, Moxie and GoHighLevel."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-23-review-requests-and-imports/import-sources-phone.webp",
            "width": 780,
            "height": 970,
            "alt": "The same Confirm what we detected step on a phone with the Source app list open on HoneyBook, Dubsado, Bonsai, 17hats, Moxie and GoHighLevel."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, AI Import shows Confirm what we detected for a client export, with Source app Dubsado, Data type Clients and a column mapping preview from First Name to Created Date. The Source app list opens on HoneyBook, Dubsado, Bonsai, 17hats, Moxie and GoHighLevel, Dubsado stays selected, and the import moves to review: 5 records parsed, each marked Will create new client, starting with Maya Okafor and Daniel Park, with Commit 5 records at the bottom.",
            "caption": "AI Import suggests the app your export came from, and you can change it before anything is imported. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "AI Import",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-23-review-requests-and-imports/import-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-23-review-requests-and-imports/import-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-23-review-requests-and-imports/import-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-23-review-requests-and-imports/import-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-23-review-requests-and-imports/import-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-23-review-requests-and-imports/import-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-23-review-requests-and-imports/import-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-23-review-requests-and-imports/import-phone-light.webm",
                "poster": "/images/release-notes/2026-10-23-review-requests-and-imports/import-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-23-review-requests-and-imports/import-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-23-review-requests-and-imports/import-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-23-review-requests-and-imports/import-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Clients → Import data",
          "appRoute": null,
          "plans": [
            "Cadet",
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Switch from HoneyBook",
              "href": "/switch/honeybook"
            },
            {
              "label": "Switch from Dubsado",
              "href": "/switch/dubsado"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can Workspace369 ask clients for a Google review automatically?",
          "a": "Yes. Save your review page link in Settings → General → Contact, then use the Ask for a review workflow template under Calendar. Two hours after an appointment ends it emails the client a thank-you with your review link."
        },
        {
          "q": "Does the review request go out for no-shows?",
          "a": "No. The Ask for a review template skips appointments marked as a no-show. It opens as a draft, so you pick the mailbox it sends from and switch it on."
        },
        {
          "q": "Which review sites can I link to?",
          "a": "Your Google, Yelp or Facebook review page. Use the full link, starting with https://."
        },
        {
          "q": "Which plans include review requests and AI Import?",
          "a": "Both are on every plan, Cadet through Enterprise. Review links can be sent by text from Voyager up, and importing expenses needs Specialist or above."
        },
        {
          "q": "Can I import my data from HoneyBook, Dubsado, Bonsai, 17hats or Moxie?",
          "a": "Yes. Upload a CSV or Excel export under Clients → Import data and AI Import suggests the tool it came from. You can correct the source before the import starts."
        },
        {
          "q": "Do I get to check imported data before it is saved?",
          "a": "Yes. Each import brings in one kind of record, such as clients, products, invoices, proposals or expenses, and you review every row before anything is saved. Imports use your monthly AI usage."
        }
      ]
    },
    {
      "slug": "2026-10-21-booking-approval-by-day",
      "date": "2026-10-21",
      "updated": "2026-11-04",
      "title": "Choose which days of the week bookings need your approval",
      "seoTitle": "Booking Approval by Day of the Week",
      "summary": "Bookings can now need your approval only on the days you pick, booking pages tag times Instant or Request, and embedded booking can record where new clients came from.",
      "areas": [
        "scheduling"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-21-booking-approval-by-day/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a row of calendar tiles: most have open doors that clients pass straight through, and the last two have a bell, a closed gate and a wax seal, beside the Approval setting with On these days chosen and Sun and Sat selected."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Booking approval by day of the week in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "approval-days",
          "title": "Approval on the days you pick",
          "body": [
            "A bookable service used to be all or nothing: every booking either landed on your calendar right away or waited for you to accept it. Approval now has three choices: Never, Always and On these days. Pick On these days, then tap the weekdays that should wait for you, for example weekends, while the rest of the week books instantly.",
            "Days follow your workspace time zone, whichever time zone your client is in. It is on the web app and in the iPhone app too."
          ],
          "highlights": [
            "Never, Always or On these days",
            "Pick the weekdays that need your approval",
            "Days follow your workspace time zone"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-days.webp",
            "width": 1050,
            "height": 540,
            "alt": "The Approval setting for a bookable service on desktop: On these days is chosen, Sun and Sat are selected, a note says bookings on these days wait for your approval and other days book instantly, and Blackout dates sits below."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-days-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The Online Booking settings for a Ski shoot service on a phone: booking hosts, then Approval with On these days chosen and Sun and Sat selected, then Blackout dates."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Online booking settings for Brand strategy session show Approval set to Never. On these days is chosen, all seven days appear selected, Mon to Fri are switched off, and only Sun and Sat stay selected, with the note: Bookings on these days wait for your approval. Other days book instantly. Days follow your workspace time zone.",
            "caption": "Choose which days wait for your approval, and the rest of the week books without it. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Online booking",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-phone-light.webm",
                "poster": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-21-booking-approval-by-day/approval-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Product Catalog → open a service → Online booking → Configure booking → Approval",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        },
        {
          "id": "instant-or-request-times",
          "title": "Clients see which times book instantly",
          "body": [
            "For a service that uses On these days, each time on your booking page now carries a small Instant or Request tag, so clients know before they pick whether the time is confirmed straight away or sent to you as a request. The button and the payment note follow the time they choose.",
            "If a client reschedules into a day that needs approval, the manage page tells them the booking is now a request."
          ],
          "highlights": [
            "Instant or Request on every time",
            "Button and payment note follow the chosen time",
            "Clear message when a reschedule becomes a request"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-21-booking-approval-by-day/booking-times.webp",
            "width": 700,
            "height": 910,
            "alt": "A booking page for Fri, Oct 23 with 16 openings, where the first six times, from 9:00 AM to 1:00 PM, are each tagged Request."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-21-booking-approval-by-day/booking-times-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The same booking page on a phone when Friday books instantly: the first ten times, from 9:00 AM to 3:00 PM, are each tagged Instant."
          },
          "whereToFind": "Your clients see it on your booking page; you set it with Approval in each service’s Online booking settings",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        },
        {
          "id": "booking-source",
          "title": "See where a client booked through your website came from",
          "body": [
            "If your website embeds your booking page with the booking script, your site can now pass along where the visit came from: the site and page they booked on, the site that sent them there and any UTM campaign tags, such as source, medium and campaign. When that booking creates a new client, Workspace369 saves it with the client.",
            "It shows as a Booking source group in the client quick view and on the full client profile. It is read-only, so edits to the client never change it, and an empty value gets no row. Clients who open your hosted booking link directly have no booking source."
          ],
          "highlights": [
            "Referrer and landing page for clients booked through your website",
            "UTM source, medium, campaign, term and content",
            "Read-only on the client quick view and profile"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-21-booking-approval-by-day/lead-source.webp",
            "width": 1073,
            "height": 670,
            "alt": "The Details section of a client quick view for Maya Chen, followed by a Booking source group: Referrer www.google.com, Landing page maplerowdental.example/book/, UTM source google and UTM medium cpc."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-21-booking-approval-by-day/lead-source-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The client quick view sheet on a phone, scrolled to Details and the Booking source group with Referrer www.google.com, Landing page maplerowdental.example/book/, UTM source google and UTM medium cpc, each with a copy button."
          },
          "whereToFind": "Clients → open a client created by a booking on your website → Booking source",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        },
        {
          "id": "booking-page-links",
          "title": "A link to every booking page setting",
          "body": [
            "Each section of a booking page editor, such as Services, Booking rules or Hosts, and each Share & embed tab now has its own web address. The address follows you as you move around, a refresh keeps you on the same screen, and you can send a teammate a link straight to the setting you mean."
          ],
          "highlights": [
            "Links to each editor section and Share & embed tab",
            "Refresh keeps your place"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Settings → Booking pages, in the web app",
          "appRoute": null,
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Online booking",
              "href": "/features/online-booking"
            },
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which plans include approval by day for bookings?",
          "a": "Specialist, Commander and Enterprise."
        },
        {
          "q": "How do I make bookings need approval only on some days?",
          "a": "Open Product Catalog → a service → Online booking → Configure booking → Approval. Choose On these days, then tap the weekdays that should wait for you. Other days book instantly."
        },
        {
          "q": "Which time zone do the approval days follow?",
          "a": "Your workspace time zone, whichever time zone your client is in."
        },
        {
          "q": "How do clients know which times book instantly?",
          "a": "For a service using On these days, each time carries an Instant or Request tag. The button and payment note follow the time they choose."
        },
        {
          "q": "What if a client reschedules onto a day that needs approval?",
          "a": "The manage page tells them the booking is now a request."
        },
        {
          "q": "Can I see where a client who booked through my website came from?",
          "a": "Yes, if your site embeds the booking page with the booking script. A Booking source group shows on the client's profile. It's read-only, and direct hosted-link bookings have no booking source."
        }
      ]
    },
    {
      "slug": "2026-10-21-after-payment-page",
      "date": "2026-10-21",
      "title": "Clients see your own thank-you page after they pay",
      "seoTitle": "After-Payment Thank-You Page for Clients",
      "summary": "After a client pays an invoice, pay link, proposal or booking, they now see your note and next-step buttons under the confirmation, with an optional redirect to your site.",
      "areas": [
        "billing",
        "proposals",
        "scheduling"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-21-after-payment-page/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of a receipt with a check mark, a small note with a bookmark and a doorway opening onto stepping stones, beside a paid pay link page with a note from the business and Book your next detail and Download the care guide buttons."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "After-payment thank-you page in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "thank-you-page",
          "title": "A note and next steps for clients right after they pay",
          "body": [
            "Once a payment is confirmed, the page your client sees keeps the confirmation first: paid, the amount, the receipt and the document. Under it, they now see a short note from you and up to two buttons for what comes next, such as booking a kickoff call or downloading a care guide.",
            "You can also send clients on to a page of your own. The redirect starts only after the payment is confirmed, with a 5-second countdown that names the site, plus Go now and Stay. Nothing about the payment is added to the link. It works on invoices, pay links, proposals and bookings."
          ],
          "highlights": [
            "Your note under the payment confirmation",
            "Up to two next-step buttons",
            "Optional redirect with a 5-second countdown and Stay"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-21-after-payment-page/thank-you-page.webp",
            "width": 560,
            "height": 860,
            "alt": "A paid invoice page for Fernhill Design: Thanks, Ana. You're all set, Invoice 26-0148 is paid, Payment received and Receipt emailed, a note from Fernhill Design with a Book your kickoff call button, a bar reading Taking you to fernhilldesign.example in 5 s with Go now and Stay, and Receipt and View invoice buttons."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-21-after-payment-page/thank-you-page-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "A paid pay link on a phone for Apex Mobile Detailing: Paid. Thank you!, a note from the business about a maintenance wash, a Book your next detail button and a Download the care guide button."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, a paid invoice page for Fernhill Design reads Thanks, Ana. You're all set, with Payment received, Receipt emailed and a note from Fernhill Design with a Book your kickoff call button. A bar counts down Taking you to fernhilldesign.example in 5, 4, 3 seconds with Go now and Stay. Stay is pressed, the bar becomes Continue to fernhilldesign.example, and the page stays put.",
            "caption": "After paying, clients see your note, your next step and an optional countdown to your own site. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Paid invoice",
              "sub": "Client view",
              "light": {
                "mp4": "/images/release-notes/2026-10-21-after-payment-page/afterpay-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-21-after-payment-page/afterpay-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-21-after-payment-page/afterpay-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-21-after-payment-page/afterpay-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-21-after-payment-page/afterpay-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-21-after-payment-page/afterpay-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-21-after-payment-page/afterpay-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-21-after-payment-page/afterpay-phone-light.webm",
                "poster": "/images/release-notes/2026-10-21-after-payment-page/afterpay-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-21-after-payment-page/afterpay-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-21-after-payment-page/afterpay-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-21-after-payment-page/afterpay-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Your clients see it on the page they pay on; you set it in Settings → Workspace → After payment",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Online payments",
              "href": "/features/payments"
            },
            {
              "label": "Invoices",
              "href": "/features/invoices"
            }
          ]
        },
        {
          "id": "after-payment-settings",
          "title": "Set it once for the workspace, change it per document",
          "body": [
            "A new After payment page in Settings holds your message (plain text, line breaks kept), up to two buttons with a label, link and icon (Book a call, Download or Link), the optional redirect, and where it shows: invoices, Flash Pay links, proposals and bookings. A live preview shows what a client sees with your unsaved changes.",
            "Any invoice, proposal or booking service can use the workspace page, its own page or none, from an After payment row in its editor, and a pay link can do the same when you create it. The redirect is off until you turn it on, and links must start with https."
          ],
          "highlights": [
            "One page for the whole workspace",
            "Default, custom or off for each document",
            "Live preview before you save"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-21-after-payment-page/after-payment-settings.webp",
            "width": 1020,
            "height": 2340,
            "alt": "The After payment settings: a message from Apex Auto Spa, Button 1 Book your next detail with the Book a call icon, Button 2 Download the care guide with the Download icon, and Take clients to another page switched on with a thank-you page link and a note that it starts only once the payment is confirmed."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-21-after-payment-page/after-payment-settings-phone.webp",
            "width": 780,
            "height": 3900,
            "alt": "The same After payment page on a phone, with a Preview button, the message, two next-step buttons, the redirect, and Where it shows with Invoices, Flash Pay links and Bookings on and Proposals off."
          },
          "whereToFind": "Settings → Workspace → After payment, or the After payment row in an invoice, proposal or booking service, or when you create a pay link",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Online payments",
              "href": "/features/payments"
            },
            {
              "label": "Proposals",
              "href": "/features/quoting"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "What do my clients see after they pay?",
          "a": "The confirmation comes first: the payment received and the receipt emailed. Under it they see your own page: an optional title, a note and up to five next steps in the order you set, such as booking a kickoff call or downloading a care guide."
        },
        {
          "q": "Where do I set up the after-payment page?",
          "a": "In Settings → Workspace → After payment. A live preview shows what a client sees with your unsaved changes."
        },
        {
          "q": "Does the after-payment page work on invoices, proposals and bookings?",
          "a": "Yes. It works on invoices, pay links and proposals on every plan, and on bookings from Specialist, and you choose which of them show it."
        },
        {
          "q": "Can I send clients to my own website after they pay?",
          "a": "Yes. The optional redirect starts only after the payment is confirmed, with a 5, 10 or 15 second countdown that names the site, plus Go now and Stay buttons. It is off until you turn it on, links must start with https, and nothing about the payment is added to the link."
        },
        {
          "q": "Can one invoice or proposal use a different message?",
          "a": "Yes. Any invoice, proposal or booking service can use the workspace page, its own page or none, from an After payment row in its editor. A pay link can do the same when you create it."
        },
        {
          "q": "Which plans include the after-payment page?",
          "a": "Every Workspace369 plan includes the after-payment page. On bookings it needs Specialist or above, where booking pages start."
        }
      ]
    },
    {
      "slug": "2026-10-19-upgrade-prompts-and-safer-drafts",
      "date": "2026-10-19",
      "title": "Locked features now show what they do, and unsaved work is easier to recover",
      "seoTitle": "Locked Feature Previews and Safer Drafts",
      "summary": "Locked features now show a preview and the plan that includes them, plan limits show your real usage and the next plan, and unsaved work is easier to recover.",
      "areas": [
        "workspace",
        "billing"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of an open padlock, a paper door opening onto a glowing shape and a cloud with a bookmark, beside the Unlock dialog for installments on the Specialist plan."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Locked feature previews in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "unlock-dialog",
          "title": "Every locked feature explains itself before you upgrade",
          "body": [
            "Tap a plan lock anywhere in Workspace369 and an Unlock dialog opens for that feature. A short animated preview shows the real feature at work, a few points say what it does, and the plan that includes it is shown with its price, billed yearly or monthly. Upgrade opens your plans with that plan suggested, and Compare plans shows them all.",
            "It covers locked features across the app, such as inbox rules, SMS automation, installments, inventory, funnels and team management. Enterprise features show the plan without a price. On an invoice's Payment tab, the lock now says what it unlocks: installments, on Specialist."
          ],
          "highlights": [
            "A short preview of the real feature",
            "The plan that includes it, with its price",
            "Upgrade opens your plans with that plan suggested"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/unlock-dialog.webp",
            "width": 1056,
            "height": 1362,
            "alt": "The Unlock dialog for installments: a preview of an invoice split into three payments, the Specialist badge, Let clients pay in installments with three points, Included in Specialist at $119.25 a month billed yearly or $149 monthly, and Upgrade to Specialist."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/unlock-dialog-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The same Unlock dialog as a sheet on a phone at 125% text: the installments preview, what it does, Included in Specialist with its price, and Upgrade to Specialist above Compare plans."
          },
          "whereToFind": "Any feature with a plan lock → tap the lock or See how it works",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Pricing",
              "href": "/pricing"
            },
            {
              "label": "Online payments",
              "href": "/features/payments"
            }
          ]
        },
        {
          "id": "locked-explained",
          "title": "Locked reports and actions now say which plan has them",
          "body": [
            "Places that used to hide a locked option or do nothing now show it with its plan. Financial reports lists the extra reports under More reports on Commander, each with a lock.",
            "Create expense in the share menu and the task Time row show their plan, and the PRO chip plus Team members and Booking in Settings open the same Unlock dialog as other locked features."
          ],
          "highlights": [
            "More reports on Commander, listed with locks",
            "Locked actions show the plan that includes them",
            "Every lock opens the Unlock dialog"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/locked-reports.webp",
            "width": 1600,
            "height": 1019,
            "alt": "Financial reports on Specialist: AR Aging, Customer Profitability and Job Profitability open, then More reports on Commander with a Commander badge and ten locked reports including Profit & Loss, Balance Sheet, Cash Flow Statement and Tax Summary."
          },
          "imagePhone": null,
          "whereToFind": "Accounting → Reports, the share menu, a task's Time row, and Settings → Team members or Booking",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Accounting",
              "href": "/features/accounting"
            },
            {
              "label": "Pricing",
              "href": "/pricing"
            }
          ]
        },
        {
          "id": "limit-dialog",
          "title": "Hitting a plan limit shows your usage and the next step",
          "body": [
            "When you reach a limit on your plan, one dialog now explains it instead of a short error or a button that does nothing. It covers team seats, phone numbers, full file storage, a file too large for the space left, AI imports over your plan's limit and running out of usage.",
            "The dialog shows your real usage, such as 1 of 1 seat used or 5 GB of 5 GB used, then the next plan that lifts the limit with what it includes and its price. Where you can add a single seat or ask for more phone numbers, that option comes first. Upgrade opens your plans with that plan suggested."
          ],
          "highlights": [
            "Your real usage, shown as a meter",
            "The next plan that lifts the limit",
            "Add a seat or request numbers where you can"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/limit-dialog.webp",
            "width": 1040,
            "height": 1245,
            "alt": "The Limit reached dialog for team seats: a Team & seats card showing 1 of 1 seat used, the heading Every seat on your plan is taken, and a Voyager card with 2 seats included, its yearly and monthly price and Upgrade to Voyager."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/limit-dialog-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The same dialog as a sheet on a phone at 125% text for full storage: 5 GB of 5 GB used, Your file storage is full, and Voyager with 50 GB of file storage above Upgrade to Voyager and Not now."
          },
          "whereToFind": "Appears when you reach a limit, for example inviting a team member, adding a phone number or uploading a file",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Pricing",
              "href": "/pricing"
            },
            {
              "label": "Files",
              "href": "/features/files"
            }
          ]
        },
        {
          "id": "safer-unsaved-work",
          "title": "Unsaved work stays quiet until it needs you",
          "body": [
            "When an editor keeps your changes on this device, a small line under the title says Unsaved changes, Backed up on this device. A full message appears only when there is something to do: changes found from earlier that you can restore or skip, a newer version saved somewhere else, or a backup that failed. In the last two cases a Copy backup button lets you keep your work before you leave.",
            "This works in invoices, change orders, the knowledge base and email templates. Proposals and notes also warn you and let you copy a backup when your work needs attention."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/offline-saves.webp",
            "width": 1544,
            "height": 1057,
            "alt": "The unsaved-work states: a quiet line reading Unsaved changes, Backed up on this device; a message offering Restore changes or Keep saved version; a notice that this changed somewhere else with Copy backup; and a warning that changes couldn't be backed up with Copy backup."
          },
          "imagePhone": null,
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Edit template page for Project kickoff shows a card: You have unsaved changes from earlier. They were kept on this device. Restore them to review, or keep the saved version, with Restore changes and Keep saved version. Restore changes is chosen, the card shrinks to a line reading Restored from this device, Check it, then save, and a few words are typed into the body before Save.",
            "caption": "Changes kept on this device come back in one step, and a small line says what to do next. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Email templates",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-phone-light.webm",
                "poster": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-19-upgrade-prompts-and-safer-drafts/drafts-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Invoices, Change orders, Knowledge base and Email templates → the editor, under the title",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Invoices",
              "href": "/features/invoices"
            },
            {
              "label": "Proposals",
              "href": "/features/quoting"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "What happens when I tap a locked feature in Workspace369?",
          "a": "An Unlock dialog opens for that feature with a short animated preview, a few points on what it does, and the plan that includes it. Upgrade opens your plans with that plan suggested, and Compare plans shows them all."
        },
        {
          "q": "What happens when I reach a plan limit?",
          "a": "One dialog explains the limit and shows your real usage, such as 1 of 1 seat used or 5 GB of 5 GB used, then the next plan that lifts it. It covers team seats, phone numbers, file storage, AI imports and running out of usage."
        },
        {
          "q": "Where do I see which plan has a financial report?",
          "a": "Open Reports. Reports your plan doesn't include are listed under a line such as More reports on Commander, each with a lock, and tapping one shows the plan that includes it."
        },
        {
          "q": "Does Workspace369 keep my work if I close an editor before saving?",
          "a": "It keeps your changes on this device in invoices, change orders, the knowledge base and email templates, and shows Unsaved changes, Backed up on this device under the title. Proposals and notes also warn you and let you copy a backup when your work needs attention."
        },
        {
          "q": "What if a newer version of my document was saved somewhere else?",
          "a": "The editor shows a full message and a Copy backup button so you can keep your work before you leave. The same happens if a backup fails."
        }
      ]
    },
    {
      "slug": "2026-10-18-flash-pay",
      "updated": "2026-11-04",
      "date": "2026-10-18",
      "title": "Flash Pay: take a payment on the spot with a QR code or a pay link",
      "seoTitle": "Flash Pay: QR Code and Pay Link Payments",
      "summary": "Type an amount, turn your phone to the customer and let them pay by Apple Pay, Google Pay or card. Every Flash Pay becomes a paid invoice, with optional tips.",
      "areas": [
        "billing"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-18-flash-pay/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a phone showing a QR code, a cyan lightning bolt, a curling paper receipt and a gold coin with a star for a tip."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Flash Pay in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "flash-pay-qr",
          "title": "Get paid by QR code, right where you are",
          "body": [
            "Open Flash Pay, type the amount and choose Show QR code. Turn the phone to your customer: they point their camera at it and pay with Apple Pay, Google Pay or a card on a secure page with your business name. You'll need Stripe connected first.",
            "You don't need their details first. They add their own name and email when they pay, and the screen shows Payment received the moment it goes through."
          ],
          "highlights": [
            "Apple Pay, Google Pay or card",
            "No customer details needed up front",
            "Works through your own Stripe account"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-18-flash-pay/qr-code.webp",
            "width": 1600,
            "height": 1000,
            "alt": "Flash Pay's QR screen in light and dark mode: Apex Auto Spa, Scan to pay, a large QR code above $120.00 and the line Apple Pay, Google Pay or card."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-18-flash-pay/qr-code-phone.webp",
            "width": 780,
            "height": 1380,
            "alt": "Flash Pay's QR screen on a phone: Apex Auto Spa, Scan to pay, a large QR code above $120.00 and the line Apple Pay, Google Pay or card, waiting for payment."
          },
          "whereToFind": "Flash Pay in the sidebar, just below Invoices",
          "appRoute": "/flash-pay",
          "plans": "all",
          "links": [
            {
              "label": "Online payments",
              "href": "/features/payments"
            },
            {
              "label": "Stripe integration",
              "href": "/integrations/stripe"
            },
            {
              "label": "Invoices and billing",
              "href": "/features/invoices"
            }
          ],
          "motion": {
            "layout": "tablet-phone",
            "alt": "On an iPad and an iPhone, Flash Pay opens at 0 dollars, 8, 5 and 00 are tapped to make 85 dollars, and Show QR code opens a QR code for Northstar Studio with Waiting for payment. The screen then shows Payment received for 97.75 dollars from Maya Chen, with a 12.75 dollar tip, invoice 26-142 and New client saved.",
            "caption": "Type the amount, show the QR code, and see Payment received when the customer pays. Example data.",
            "duration": "PT7S",
            "large": {
              "width": 1280,
              "height": 894,
              "light": {
                "mp4": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-light.mp4",
                "webm": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-light.webm",
                "poster": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-dark.mp4",
                "webm": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-dark.webm",
                "poster": "/images/release-notes/2026-10-18-flash-pay/flash-pay-ipad-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-light.webm",
                "poster": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-18-flash-pay/flash-pay-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "flash-pay-link",
          "title": "Or text and email a pay link",
          "body": [
            "Not standing next to the customer? Create a pay link instead and copy it, share it from your phone, or send it by text (from Voyager) or email. The link shows the same secure checkout as the QR code.",
            "Links expire after the number of days you choose: 1, 7, 30 or 90. You can cancel a link that hasn't been paid, and nothing is charged. (Changed Nov 3: before you create a link you can add a Client, so the payment lands on that client, and Items with a name, price and quantity, which add up to the amount. On a computer you can also add a tax rate, and the total shows with tax. Text message and Email fill in the client's phone or email, and nothing goes out until you send it; texting starts on Voyager.)"
          ],
          "highlights": [
            "Copy, share, text or email",
            "You set when links expire",
            "Cancel an unpaid link, nothing charged"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-18-flash-pay/pay-link.webp",
            "width": 780,
            "height": 880,
            "alt": "Send payment link on a phone at 125% text: a 369.dev/pay link with Copy, a note that copying or sharing needs no customer details, Text message, Email and Share buttons, Expires in 7 days, and Done."
          },
          "imagePhone": null,
          "whereToFind": "Flash Pay → type an amount → Send payment link",
          "appRoute": "/flash-pay",
          "plans": "all",
          "links": [
            {
              "label": "Online payments",
              "href": "/features/payments"
            },
            {
              "label": "Stripe integration",
              "href": "/integrations/stripe"
            },
            {
              "label": "Invoices and billing",
              "href": "/features/invoices"
            }
          ]
        },
        {
          "id": "flash-pay-paid-invoice",
          "title": "Each payment becomes a paid invoice, with optional tips",
          "body": [
            "Every Flash Pay is booked as a paid invoice, so it shows in your invoices and reports like any other payment.",
            "In Flash Pay settings you can ask for a tip with your own suggested percentages, or fixed amounts for small sales, and choose whether tips are worked out before or after tax. Choose which customer details to ask for, and whether to save customers as clients: Flash Pay matches an existing client by email or phone first."
          ],
          "highlights": [
            "Booked as a paid invoice",
            "Optional tips with your own suggestions",
            "Matches existing clients by email or phone",
            "Customers saved as clients if you want"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-18-flash-pay/payment-received.webp",
            "width": 1600,
            "height": 1000,
            "alt": "The Payment received screen in light and dark mode: $138.00 from Maya Chen, saved as a new client, and invoice 26-115 with an $18.00 tip."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-18-flash-pay/payment-received-phone.webp",
            "width": 780,
            "height": 1460,
            "alt": "The Payment received screen in dark mode: $138.00 from Maya Chen, saved as a new client, and invoice 26-115 with an $18.00 tip."
          },
          "whereToFind": "Settings → Invoices → Flash Pay",
          "appRoute": "/settings/flash-pay",
          "plans": "all",
          "links": [
            {
              "label": "Online payments",
              "href": "/features/payments"
            },
            {
              "label": "Stripe integration",
              "href": "/integrations/stripe"
            },
            {
              "label": "Invoices and billing",
              "href": "/features/invoices"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans include Flash Pay?",
          "a": "Every plan. Flash Pay is in the sidebar on all plans, just below Invoices."
        },
        {
          "q": "How does a customer pay with Flash Pay?",
          "a": "Open Flash Pay, type the amount and choose Show QR code. The customer points their camera at it and pays with Apple Pay, Google Pay or a card on a secure page with your business name."
        },
        {
          "q": "What do I need before I can use Flash Pay?",
          "a": "You'll need Stripe connected first. Payments go through your own Stripe account, and you don't need the customer's details up front."
        },
        {
          "q": "Can I send a pay link instead of showing a QR code?",
          "a": "Yes. Type an amount, choose Send payment link, then copy, share, text or email it. You pick when links expire: 1, 7, 30 or 90 days. An unpaid link can be cancelled and nothing is charged."
        },
        {
          "q": "Where do I find Flash Pay and its settings?",
          "a": "Flash Pay is in the sidebar, just below Invoices. Its settings, including tips, are under Settings → Invoices → Flash Pay."
        },
        {
          "q": "What happens after a Flash Pay payment goes through?",
          "a": "Each one is booked as a paid invoice, so it shows in your invoices and reports, with any tip on the same invoice."
        }
      ]
    },
    {
      "slug": "2026-10-18-client-emails-in-your-brand",
      "date": "2026-10-18",
      "title": "Client emails now arrive in your brand, and signatures get a proper editor",
      "seoTitle": "Branded Client Emails and Signatures",
      "summary": "Invoice reminders, proposals, receipts and e-signature emails go out in your workspace's look from your mailbox, with a richer signature editor and a clearer reply box.",
      "areas": [
        "billing",
        "inbox",
        "proposals"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-18-client-emails-in-your-brand/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a fan of envelopes closed with cyan wax seals, a fountain pen drawing a signature and a small stack of business cards."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Branded client emails and signatures in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "branded-client-emails",
          "title": "Client emails in your own look, from your own mailbox",
          "body": [
            "Emails your clients get from you now carry your workspace's email look: your logo, brand color and layout. They go from your business mailbox, so a reply comes back to you.",
            "This covers payment reminders with the invoice PDF attached, proposal emails and proposal accepted and follow-up emails, payment receipts, billing and autopay notices, e-signature emails and change-order emails."
          ],
          "highlights": [
            "Reminders, proposals, receipts, e-signature and change-order emails",
            "Replies come back to your business mailbox",
            "Replies you type in the Inbox still go out as plain email"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Automatic when you send from Invoices, Proposals, Contracts and Change orders",
          "appRoute": "/settings/communications",
          "plans": "all",
          "links": [
            {
              "label": "Branded documents and emails",
              "href": "/features/branding"
            },
            {
              "label": "PDF customization",
              "href": "/features/pdf-customization"
            },
            {
              "label": "Invoices and billing",
              "href": "/features/invoices"
            }
          ]
        },
        {
          "id": "email-appearance",
          "title": "Choose your email layout and signature card",
          "body": [
            "In Email appearance you pick left-aligned or centered text and whether your logo sits on top or small beside your business name under the message. You can set the size of that signature logo.",
            "A signature card shows your name and role next to the logo. Each inbox can follow the workspace look or override it for that inbox only."
          ],
          "highlights": [
            "Left or centered layout",
            "Logo on top or in the signature, with a size setting",
            "Name and role on the signature card",
            "Per-inbox override"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance.webp",
            "width": 1549,
            "height": 1575,
            "alt": "Settings, Email appearance for the demo workspace Apex Auto Spa: Send as Branded or Plain text, eight email layouts with Branded Band selected, Alignment Left or Centered, Logo position Top, Signature or None, and a live preview of an invoice email with a View invoice button."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "Email appearance on a phone at larger text, scrolled to the live preview: an invoice email from Apex Auto Spa with a View invoice button and a signature card for Jordan Lee, Owner, under the message."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, Email appearance in Settings: the Letterhead layout is picked and the invoice email preview changes, Alignment is set to Centered, Logo position is set to Signature, and a signature card for Jordan Lee, Owner appears under the message in the preview.",
            "caption": "Pick a layout, center the text and add a signature card, and the live preview updates. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Email appearance",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-phone-light.webm",
                "poster": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-18-client-emails-in-your-brand/email-appearance-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings → Email, SMS & phone → Email → Email appearance",
          "appRoute": "/settings/communications",
          "plans": "all",
          "links": [
            {
              "label": "Branded documents and emails",
              "href": "/features/branding"
            },
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            }
          ]
        },
        {
          "id": "signature-editor",
          "title": "A signature editor that does the work for you",
          "body": [
            "Size each signature image (100, 160, 240 or 360 pixels wide), color your text and add a divider line. Starting from nothing, build a signature from a short form with job title, company, phone and website.",
            "Or paste the HTML of your existing Gmail or Outlook signature and keep its text, links, colors, images and dividers. Reply boxes now show your signature as a preview under the message."
          ],
          "highlights": [
            "Image sizes, text color and divider",
            "Build from a short form",
            "Paste an existing HTML signature",
            "Same signature for your own sends and each inbox's shared one"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-18-client-emails-in-your-brand/signature-editor.webp",
            "width": 1520,
            "height": 950,
            "alt": "The My signature editor with bold, italic, underline, link, text color, divider and image tools, a three-line signature for Jordan Lee at Apex Auto Spa and its preview below."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Email, SMS & phone → My preferences → My signature",
          "appRoute": "/settings/communications",
          "plans": "all",
          "links": [
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            }
          ]
        },
        {
          "id": "reply-box-shortcuts",
          "title": "A reply box with a real Send button and shortcuts",
          "body": [
            "In the Inbox, Enter now starts a new line, so you can write a paragraph on a phone. Press Cmd or Ctrl and Enter to send, and Esc to close the quick-reply list or minimize the box. Send is a proper button in both the conversation and Emails reply boxes, and on desktop its tooltip shows the shortcut."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-18-client-emails-in-your-brand/reply-box.webp",
            "width": 1800,
            "height": 760,
            "alt": "The Inbox reply box on desktop, replying to Detailing quote: a two-line reply typed on separate lines, the sender's signature preview under it, and the Send button with its tooltip, Send (⌘↵)."
          },
          "imagePhone": null,
          "whereToFind": "Inbox, or Emails, in the reply box",
          "appRoute": "/communications/inbox",
          "plans": "all",
          "links": [
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Do Workspace369 emails to my clients use my branding?",
          "a": "Yes. They carry your workspace's email look: your logo, brand color and layout. They are sent from your business mailbox, so replies come back to you."
        },
        {
          "q": "Which client emails are branded?",
          "a": "Payment reminders with the invoice PDF attached, proposal emails and proposal accepted and follow-up emails, payment receipts, billing and autopay notices, e-signature emails and change-order emails."
        },
        {
          "q": "Where do I change my email layout?",
          "a": "In Settings → Email, SMS & phone → Email → Email appearance. You choose left-aligned or centered text, put your logo on top or small beside your business name, and set the signature logo size."
        },
        {
          "q": "Can I use my existing Gmail or Outlook signature?",
          "a": "Yes. Paste the HTML of your existing signature in Settings → Email, SMS & phone → My preferences → My signature, and it keeps its text, links, colors, images and dividers."
        },
        {
          "q": "Can I send a reply with a keyboard shortcut?",
          "a": "Yes. Press Cmd or Ctrl and Enter to send. Enter starts a new line, and Esc closes the quick-reply list or minimizes the box."
        },
        {
          "q": "Which plans include branded client emails?",
          "a": "Every Workspace369 plan includes branded client emails."
        }
      ]
    },
    {
      "slug": "2026-10-17-more-ways-for-clients-to-pay",
      "date": "2026-10-17",
      "title": "More ways for clients to pay, and a redesigned invoice editor",
      "seoTitle": "More Ways to Get Paid on Invoices",
      "summary": "Choose which payment methods clients see through your Stripe account, override them on a single invoice, and edit invoices in a cleaner tabbed editor.",
      "areas": [
        "billing"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a payment card, a phone with contactless waves, a bank building and three coin stacks of rising height."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "More ways to get paid in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "payment-methods",
          "title": "Choose how clients can pay you online",
          "body": [
            "In Online payments, a new Payment methods tab lets you set who pays you (people, businesses or both) and switch on the ways they can pay. Cards are always on; Apple Pay and Google Pay start on.",
            "You can also turn on bank account (ACH) payments, with an optional amount below which bank payments are not offered, pay over time with Affirm, Klarna or Afterpay, Cash App Pay and Amazon Pay."
          ],
          "highlights": [
            "Apple Pay, Google Pay and cards",
            "Bank account (ACH) with an optional minimum amount",
            "Affirm, Klarna and Afterpay, shown to individuals only",
            "Each method shows its status from your Stripe account"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods.webp",
            "width": 1400,
            "height": 1446,
            "alt": "Settings, Online payments, Payment methods: Who pays you set to Both, Cards always on, Apple Pay and Google Pay on and Ready, Bank account (ACH) on with an Only offer from amount, Affirm marked Turn on in Stripe, Klarna marked Stripe is reviewing, and Afterpay, Cash App Pay and Amazon Pay Ready with switches off."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-phone-still.webp",
            "width": 780,
            "height": 1696,
            "alt": "Settings, Online payments, Payment methods on a phone: Who pays you set to Both, Cards always on, and Apple Pay and Google Pay both switched on and marked Ready."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, Settings, Online payments, Payment methods: Who pays you changes from People to Both, then the Google Pay switch under Cards and wallets turns on and its status reads Ready.",
            "caption": "Choose who pays you, then switch on the ways they can pay. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Online payments",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-phone-light.webm",
                "poster": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/payment-methods-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings → Online payments → Payment methods",
          "appRoute": "/settings/online-payments",
          "plans": "all",
          "links": [
            {
              "label": "Online payments",
              "href": "/features/payments"
            },
            {
              "label": "Stripe",
              "href": "/integrations/stripe"
            },
            {
              "label": "Invoices and payments docs",
              "href": "https://docs.workspace369.com/v/2026.3/finance/invoices-and-payments/"
            }
          ]
        },
        {
          "id": "invoice-payment-methods",
          "title": "Pick the methods for one invoice and preview what your client sees",
          "body": [
            "Methods work through your Stripe account, so each one shows whether Stripe has it ready, is still reviewing it, or does not offer it for your country or business. A method that is not ready is not shown to clients.",
            "On any invoice, the Payment tab can use your defaults or a custom set for just that invoice, with a preview of what the client will see. Bank payments take days to clear, and the app shows one that is still on its way so you do not take payment twice."
          ],
          "highlights": [
            "Default or custom methods per invoice",
            "Preview of what the client will see",
            "Bank payments still clearing are flagged on the invoice"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/invoice-payment-methods.webp",
            "width": 1470,
            "height": 930,
            "alt": "An invoice's Payment tab: How Ruiz Bakery can pay, Online selected, Default or Custom methods, a note that bank (ACH) is off in your defaults with Turn on, Bill to From client, and The client will see Cards, Apple Pay and Google Pay."
          },
          "imagePhone": null,
          "whereToFind": "Invoices → open an invoice → Payment tab → Payment methods",
          "appRoute": "/invoices",
          "plans": "all",
          "links": [
            {
              "label": "Invoices and billing",
              "href": "/features/invoices"
            },
            {
              "label": "Online payments",
              "href": "/features/payments"
            }
          ]
        },
        {
          "id": "invoice-editor",
          "title": "A tabbed invoice editor with problems shown next to the field",
          "body": [
            "The invoice editor's left panel now has Details, Payment and More tabs, and recurring plans get Details and Repeat. Clients, contacts, dates and terms are simple rows with search and quick-create, and anything wrong is flagged beside the field so you can fix it. The live PDF preview stays on the right. On a phone, a bottom bar keeps the total, Preview and Send within reach."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/invoice-editor.webp",
            "width": 1180,
            "height": 1225,
            "alt": "The invoice editor's Details tab for a recurring invoice: Lumen Labs has no email on file, flagged in red under the Contact field with an Add email link, next to the client, due and repeat rows, with three line items below."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-17-more-ways-for-clients-to-pay/invoice-editor-phone.webp",
            "width": 585,
            "height": 1266,
            "alt": "The invoice editor on a phone: issue date, due date, repeat and signature rows, three line items, and a bottom bar with the $9,690.00 total, Preview and Send."
          },
          "whereToFind": "Invoices → New invoice, or open a draft",
          "appRoute": "/invoices",
          "plans": "all",
          "links": [
            {
              "label": "Invoices and billing",
              "href": "/features/invoices"
            },
            {
              "label": "Retainers and recurring billing",
              "href": "/features/retainers-and-recurring-billing"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Is choosing payment methods on every plan?",
          "a": "Every plan. Payment methods, per-invoice methods and the tabbed invoice editor are on all plans."
        },
        {
          "q": "Where do I choose which payment methods clients see?",
          "a": "Go to Settings → Online payments → Payment methods. There you set who pays you (people, businesses or both) and switch on the ways they can pay."
        },
        {
          "q": "Which payment methods can I turn on?",
          "a": "Cards are always on, and Apple Pay and Google Pay start on. You can also turn on bank account (ACH), Affirm, Klarna and Afterpay, Cash App Pay and Amazon Pay."
        },
        {
          "q": "Can I change payment methods for just one invoice?",
          "a": "Yes. Open the invoice and use the Payment tab. It can use your defaults or a custom set for that invoice, with a preview of what the client will see."
        },
        {
          "q": "Why might a payment method not show to my clients?",
          "a": "Methods work through your Stripe account. A method that is not ready, because Stripe is still reviewing it or does not offer it for your country or business, is not shown to clients."
        },
        {
          "q": "Do bank payments clear instantly?",
          "a": "No. Bank payments take days to clear, and the app shows one that is still on its way so you do not take payment twice. In Settings → Online payments → Payment methods you can also set an optional amount below which bank payments are not offered."
        }
      ]
    },
    {
      "slug": "2026-10-16-ai-approvals-linkable-settings-new-home",
      "date": "2026-10-16",
      "title": "Approve what connected AI apps send, link to any settings page, and try the new Home",
      "seoTitle": "AI Approvals and a New Home Option",
      "summary": "Messages that Claude, ChatGPT or another connected AI wants to send wait for your approval, settings pages get their own web links, and a new Home arrives, now the only Home.",
      "areas": [
        "ai",
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a paper airplane message waiting at a checkpoint gate beside an approval stamp, in front of a grid of dashboard tiles."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Approvals, settings links and the new Home",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "ai-approvals",
          "title": "Approve what a connected AI app wants to send",
          "body": [
            "When an AI app connected to Workspace369, such as Claude or ChatGPT, tries to send an invoice, email, text or contract for you, the request waits for your approval. You see what it wants to send and when the request expires, then approve or decline. Past requests stay listed with their outcome. For an app you trust, a per-app setting lets it send without asking."
          ],
          "highlights": [
            "Approve or decline in the app",
            "Requests expire if you do not act",
            "Send-without-asking is off by default and set per connected app"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals.webp",
            "width": 1400,
            "height": 880,
            "alt": "The Approvals page: two requests waiting for you, an invoice from Claude and a text from ChatGPT, and recent requests marked Done, Declined and Expired."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approval-phone.webp",
            "width": 780,
            "height": 1380,
            "alt": "One approval on a phone: Claude, verified, asks to send invoice 26-58 for $2,200.00 to Jordan Lee, with the recipient, subject and message, an expiry time, and Approve and send or Decline."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Approvals list shows one request waiting for you, an invoice from Claude for Maya Okafor, above recent requests marked Done and Declined. The request opens to show who is asking, the recipient, amount, subject and message, and when it expires, with Approve and send and Decline. Approve and send is tapped, the page says Approved and done, and back on the list the invoice now sits under Recent marked Done.",
            "caption": "A connected AI app's send waits for your approval, and past requests stay listed with their outcome. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Approvals",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-phone-light.webm",
                "poster": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/approvals-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings → Approvals",
          "appRoute": "/settings/approvals",
          "plans": "all",
          "links": [
            {
              "label": "AI connections (MCP)",
              "href": "/integrations/mcp"
            },
            {
              "label": "AI chat",
              "href": "/features/ai-chat"
            }
          ]
        },
        {
          "id": "settings-links",
          "title": "Every settings page has its own web address",
          "body": [
            "On the web app, each Settings page now has its own address, for example /settings/billing or /settings/ai-connections. Refresh the page, bookmark it or send the link, and it reopens the same page. Nested settings pages on tablet and desktop also have a Back button."
          ],
          "highlights": [],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Web app: any Settings page",
          "appRoute": "/settings",
          "plans": "all",
          "links": [
            {
              "label": "Features",
              "href": "/features"
            }
          ]
        },
        {
          "id": "new-home",
          "title": "A new Home you can switch on",
          "body": [
            "The new Home was optional when this shipped, with the classic Home as the default. (Changed Oct 31: the new Home is now the only Home for everyone, and the Home switch in Settings → Appearance is gone.)",
            "It adds a strip of overdue, waiting and to-sign figures, an Ask bar for AutoPilot, a needs-attention list and today's plan, plus money, pipeline and timesheet widgets. Drag, resize, add and hide widgets in Customize, on phones too."
          ],
          "highlights": [
            "Overdue, waiting and to-sign figures at the top",
            "Customize by dragging, resizing, adding and hiding widgets",
            "Owners and admins set the starting Home for each role from Team → Home layouts",
            "Only widgets a person has access to appear"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-16-ai-approvals-linkable-settings-new-home/new-home.webp",
            "width": 1300,
            "height": 700,
            "alt": "The new Home: a greeting, overdue, waiting-on-a-reply and to-sign figures, an Ask bar for AutoPilot with suggested prompts, a Needs your attention list with one-click actions, and today's events and tasks."
          },
          "imagePhone": null,
          "whereToFind": "Home; role layouts from the Team members screen",
          "appRoute": "/settings/appearance",
          "plans": "all",
          "links": [
            {
              "label": "Dashboards and reports",
              "href": "/features/analytics"
            },
            {
              "label": "AI chat",
              "href": "/features/ai-chat"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I approve what Claude or ChatGPT sends from my Workspace369 account?",
          "a": "Yes. When a connected AI app tries to send an invoice, email, text or contract for you, the request waits for your approval. You see what it wants to send and when the request expires, then approve or decline."
        },
        {
          "q": "Where do I find AI send approvals?",
          "a": "In Settings → Approvals. Past requests stay listed with their outcome."
        },
        {
          "q": "Can I let a trusted AI app send without asking?",
          "a": "Yes. A per-app setting lets an app you trust send without asking."
        },
        {
          "q": "Does every settings page have its own web link?",
          "a": "Yes, on the web app. For example /settings/billing or /settings/ai-connections reopens the same page when you refresh, bookmark it or send the link."
        },
        {
          "q": "Which plans include AI approvals and linkable settings?",
          "a": "Every Workspace369 plan includes AI approvals and linkable settings."
        }
      ]
    },
    {
      "slug": "2026-10-14-google-events-meet-email-domains-and-sms-templates",
      "date": "2026-10-14",
      "title": "Google events in your calendar, Meet for all, easier email domains and SMS templates",
      "seoTitle": "Google Calendar, Meet and SMS Templates",
      "summary": "See your Google Calendar events next to your bookings, add Google Meet on any plan, connect a custom email domain in three steps, and save reusable texts.",
      "areas": [
        "scheduling",
        "inbox"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Overlapping calendar grids, a video camera and speech bubbles beside a real Workspace369 calendar week that shows Google events next to client meetings."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Google events, Meet, email domains and SMS templates",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "google-events",
          "title": "See your Google Calendar events in your calendar",
          "body": [
            "Turn on Show my Google events in Workspace369 and the events from the Google calendars you choose appear in your Workspace369 calendar next to your bookings. They are read-only and only you can see them, so you spot conflicts before you book.",
            "To change one of those events, edit it in Google Calendar. You choose which of your Google calendars appear, so personal calendars you leave off stay out of view."
          ],
          "highlights": [
            "Choose which Google calendars to show",
            "Read-only and visible only to you",
            "Appears in every calendar view"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/google-events-week.webp",
            "width": 1600,
            "height": 1025,
            "alt": "A week in the Workspace369 calendar with Google events such as Dentist, Gym and School pickup shown next to client meetings like a discovery call and a proposal review."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Integrations → Google Calendar → Show my Google events in Workspace369",
          "appRoute": "/settings/integrations",
          "plans": "all",
          "links": [
            {
              "label": "Google Calendar",
              "href": "/integrations/google-calendar"
            },
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        },
        {
          "id": "google-meet",
          "title": "Google Meet on every plan, with nothing to switch on",
          "body": [
            "Google Meet is available to every workspace. Each team member connects their own Google account, and connecting Google Calendar connects Meet too. Any member, not only managers, can connect from the Meet page.",
            "Use Meet links on calendar events on every plan. On Specialist and above, booking pages and services can also use Google Meet as the meeting location, so clients get a link when they book."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/google-meet.webp",
            "width": 1600,
            "height": 807,
            "alt": "The Google Meet page under Settings, Integrations: Connected, a Google account row ready to host Google Meet calls with a Disconnect button, and what you get, such as a Meet link on every video booking."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Integrations → Google Meet; booking page editor → meeting location",
          "appRoute": "/settings/integrations",
          "plans": "all",
          "links": [
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            },
            {
              "label": "Google Calendar",
              "href": "/integrations/google-calendar"
            }
          ]
        },
        {
          "id": "email-domain-setup",
          "title": "Connect your own email domain in three steps",
          "body": [
            "Adding your domain is now three steps: your domain, add the records, then check and finish. Paste any address or web link and it is cleaned up for you, and records are grouped by purpose with one-tap copy.",
            "There is a how-to for Cloudflare, GoDaddy, Namecheap, Squarespace and Wix, every check says what to fix, and you can keep existing Google Workspace or Microsoft 365 mail working."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/email-domain-records.webp",
            "width": 1600,
            "height": 1125,
            "alt": "Setting up a custom email domain: sending is ready, one record is left to receive email, and each DNS record shows whether it was found."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/email-domain-records-phone.webp",
            "width": 780,
            "height": 1560,
            "alt": "Custom email domain setup on a phone: sending is ready, with one step left to add the record that lets replies reach the inbox."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, Settings, Email, Domains and connections opens Add domain. A web link pasted into the first step, https://www.fernhilldesign.example/contact, is cleaned up to fernhilldesign.example when Continue is tapped. The second step lists the records to add, grouped by purpose: To send email, To receive email and optional branded links, each with a copy button; tapping copy on a record shows a check. The third step checks the records and shows fernhilldesign.example is connected, with Send and Receive both Ready. Example data.",
            "caption": "Paste a web link, copy the records, and the check shows your domain connected once they're live. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Domains & connections",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-phone-light.webm",
                "poster": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/domain-setup-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings → Email, SMS & phone → Email → Domains & connections → Add domain",
          "appRoute": "/settings/communications",
          "plans": "all",
          "links": [
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            },
            {
              "label": "SendGrid",
              "href": "/integrations/sendgrid"
            }
          ]
        },
        {
          "id": "sms-templates",
          "title": "Reusable text messages with a default for each message type",
          "body": [
            "Save texts you send often, with fields that fill in for each client, and see a phone-bubble preview and how many parts the message will be sent in. Choose the text that opens when you text an invoice, a proposal, an appointment or a request reply.",
            "Starter templates are included, and every composer that sends a text offers your templates. Each part of a longer text counts toward your plan's usage, and the editor warns you before you send."
          ],
          "highlights": [
            "Defaults for invoice, proposal, appointment and request texts",
            "Merge fields and a message preview",
            "Shared with your team"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-14-google-events-meet-email-domains-and-sms-templates/sms-templates.webp",
            "width": 1600,
            "height": 1226,
            "alt": "The SMS templates page: a default text for invoice, proposal and appointment texts and request replies, a Browse starters button, and saved templates such as Invoice ready and Appointment reminder with their fields."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Email, SMS & phone → Phone & SMS → SMS templates",
          "appRoute": "/settings/communications",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I see my Google Calendar events in Workspace369?",
          "a": "Yes. Turn on Show my Google events in Workspace369 under Settings → Integrations → Google Calendar. The events are read-only and only you can see them."
        },
        {
          "q": "Is Google Meet available on every plan?",
          "a": "Yes. Each team member connects their own Google account, and connecting Google Calendar connects Meet too. Meet links on calendar events work on every plan; booking pages and services can use Meet as the meeting location on Specialist and above."
        },
        {
          "q": "Can I connect my own email domain?",
          "a": "Yes. Adding a domain takes three steps: your domain, add the records, then check and finish. There is a how-to for Cloudflare, GoDaddy, Namecheap, Squarespace and Wix."
        },
        {
          "q": "Can I keep my Google Workspace or Microsoft 365 mail when I add a domain?",
          "a": "Yes. You can keep existing Google Workspace or Microsoft 365 mail working."
        },
        {
          "q": "Which plans include SMS templates?",
          "a": "Voyager, Specialist, Commander and Enterprise."
        },
        {
          "q": "What can I do with SMS templates?",
          "a": "Save texts you send often with fields that fill in for each client, see a phone-bubble preview and how many parts the message will be sent in, and choose the text that opens for an invoice, proposal, appointment or request reply. Each part of a longer text counts toward your plan's usage."
        }
      ]
    },
    {
      "slug": "2026-10-11-retainers-and-recurring-autopay",
      "date": "2026-10-11",
      "title": "Retainers that track every hour, and recurring invoices on autopay",
      "seoTitle": "Retainers and Recurring Invoices on Autopay",
      "summary": "Run hour-bank, fixed monthly and prepaid retainers with a live hours meter, put repeat invoices on card autopay your clients agree to, and void unpaid invoices cleanly.",
      "areas": [
        "billing",
        "work"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "The Workspace369 retainer record for a 40-hour product design retainer, showing 3 hours left this cycle, the allowance and billing details, and the team's time entries."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Retainers and recurring autopay in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "retainers",
          "title": "Retainers with a live hours meter",
          "body": [
            "Set a retainer up as an hour bank, a fixed monthly fee or a prepaid deposit. Each one has its own record with the allowance, the price, the billing cycle and the client contact in one place.",
            "Time your team logs against the client counts toward the cycle as it happens. The meter shows approved hours, hours waiting for your approval and what is left, and it warns you before extra hours land on the next invoice."
          ],
          "highlights": [
            "Hour bank, fixed monthly and prepaid deposit retainers",
            "Approve pending time before it counts, then bill extra hours at your rate",
            "Choose whether unused hours expire or roll over",
            "Alerts when a retainer reaches 80% and 100% of its hours"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainer-record.webp",
            "width": 1600,
            "height": 1075,
            "alt": "A retainer record with the allowance and billing details on the left, a cycle chart showing 37 of 40 hours approved, and the team's time entries for October."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainer-record-phone.webp",
            "width": 780,
            "height": 1080,
            "alt": "The retainer record on a phone: 3 hours left this cycle, 37 of 40 hours approved and 3.5 hours waiting for approval, above the October time entries."
          },
          "whereToFind": "Retainers in the sidebar",
          "appRoute": "/retainers",
          "plans": "all",
          "links": [
            {
              "label": "Retainers and recurring billing",
              "href": "/features/retainers-and-recurring-billing"
            },
            {
              "label": "Time tracking",
              "href": "/features/time-tracking"
            },
            {
              "label": "Payment plans and retainers docs",
              "href": "https://docs.workspace369.com/v/2026.3/finance/payment-plans-credits-retainers/"
            }
          ],
          "motion": {
            "layout": "tablet-phone",
            "alt": "On an iPad and an iPhone, the Retainers list opens, Product design retainer for Northline Health is tapped, and its page shows 3 hours left this cycle, 37 of 40 hours approved and 3.5 waiting, the time entries, and billing monthly on the 1st with the client’s card on autopay. On the iPad, the Ledger tab then opens to show each approval and the 80% alert.",
            "caption": "Open a retainer to see the hours left this cycle, the time waiting for approval and how it bills. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 894,
              "light": {
                "mp4": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-ipad-light.mp4",
                "webm": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-ipad-light.webm",
                "poster": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-ipad-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-ipad-dark.mp4",
                "webm": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-ipad-dark.webm",
                "poster": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-ipad-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-phone-light.webm",
                "poster": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainers-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "retainer-list",
          "title": "Every retainer on one screen",
          "body": [
            "The Retainers list shows monthly retainer revenue, hours used this cycle, prepaid money you are holding and anything that needs your attention, above a table of every retainer with its cycle, next invoice and how it gets paid."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainer-list.webp",
            "width": 1600,
            "height": 1110,
            "alt": "The Retainers list in dark mode with totals for retainer revenue, hours used, prepaid balance held and retainers that need attention, above a table of eight retainers."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/retainer-list-phone.webp",
            "width": 780,
            "height": 1310,
            "alt": "The Retainers list on a phone in dark mode, with cards showing each retainer's hours this cycle, monthly amount and next invoice date."
          },
          "whereToFind": "Retainers in the sidebar",
          "appRoute": "/retainers",
          "plans": "all",
          "links": [
            {
              "label": "Invoices and billing",
              "href": "/features/invoices"
            }
          ]
        },
        {
          "id": "recurring-autopay",
          "title": "Recurring invoices on autopay your client controls",
          "body": [
            "Put hosting, maintenance or any repeat service on a recurring invoice plan, and each invoice goes out on its schedule. Clients agree to card autopay first and can manage it from a secure page.",
            "Before every automatic charge, your client gets an email 3 days ahead, or 7 days ahead of a yearly charge or the first charge after a long pause, with the date and amount. Plans that send by text also text the notice, so nobody is surprised."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/recurring-plan.webp",
            "width": 1600,
            "height": 1013,
            "alt": "A recurring Website care plan at $450 a month with autopay on a Visa card, a 3-day upcoming-charge notice, and a timeline of invoices paid by autopay each month."
          },
          "imagePhone": null,
          "whereToFind": "Invoices → Recurring",
          "appRoute": "/invoices?view=recurring",
          "plans": "all",
          "links": [
            {
              "label": "Online payments",
              "href": "/features/payments"
            },
            {
              "label": "Retainer agreement template",
              "href": "/learn/retainer-agreement-template"
            }
          ]
        },
        {
          "id": "void-invoice",
          "title": "Void an invoice that was sent but never paid",
          "body": [
            "Sent an invoice by mistake, or the job was called off? Void it from the invoice's actions menu. The invoice stays on record with who voided it, when, and the reason if you gave one. It no longer counts as overdue or as money owed, and its payment link stops working."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-11-retainers-and-recurring-autopay/void-invoice.webp",
            "width": 1400,
            "height": 1116,
            "alt": "Voiding invoice 26-61: a confirmation saying the client can no longer pay it, with an optional reason, Job was called off. Below, the invoice marked Void, kept on record with the date it was voided and the reason."
          },
          "imagePhone": null,
          "whereToFind": "Invoices → open an invoice → Actions → Void invoice",
          "appRoute": "/invoices",
          "plans": "all",
          "links": [
            {
              "label": "Invoices and billing",
              "href": "/features/invoices"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans include retainers and recurring autopay?",
          "a": "Every plan includes retainers, recurring invoices on autopay and voiding unpaid invoices."
        },
        {
          "q": "What kinds of retainers can I set up?",
          "a": "An hour bank, a fixed monthly retainer or a prepaid deposit. Each has its own record with the allowance, the price, the billing cycle and the client contact in one place."
        },
        {
          "q": "How does the retainer hours meter work?",
          "a": "Time your team logs against the client counts toward the cycle as it happens. The meter shows approved hours, hours waiting for your approval and what is left, and warns you before extra hours land on the next invoice."
        },
        {
          "q": "What does my client see before an autopay charge?",
          "a": "Clients agree to card autopay first and can manage it from a secure page. Before each charge they get an email 3 days ahead, or 7 days ahead of a yearly charge or the first charge after a long pause."
        },
        {
          "q": "Where do I find recurring invoices?",
          "a": "Recurring plans are under Invoices → Recurring."
        },
        {
          "q": "What happens when I void an invoice?",
          "a": "Open a sent but unpaid invoice and choose Actions → Void invoice. It stays on record with who voided it, when, and the reason if you gave one. It no longer counts as money owed, and its payment link stops working."
        }
      ]
    },
    {
      "slug": "2026-10-08-guided-setup-and-per-workspace-themes",
      "date": "2026-10-08",
      "title": "Guided setup that starts with your first client, and a theme for each workspace",
      "seoTitle": "Guided Setup and Workspace Themes",
      "summary": "New workspaces get a step-by-step setup card on Home, and each workspace you belong to can have its own light or dark mode and accent color.",
      "areas": [
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: stepping stones rising to a small flag, next to a fan of color swatch cards."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Guided setup and per-workspace themes",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "guided-setup",
          "title": "Set up one step at a time, starting with your first client",
          "body": [
            "Guided setup is a card on Home that takes a new workspace from empty to its first invoice one step at a time, starting with your first client. It is on every plan and is for anyone setting up Workspace369 for the first time.",
            "New workspaces get a setup card on Home that shows one Up next step at a time, with a progress bar, a count of steps done and about how many minutes are left. Use Skip for now on any step. A skipped step stays in All steps, so you can come back to it. Setup opens on adding your first client, with an option to import the rest later from a spreadsheet or CSV, and you review everything before it is saved.",
            "It then walks through your business profile, sending a first proposal, getting paid online, what you sell and your business email, with a live invoice preview that fills in from your own details. The profile step takes your business name, logo and address and shows them on an invoice header as you type. The payment step connects Stripe so clients can pay by card, Apple Pay or Google Pay from the invoice. One step sends your first invoice, with everything above filled in.",
            "Steps tick off by themselves when the work exists, for example once you have saved a service or sent a proposal. You can also tell setup what to handle first, such as invoices, proposals, payments, scheduling, tasks or projects, and how many people need access, and it builds a short list from your answers. When everything is done, the card says Setup complete and you can hide it. Setup options let you hide it from Home or show it again. Optional extras sit under More you can set up, so you can add them whenever you need them."
          ],
          "highlights": [
            "One Up next step at a time with a progress bar",
            "Skip any step for now; skipped steps stay in All steps",
            "Live invoice preview that fills in from your details",
            "Steps tick off on their own as you do the work"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-card.webp",
            "width": 1600,
            "height": 463,
            "alt": "The setup card on Home: Set up your workspace, 0 of 7 done with a seven-part progress bar, Up next step 1 of 7 Add your first client with Start and Skip for now, and shortcuts to a new invoice, client or task."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-card-phone.webp",
            "width": 780,
            "height": 1050,
            "alt": "The same setup card on a phone at 125% text: Up next, Add your first client, Start and Skip for now, then Invoice, Client and Task shortcuts."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the setup card on Home shows Set up your workspace, 0 of 8 done, with Up next, step 1 of 8, Add your first client, and Start and Skip for now. Start opens the step: the name Priya Raman and the email priya@oakleafstudio.example fill in the Bill to preview, and Add client saves them. Back on Home the card reads 1 of 8 done and the next Up next is step 2 of 8, Your booking page.",
            "caption": "Add your first client from the setup card and the card moves on to the next step. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Home",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-phone-light.webm",
                "poster": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/setup-loop-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "The setup card on Home, or Account setup",
          "appRoute": null,
          "plans": "all",
          "links": [
            {
              "label": "Invoices and billing",
              "href": "/features/invoices"
            },
            {
              "label": "Online payments",
              "href": "/features/payments"
            }
          ]
        },
        {
          "id": "workspace-appearance",
          "title": "A different theme and accent color for each workspace",
          "body": [
            "If you belong to several workspaces, you can give each its own light, dark or system mode and accent color. It is on every plan and is for people who switch between workspaces.",
            "Give each workspace its own look, for example pink and light for one and green and dark for another. The look switches as you change workspace.",
            "Text size and language stay the same everywhere. Pick the setting once under Applies to, and change it back to All workspaces at any time. Choosing Only this workspace saves the theme and accent for that workspace alone, and every other workspace keeps your default look. If you switch back to All workspaces, that workspace uses your default look after you save."
          ],
          "highlights": [
            "Light, dark or system mode per workspace",
            "Accent color per workspace",
            "Applies to: All workspaces or Only this workspace"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-08-guided-setup-and-per-workspace-themes/workspace-appearance.webp",
            "width": 1600,
            "height": 927,
            "alt": "The Appearance page: Applies to set to Only Fernhill Design instead of All workspaces, a note that only theme and accent change, then the Light, System and Dark themes and the accent color and text size settings."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Appearance → Applies to (All workspaces or Only this workspace)",
          "appRoute": "/settings/appearance",
          "plans": "all",
          "links": [
            {
              "label": "Themes",
              "href": "/features/themes"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can each Workspace369 workspace have its own theme and accent color?",
          "a": "Yes. If you belong to several workspaces, you can give each its own light, dark or system mode and accent color. Every Workspace369 plan includes it."
        },
        {
          "q": "Where do I set a different theme for one workspace?",
          "a": "Go to Settings → You → Appearance and, under Applies to, choose Only this workspace. Then pick the theme and accent color and save."
        },
        {
          "q": "What happens to my other workspaces when I set a theme for one?",
          "a": "They keep your default look. Choosing Only this workspace saves the theme and accent for that workspace alone, and switching back to All workspaces returns it to your default."
        },
        {
          "q": "Do text size and language change per workspace?",
          "a": "No. Text size and language stay the same in every workspace. Only the light, dark or system mode and the accent color can differ."
        }
      ]
    },
    {
      "slug": "2026-10-07-autopilot-chat-redesign",
      "date": "2026-10-07",
      "title": "AutoPilot chat is redesigned, with private chats, tables and one-tap next steps",
      "seoTitle": "AutoPilot Chat Redesign",
      "summary": "Chat with AutoPilot in a cleaner layout with private, renamable, pinnable chats and real tables, then run its suggested next steps with one tap.",
      "areas": [
        "ai"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-07-autopilot-chat-redesign/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: layered chat bubbles, one holding a small table, beside a compass pointing forward."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The redesigned AutoPilot chat",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "autopilot-chat",
          "title": "A redesigned AutoPilot chat with private chats and tables",
          "body": [
            "AutoPilot chat has a new look: a full-screen chat on phones, a chats list beside the conversation on tablets and desktops, and private chats you can rename, pin and delete. It is on every plan and is for anyone who asks AutoPilot about their workspace.",
            "On phones, AutoPilot chat is a clean full-screen conversation. On tablets and desktops a chats list sits beside it, and you can show or hide it. Chats are grouped as Pinned, Previous 7 days, Previous 30 days and Older. Your chats are private to you, and only the person who started a chat can change it. You can rename, pin and delete them. Deleting removes the chat and all of its messages for good.",
            "You can edit your last question and run an answer again. Only the latest message can be edited or run again. If the answer created or changed records, the app asks Run this again? first, because running it again may do that again. Rate a response with Good response or Bad response and say what went wrong: wrong information, it did not do what you asked, too long, or something else.",
            "Lists of records appear as real tables. Records in a table link to open them, and you can copy the table or download it as CSV. A new chat shows shortcuts such as Plan my day, Draft an invoice and Review my workspace. Add your own, and hold or right-click one to edit or delete it. Mention a client, project or invoice in your message to point AutoPilot at it."
          ],
          "highlights": [
            "Chats are private to you",
            "Rename, pin and delete chats",
            "Tables that open the record and download as CSV",
            "Rate answers, edit your last question, run it again"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat.webp",
            "width": 1120,
            "height": 770,
            "alt": "AutoPilot chat with demo data: the question What's my recurring revenue, and what's at risk this month?, a finished steps row, and an answer with a real table of clients, reasons and amounts at risk."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-phone.webp",
            "width": 780,
            "height": 2200,
            "alt": "The same AutoPilot conversation full screen on a phone at 125% text: the question, 2 steps, the answer with the table shown as cards, three suggested next steps and the Ask anything box."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the AutoPilot chat under Sidebar, AI AutoPilot, Chat. On the desktop a Chats list sits beside a new chat that offers shortcuts such as Plan my day and Draft an invoice, with the Ask anything box below. Typing Which invoices are overdue? and sending it starts a chat, and AutoPilot answers with a short table of three clients, their invoice numbers, amounts and days late. When the answer finishes, the chat, now named Overdue invoices, appears at the top of the Chats list. On the iPhone the chat is full screen: the same question and answer, with the table shown as cards, and the chat gets its name in the header.",
            "caption": "Ask AutoPilot a question and get a table back. Example text; results vary. Example data.",
            "duration": "PT9S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "AutoPilot chat",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-phone-light.webm",
                "poster": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-chat-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Sidebar → AI AutoPilot → Chat",
          "appRoute": "/ai/chat",
          "plans": "all",
          "links": [
            {
              "label": "AI chat",
              "href": "/features/ai-chat"
            }
          ]
        },
        {
          "id": "autopilot-actions",
          "title": "Suggested next steps under AutoPilot's answers",
          "body": [
            "After an answer, up to three buttons offer the next step, such as sending a client a pay link, sending an invoice, or opening the Recurring view, a plan, a retainer or an invoice. Tap one to run it; sends ask you to confirm first. Actions follow your permissions.",
            "Buttons that send something show as outlined buttons with an icon. Tapping one only proposes the action, and a confirmation card follows, so nothing goes out until you approve it. Buttons that open a page read as links with an arrow. They appear only under the latest reply, and only while nothing is running or waiting for your approval.",
            "The chat shows whether AutoPilot is set to Ask first or Auto-apply. Ask first means it asks before it changes anything in the workspace. Auto-apply applies changes without asking, but it still asks before sending emails and texts. A button you do not have permission for is left out."
          ],
          "highlights": [
            "Up to three buttons under the latest answer",
            "Sends ask you to confirm before anything goes out",
            "Buttons follow your permissions"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-07-autopilot-chat-redesign/autopilot-actions.webp",
            "width": 1120,
            "height": 530,
            "alt": "The end of an AutoPilot answer about retainers and upcoming invoices, followed by three suggested next steps: Send Priya a pay link, Remind Dan to confirm and Open Recurring view."
          },
          "imagePhone": null,
          "whereToFind": "Sidebar → AI AutoPilot → Chat, under the latest reply",
          "appRoute": "/ai/chat",
          "plans": "all",
          "links": [
            {
              "label": "AI chat",
              "href": "/features/ai-chat"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Are my AutoPilot chats private?",
          "a": "Yes. Your chats are private to you, and only the person who started a chat can change it. You can rename, pin and delete your own chats."
        },
        {
          "q": "What happens when I delete an AutoPilot chat?",
          "a": "Deleting removes the chat and all of its messages for good. Only the person who started a chat can delete it."
        },
        {
          "q": "When does AutoPilot ask before changing my workspace?",
          "a": "It depends on the mode shown in the chat. Ask first means it asks before changing anything. Auto-apply makes changes without asking, but it still asks before sending emails and texts."
        },
        {
          "q": "Can I download a table from AutoPilot chat?",
          "a": "Yes. Lists of records appear as real tables. You can copy a table or download it as CSV, and records in it link to open them."
        },
        {
          "q": "Which plans include the redesigned AutoPilot chat?",
          "a": "Every Workspace369 plan includes the redesigned AutoPilot chat, with private chats, tables and suggested next steps."
        }
      ]
    },
    {
      "slug": "2026-10-04-proposal-builder",
      "date": "2026-10-04",
      "title": "A new proposal builder with cover pictures, and your AI assistant can design proposals",
      "seoTitle": "New Proposal Builder and AI Design",
      "summary": "Build proposals with a cleaner editor, an easier block picker and 18 cover designs, or ask a connected AI assistant to style and write one for you.",
      "areas": [
        "proposals",
        "ai"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-04-proposal-builder/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: an open portfolio with layout blocks lifting off the page and a fan of cover designs."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The new proposal builder",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "proposal-editor",
          "title": "A cleaner proposal editor with an easier block picker",
          "body": [
            "The proposal editor has a cleaner toolbar, a modern block picker where the plus between blocks adds a block where you click, and drag and drop that holds steady. One shared color picker is used across the app. Clients see the same layout on the proposal page and in the PDF."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-04-proposal-builder/proposal-editor.webp",
            "width": 1600,
            "height": 1111,
            "alt": "The proposal editor for a sample proposal, Brand & website partnership: a toolbar with Saved, undo, Preview and Send proposal, the document with a green arches cover, title, prepared for and by, and a Scope & investment table, and a Design panel with document themes, accent colors, page background and cover image settings."
          },
          "imagePhone": null,
          "whereToFind": "Proposals → create or open a proposal",
          "appRoute": "/proposals",
          "plans": "all",
          "links": [
            {
              "label": "Proposals",
              "href": "/features/quoting"
            },
            {
              "label": "Proposal software for agencies",
              "href": "/solutions/proposal-software-for-agencies"
            }
          ]
        },
        {
          "id": "proposal-covers",
          "title": "Pick a cover for your proposal",
          "body": [
            "Choose a cover opens 18 ready-made banner designs, or you can upload your own image. The title can sit on the image or below it for a more editorial look. The cover shows at the top of the proposal your client opens and on its PDF."
          ],
          "highlights": [
            "18 banner designs plus your own image",
            "Title on the image or below it"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers.webp",
            "width": 1438,
            "height": 1548,
            "alt": "The Choose a cover dialog: Templates and Images tabs, twelve ready-made banners including Sage Arches, Terracotta Studio, Coastal Layers and Midnight Orbit, and an Upload image button."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "Choose a cover as a sheet on a phone at 125% text: Templates and Images, eight banners in two columns, and Upload image above Cancel."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, a website redesign proposal for Priya Raman from Fernlane Studio is open with no cover. Choose a cover opens a grid of ready-made banner designs with Templates and Images tabs and an Upload image button. A terracotta design is picked and appears at the top of the proposal with the title on it, then Below image moves the title under the cover.",
            "caption": "Pick a ready-made banner for your proposal, then choose whether the title sits on the image or below it. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Proposal",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-phone-light.webm",
                "poster": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-04-proposal-builder/proposal-covers-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Proposals → open a proposal → Choose a cover",
          "appRoute": "/proposals",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Proposals",
              "href": "/features/quoting"
            }
          ]
        },
        {
          "id": "ai-proposal-design",
          "title": "Design proposals with your AI assistant",
          "body": [
            "An AI app connected to Workspace369, such as Claude or ChatGPT, can now build or restyle a proposal for you. It can set the theme, write and reorder sections, add images, save a proposal as a reusable template and change your proposal defaults. Changes show up live in the editor you see in Workspace369. Covers and page backgrounds need Specialist or higher."
          ],
          "highlights": [],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Settings → AI connections to connect an app, then ask it to build a proposal",
          "appRoute": "/settings/ai-connections",
          "plans": "all",
          "links": [
            {
              "label": "AI connections (MCP)",
              "href": "/integrations/mcp"
            },
            {
              "label": "Proposals",
              "href": "/features/quoting"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans include the new proposal editor?",
          "a": "Every plan. The cover designs need Specialist, Commander or Enterprise."
        },
        {
          "q": "Where do I choose a proposal cover?",
          "a": "Open a proposal under Proposals and choose Choose a cover. It opens 18 ready-made banner designs, or you can upload your own image. Covers are on Specialist, Commander and Enterprise."
        },
        {
          "q": "What does the client see of the cover and layout?",
          "a": "The cover shows at the top of the proposal your client opens and on its PDF. Clients see the same layout on the proposal page and in the PDF."
        },
        {
          "q": "Can I put the proposal title on the cover image?",
          "a": "Yes. The title can sit on the image or below it for a more editorial look."
        },
        {
          "q": "Can an AI assistant build a proposal for me?",
          "a": "Yes. An AI app connected to Workspace369, such as Claude or ChatGPT, can build or restyle one, writing and reordering sections, adding images and setting the theme. Changes show live in your editor."
        },
        {
          "q": "How do I connect an AI assistant for proposals?",
          "a": "Go to Settings → AI connections to connect an app, then ask it to build a proposal. Covers and page backgrounds it sets need Specialist or higher."
        }
      ]
    },
    {
      "slug": "2026-10-02-booking-team-members-and-portal-preview",
      "date": "2026-10-02",
      "title": "Clients can pick their team member when booking, and the client portal is easier to style",
      "seoTitle": "Booking With Team Members and Portal Styling",
      "summary": "Online booking can ask clients which team member they want, with each person's own service length, and the client portal gets a preview and brand color controls.",
      "areas": [
        "scheduling",
        "portal"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a calendar tile with three colored tokens to choose from and a small arched doorway glowing inside."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Team member booking and the client portal",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "booking-team-member",
          "title": "Clients choose their team member, with each person's own service length",
          "body": [
            "Online booking can now let clients choose their team member. Turn on Clients pick a team member and a Team step appears after Service, with an Any team member choice if you want it. It is for businesses where clients ask for a particular person, and it is available on Specialist, Commander and Enterprise.",
            "A booking page can add a team step after the service, or offer Any team member, which books the first free person. The step is skipped for a service that only one team member does. The booked person and the booked length carry through the page and the reschedule flow.",
            "Each team member can have their own length for the same service, for example 30 or 45 minutes, while the price stays the same. Open a host in Hosts, tick the services they do and set how long each takes them. Changes apply to every booking page using those services. The editor explains who can take bookings, and warns you when only one team member can, because clients then have no choice.",
            "Hosts and assignment sit in one section where you choose your hosts, set their hours and decide how bookings are assigned: Round robin, Prioritize hosts, or Client chooses. A host uses workspace hours unless you set custom hours for that page. Each booking page also has an About section that you can use from Brand and looks, write for that page only, or hide."
          ],
          "highlights": [
            "Team step with an Any team member option",
            "Per-person service lengths set in Hosts",
            "About section you can use, replace or hide per booking page"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step.webp",
            "width": 1051,
            "height": 1382,
            "alt": "The booking page editor's Layout section: First step set to Service, Service photos, First screen switches, and a Team step group with Clients pick a team member and Offer “Any team member” switched on, and Team members’ own lengths set for each service in Hosts."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The same booking page on a phone: Select a team member lists Any team member, Dana Ruiz at 45 min, and Sam Patel and Lee Okafor at 60 min."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Maple Row Physio booking page opens on Select a service. Initial assessment is chosen and a Select a team member step follows with Any team member and three people, Dana Ruiz at 45 min and Sam Patel and Lee Okafor at 60 min. Dana Ruiz is chosen and Select a time shows the days and her 45-minute openings.",
            "caption": "Clients pick a team member after the service, and each person shows their own length. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Pick a team member",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-phone-light.webm",
                "poster": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/booking-team-step-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings → Booking pages → Layout → Team step",
          "appRoute": "/settings/booking-pages",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            }
          ]
        },
        {
          "id": "portal-styling",
          "title": "Preview and style the client portal",
          "body": [
            "Set your portal's accent color with a check that it stays readable on buttons, choose a default theme, and browse all the themes. A project, board or client can still set its own accent and theme.",
            "The accent check shows a contrast ratio and tells you whether the color is Readable on buttons or Low contrast on buttons, so you find out before a client does. The brand applies to every portal type, the sign-in screen and the code email.",
            "Preview client page shows the portal, the Sign-in screen and the Code email with sample data and your unsaved changes, so you see the result before clients do. Nothing is sent to your clients. For layout, a single column stacks every section, two columns put some sections on the right, and tabs show one section at a time."
          ],
          "highlights": [
            "Accent color with a readability check",
            "Sample-data preview of portal, sign-in and code email",
            "Single column, two columns or tabs"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-02-booking-team-members-and-portal-preview/portal-styling.webp",
            "width": 1154,
            "height": 1990,
            "alt": "Settings, Client portal, Brand tab for the demo workspace Apex Auto Spa: eight looks, the workspace logo, a brand color with a readability warning and Use a darker shade, a palette of seven themes with Corporate selected, and Browse all 35 themes."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Client portal",
          "appRoute": "/settings/client-portal",
          "plans": "all",
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Themes",
              "href": "/features/themes"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can clients choose their team member when they book online?",
          "a": "Yes. Turn on Clients pick a team member and a Team step appears after Service. It is available on the Specialist, Commander and Enterprise plans."
        },
        {
          "q": "What does Any team member do on a booking page?",
          "a": "It books the first free person. You can offer it alongside named team members, and the Team step is skipped for a service that only one person does."
        },
        {
          "q": "Can team members have different appointment lengths for the same service?",
          "a": "Yes. Each team member can have their own length for a service, such as 30 or 45 minutes, while the price stays the same. Set it per host in Hosts."
        },
        {
          "q": "Can I preview my client portal before clients see it?",
          "a": "Yes. In Settings → Channels → Client portal, Preview client page shows the portal, the sign-in screen and the code email with sample data and your unsaved changes. Nothing is sent to clients."
        }
      ]
    },
    {
      "slug": "2026-10-01-workflows-decisions-and-device-drafts",
      "date": "2026-10-01",
      "title": "Workflows get decisions, waits and drafts, and unsaved work is kept on your device",
      "seoTitle": "Smarter Workflows and Device Drafts",
      "summary": "Add decision steps and waits to workflows, test before going live, edit live workflows through a draft, and recover work you were typing when the connection dropped.",
      "areas": [
        "automations",
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a path that splits at a decision tile, with an hourglass on one branch and a draft sheet tucked into a pocket."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Smarter workflows and device drafts",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "workflow-decisions",
          "title": "Decisions, waits and business hours in workflows",
          "body": [
            "Add a Check a condition step so a workflow takes a different path depending on the record, or, on Voyager and above, let the workspace owner add an AI decision that answers a Yes or No question. A wait can run until a date on a record, up to a year from the trigger (30 days when the workflow has an AI decision). Email and text steps can be limited to your business hours, so messages are held until you are open."
          ],
          "highlights": [
            "Check a condition steps, and AI decisions on Voyager and above",
            "Wait until a date on a record, up to 365 days",
            "Only send during business hours"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-condition.webp",
            "width": 799,
            "height": 845,
            "alt": "A workflow's Check a condition panel: check Invoice status is paid, Add condition, a note that matching runs go down Yes and the rest down No, and three steps set to Yes, No and Then."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The Check a condition panel on a phone: Payment progress is any of Unpaid, with the Email the client step set to the Yes path and a Remove the check button."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, an Invoice follow-up workflow with an Email the client step gets a Check a condition step from the add-step menu. The condition Payment progress is any of Unpaid is set and the email moves to the Yes path. A wait is added before the email and set to wait until the due date, and the email is switched to only send during business hours.",
            "caption": "Add a Check a condition step, a wait until a date, and limit an email to business hours. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Workflows",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-desktop-light.mp4",
                "webm": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-desktop-light.webm",
                "poster": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-desktop-dark.webm",
                "poster": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-phone-light.mp4",
                "webm": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-phone-light.webm",
                "poster": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-phone-dark.mp4",
                "webm": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-phone-dark.webm",
                "poster": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-decisions-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Workflows in the sidebar → open or create a workflow",
          "appRoute": "/workflows",
          "plans": "all",
          "links": [
            {
              "label": "Workflow automation",
              "href": "/features/automation"
            },
            {
              "label": "Build, test and activate a workflow",
              "href": "https://docs.workspace369.com/v/2026.3/automation/build-test-activate-workflow/"
            }
          ]
        },
        {
          "id": "workflow-drafts",
          "title": "Edit a live workflow without breaking it",
          "body": [
            "A live workflow now keeps a draft you can publish, discard or revert to an earlier version, so editing does not disturb what is running. Test the draft on a record you choose, or on a sample record, before you publish. Each run page explains what happened at every step and when."
          ],
          "highlights": [
            "Publish, discard or revert a draft",
            "Test a draft on a record you choose",
            "Run page explains every step"
          ],
          "image": {
            "src": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/workflow-test.webp",
            "width": 1600,
            "height": 680,
            "alt": "A draft workflow, New lead then Email the lead, with the Test this workflow dialog open: Sample record or Choose a record, a note on how the sample is filled in, and Run test."
          },
          "imagePhone": null,
          "whereToFind": "Workflows → open a workflow → Test; run history under Workflows",
          "appRoute": "/workflows",
          "plans": "all",
          "links": [
            {
              "label": "Workflow automation",
              "href": "/features/automation"
            }
          ]
        },
        {
          "id": "device-drafts",
          "title": "Interrupted work is kept on your device",
          "body": [
            "If your connection drops or the app closes while you are writing something, your unsaved work stays on that device. Review, copy or discard it from Device drafts, and restore it from the recovery prompt inside editors such as proposals.",
            "A retried send does not create a duplicate. Drafts are stored per account and workspace on that device only, so sign in to the same account to see them."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-10-01-workflows-decisions-and-device-drafts/device-drafts.webp",
            "width": 1400,
            "height": 1069,
            "alt": "Settings, You, Device drafts: three copies saved on this device for an expense, a note and a proposal, each Pending review with Open related screen, Copy backup and Discard device copy, and a Refresh button."
          },
          "imagePhone": null,
          "whereToFind": "Settings → You → Device drafts",
          "appRoute": "/settings/device-drafts",
          "plans": "all",
          "links": [
            {
              "label": "Mobile app",
              "href": "/features/mobile-app"
            },
            {
              "label": "Proposals",
              "href": "/features/quoting"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can a Workspace369 workflow take different paths?",
          "a": "Yes. Add a Check a condition step so the workflow follows a different path depending on the record. On Voyager and above, the workspace owner can also add an AI decision that answers a Yes or No question."
        },
        {
          "q": "How long can a workflow wait?",
          "a": "A wait can run until a date on a record, up to a year from the trigger. When the workflow has an AI decision, the longest wait is 30 days."
        },
        {
          "q": "Can workflow emails and texts wait until my business hours?",
          "a": "Yes. Email and text steps can be limited to your business hours, so messages are held until you are open."
        },
        {
          "q": "Can I edit a live workflow without breaking it?",
          "a": "Yes. A live workflow keeps a draft you can test, then publish, discard or revert to an earlier version. Editing the draft does not disturb what is running."
        },
        {
          "q": "Is unsaved work kept if my connection drops?",
          "a": "Yes. Work you were writing stays on that device, and you can review, copy or discard it in Settings → You → Device drafts. Drafts are stored per account and workspace."
        }
      ]
    },
    {
      "slug": "2026-09-30-branded-client-portals",
      "date": "2026-09-30",
      "title": "Client portals in your brand, and a private portal for each client",
      "seoTitle": "Branded Client Portals",
      "summary": "Client portals carry your logo and colors, let you choose the sections and layout, and every client can now have a private portal of their own.",
      "areas": [
        "portal",
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-09-30-branded-client-portals/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: an arched doorway opening onto rooms of colored panels, with a brass key on the step."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Branded client portals in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "portal-branding",
          "title": "Portals that carry your logo, colors and layout",
          "body": [
            "Client portals now carry your logo and accent color, let you choose which sections show and in what layout, and every client can have a private portal of their own. It is on every plan and is for anyone who shares projects, task boards or client pages with customers.",
            "Project and task board portals show your logo and accent color on the sign-in screen, in the sign-in code email and on the portal itself, so your client sees your brand from the first click. The logo comes from your workspace details. For the accent, type a hex color like #1F6FEB or use your theme color.",
            "Choose what each portal shows. Turn sections on or off, drag them into the order you want, and pick a single column, two columns or tabs. A section you hide is never sent to your client's browser.",
            "The sections depend on the page. A project portal can show Milestones, Events, Team, Files, Invoices, Comments and Budget. A task board has header sections for Description, Last activity and Stats, with Search and filters always below them. A client portal has modules such as Action items, Projects, Boards, Retainers, Proposals, Change orders and Contracts.",
            "Set the defaults once under Settings, Client portal, for projects, boards and clients. Every shared project, board or client portal starts with them, and each one can still change its own in its sharing sheet."
          ],
          "highlights": [
            "Logo and accent color on sign-in, code email and portal",
            "Single column, two columns or tabs",
            "Show, hide and reorder sections",
            "Task boards get their own header sections"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding.webp",
            "width": 1070,
            "height": 2288,
            "alt": "Client portal settings, Projects tab: page layout, style, density and a list of sections you can reorder or switch off"
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "Client portal settings on a phone, Brand tab: the Maple Row Physio logo with a Change button, and the brand color set to Teal."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, Settings, Client portal opens on the Brand tab. A new logo for Maple Row Physio appears, a Teal brand color is picked from the color menu, and the sample client portal beside the settings takes the logo and color. On the Projects tab the page layout changes from a single column to two columns, which the sample project page beside it follows, and then to tabs.",
            "caption": "Add your logo, pick a brand color and choose a layout, and the portal preview follows. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Client portal",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-desktop-light.mp4",
                "webm": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-desktop-light.webm",
                "poster": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-desktop-dark.webm",
                "poster": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-phone-light.mp4",
                "webm": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-phone-light.webm",
                "poster": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-phone-dark.mp4",
                "webm": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-phone-dark.webm",
                "poster": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings → Client portal",
          "appRoute": "/settings/client-portal",
          "plans": "all",
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Client portal for agencies",
              "href": "/solutions/client-portal-for-agencies"
            },
            {
              "label": "Client portal tutorial",
              "href": "/tutorials/client-portal"
            }
          ]
        },
        {
          "id": "portal-per-client",
          "title": "A private portal for each client",
          "body": [
            "Give any client their own portal that shows only what you choose to share, including contracts waiting for their signature. Visitors sign in with a code sent to their email, so the page is always private.",
            "Open a client and go to Client portal. Access is set to Private, email code required, so only that client's email, its contact people and the people you add can sign in. Invite someone by email or choose from the people already saved on the client. To cover everyone, share with the whole company: it is one grant, so anyone you add to the client later gets access too.",
            "Each person gets a role: Can view, Can comment, Can collaborate, Can contribute or Full access, or a custom set from comment, upload files, view invoices, add tasks, comment on tasks and move tasks between statuses. You can resend an invite, set an expiry date, suspend access, or regenerate the link, which stops the old one at once.",
            "A new Share permission decides which teammates can create and manage client portals, so you control who can open one up. Projects and boards can also be shared with anyone who has the link, in a view-only page that can never comment, upload or change anything."
          ],
          "highlights": [
            "Private by email code, per client",
            "Roles from Can view to Full access, or a custom set",
            "Expiry date, suspend, and regenerate link",
            "Share with the whole company in one grant"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-30-branded-client-portals/portal-per-client.webp",
            "width": 1070,
            "height": 2270,
            "alt": "Client portal settings, Clients tab: the layout and modules every client portal starts with, including Contracts"
          },
          "imagePhone": null,
          "whereToFind": "Clients → open a client → Client portal",
          "appRoute": "/clients",
          "plans": "all",
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Client scoped access",
              "href": "/features/client-scoped-access"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans include branded client portals?",
          "a": "Every plan. Portal branding and per-client portals are on all plans."
        },
        {
          "q": "How do I add my logo and accent color to a project or task board portal?",
          "a": "Project and task board portals show your logo and accent color on the sign-in screen, the sign-in code email and the portal. The logo comes from your workspace details. For the accent, type a hex color or use your theme color."
        },
        {
          "q": "Where do I set portal defaults?",
          "a": "Go to Settings → Client portal. Set defaults once for projects, boards and clients. Every shared portal starts with them, and each one can still change its own in its sharing sheet."
        },
        {
          "q": "Can I choose what a portal shows?",
          "a": "Yes. Turn sections on or off, drag them into order and pick a single column, two columns or tabs. A section you hide is never sent to your client's browser."
        },
        {
          "q": "How do I give a client their own private portal?",
          "a": "Open the client and go to Client portal. Access is Private, email code required, so only that client's email, its contact people and people you add can sign in."
        },
        {
          "q": "What can I control for people with portal access?",
          "a": "Give each person a role, from Can view to Full access, or a custom set. You can resend an invite, set an expiry date, suspend access or regenerate the link, which stops the old one at once."
        }
      ]
    },
    {
      "slug": "2026-09-30-september-2026-roundup",
      "date": "2026-09-30",
      "title": "September 2026: e-signature contracts, AutoPilot Today, client stages and branded portals",
      "seoTitle": "Workspace369 September 2026 Updates",
      "summary": "Send contracts for e-signature, run your day from AI AutoPilot Today, track clients through stages, brand client portals, and rebuilt workflows, tasks and Settings.",
      "areas": [
        "proposals",
        "billing",
        "clients",
        "ai",
        "scheduling",
        "work",
        "automations",
        "portal",
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-09-30-september-2026-roundup/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "A navy release-notes plate titled Workspace369 September 2026 Updates, dated September 30, 2026, with the Proposals & contracts, Billing & payments, Clients & CRM, Workspace AI, Calendar & booking, Projects, tasks & time, Workflows, Client portal, Workspace & team labels."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Workspace369 September 2026 updates",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "contracts-e-signature",
          "title": "Contracts you send for e-signature",
          "body": [
            "Send a contract for e-signature from Workspace369: upload a PDF or start from a template, place signature fields, add your signers and send it. Signers verify by email code, and every contract keeps a History timeline and an evidence file.",
            "The Contracts page was rebuilt with a status filter, a Templates view for reusable agreements, a builder where you set the signing order and add teammates as signers, and countersigning and reminders."
          ],
          "highlights": [
            "Start from a PDF or a reusable template",
            "Audit trail and evidence file for every contract",
            "Countersigning and reminders"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-20-contracts-and-e-signature/contract-detail.webp",
            "width": 1600,
            "height": 1000,
            "alt": "A contract waiting on a countersignature: one of two signers has signed, with the signing order, reminders every 3 days, email code verification and the activity timeline beside the document."
          },
          "imagePhone": null,
          "whereToFind": "Contracts in the sidebar",
          "appRoute": "/contracts",
          "plans": "all",
          "links": [
            {
              "label": "Contracts",
              "href": "/features/contracts"
            },
            {
              "label": "Contracts and e-signature",
              "href": "/changelog/2026-09-20-contracts-and-e-signature"
            },
            {
              "label": "Contracts, Requests and Team pages",
              "href": "/changelog/2026-09-27-contracts-requests-and-team-invites"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, a ready Master services agreement is on Review and send. Send for signature is chosen and confirmed, and Contract sent appears. The Contracts list shows it as Waiting with 0 of 2 signed. Opening it lists Dana Ruiz then Sam Patel in signing order; Dana signs, the count reads 1 of 2 signed, and Countersign now appears for Sam.",
            "caption": "Send a contract for signature, see it listed as Waiting, and open it to follow each signer. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Send a contract",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-light.mp4",
                "webm": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-light.webm",
                "poster": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-dark.webm",
                "poster": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-light.mp4",
                "webm": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-light.webm",
                "poster": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-dark.mp4",
                "webm": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-dark.webm",
                "poster": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "change-orders",
          "title": "Change orders for accepted proposals and paid invoices",
          "body": [
            "Once a proposal is accepted, or a deposit or payment comes in, its items and prices lock, and a banner explains why. To change it, create a numbered change order that shows exactly what changed."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/change-orders.webp",
            "width": 2200,
            "height": 2980,
            "alt": "Change order composer for a part-paid invoice: a title and reason, the edited items, a summary of what changed and the new total and balance due"
          },
          "imagePhone": null,
          "whereToFind": "Open a locked proposal or invoice → Change order",
          "appRoute": "/proposals",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Change orders",
              "href": "/features/change-orders"
            },
            {
              "label": "Invoice page design and change orders",
              "href": "/changelog/2026-09-24-invoice-page-design-and-change-orders"
            }
          ]
        },
        {
          "id": "invoice-page-design",
          "title": "Design the invoice page your clients open",
          "body": [
            "Choose how the page your clients open from an invoice link looks: pick a template and a color palette, then set the typeface and logo size."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes.webp",
            "width": 978,
            "height": 1700,
            "alt": "Settings, Invoices, Document themes for the demo workspace Apex Auto Spa: nine invoice templates, Classic selected, with Modern, Minimal, Bold, Letterhead, Elegant, Sidebar, Receipt and Statement, each with a short description."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Invoices → Document themes",
          "appRoute": "/settings/document-themes",
          "plans": "all",
          "links": [
            {
              "label": "Invoices",
              "href": "/features/invoices"
            },
            {
              "label": "Invoice page design and change orders",
              "href": "/changelog/2026-09-24-invoice-page-design-and-change-orders"
            }
          ]
        },
        {
          "id": "clients-stages-requests",
          "title": "Client stages, follow-ups and a Requests form builder",
          "body": [
            "Add people as Leads and move clients through stages you can rename, recolor, reorder or hide. A follow-up queue says why each client is due, and a quick-view panel lets you have AI draft the email, text or call notes.",
            "Requests show in a table with a quick-view panel and a visual form builder, and you can convert a request to a client in one click."
          ],
          "highlights": [
            "Stages, Leads and a follow-up queue",
            "AI-drafted follow-ups from the client quick view",
            "Requests table and form builder"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-follow-ups.webp",
            "width": 2640,
            "height": 1395,
            "alt": "Clients table with a tab for each stage, a Stage column, and a Next follow-up column that says when each client is due and why"
          },
          "imagePhone": null,
          "whereToFind": "Clients in the sidebar → Follow-ups; Requests in the sidebar",
          "appRoute": "/clients",
          "plans": "all",
          "links": [
            {
              "label": "Client management",
              "href": "/solutions/client-management-software"
            },
            {
              "label": "Client stages and the calendar editor",
              "href": "/changelog/2026-09-27-clients-stages-and-calendar-editor"
            },
            {
              "label": "Contracts, Requests and Team pages",
              "href": "/changelog/2026-09-27-contracts-requests-and-team-invites"
            }
          ]
        },
        {
          "id": "autopilot-today",
          "title": "AI AutoPilot Today, Client Health and watches on money, projects and tasks",
          "body": [
            "AI AutoPilot opens on Today, a ranked list of what needs you, like an invoice to chase or a client to check in with. Client Health flags clients who need attention with the reason shown, and Money Watch and Project Watch point out unpaid invoices and projects that need a look.",
            "AutoPilot only suggests: it drafts reminders and follow-ups for you to review."
          ],
          "highlights": [
            "A Today feed that ranks what to do next",
            "Client Health with a Draft follow-up you can edit"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today.webp",
            "width": 1620,
            "height": 1680,
            "alt": "AI AutoPilot Today in Lanes view: filters for Money Watch, Project Watch, Task Assist and more, then Money, Clients, Tasks and Inbox lanes with items such as Chase invoice INV-1042 for Parker Group, 12 days past due."
          },
          "imagePhone": null,
          "whereToFind": "AI AutoPilot in the sidebar",
          "appRoute": "/ai",
          "plans": "all",
          "links": [
            {
              "label": "AI AutoPilot",
              "href": "/features/autopilot"
            },
            {
              "label": "AI AutoPilot Today",
              "href": "/changelog/2026-09-23-ai-autopilot-today"
            }
          ]
        },
        {
          "id": "autopilot-briefing",
          "title": "A morning briefing and message sorting",
          "body": [
            "Turn on the morning briefing and message sorting and AI summarizes your day and suggests labels on new email and text messages. It never moves messages or sends replies."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-briefing.webp",
            "width": 1600,
            "height": 350,
            "alt": "The morning briefing at the top of AI AutoPilot Today: start with INV-1042, Parker Group is 12 days past due on $1,250, then check in with Northstar Studio and reply to the quote request, marked AI-written, above the Lanes and Timeline switch and a line reading Reviewing new email and SMS."
          },
          "imagePhone": null,
          "whereToFind": "AI AutoPilot → Settings",
          "appRoute": "/ai",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            },
            {
              "label": "AI AutoPilot Today",
              "href": "/changelog/2026-09-23-ai-autopilot-today"
            }
          ]
        },
        {
          "id": "calendar-editor-meet",
          "title": "Create calendar events by dragging, with Google Meet and guest invites",
          "body": [
            "Drag on the calendar to create an event, or open the full editor to set guests, reminders and team availability. Add a Google Meet link once your Google account is connected, and email invites go to your guests."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/calendar-editor.webp",
            "width": 2432,
            "height": 1800,
            "alt": "Full event editor with time, Google Meet, client, team, guests and reminders, beside a team availability panel that flags a clash and suggests free times"
          },
          "imagePhone": null,
          "whereToFind": "Calendar in the sidebar",
          "appRoute": "/calendar",
          "plans": "all",
          "links": [
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            },
            {
              "label": "Client stages and the calendar editor",
              "href": "/changelog/2026-09-27-clients-stages-and-calendar-editor"
            }
          ]
        },
        {
          "id": "tasks-time-files",
          "title": "Tasks, time tracking and files rebuilt",
          "body": [
            "Add a task straight from the bottom of a board column and open any task in a preview. Time off shows balances, who is out and requests waiting for approval on one page, and a Reports tab charts the hours your team logged.",
            "Files uploads now run through a queue with a status for every file, and you choose what happens when a file with the same name exists."
          ],
          "highlights": [
            "Quick task creation",
            "Time off and team hours reports",
            "An upload queue that handles duplicates"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-create.webp",
            "width": 1400,
            "height": 880,
            "alt": "Task quick create with the due date typed as next fri and read as Friday, alongside priority, assignee, tags and subtasks"
          },
          "imagePhone": null,
          "whereToFind": "Tasks, Time tracking and Files in the sidebar",
          "appRoute": "/tasks",
          "plans": "all",
          "links": [
            {
              "label": "Time tracking",
              "href": "/features/time-tracking"
            },
            {
              "label": "Tasks, time tracking and files",
              "href": "/changelog/2026-09-27-tasks-time-tracking-and-files"
            }
          ]
        },
        {
          "id": "workflows-rebuilt",
          "title": "Workflows rebuilt with a table, templates, test runs and AI drafting",
          "body": [
            "Workflows open on a table of everything you have built, with filters and bulk actions. Start from a template or describe what you want and let AI draft it, and test it before it goes live.",
            "A workflow that starts when a new lead arrives can assign the lead to one teammate or rotate it between several."
          ],
          "highlights": [
            "Templates and AI drafting",
            "Assign new leads to a teammate"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt.webp",
            "width": 2880,
            "height": 790,
            "alt": "Workflows table with views for All, Active, Drafts, Paused and Needs attention, showing each workflow's status, trigger, steps, runs and last run"
          },
          "imagePhone": null,
          "whereToFind": "Workflows in the sidebar",
          "appRoute": "/workflows",
          "plans": "all",
          "links": [
            {
              "label": "Workflow Automations",
              "href": "/features/automation"
            },
            {
              "label": "Workflows table, templates and AI drafts",
              "href": "/changelog/2026-09-29-workflows-table-templates-ai-drafts"
            }
          ]
        },
        {
          "id": "branded-portals",
          "title": "Client portals in your brand, and a private portal for each client",
          "body": [
            "Client portals carry your logo and accent color, and you choose which sections show and in what layout. Every client can have a private portal that shows only what you choose to share, including contracts waiting for their signature, and visitors sign in with a code sent to their email."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-30-branded-client-portals/portal-branding.webp",
            "width": 1070,
            "height": 2288,
            "alt": "Client portal settings, Projects tab: page layout, style, density and a list of sections you can reorder or switch off"
          },
          "imagePhone": null,
          "whereToFind": "Settings → Client portal",
          "appRoute": "/settings/client-portal",
          "plans": "all",
          "links": [
            {
              "label": "Client portal",
              "href": "/features/client-portal"
            },
            {
              "label": "Branded client portals",
              "href": "/changelog/2026-09-30-branded-client-portals"
            }
          ]
        },
        {
          "id": "team-invites-seats",
          "title": "Invite teammates and add seats in one place",
          "body": [
            "The Team & seats page lets you invite several people by email, resend an invite, edit it, or copy an invite link."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/team-invites.webp",
            "width": 1600,
            "height": 312,
            "alt": "The Invites tab of Team & seats: liam@oconnorbuild.example with a Custom role and access to 3 clients, expiring in 5 days and holding a seat, with a Resend button, and an expired invite for mia@maplerow.example with a Send a new invite button."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Team & seats",
          "appRoute": "/settings/team-members",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Invite your team",
              "href": "/tutorials/invite-your-team"
            },
            {
              "label": "Contracts, Requests and Team pages",
              "href": "/changelog/2026-09-27-contracts-requests-and-team-invites"
            }
          ]
        },
        {
          "id": "settings-text-size",
          "title": "Settings in groups with search, and text size per device",
          "body": [
            "Every Settings page follows one layout with grouped navigation and a search box, on the web and in the app. Phones and larger screens now remember their own text size."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-overview.webp",
            "width": 1440,
            "height": 1300,
            "alt": "The Settings overview: a sidebar grouped into You, Workspace, Sales and Operations under a search box, with items that need attention and Jump back in shortcuts."
          },
          "imagePhone": null,
          "whereToFind": "Settings in the sidebar",
          "appRoute": "/settings",
          "plans": "all",
          "links": [
            {
              "label": "Themes and appearance",
              "href": "/features/themes"
            },
            {
              "label": "Settings redesign and text size",
              "href": "/changelog/2026-09-28-settings-redesign-and-text-size"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "What's new in Workspace369 in September 2026?",
          "a": "Contracts you send for e-signature, change orders, invoice page design, client stages and follow-ups, AI AutoPilot Today, branded client portals, rebuilt workflows, tasks and Settings."
        },
        {
          "q": "Can I send a contract for e-signature in Workspace369?",
          "a": "Yes, on every plan. Upload a PDF or start from a template, place signature fields, add signers and send it. Signers verify by email code, and each contract keeps an audit trail."
        },
        {
          "q": "Which plans include change orders?",
          "a": "Change orders are on Specialist and up. Once a proposal is accepted or a payment comes in, its items lock, and a numbered change order shows exactly what changed."
        },
        {
          "q": "What does AI AutoPilot Today do?",
          "a": "It ranks what needs you each day, flags clients who need attention, and drafts reminders for you to review. AutoPilot only suggests; the morning briefing is on Voyager and up."
        },
        {
          "q": "Can clients have their own client portal?",
          "a": "Yes, on every plan. Portals carry your logo and colors, you choose the sections, and each client can have a private portal where visitors sign in with a code sent to their email."
        }
      ]
    },
    {
      "slug": "2026-09-29-workflows-table-templates-ai-drafts",
      "updated": "2026-11-04",
      "date": "2026-09-29",
      "title": "Workflows rebuilt with a table, templates, test runs and AI drafting",
      "seoTitle": "Workflow Automations: Templates and AI",
      "summary": "Manage every workflow in one table, start from a template or describe what you want, test it before it goes live, and assign new leads to a teammate.",
      "areas": [
        "automations",
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a loop of connected nodes running along a track, beside a fan of template cards."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The new Workflows page in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "workflows-rebuilt",
          "title": "A new Workflows page, templates and AI drafting",
          "body": [
            "Workflows now open on a table of everything you have built, with views for All, Active, Drafts, Paused and Needs attention, filters by trigger, action, status and creator, and bulk actions to activate, pause, duplicate or delete several at once.",
            "Start from a template grouped by area, such as leads, invoices, proposals, inbox, calendar and tasks, or describe what you need and let AI draft the workflow for you to edit. Drafting counts toward your plan's AI usage, and nothing goes live until you activate it. Drafting with AI is included with Commander and Enterprise.",
            "Run a test before you switch a workflow on. Every run keeps a log you can open, and a failed run can be retried from the step that failed."
          ],
          "highlights": [
            "Views for All, Active, Drafts, Paused and Needs attention",
            "Templates by area, or describe it and AI drafts it",
            "Test runs and a log of every run",
            "Retry a failed run from the failed step"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt.webp",
            "width": 2880,
            "height": 790,
            "alt": "Workflows table with views for All, Active, Drafts, Paused and Needs attention, showing each workflow's status, trigger, steps, runs and last run"
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The Workflows list on a phone, with views for All, Active, Drafts and Paused and each workflow's status, trigger and runs."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Workflows page lists every workflow with its status, trigger and runs. The Active and Drafts views are chosen, then All again. New workflow opens a list of templates grouped by area, such as Leads and Invoices. Welcome new leads and a 1-day unpaid invoice reminder are previewed, and Use template opens the reminder in the workflow editor as a draft.",
            "caption": "Switch between views, then start a new workflow from a template. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Workflows",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-desktop-light.mp4",
                "webm": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-desktop-light.webm",
                "poster": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-desktop-dark.webm",
                "poster": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-phone-light.mp4",
                "webm": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-phone-light.webm",
                "poster": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-phone-dark.mp4",
                "webm": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-phone-dark.webm",
                "poster": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflows-rebuilt-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Workflows in the sidebar",
          "appRoute": "/workflows",
          "plans": "all",
          "links": [
            {
              "label": "Workflow automation",
              "href": "/features/automation"
            },
            {
              "label": "Workflows tutorial",
              "href": "/tutorials/workflows"
            },
            {
              "label": "Automations docs",
              "href": "https://docs.workspace369.com/v/2026.3/automation/automations/"
            }
          ]
        },
        {
          "id": "workflow-assign-lead",
          "title": "Assign new leads to a teammate",
          "body": [
            "A workflow that starts when a new lead arrives can assign the lead to one teammate or rotate it between several, and can first check which form the lead came from and how they answered.",
            "Use it to send each lead to the right person without anyone sorting the inbox by hand, and keep following up with the usual email and task steps (text steps from Voyager) after the lead is assigned."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-29-workflows-table-templates-ai-drafts/workflow-assign-lead.webp",
            "width": 796,
            "height": 1210,
            "alt": "Assign to teammate step set to Round robin, rotating new leads between three teammates with the next one shown, and an option to move their booked call"
          },
          "imagePhone": null,
          "whereToFind": "Workflows → New lead trigger → Assign to teammate",
          "appRoute": "/workflows",
          "plans": "all",
          "links": [
            {
              "label": "Workflow automation",
              "href": "/features/automation"
            },
            {
              "label": "Leads from your website",
              "href": "/tutorials/leads-from-your-website"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can AI build a workflow for me in Workspace369?",
          "a": "Yes, on Commander and Enterprise. Describe what you need and AI drafts the workflow for you to edit. Nothing goes live until you activate it, and drafting counts toward your plan's AI usage."
        },
        {
          "q": "Are there ready-made workflow templates?",
          "a": "Yes. Start from a template grouped by area, such as leads, invoices, proposals, inbox, calendar and tasks, then edit it before you switch it on."
        },
        {
          "q": "How many workflows can I have active at once?",
          "a": "Cadet allows 3 active workflows, Voyager 10 and Specialist 25. Commander and Enterprise have no limit on active workflows."
        },
        {
          "q": "What if a workflow run fails?",
          "a": "Every run keeps a log you can open, and a failed run can be retried from the step that failed. You can also run a test before you switch a workflow on."
        },
        {
          "q": "Can a workflow assign new leads to a teammate?",
          "a": "Yes. A workflow that starts on a new lead can assign it to one teammate or rotate it between several. It can first check which form the lead came from and how they answered."
        }
      ]
    },
    {
      "slug": "2026-09-28-settings-redesign-and-text-size",
      "date": "2026-09-28",
      "title": "Settings reorganized into groups with search, and text size per device",
      "seoTitle": "New Settings Layout",
      "summary": "Every Settings page now follows one layout with grouped navigation and search, and your phone and your computer each remember their own text size.",
      "areas": [
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a filing cabinet with grouped drawers, a magnifying glass and two blocks of different sizes for text size."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "A tour of the new Settings in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "settings-redesign",
          "title": "One layout for every Settings page",
          "body": [
            "Settings is now organized into groups with a search box, so you can find any setting without hunting. It is on every plan, on the web and in the app, and is for everyone who manages a workspace.",
            "The groups are You, Workspace, Sales, Operations, Channels, AI and Data. Open Settings and you land on an overview with your name and Edit profile, your workspace and plan with Manage plan, a Needs attention list for things that need a look, and Jump back in cards. A dot next to a page in the menu means it needs attention.",
            "Type in Search settings and the results include pages inside other pages. Searching for theme finds Appearance, even though it sits inside a group. A few pages open full screen, and the menu marks them with an arrow.",
            "Pages follow the same layout throughout. If you leave a page with unsaved changes, the app asks Discard unsaved changes? and lets you keep editing or discard them, so a half-finished edit is not lost by accident."
          ],
          "highlights": [
            "Groups: You, Workspace, Sales, Operations, Channels, AI, Data",
            "Search across all settings, including pages inside pages",
            "Overview with Needs attention and Jump back in",
            "A prompt before unsaved changes are discarded"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-overview.webp",
            "width": 1440,
            "height": 1300,
            "alt": "The Settings overview: a sidebar grouped into You, Workspace, Sales and Operations under a search box, with items that need attention and Jump back in shortcuts."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-overview-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "Settings on a phone: a search box, then your name and workspace, and the You and Workspace groups listing Account, Appearance, Notifications, Customize, General and Brand and looks."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, Settings lists its pages in groups. Appearance, Notifications and General each open with the same layout: a title, a short description and grouped cards. Typing theme into Search settings lists Appearance, Brand and looks, Document themes and Email appearance.",
            "caption": "Settings groups its pages under one layout, and searching for theme finds Appearance. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Settings",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-desktop-light.mp4",
                "webm": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-desktop-light.webm",
                "poster": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-desktop-dark.webm",
                "poster": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-phone-light.mp4",
                "webm": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-phone-light.webm",
                "poster": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-phone-dark.mp4",
                "webm": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-phone-dark.webm",
                "poster": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/settings-layout-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings in the sidebar",
          "appRoute": "/settings",
          "plans": "all",
          "links": [
            {
              "label": "Themes and branding",
              "href": "/features/themes"
            },
            {
              "label": "Set up your business",
              "href": "/tutorials/set-up-your-business"
            }
          ]
        },
        {
          "id": "text-size-per-device",
          "title": "Text size is remembered separately on phones and larger screens",
          "body": [
            "Phones now keep their own text size, set to 125% by default, while tablets and computers keep theirs at 100%. Changing the size on one kind of screen no longer changes the other.",
            "The Text size setting always edits the size for the screen you are on, so you can read comfortably on your phone without making your desktop layout larger than you want. On a phone the choices are 100%, 125%, 150% and 175%. On a tablet or computer they are 75%, 100%, 125% and 150%. Each list names its default as Default, with Small below it and Large and Extra large above it.",
            "The new size shows right away, and it is kept when you save. The same page has your Theme (Light, System or Dark), your Accent color and the language the app is shown in. A right-to-left layout turns on by itself when you choose a right-to-left language such as Arabic or Hebrew."
          ],
          "highlights": [
            "Phone default 125%; tablet and computer default 100%",
            "Four sizes per screen type",
            "Theme, accent color and language on the same page"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-28-settings-redesign-and-text-size/text-size.webp",
            "width": 780,
            "height": 1100,
            "alt": "Settings, Appearance on a phone at 125% text: Applies to all workspaces or only this one, Light, System or Dark theme, Accent color, and Text size showing Default · 125%."
          },
          "imagePhone": null,
          "whereToFind": "Settings → You → Appearance",
          "appRoute": "/settings/appearance",
          "plans": "all",
          "links": [
            {
              "label": "Themes and branding",
              "href": "/features/themes"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I search Workspace369 settings?",
          "a": "Yes. Settings has a Search settings box, and results include pages inside other pages. Searching for theme finds Appearance, for example."
        },
        {
          "q": "How are Workspace369 settings organized?",
          "a": "Into seven groups: You, Workspace, Sales, Operations, Channels, AI and Data. The Settings overview also lists what needs attention."
        },
        {
          "q": "Is text size the same on my phone and my computer?",
          "a": "No. Phones keep their own text size, 125% by default, while tablets and computers keep theirs at 100%. Changing one does not change the other."
        },
        {
          "q": "Where do I change the text size?",
          "a": "Go to Settings → You → Appearance. The Text size setting edits the size for the screen you are on, and the same page has Theme, Accent color and language."
        },
        {
          "q": "Does Workspace369 support right-to-left languages?",
          "a": "Yes. A right-to-left layout turns on by itself when you choose a right-to-left language such as Arabic or Hebrew."
        }
      ]
    },
    {
      "slug": "2026-09-27-tasks-time-tracking-and-files",
      "date": "2026-09-27",
      "title": "Tasks, time tracking and files rebuilt for faster everyday work",
      "seoTitle": "Tasks, Time Tracking and Files Update",
      "summary": "Create tasks in seconds and drag them across the board, fill in a weekly timesheet with approvals, and upload files through a queue that handles duplicates.",
      "areas": [
        "work"
      ],
      "hero": {
        "src": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a checklist with ticked boxes, a stopwatch and an open folder of sheets."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Tasks, timesheets and files in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "tasks-quick-create",
          "title": "Quick task creation and a smoother board",
          "body": [
            "Add a task straight from the bottom of a board column, or open quick create to set its properties and type a date like \"next fri\". Open any task in a preview, or move to the full-page editor when you need more room.",
            "Drag cards between columns with a clear lift and a slot showing where the card will land, so you can reorganize a board quickly even when columns are long."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-create.webp",
            "width": 1400,
            "height": 880,
            "alt": "Task quick create with the due date typed as next fri and read as Friday, alongside priority, assignee, tags and subtasks"
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-create-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "Quick create on a phone: a task titled Call back new patient with the due date set to Tomorrow, above the Create button, over the To do column of a task board."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop, a task board has To do, In progress and Done columns. Add Task at the foot of To do opens a title field, Call back new patient is typed, and the due date field reads next fri as Friday. The new card lands in To do and is dragged into In progress. On an iPhone, quick create opens over the board, the same title is typed, Tomorrow is picked as the due date, Create is pressed and the new card appears in To do.",
            "caption": "Add a task from the foot of a column or from quick create, then drag cards between columns. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Tasks",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-desktop-light.mp4",
                "webm": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-desktop-light.webm",
                "poster": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-desktop-dark.webm",
                "poster": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-phone-light.mp4",
                "webm": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-phone-light.webm",
                "poster": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-phone-dark.mp4",
                "webm": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-phone-dark.webm",
                "poster": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/tasks-quick-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Tasks in the sidebar",
          "appRoute": "/tasks",
          "plans": "all",
          "links": [
            {
              "label": "Tasks tutorial",
              "href": "/tutorials/tasks"
            },
            {
              "label": "Agency project management software",
              "href": "/solutions/agency-project-management-software"
            }
          ]
        },
        {
          "id": "timesheet-approvals",
          "title": "Time off and team hours reports",
          "body": [
            "Time off shows balances, who is out next week and the requests waiting for approval on one page, and the Reports tab charts the hours your team logged so you can see where time went.",
            "The weekly timesheet is now a grid where you edit hours in place, and managers review submitted weeks against each person's weekly capacity."
          ],
          "highlights": [
            "Time off balances and who is out next week",
            "Reports chart the hours your team logged",
            "Review weeks against weekly capacity"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/timesheet-approvals.webp",
            "width": 2800,
            "height": 1640,
            "alt": "Timesheet approvals: weeks waiting for review, with one week open in a side panel showing hours by day and project, its entries, and Approve week"
          },
          "imagePhone": null,
          "whereToFind": "Time Tracking in the sidebar",
          "appRoute": "/time-tracking",
          "plans": "all",
          "links": [
            {
              "label": "Time tracking",
              "href": "/features/time-tracking"
            },
            {
              "label": "Time tracking tutorial",
              "href": "/tutorials/time-tracking"
            }
          ]
        },
        {
          "id": "file-manager-upload-queue",
          "title": "An upload queue that handles duplicates",
          "body": [
            "Uploads now run through a queue you can minimize, with a status for every file. When a file with the same name already exists, choose New version, Keep both, Replace or Skip.",
            "You can link uploaded files to the client or project they belong to as they go in, so they are easy to find later from the record they relate to."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-27-tasks-time-tracking-and-files/file-manager-upload-queue.webp",
            "width": 2880,
            "height": 1800,
            "alt": "Files with the upload queue open: three files uploaded and one that already exists, offering New version, Keep both, Replace or Skip"
          },
          "imagePhone": null,
          "whereToFind": "Files in the sidebar",
          "appRoute": "/files",
          "plans": "all",
          "links": [
            {
              "label": "File management",
              "href": "/features/files"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I add a task straight from a board column?",
          "a": "Yes. Add a task from the bottom of a board column, or open quick create to set its properties and type a date like next fri."
        },
        {
          "q": "What can I do when I upload a file that already exists?",
          "a": "Choose New version, Keep both, Replace or Skip. Uploads run through a queue you can minimize, with a status for every file."
        },
        {
          "q": "Can I link uploaded files to a client or project?",
          "a": "Yes. You can link files to the client or project they belong to as they upload, so you can find them later from that record."
        },
        {
          "q": "Can my team fill in weekly timesheets in a grid?",
          "a": "Yes. The weekly timesheet is a grid where you edit hours in place, and managers review submitted weeks against each person's weekly capacity."
        }
      ]
    },
    {
      "slug": "2026-09-27-contracts-requests-and-team-invites",
      "date": "2026-09-27",
      "updated": "2026-10-31",
      "title": "Contracts, Requests and Team pages redesigned, with forms you can embed",
      "seoTitle": "Contracts, Requests and Team Updates",
      "summary": "Contracts get templates, countersigning and reminders, Requests get a form builder and embed codes, and inviting teammates and buying seats is simpler.",
      "areas": [
        "proposals",
        "clients",
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "A paper clipboard form and an inbox tray beside a real Workspace369 form's Share tab with its link, QR code and embed code."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Contracts, requests and team invites in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "contracts-templates-countersign",
          "title": "Contract templates, countersigning and reminders",
          "body": [
            "The Contracts page was rebuilt with a status filter, a Templates view for reusable agreements with signing roles and fields, and a builder where you set the signing order and add teammates as signers.",
            "Teammates can countersign through their own link, and you can send reminders to everyone still waiting or set how often each contract nags its signers."
          ],
          "highlights": [
            "Reusable text and PDF templates",
            "Signing order and teammates as signers",
            "Reminders for signers who have not signed"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates.webp",
            "width": 1600,
            "height": 489,
            "alt": "The Contracts Templates view: master services agreement, statement of work, mutual NDA and more, with their kind, signing roles such as Client and Countersigner, fields and how often each is used."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-phone.webp",
            "width": 780,
            "height": 1400,
            "alt": "Contract templates on a phone: each template shows whether it is rich text or a PDF and its signing roles, such as Client and Countersigner."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Contracts page opens. On the desktop the Templates view lists a master services agreement, statement of work and mutual NDA with their signing roles, and Use template opens New contract from a template. On the iPhone the New contract menu opens it. Choosing the client Dana Ruiz fills in the contract's details and the signers read Dana Ruiz, then Sam Patel. Create and review opens Review and send, which lists Dana Ruiz as signer and Sam Patel as countersigner, and the Reminders dialog sets when signers are reminded.",
            "caption": "Start a contract from a template, pick the client, review who signs in which order, and set reminders. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Contracts",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-desktop-light.mp4",
                "webm": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-desktop-light.webm",
                "poster": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-desktop-dark.webm",
                "poster": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-phone-light.mp4",
                "webm": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-phone-light.webm",
                "poster": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-phone-dark.mp4",
                "webm": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-phone-dark.webm",
                "poster": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/contract-templates-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Contracts in the sidebar",
          "appRoute": "/contracts",
          "plans": "all",
          "links": [
            {
              "label": "Contracts",
              "href": "/features/contracts"
            },
            {
              "label": "Send a contract for signature docs",
              "href": "https://docs.workspace369.com/v/2026.3/contracts/send-a-contract-for-signature/"
            }
          ]
        },
        {
          "id": "requests-forms-builder",
          "title": "A Requests table and a visual form builder",
          "body": [
            "Requests show in a table with a quick-view panel. Convert a request to a client in one click, reply by text, or mark it as new again. Conversion checks for an existing client so you do not create a duplicate.",
            "Forms have their own list and a visual builder with a Design tab for look, accent color and font. Share a link or QR code, or embed the form on your website inline, as a popup or behind your own button. Hidden fields pass values like campaign tags from the page address along with each submission.",
            "Spam protection is built in, and a Send test lead button sends a sample lead through your setup so you can confirm it arrives in Requests before you publish the form."
          ],
          "highlights": [
            "Embed inline, as a popup or behind your own button",
            "Hidden fields carry URL values such as campaign tags",
            "Share link and QR code",
            "Send a test lead"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/form-share-embed.webp",
            "width": 1600,
            "height": 1132,
            "alt": "The Share tab of a website contact form with its link, a downloadable QR code and embed code with inline, popup and your own button options."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/form-design-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The form builder on a phone with the Design tab open: accent color, font, corner style, layout and the show-your-logo switch."
          },
          "whereToFind": "Requests in the sidebar → Forms",
          "appRoute": "/requests",
          "plans": "all",
          "links": [
            {
              "label": "Client intake form software",
              "href": "/solutions/client-intake-form-software"
            },
            {
              "label": "Leads from your website",
              "href": "/tutorials/leads-from-your-website"
            }
          ]
        },
        {
          "id": "team-invites-seats",
          "title": "Invite teammates and add seats in one place",
          "body": [
            "The Team & seats page shows how many seats are used. Invite several people by email, resend an invite, edit it, or copy an invite link. Invites expire after 7 days.",
            "If you are out of seats, the page offers to add one and shows the price before you confirm. Plans that cannot add seats say so and point you to changing plan."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/team-invites.webp",
            "width": 1600,
            "height": 312,
            "alt": "The Invites tab of Team & seats: liam@oconnorbuild.example with a Custom role and access to 3 clients, expiring in 5 days and holding a seat, with a Resend button, and an expired invite for mia@maplerow.example with a Send a new invite button."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-27-contracts-requests-and-team-invites/team-invites-phone.webp",
            "width": 780,
            "height": 1313,
            "alt": "Team & seats on a phone: four members with their roles (Owner, Admin, Manager, Member), two invites, one expiring in 5 days and one expired, links to Groups and Home layouts, and an Invite people button."
          },
          "whereToFind": "Settings → Team & seats",
          "appRoute": "/settings/team-members",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Roles and client-scoped access",
              "href": "/features/client-scoped-access"
            },
            {
              "label": "Invite your team tutorial",
              "href": "/tutorials/invite-your-team"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can my teammates countersign a contract?",
          "a": "Yes. Add teammates as signers in the builder, set the signing order, and each countersigns through their own link. You can also send reminders to everyone still waiting."
        },
        {
          "q": "Can I save a contract as a reusable template?",
          "a": "Yes. The Templates view holds reusable agreements with signing roles and fields, and you start a contract from one."
        },
        {
          "q": "Can I put a request form on my own website?",
          "a": "Yes. Share a link or QR code, or embed the form on your website inline, as a popup or behind your own button. Spam protection is built in."
        },
        {
          "q": "Does converting a request to a client create duplicates?",
          "a": "No. Converting a request to a client checks for an existing client first, so you do not create a duplicate."
        },
        {
          "q": "How long does a team invite last?",
          "a": "An invite expires after 7 days. You can resend it, edit it or copy the invite link from Settings → Workspace → Team & seats."
        }
      ]
    },
    {
      "slug": "2026-09-27-clients-stages-and-calendar-editor",
      "date": "2026-09-27",
      "updated": "2026-10-31",
      "title": "Clients get stages and follow-ups, and the calendar gets a faster editor with Google Meet",
      "seoTitle": "Client Stages and Calendar Editor",
      "summary": "Track clients through stages with a follow-up queue and AI-drafted messages, and create calendar events by dragging, with Google Meet links and guest invites.",
      "areas": [
        "clients",
        "scheduling",
        "ai"
      ],
      "hero": {
        "src": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: three stage columns with client coins moving from left to right, and a small calendar tile."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Client stages and the new calendar in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "client-stages-follow-ups",
          "title": "Stages, Leads and a follow-up queue",
          "body": [
            "Add people as Leads and move clients through stages you can rename, recolor, reorder or hide. The Clients list has a tab for each stage, and the Next follow-up column says why each client is due.",
            "The Follow-ups view lists who to contact today and why, and each stage can remind you when a client has been quiet for a number of days you choose, so nobody drifts away unnoticed."
          ],
          "highlights": [
            "A tab for every stage, with your own stages",
            "Follow-ups view: who to contact today and why",
            "Remind me after a quiet period set per stage"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-follow-ups.webp",
            "width": 2640,
            "height": 1395,
            "alt": "Clients table with a tab for each stage, a Stage column, and a Next follow-up column that says when each client is due and why"
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The Clients list on a phone with a chip for each stage, Leads selected, a banner reading 5 follow-ups due today, and each client row showing its stage and next follow-up."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Clients list opens with a tab or chip for each stage. Leads is chosen and the list narrows to the prospects. The follow-up queue opens, grouped into Overdue, Today and This week with the reason each person is due, and one follow-up is marked done.",
            "caption": "Switch to the Leads stage, open the follow-up queue and mark a follow-up done. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Clients",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-desktop-light.mp4",
                "webm": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-desktop-light.webm",
                "poster": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-desktop-dark.webm",
                "poster": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-phone-light.mp4",
                "webm": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-phone-light.webm",
                "poster": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-phone-dark.mp4",
                "webm": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-phone-dark.webm",
                "poster": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-stages-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Clients in the sidebar → Follow-ups",
          "appRoute": "/clients",
          "plans": "all",
          "links": [
            {
              "label": "Client management software",
              "href": "/solutions/client-management-software"
            },
            {
              "label": "Add clients tutorial",
              "href": "/tutorials/add-clients"
            }
          ]
        },
        {
          "id": "client-quick-view",
          "title": "Quick view with AI-drafted follow-ups",
          "body": [
            "Select a client to open a side panel with their stage, timeline and next follow-up. From there you can snooze or mark it done, schedule a call or meeting, or have AI draft the email, text or call notes.",
            "Drafting counts toward your plan's AI usage, and you edit the message before anything is sent. Drafting is also available from the client sheet on your phone."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/client-quick-view.webp",
            "width": 1075,
            "height": 1660,
            "alt": "Client quick view side panel with stage, quick actions, the next follow-up with Schedule call and Draft email, and the client's activity timeline"
          },
          "imagePhone": null,
          "whereToFind": "Clients → select a client",
          "appRoute": "/clients",
          "plans": "all",
          "links": [
            {
              "label": "Client management software",
              "href": "/solutions/client-management-software"
            },
            {
              "label": "Workspace AI tutorial",
              "href": "/tutorials/workspace-ai"
            }
          ]
        },
        {
          "id": "calendar-editor",
          "title": "Create events by dragging, edit them in a full editor",
          "body": [
            "Drag on the calendar to create an event with a quick popover, or open the full editor to set guests, reminders and team availability. Hold Shift while dragging to land on the exact minute.",
            "Preview any event from a popover or side panel and use its actions menu to change or delete it without leaving the calendar. Deleting a repeating event can apply to this and the following events."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/calendar-editor.webp",
            "width": 2432,
            "height": 1800,
            "alt": "Full event editor with time, Google Meet, client, team, guests and reminders, beside a team availability panel that flags a clash and suggests free times"
          },
          "imagePhone": null,
          "whereToFind": "Calendar in the sidebar",
          "appRoute": "/calendar",
          "plans": "all",
          "links": [
            {
              "label": "Calendar and scheduling",
              "href": "/features/schedule"
            },
            {
              "label": "Calendar tutorial",
              "href": "/tutorials/calendar"
            }
          ]
        },
        {
          "id": "calendar-meet-invites",
          "title": "Google Meet links, guest invites and text reminders",
          "body": [
            "Add a Google Meet link to any event once your Google account is connected in Settings → Integrations. Email invites go to your guests with a separate note for guests, so your internal description stays private.",
            "Clients can also get a text reminder before the event. Text reminders start at Voyager, and sending invites needs the Send invites permission, so you decide which teammates can email guests or clients from the calendar."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-27-clients-stages-and-calendar-editor/calendar-meet-invites.webp",
            "width": 1620,
            "height": 1415,
            "alt": "Event editor with a Google Meet link created on save, an email invite to the client, three guests and a note for guests kept apart from the internal description"
          },
          "imagePhone": null,
          "whereToFind": "Calendar → open an event → Add Google Meet",
          "appRoute": "/calendar",
          "plans": "all",
          "links": [
            {
              "label": "Calendar and scheduling",
              "href": "/features/schedule"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I track leads and client stages in Workspace369?",
          "a": "Yes. Add people as Leads and move clients through stages you can rename, recolor, reorder or hide. The Clients list has a tab for each stage."
        },
        {
          "q": "How does Workspace369 remind me to follow up with clients?",
          "a": "The Follow-ups view lists who to contact today and why. Each stage can also remind you when a client has been quiet for a number of days you choose."
        },
        {
          "q": "Can AI draft a follow-up to a client?",
          "a": "Yes. From a client's quick view, AI can draft the email, text or call notes. You edit the message before anything is sent, and drafting counts toward your plan's AI usage."
        },
        {
          "q": "Can I add a Google Meet link to a calendar event?",
          "a": "Yes, once your Google account is connected in Settings → Data → Integrations. Then add a Google Meet link to any event."
        },
        {
          "q": "Can clients get a text reminder before an event?",
          "a": "Yes. Clients can get a text reminder before the event. Text reminders start at Voyager."
        }
      ]
    },
    {
      "slug": "2026-09-24-invoice-page-design-and-change-orders",
      "date": "2026-09-24",
      "title": "Design the invoice page your clients see, and track changes with change orders",
      "seoTitle": "Invoice Page Design and Change Orders",
      "summary": "Choose the template, palette and extras for your public invoice page, and change accepted proposals or paid invoices through approved change orders.",
      "areas": [
        "billing",
        "proposals"
      ],
      "hero": {
        "src": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: an invoice sheet with color swatches and a ruler, and a second sheet behind it with a revision arrow."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Invoice design and change orders in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "invoice-page-design",
          "title": "Design the invoice page your clients open",
          "body": [
            "Invoice page design lets you choose how the page your clients open from an invoice link looks. Pick one of ten templates and a color palette, then set the typeface and logo size. It is on every plan and is for anyone who wants invoices to look like their brand.",
            "The templates are Classic, Modern, Minimal, Bold, Letterhead, Elegant, Sidebar, Receipt, Statement and Studio, and the app tags the ones that suit your industry as Recommended. For the typeface, keep each template's own or choose sans-serif, serif, grotesque or mono accents. Set the logo size to small, medium or large, and replace the word Invoice at the top with your own document title, like Tax invoice or Bill. A live preview shows the result before you save.",
            "Under Show on invoice, hide details you do not want clients to see, such as your tax ID, the PO number, payment terms, notes or the footer note. Fields without data never show. Page language sets the language of the labels, like Amount due. Your own text is never translated, and pages stay in English until you choose a language.",
            "Page extras are off until you turn them on. The scan-to-pay QR code opens the invoice page on a phone and is printed too. The print button lets clients print from the page. The due date countdown reads Due in 5 days, Overdue by 2 days, or the day it was paid.",
            "To give one invoice its own look, open its editor, find Page design for this invoice, and pick a different template or palette. Use workspace design takes it back, and Preview page shows it first."
          ],
          "highlights": [
            "Template, palette, typeface and logo size",
            "Scan-to-pay QR code, print button, due date countdown",
            "Different design for a single invoice",
            "Reset to defaults any time"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes.webp",
            "width": 978,
            "height": 1700,
            "alt": "Settings, Invoices, Document themes for the demo workspace Apex Auto Spa: nine invoice templates, Classic selected, with Modern, Minimal, Bold, Letterhead, Elegant, Sidebar, Receipt and Statement, each with a short description."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The same Document themes page on a phone: the Preview invoice button above the invoice templates, with Modern selected."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Document themes page opens on the Classic template. The Modern template is chosen, then the Emerald color palette, and the Serif typeface, and the invoice page preview for Dana Ruiz follows each change. On the phone, Preview invoice opens the full invoice page.",
            "caption": "Pick a template, palette and typeface and the invoice page preview follows. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Document themes",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-desktop-light.mp4",
                "webm": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-desktop-light.webm",
                "poster": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-desktop-dark.webm",
                "poster": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-phone-light.mp4",
                "webm": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-phone-light.webm",
                "poster": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-phone-dark.mp4",
                "webm": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-phone-dark.webm",
                "poster": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/document-themes-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings → Invoices → Document themes",
          "appRoute": "/settings/document-themes",
          "plans": "all",
          "links": [
            {
              "label": "PDF and document customization",
              "href": "/features/pdf-customization"
            },
            {
              "label": "Invoices",
              "href": "/features/invoices"
            }
          ]
        },
        {
          "id": "change-orders",
          "title": "Change orders for accepted proposals and paid invoices",
          "body": [
            "Once a proposal is accepted, or a deposit or payment comes in, its items and prices lock, and a banner explains why. To change it, create a numbered change order that shows exactly what changed.",
            "Give the change order a short title and the reason, which is kept in the audit trail and shown to the client, and pick the type of change: client request, scope change, price correction, error correction or other. Then edit, add or remove items. Each line is marked Added, Removed or Changed, with Before and After values. The summary works out the original total, earlier change orders, this change, the new total, what is already paid and the new balance due.",
            "Choose Send to client and they get an email with a link to review and approve it. Nothing changes until they approve. If they approved by email, phone or in person, use Record client approval and add a note on how, which is kept in the audit trail. A change order moves from Draft to Awaiting client to Approved, or ends as Declined or Voided. Workspace settings can require clients to approve themselves and to sign when they do.",
            "The original and every approved change are kept, so you always have a record of what was agreed. If the new total is below what the client already paid, the app warns you to refund the difference from the payments list. Owners can also choose to lock invoices as soon as they are sent, and an invoice locked that way stays locked if you later turn the setting off. Starting a change order needs Specialist or higher; existing ones stay readable on every plan."
          ],
          "highlights": [
            "Reason and type of change on every change order",
            "Added, removed and changed lines with before and after",
            "Send for approval, or record an approval you got by phone or email"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-24-invoice-page-design-and-change-orders/change-orders.webp",
            "width": 2200,
            "height": 2980,
            "alt": "Change order composer for a part-paid invoice: a title and reason, the edited items, a summary of what changed and the new total and balance due"
          },
          "imagePhone": null,
          "whereToFind": "Open a locked proposal or invoice → Change order",
          "appRoute": "/proposals",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Change orders",
              "href": "/features/change-orders"
            },
            {
              "label": "Proposals",
              "href": "/features/quoting"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I customize the invoice page my clients open?",
          "a": "Yes. Pick one of ten templates and a color palette, then set the typeface and logo size, with a live preview. It is in Settings → Sales → Invoices → Document themes."
        },
        {
          "q": "Can one invoice have its own design?",
          "a": "Yes. Open the invoice's editor, find Page design for this invoice, and pick a different template or palette. Use workspace design takes it back."
        },
        {
          "q": "Can I change an invoice or proposal after it is accepted or paid?",
          "a": "Yes, with a change order. Items and prices lock once a proposal is accepted or a payment comes in, and a numbered change order records what changed. Starting one needs Specialist or higher."
        },
        {
          "q": "Does the client have to approve a change order?",
          "a": "Yes. Nothing changes until the client approves it. You send it by email for review, or record approval you got by phone or in person, with a note on how."
        },
        {
          "q": "Can I hide details like my tax ID on the invoice page?",
          "a": "Yes. Under Show on invoice, hide details such as your tax ID, the PO number, payment terms, notes or the footer note."
        }
      ]
    },
    {
      "slug": "2026-09-23-ai-autopilot-today",
      "date": "2026-09-23",
      "title": "AI AutoPilot: a daily Today feed, Client Health and watches on money, projects and tasks",
      "seoTitle": "AI AutoPilot Today Feed",
      "summary": "AI AutoPilot ranks what needs you today, flags clients, invoices and projects that need attention, and drafts reminders for you to review. It only suggests.",
      "areas": [
        "ai",
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-09-23-ai-autopilot-today/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a sunrise over a ranked stack of cards, with a lighthouse keeping watch."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "AI AutoPilot Today in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "autopilot-today",
          "title": "A Today feed that ranks what to do next",
          "body": [
            "AI AutoPilot opens on Today, a ranked list of what needs you: an invoice to chase, a client to check in with, a request to answer. View it as lanes or a timeline, and open How I ordered this to see why each item sits where it does.",
            "For now AutoPilot works when the workspace owner's app language is English."
          ],
          "highlights": [
            "Lanes and Timeline views",
            "How I ordered this explains the ranking",
            "Suggestion only: nothing is sent for you"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today.webp",
            "width": 1620,
            "height": 1680,
            "alt": "AI AutoPilot Today in Lanes view: filters for Money Watch, Project Watch, Task Assist and more, then Money, Clients, Tasks and Inbox lanes with items such as Chase invoice INV-1042 for Parker Group, 12 days past due."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "AI AutoPilot Today on a phone: a Good morning heading, an AI-written summary that starts with INV-1042 for Dana Ruiz, the Lanes and Timeline switch, then Money and Clients lanes with Chase invoice INV-1042 and Keep an eye on Sam Patel."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, AI AutoPilot Today shows an AI-written summary and a Lanes feed with Chase invoice INV-1042 for Dana Ruiz under Money and Keep an eye on Sam Patel under Clients. The menu on the invoice opens and Mark as Done is chosen, the invoice leaves the list, and the Timeline view then shows the remaining items.",
            "caption": "Today ranks what needs you; Mark as Done clears one. The AI-written summary is Voyager and up. Example text; results vary. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "AI AutoPilot Today",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-desktop-light.mp4",
                "webm": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-desktop-light.webm",
                "poster": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-desktop-dark.webm",
                "poster": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-phone-light.mp4",
                "webm": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-phone-light.webm",
                "poster": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-phone-dark.mp4",
                "webm": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-phone-dark.webm",
                "poster": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-today-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "AI AutoPilot in the sidebar",
          "appRoute": "/ai",
          "plans": "all",
          "links": [
            {
              "label": "AI AutoPilot Today",
              "href": "/features/autopilot"
            },
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            },
            {
              "label": "Workspace AI tutorial",
              "href": "/tutorials/workspace-ai"
            }
          ]
        },
        {
          "id": "autopilot-briefing",
          "title": "A morning briefing and message sorting",
          "body": [
            "Turn on the morning briefing and message sorting and AI summarizes your day and suggests labels on new email and text messages. It never moves messages or sends replies. Owners choose the sources, and teammates can get their own Today. Both count toward your plan's AI usage."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-briefing.webp",
            "width": 1600,
            "height": 350,
            "alt": "The morning briefing at the top of AI AutoPilot Today: start with INV-1042, Parker Group is 12 days past due on $1,250, then check in with Northstar Studio and reply to the quote request, marked AI-written, above the Lanes and Timeline switch and a line reading Reviewing new email and SMS."
          },
          "imagePhone": null,
          "whereToFind": "AI AutoPilot → Settings",
          "appRoute": "/ai",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            },
            {
              "label": "Workspace AI tutorial",
              "href": "/tutorials/workspace-ai"
            }
          ]
        },
        {
          "id": "autopilot-client-health",
          "title": "Client Health and check-in suggestions",
          "body": [
            "Client Health flags clients who need attention, with the reason shown: an overdue invoice, a quiet stretch after earlier back-and-forth, or a message marked as a complaint. It offers a Draft follow-up you can edit.",
            "It is off until an owner turns on background analysis in AutoPilot settings, and flags are for you only, never shown to the client."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-client-health.webp",
            "width": 1248,
            "height": 520,
            "alt": "Client Health card marked Needs attention, showing an overdue invoice and a quiet stretch, with Draft follow-up, Plan a check-in, Snooze and Dismiss"
          },
          "imagePhone": null,
          "whereToFind": "Clients → open a client → Client Health",
          "appRoute": "/clients",
          "plans": "all",
          "links": [
            {
              "label": "AI AutoPilot Today",
              "href": "/features/autopilot"
            },
            {
              "label": "Client management software",
              "href": "/solutions/client-management-software"
            },
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            }
          ]
        },
        {
          "id": "autopilot-watches",
          "title": "Money Watch, Project Watch and Task Assist",
          "body": [
            "Money Watch on an invoice shows the unpaid balance, due date and any missed installments, with a Draft reminder you can edit. Project Watch compares recorded billable hours with planned hours, counts completed items and lists tasks unchanged for 7 days. Task Assist lists tasks sitting unchanged in the statuses you pick on one board.",
            "Every watch is switched on separately in AutoPilot settings, and none of them sends anything by itself. You decide whether a drafted reminder goes out."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-23-ai-autopilot-today/autopilot-watches.webp",
            "width": 1710,
            "height": 1290,
            "alt": "AutoPilot Today with Money Watch, Project Watch and Task Assist items: an overdue invoice, a project near its planned hours and a task left unchanged"
          },
          "imagePhone": null,
          "whereToFind": "AI AutoPilot in the sidebar; Money Watch shows on invoice details",
          "appRoute": "/ai",
          "plans": "all",
          "links": [
            {
              "label": "AI AutoPilot Today",
              "href": "/features/autopilot"
            },
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            },
            {
              "label": "Invoices",
              "href": "/features/invoices"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Does AI AutoPilot send messages to my clients by itself?",
          "a": "No. None of the AutoPilot watches sends anything by itself. They draft reminders you can edit, and you decide whether a drafted reminder goes out."
        },
        {
          "q": "Which plans include the AutoPilot morning briefing?",
          "a": "Voyager, Specialist, Commander and Enterprise. It summarizes your day, and message sorting suggests labels on new email and texts. Both count toward your plan's AI usage."
        },
        {
          "q": "What does Client Health show?",
          "a": "It flags clients who need attention and shows the reason, such as an overdue invoice, a quiet stretch or a complaint, with a Draft follow-up you can edit. Flags are for you only, never shown to the client."
        },
        {
          "q": "What does Money Watch do on an invoice?",
          "a": "It shows the unpaid balance, the due date and any missed installments, with a Draft reminder you can edit. It is switched on separately in AutoPilot settings."
        }
      ]
    },
    {
      "slug": "2026-09-20-contracts-and-e-signature",
      "date": "2026-09-20",
      "title": "Send contracts for e-signature from Workspace369",
      "seoTitle": "Send Contracts for E-Signature",
      "summary": "Upload a PDF or use a template, place signature fields, and send it for signing. Signers verify by email code, and you keep an audit trail and evidence file.",
      "areas": [
        "proposals",
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-09-20-contracts-and-e-signature/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "A paper contract with a fountain pen, signature, seal and padlock beside a real Workspace369 template editor: the Master services agreement with its clause text, merge fields and Client and Countersigner signature fields."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Send a contract for e-signature in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "send-contract",
          "title": "Send a contract and track who has signed",
          "body": [
            "You can now send a contract for e-signature from Workspace369. Upload a PDF or start from a template, place signature fields, add your signers and send it. It is on every plan and is for anyone who needs a client to sign an agreement online.",
            "Start from a PDF or a reusable template. A PDF can be up to 25 MB and 300 pages. The builder walks you through four steps: PDF document, Recipients, Signing fields, and Review and send. Add each recipient as a Signer, Approver, Viewer, or someone who receives a copy. Recipients with the same signing order act at the same time, and lower numbers go first. A contract can have up to 20 recipients.",
            "Link the contract to a client and the client's details fill in the signer, and the contract also shows on the client's profile. To place a field, pick its type, then tap the page. You can add a signature, initials, date signed, full name, text field or checkbox, up to 500 fields per contract. Drag a field to move it and drag its corner to resize it. Every signer needs at least one signature field.",
            "Choose how signers verify. With Email code, the signer enters a code we email them before they can sign, which we recommend for most contracts. Link only lets anyone with the link sign, and an owner has to allow it first in Settings, under Contract Settings. Set an expiry from 1 to 365 days, then press Send for signature. People in the first signing group are emailed right away, and the document cannot be changed after sending.",
            "Each signer confirms with a code we email them, then signs from a private link. The Contracts list shows where every contract stands, from Draft, Sent and In progress to Completed, Declined, Voided or Expired. Open one to see each recipient as Invited, Opened, Verified or Done, and use Remind to nudge a signer. The app tells you if a signer was already reminded in the last 24 hours.",
            "If something is wrong, void the contract, or choose Void and edit a copy. That ends it for every recipient and gives you a new draft with the same document, recipients and fields. To sign face to face, start in-person signing: you confirm you checked the signer's ID, choose the ID type, and the signing page opens on your device for 15 minutes. To send one template to many people, use Bulk send with clients you select or a CSV of up to 500 rows."
          ],
          "highlights": [
            "PDF or template, up to 500 fields",
            "Up to 20 recipients and a signing order",
            "Email code verification, with an expiry from 1 to 365 days",
            "Status for every contract with reminders",
            "Void and edit a copy"
          ],
          "image": {
            "src": "/images/release-notes/2026-09-20-contracts-and-e-signature/contract-detail.webp",
            "width": 1600,
            "height": 1000,
            "alt": "A contract waiting on a countersignature: one of two signers has signed, with the signing order, reminders every 3 days, email code verification and the activity timeline beside the document."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-09-20-contracts-and-e-signature/contract-detail-phone.webp",
            "width": 780,
            "height": 1688,
            "alt": "The contract on a phone: waiting on others, one of two signers done, with reminders, email code verification and a Countersign now button."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, a ready Master services agreement is on Review and send. Send for signature is chosen and confirmed, and Contract sent appears. The Contracts list shows it as Waiting with 0 of 2 signed. Opening it lists Dana Ruiz then Sam Patel in signing order; Dana signs, the count reads 1 of 2 signed, and Countersign now appears for Sam.",
            "caption": "Send a contract for signature, see it listed as Waiting, and open it to follow each signer. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Send a contract",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-light.mp4",
                "webm": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-light.webm",
                "poster": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-dark.webm",
                "poster": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-light.mp4",
                "webm": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-light.webm",
                "poster": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-dark.mp4",
                "webm": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-dark.webm",
                "poster": "/images/release-notes/2026-09-20-contracts-and-e-signature/send-contract-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Contracts in the sidebar",
          "appRoute": "/contracts",
          "plans": "all",
          "links": [
            {
              "label": "Contracts",
              "href": "/features/contracts"
            },
            {
              "label": "Send a contract for signature docs",
              "href": "https://docs.workspace369.com/v/2026.3/contracts/send-a-contract-for-signature/"
            },
            {
              "label": "Web design contract template",
              "href": "/learn/web-design-contract-template"
            }
          ]
        },
        {
          "id": "contract-evidence",
          "title": "An audit trail and evidence file for every contract",
          "body": [
            "Every contract keeps a History timeline of what happened. It records when the document was sent, each signing link opened and each code sent and verified, plus consent to electronic records, documents viewed, a recipient finishing or declining, and when sealing started. A wrong code or a locked verification shows up there too.",
            "When everyone has signed, the app seals the signed copy. Under Downloads you can then get the Signed PDF, a Certificate of completion and an Evidence file, and the contract tells you whether the audit trail is intact or was altered, and at which event.",
            "Ended contracts (completed, declined, voided or expired) can be deleted for good once the retention period has passed. The owner or an admin sets that period, from 1 to 10 years, in Contract Settings. Deleting removes field values, signatures and working files, while the signed copy stays verifiable and the audit trail is kept.",
            "On plans with a monthly allowance of sent contracts, the send screen shows how many you have used this month before you send."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-09-20-contracts-and-e-signature/contract-evidence.webp",
            "width": 760,
            "height": 1800,
            "alt": "A completed contract's side panel: Signed, two signers in order, details, downloads for the Signed PDF, Certificate of completion and Evidence file, and an Activity timeline marked Audit trail intact."
          },
          "imagePhone": null,
          "whereToFind": "Contracts → open a contract",
          "appRoute": "/contracts",
          "plans": "all",
          "links": [
            {
              "label": "Contracts",
              "href": "/features/contracts"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Which Workspace369 plans include contracts and e-signature?",
          "a": "Every plan. On plans with a monthly allowance of sent contracts, the send screen shows how many you have used this month before you send."
        },
        {
          "q": "How do I send a contract for signature?",
          "a": "Open Contracts in the sidebar. Upload a PDF or start from a template, place signature fields, add your signers and press Send for signature. The builder has four steps."
        },
        {
          "q": "How do signers verify who they are?",
          "a": "With Email code, the signer enters a code emailed to them before signing. Link only lets anyone with the link sign, and an owner must allow it first in Settings, under Contract Settings."
        },
        {
          "q": "What are the limits on a contract?",
          "a": "A PDF can be up to 25 MB and 300 pages. A contract can have up to 20 recipients and up to 500 fields. Expiry can be set from 1 to 365 days."
        },
        {
          "q": "What do I get once a contract is signed?",
          "a": "When everyone has signed, the app seals the signed copy. Under Downloads you can get the Signed PDF, a Certificate of completion and an Evidence file, plus a History timeline of what happened."
        },
        {
          "q": "Can I track signers and send reminders?",
          "a": "Yes. The Contracts list shows each contract from Draft to Completed. Open one to see each recipient as Invited, Opened, Verified or Done, and use Remind to nudge a signer."
        }
      ]
    },
    {
      "slug": "2026-08-31-august-2026-roundup",
      "date": "2026-08-31",
      "updated": "2026-10-31",
      "title": "August 2026: connect Claude and ChatGPT, review AI changes first, and a Gantt view",
      "seoTitle": "Workspace369 August 2026 Updates",
      "summary": "Connect Claude, ChatGPT or any MCP client with approvals on every send, let AI AutoPilot confirm before it changes anything, and plan work on a Gantt timeline.",
      "areas": [
        "ai",
        "work",
        "inbox",
        "automations",
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-08-31-august-2026-roundup/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: two puzzle pieces clicking together like a plug and socket, beside stepped timeline bars like a Gantt chart."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Workspace369 August 2026 updates",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "mcp-server",
          "title": "Connect Claude, ChatGPT or any AI app to your workspace",
          "body": [
            "Workspace369 has an MCP server, so Claude, ChatGPT or any client that supports MCP over OAuth can work inside your workspace. It can look up clients, draft proposals and invoices, log time, check your calendar and read your messages, and it can update records in clients, projects, tasks, expenses and workflows too.",
            "You stay in control. A workspace admin turns MCP on and chooses what each connection may do, and anything that sends, like an email or an invoice, waits for your approval in the app. MCP is included on every plan, and each call counts toward your plan's AI usage."
          ],
          "highlights": [
            "Works with Claude, ChatGPT and other MCP clients",
            "Sends wait for your approval in the app",
            "Create personal access tokens for clients that need one",
            "Included on every plan once an admin turns it on"
          ],
          "image": {
            "src": "/images/release-notes/2026-08-31-august-2026-roundup/mcp-server.webp",
            "width": 1930,
            "height": 665,
            "alt": "AI connections settings card reading Bring Workspace369 into your AI, with the MCP server URL, a Copy URL button and the AI apps that can connect"
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The AI connections page on a phone, with the Connect an AI app card above Connected apps listing Maple Row Assistant and Front Desk Helper."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the AI connections page shows the Connect an AI app card with the server URL and steps. The Connected apps list shows Maple Row Assistant and Front Desk Helper, and View permissions lists the five permissions Maple Row Assistant has.",
            "caption": "Copy the server URL into your AI app, then see each connected app and the permissions it has. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "AI connections",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-desktop-light.mp4",
                "webm": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-desktop-light.webm",
                "poster": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-desktop-dark.webm",
                "poster": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-phone-light.mp4",
                "webm": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-phone-light.webm",
                "poster": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-phone-dark.mp4",
                "webm": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-phone-dark.webm",
                "poster": "/images/release-notes/2026-08-31-august-2026-roundup/ai-connections-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Settings → AI connections",
          "appRoute": "/settings/ai-connections",
          "plans": "all",
          "links": [
            {
              "label": "Workspace369 MCP",
              "href": "/integrations/mcp"
            },
            {
              "label": "CRM MCP server guide",
              "href": "/blog/crm-mcp-server"
            },
            {
              "label": "Workspace AI tutorial",
              "href": "/tutorials/workspace-ai"
            }
          ]
        },
        {
          "id": "ask-ai-confirmations",
          "title": "AI AutoPilot chat shows what it will change before it changes it",
          "body": [
            "AI AutoPilot chat answers questions about your workspace and can make changes for you, like creating or updating tasks, clients and addresses. Before anything changes it shows a card you can review and edit, and afterwards it tells you which record it touched. When it proposes many changes at once, you get one reviewable list with a row per item.",
            "Workspace AI is built into every workspace with nothing to set up: compose and rewrite messages, translate, and summarize. On Commander and Enterprise, AI can also draft a whole workflow for you to review before it runs. A workspace admin can turn on Auto-approve actions, which creates, updates and deletes records without asking. Sends to clients always ask first. AI use counts toward your plan's AI usage."
          ],
          "highlights": [
            "Review and edit the change before it applies",
            "Compose, rewrite, translate and summarize",
            "AI-drafted workflows on Commander and Enterprise"
          ],
          "image": {
            "src": "/images/release-notes/2026-08-31-august-2026-roundup/ask-ai-confirmations.webp",
            "width": 1720,
            "height": 1350,
            "alt": "AI AutoPilot confirmation card titled Confirm before this runs for creating a task on the Operations board, with editable title, status, priority, due date, assignee and tags, and Cancel and Create Task buttons"
          },
          "imagePhone": null,
          "whereToFind": "Sidebar → AI AutoPilot → Chat",
          "appRoute": "/ai/chat",
          "plans": "all",
          "links": [
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            },
            {
              "label": "Workspace AI tutorial",
              "href": "/tutorials/workspace-ai"
            },
            {
              "label": "Workflow Automations",
              "href": "/features/automation"
            }
          ]
        },
        {
          "id": "gantt-and-task-order",
          "title": "A Gantt timeline for your boards",
          "body": [
            "Switch a board to Gantt view to see tasks on a timeline with dependencies, baselines, a critical path and a workload heat map based on each member's capacity. It helps you spot a crunch before it lands. Gantt view is on Voyager, Specialist, Commander and Enterprise."
          ],
          "highlights": [
            "Dependencies, baselines and critical path",
            "Workload heat map from each member's capacity"
          ],
          "image": {
            "src": "/images/release-notes/2026-08-31-august-2026-roundup/gantt-and-task-order.webp",
            "width": 2800,
            "height": 1165,
            "alt": "Gantt view of a website relaunch board grouped by status, with task bars on a day timeline, dependency arrows, two milestones, a today marker and Critical path turned on"
          },
          "imagePhone": null,
          "whereToFind": "Tasks → view switcher → Gantt",
          "appRoute": "/tasks",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Agency project management",
              "href": "/solutions/agency-project-management-software"
            },
            {
              "label": "Tasks tutorial",
              "href": "/tutorials/tasks"
            }
          ]
        },
        {
          "id": "task-order",
          "title": "Your own task order",
          "body": [
            "Drag tasks within a column to put them in your own order, and on a phone drag them across statuses. The order is saved for everyone."
          ],
          "highlights": [
            "Drag to reorder, with the order saved for everyone"
          ],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Tasks → a board → drag a task within its column",
          "appRoute": "/tasks",
          "plans": "all",
          "links": [
            {
              "label": "Agency project management",
              "href": "/solutions/agency-project-management-software"
            },
            {
              "label": "Tasks tutorial",
              "href": "/tutorials/tasks"
            }
          ]
        },
        {
          "id": "inbox-email-upgrades",
          "title": "Better email in the inbox: several recipients, quoted replies and forwards",
          "body": [
            "Send an email to several recipients at once. Replies now quote the original message, forwards keep their attachments, and drafts behave the way you expect.",
            "You can search mail more deeply, mark a conversation unread, and report spam to teach the inbox to treat a sender, or a whole domain, as junk."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-08-31-august-2026-roundup/inbox-email-upgrades.webp",
            "width": 1000,
            "height": 840,
            "alt": "Report spam dialog for a sender, set to block the whole @cheap-watches.example domain instead of just the one address"
          },
          "imagePhone": null,
          "whereToFind": "Inbox in the sidebar",
          "appRoute": "/communications/inbox",
          "plans": "all",
          "links": [
            {
              "label": "Inbox and communications",
              "href": "/features/communications"
            },
            {
              "label": "Inbox tutorial",
              "href": "/tutorials/inbox"
            }
          ]
        },
        {
          "id": "workflow-stop-rules",
          "title": "Workflows that stop when the job is done",
          "body": [
            "A workflow can stop itself when a goal is met. Pick a one-tap goal or write the condition as a plain sentence, so a reminder sequence ends once the invoice is paid.",
            "The Payment overdue reminder schedule is set right in the workflow builder, so you choose the days reminders go out."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-08-31-august-2026-roundup/workflow-stop-rules.webp",
            "width": 796,
            "height": 700,
            "alt": "Stop the workflow step in the workflow builder with the common rule The invoice is paid ticked and the condition Invoice status is Paid"
          },
          "imagePhone": null,
          "whereToFind": "Workflows in the sidebar → open a workflow",
          "appRoute": "/workflows",
          "plans": "all",
          "links": [
            {
              "label": "Workflow Automations",
              "href": "/features/automation"
            },
            {
              "label": "Workflows tutorial",
              "href": "/tutorials/workflows"
            },
            {
              "label": "Build, test and activate a workflow",
              "href": "https://docs.workspace369.com/v/2026.3/automation/build-test-activate-workflow/"
            }
          ]
        },
        {
          "id": "project-team-access",
          "title": "Give team members access to specific projects",
          "body": [
            "Give a team member access to particular projects and task boards instead of everything. They see the projects they belong to and nothing else, which suits contractors and part-time helpers."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-08-31-august-2026-roundup/project-team-access.webp",
            "width": 1344,
            "height": 1164,
            "alt": "Team access dialog for a project set to Custom project access, with two of five teammates included, one with Edit and one with View, and the rest set to No access"
          },
          "imagePhone": null,
          "whereToFind": "Projects → open a project → Team",
          "appRoute": "/projects",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Client-scoped access",
              "href": "/features/client-scoped-access"
            },
            {
              "label": "Team access and permissions",
              "href": "https://docs.workspace369.com/v/2026.3/admin/team-access-and-permissions/"
            }
          ]
        },
        {
          "id": "client-records",
          "title": "Richer client profiles, and an archive instead of delete",
          "body": [
            "Add or crop a client's photo and see every address and contact person on the client screen. Choose a primary email and phone, get a warning about possible duplicates, and let contact persons opt in to messages.",
            "Deleting a client now archives it first. An Archived view lets you restore it or delete it for good, and you get a warning if you invoice, text or email an archived client."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-08-31-august-2026-roundup/client-records.webp",
            "width": 1520,
            "height": 400,
            "alt": "Archived clients view listing four archived clients with their company and the date each was archived"
          },
          "imagePhone": null,
          "whereToFind": "Clients → open a client; Clients → Archived",
          "appRoute": "/clients",
          "plans": "all",
          "links": [
            {
              "label": "Client management",
              "href": "/solutions/client-management-software"
            },
            {
              "label": "Clients and CRM docs",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/clients-and-crm/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I connect Claude or ChatGPT to Workspace369?",
          "a": "Yes. Workspace369 has an MCP server, so Claude, ChatGPT or any client that supports MCP over OAuth can work in your workspace. Set it up in Settings → AI → AI connections."
        },
        {
          "q": "Can a connected AI send emails or invoices without my approval?",
          "a": "No. A workspace admin chooses what each connection may do, and anything that sends, like an email or an invoice, waits for your approval in the app."
        },
        {
          "q": "Which plans include MCP connections?",
          "a": "Every Workspace369 plan includes MCP connections, and each call counts toward your plan's AI usage."
        },
        {
          "q": "Does Workspace369 have a Gantt view for tasks?",
          "a": "Yes, on Voyager and above. Switch a board to Gantt to see tasks on a timeline with dependencies, baselines and a critical path."
        },
        {
          "q": "What happens when I delete a client?",
          "a": "The client is archived first. An Archived view lets you restore it or delete it for good, and you get a warning if you invoice, text or email an archived client."
        }
      ]
    },
    {
      "slug": "2026-07-31-july-2026-roundup",
      "date": "2026-07-31",
      "title": "July 2026: a rebuilt calendar, funnels, inventory tracking and workflows with test runs",
      "seoTitle": "Workspace369 July 2026 Updates",
      "summary": "A rebuilt calendar, funnels that capture leads into your CRM, inventory with low-stock alerts, workflows that create tasks, and invoices with a live preview.",
      "areas": [
        "scheduling",
        "automations",
        "billing",
        "work",
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-07-31-july-2026-roundup/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a calendar, a funnel catching coins and a stack of shipping boxes."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Workspace369 July 2026 updates",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "calendar-rebuild",
          "title": "A rebuilt calendar with week, month, day and team views",
          "body": [
            "The calendar was rebuilt around a smooth week grid. Drag an event to reschedule it in 15-minute steps, and overlapping events sit side by side instead of on top of each other.",
            "Month view shows events that span several days and lets you drag an event to another day. There are also Day and Team views, and a week view designed for phones."
          ],
          "highlights": [
            "Drag to reschedule in 15-minute steps",
            "Day, week, month and team views",
            "A phone week view"
          ],
          "image": {
            "src": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-rebuild.webp",
            "width": 2560,
            "height": 1440,
            "alt": "Calendar week view from Monday to Sunday with a daily Team standup at 9 AM and color-coded events such as Discovery call, Design review, Site visit, Retainer check-in and Photo shoot, each showing its time and client"
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "Calendar week view on a phone showing Monday and Tuesday: a Team huddle, overlapping Intake call and Follow-up session events grouped in one card, and a Follow-up session with Dana Ruiz."
          },
          "whereToFind": "Calendar in the sidebar",
          "appRoute": "/calendar",
          "plans": "all",
          "links": [
            {
              "label": "Calendar and booking",
              "href": "/features/schedule"
            },
            {
              "label": "Calendar tutorial",
              "href": "/tutorials/calendar"
            },
            {
              "label": "Projects, tasks and scheduling",
              "href": "https://docs.workspace369.com/v/2026.3/core-workflows/projects-tasks-scheduling/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Maple Row Physio calendar shows a week of Intake call, Follow-up session and Team huddle events. On the desktop, Display Options switches it to month, day and then team view with Dana Ruiz and Sam Patel columns. On the phone, the view menu switches from week to day and then team, and a swipe moves from Dana Ruiz to Sam Patel.",
            "caption": "Switch views from Display Options on a desktop, or with the view button on a phone, which has week, day and team. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Calendar",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-desktop-light.mp4",
                "webm": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-desktop-light.webm",
                "poster": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-desktop-dark.webm",
                "poster": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-phone-light.mp4",
                "webm": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-phone-light.webm",
                "poster": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-phone-dark.mp4",
                "webm": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-phone-dark.webm",
                "poster": "/images/release-notes/2026-07-31-july-2026-roundup/calendar-views-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "workflows-tasks-tests",
          "title": "Workflows that create tasks and reminders, with test runs and logs",
          "body": [
            "Workflows can create real tasks and reminders, send in-app notifications to your team, wait on a timer or a schedule, and fill in client or invoice details with an Insert variable picker on every step.",
            "Before you switch a workflow on, run a simulated test to see what it would do. Every run is logged, so you can check what a workflow did and when.",
            "Every plan has workflows. Cadet is email-only with up to 3 active, Voyager adds texts with up to 10, Specialist allows 25, and Commander and Enterprise have no limit."
          ],
          "highlights": [
            "Tasks, reminders and team notifications as steps",
            "Timers and scheduled triggers",
            "Simulated test runs and execution logs"
          ],
          "image": {
            "src": "/images/release-notes/2026-07-31-july-2026-roundup/workflows-tasks-tests.webp",
            "width": 2560,
            "height": 830,
            "alt": "A workflow's runs: a 7-day summary of 23 runs with 18 delivered, 1 failed and 3 waiting, then a table of runs with status, record, steps, start time and duration, including a Test run and a failed run"
          },
          "imagePhone": null,
          "whereToFind": "Workflows in the sidebar",
          "appRoute": "/workflows",
          "plans": "all",
          "links": [
            {
              "label": "Workflow Automations",
              "href": "/features/automation"
            },
            {
              "label": "Workflows tutorial",
              "href": "/tutorials/workflows"
            },
            {
              "label": "Build, test and activate a workflow",
              "href": "https://docs.workspace369.com/v/2026.3/automation/build-test-activate-workflow/"
            }
          ]
        },
        {
          "id": "funnels",
          "title": "Build and publish funnels that capture leads into your CRM",
          "body": [
            "Funnels are multi-step pages built from blocks, with AI-written copy, result pages and follow-up email or text sequences. Publish one to a hosted address and new leads go straight into your CRM, with analytics on visitors, leads and drop-off.",
            "A/B tests and answer-based logic start on Voyager. Live funnels per plan: Cadet 1, Voyager 3, Specialist 10, Commander 25 and Enterprise 50, with unlimited drafts. AI generation counts toward your plan's AI usage."
          ],
          "highlights": [
            "Block builder with hosted public pages",
            "Leads land in your CRM automatically",
            "Funnel analytics and follow-up sequences"
          ],
          "image": {
            "src": "/images/release-notes/2026-07-31-july-2026-roundup/funnels.webp",
            "width": 2880,
            "height": 1608,
            "alt": "The funnel editor's Build tab: a list of steps on the left, a phone preview of a lead form asking for first name, work email, phone, company, budget and website, and Mobile, Desktop and Publish controls"
          },
          "imagePhone": null,
          "whereToFind": "Funnels in the sidebar",
          "appRoute": "/pages",
          "plans": "all",
          "links": [
            {
              "label": "Funnel builder with CRM",
              "href": "/solutions/funnel-builder-with-crm"
            },
            {
              "label": "Funnels tutorial",
              "href": "/tutorials/funnels"
            }
          ]
        },
        {
          "id": "inventory-tracking",
          "title": "Track stock with adjustments, low-stock alerts and a movement history",
          "body": [
            "Track stock on the products you sell. Adjust counts by hand with a history for each product, and get low-stock alerts when items run low.",
            "A workspace-wide Inventory view lists every stock movement with totals and filters, and exports to CSV. A setting lets you choose whether stock is deducted when an invoice is issued or when it is paid."
          ],
          "highlights": [
            "Stock adjustments with history per product",
            "Low-stock alerts",
            "Inventory movements list with CSV export"
          ],
          "image": {
            "src": "/images/release-notes/2026-07-31-july-2026-roundup/inventory-tracking.webp",
            "width": 2200,
            "height": 640,
            "alt": "Inventory stock table listing products with SKU, shelf location, units in stock and a status of In Stock or Low Stock"
          },
          "imagePhone": null,
          "whereToFind": "Product Catalog → Inventory; Settings → Products",
          "appRoute": "/services",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Products and inventory",
              "href": "/features/products"
            },
            {
              "label": "Product catalog tutorial",
              "href": "/tutorials/product-catalog"
            }
          ]
        },
        {
          "id": "invoice-design-preview",
          "title": "Invoices and proposals that look the part, with a live preview",
          "body": [
            "A new default PDF design for invoices and proposals adds per-line tax rates, your tax ID and registration details, page numbers, terms printed inline, attached documents merged into the PDF, and right-to-left language support.",
            "On tablet and desktop the invoice editor now shows a live preview beside the form, so you see what your client will receive while you type."
          ],
          "highlights": [],
          "image": null,
          "imagePhone": null,
          "whereToFind": "Settings → Invoices → PDF template; Invoices → New invoice",
          "appRoute": "/invoices",
          "plans": "all",
          "links": [
            {
              "label": "PDF customization",
              "href": "/features/pdf-customization"
            },
            {
              "label": "Invoices and billing",
              "href": "/features/invoices"
            },
            {
              "label": "Create, send and track an invoice",
              "href": "https://docs.workspace369.com/v/2026.3/finance/create-send-track-invoice/"
            }
          ]
        },
        {
          "id": "timesheets",
          "title": "Weekly timesheets with approvals",
          "body": [
            "Team members submit a weekly timesheet, and approvers review and approve it from an Approvals view. Approved entries are locked so they cannot change quietly, and managers can manage other people's time.",
            "The time-entry dialog was redesigned to make adding and editing time quicker."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-07-31-july-2026-roundup/timesheets.webp",
            "width": 2400,
            "height": 940,
            "alt": "Weekly timesheet with hours per project and day, daily and weekly totals, and a Draft banner with a Submit week button for approval"
          },
          "imagePhone": null,
          "whereToFind": "Time Tracking → Timesheets",
          "appRoute": "/time-tracking",
          "plans": "all",
          "links": [
            {
              "label": "Time tracking",
              "href": "/features/time-tracking"
            },
            {
              "label": "Time tracking tutorial",
              "href": "/tutorials/time-tracking"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "How many live funnels does each Workspace369 plan allow?",
          "a": "Cadet allows 1, Voyager 3, Specialist 10, Commander 25 and Enterprise 50 live funnels. Drafts don’t count toward that limit. New leads from a published funnel go straight into your CRM."
        },
        {
          "q": "Which plans can track inventory?",
          "a": "Specialist, Commander and Enterprise. You adjust counts by hand, get low-stock alerts and see a movement history. Choose whether stock is deducted at invoice issue or at payment in Settings → Sales → Products → Inventory deduction."
        },
        {
          "q": "Does Workspace369 have weekly timesheets with approvals?",
          "a": "Yes, on every plan. Team members submit a weekly timesheet, approvers review it, and approved entries are locked so they cannot change quietly."
        },
        {
          "q": "What calendar views does Workspace369 have?",
          "a": "Week, month, day and team views. You can drag an event to reschedule it in 15-minute steps, and there is a week view designed for phones."
        }
      ],
      "updated": "2026-10-30"
    },
    {
      "slug": "2026-06-30-june-2026-roundup",
      "date": "2026-06-30",
      "updated": "2026-10-31",
      "title": "June 2026: fine-grained team access, receipt scanning and notes that work like documents",
      "seoTitle": "Workspace369 June 2026 Updates",
      "summary": "Limit teammates to their own clients, bill tracked time in one step, scan receipts into expenses, and write notes with rich text, sharing and AI.",
      "areas": [
        "workspace",
        "billing",
        "work",
        "proposals",
        "clients"
      ],
      "hero": {
        "src": "/images/release-notes/2026-06-30-june-2026-roundup/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: a shield with a keyhole, a long receipt and an open notebook with a ribbon bookmark."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Workspace369 June 2026 updates",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "team-access-clients",
          "title": "Invite teammates quickly and limit them to their own clients",
          "body": [
            "Switch a team member from Full book to Scoped and they see only the clients assigned to them: those clients' records, conversations, tasks, calendar and time. Financial dashboards stay hidden from them, which suits contractors and account managers.",
            "Adding a team member also has its own focused screen now, separate from editing what they can do afterwards, so invites are quick and clear."
          ],
          "highlights": [
            "Full book or Scoped access per member",
            "Scoped members only see assigned clients' work",
            "A separate, simple invite screen"
          ],
          "image": {
            "src": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-clients.webp",
            "width": 1760,
            "height": 625,
            "alt": "A team member's Access summary: Member role with client access limited to 6 clients, a line reading Sees 6 clients: Maple Row Dental, Rossi Catering, Harbor & Co and 3 more with Edit clients, and rows showing they see only their clients' projects and boards"
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "Invite people sheet on a phone with Choose clients open and Specific selected, showing Marcus Webb and Priya Nair assigned. Example data."
          },
          "whereToFind": "Settings → Team & seats → Invite; a member → Permissions",
          "appRoute": "/settings/team-members",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Client-scoped access",
              "href": "/features/client-scoped-access"
            },
            {
              "label": "Invite your team tutorial",
              "href": "/tutorials/invite-your-team"
            },
            {
              "label": "Team access and permissions",
              "href": "https://docs.workspace369.com/v/2026.3/admin/team-access-and-permissions/"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Maple Row Physio team list opens the Invite people screen. The address sam@maplerow.example is added with the Member role, Clients is set to Specific, Priya Nair and Marcus Webb are chosen, and the invite is sent.",
            "caption": "Invite a teammate into a free seat and limit them to chosen clients from the invite screen. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Team members",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-desktop-light.mp4",
                "webm": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-desktop-light.webm",
                "poster": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-desktop-dark.webm",
                "poster": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-phone-light.mp4",
                "webm": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-phone-light.webm",
                "poster": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-phone-dark.mp4",
                "webm": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-phone-dark.webm",
                "poster": "/images/release-notes/2026-06-30-june-2026-roundup/team-access-phone-dark-poster.webp"
              }
            }
          }
        },
        {
          "id": "billable-time-to-invoice",
          "title": "Bill tracked time on an invoice in one step",
          "body": [
            "Turn billable time entries into invoice lines in one step, and unbill them if you change your mind. The time keeps its client and project context.",
            "Projects with an hours budget show how much of it is used, so you see a project running over before the invoice does."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-06-30-june-2026-roundup/billable-time-to-invoice.webp",
            "width": 1360,
            "height": 1520,
            "alt": "Bill time dialog adding five billable time entries, grouped under the projects Website relaunch and Brand refresh, to draft invoice INV-1043, with Detailed or Hours only lines and a total at the bottom"
          },
          "imagePhone": null,
          "whereToFind": "Invoices → add billable time; Projects → project details",
          "appRoute": "/invoices",
          "plans": "all",
          "links": [
            {
              "label": "Time tracking",
              "href": "/features/time-tracking"
            },
            {
              "label": "Time tracking and invoicing",
              "href": "/solutions/time-tracking-and-invoicing-software"
            },
            {
              "label": "Time tracking tutorial",
              "href": "/tutorials/time-tracking"
            }
          ]
        },
        {
          "id": "receipt-scan",
          "title": "Scan a receipt and get the expense filled in",
          "body": [
            "Take a photo of a receipt (large ones are compressed) or choose a PDF up to 30 MB, and the expense is pre-filled with vendor, date, amount and type. Scanning counts toward your plan's AI usage.",
            "Break an expense into line items with tax, from a scan or by hand. Totals add up automatically, and you can override them."
          ],
          "highlights": [
            "Photo, or a PDF up to 30 MB",
            "Vendor, date, amount and type pre-filled",
            "Editable line items with tax"
          ],
          "image": {
            "src": "/images/release-notes/2026-06-30-june-2026-roundup/receipt-scan.webp",
            "width": 1440,
            "height": 720,
            "alt": "An expense's line items: printer paper, a toner cartridge and shipping envelopes with quantity times unit price, an Add line item button, the subtotal, 8% tax and the total"
          },
          "imagePhone": null,
          "whereToFind": "Expenses → Add expense → Scan invoice/receipt",
          "appRoute": "/expenses",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Expense tracking",
              "href": "/features/expenses"
            },
            {
              "label": "Expenses tutorial",
              "href": "/tutorials/expenses"
            }
          ]
        },
        {
          "id": "proposals-home",
          "title": "Proposals get their own home",
          "body": [
            "Proposals have their own place in the sidebar, separate from Invoices, with a list of every proposal and a Proposals tab on each client.",
            "Set workspace-wide defaults for design, terms and notes, and manage your proposal templates in one place."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-06-30-june-2026-roundup/proposals-home.webp",
            "width": 2560,
            "height": 760,
            "alt": "Proposals list with search, sort, filter and a New Proposal button, showing proposals with their amount, status (Sent, Accepted, Draft or Declined), number, title and customer"
          },
          "imagePhone": null,
          "whereToFind": "Proposals in the sidebar; Settings → Proposals",
          "appRoute": "/proposals",
          "plans": "all",
          "links": [
            {
              "label": "Proposals",
              "href": "/features/quoting"
            },
            {
              "label": "Proposal software",
              "href": "/solutions/proposal-software-for-agencies"
            },
            {
              "label": "Proposals tutorial",
              "href": "/tutorials/proposals-step-by-step"
            }
          ]
        },
        {
          "id": "notes-editor",
          "title": "Notes with rich text, images and AI on the page",
          "body": [
            "Write notes with rich text, smart paste, images, files and GIFs. Select some text and use the AI toolbar to rewrite it, shorten it or continue it. AI help counts toward your plan's AI usage.",
            "It is the same editor everywhere notes live, including each client's Notes tab, where you can keep several notes with mentions and folders."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-06-30-june-2026-roundup/notes-editor.webp",
            "width": 2200,
            "height": 1060,
            "alt": "A note with a title, a paragraph and a bulleted Next steps list, and an AI suggestion that rewrites the selected paragraph, with Try again, Discard, Insert below and Replace"
          },
          "imagePhone": null,
          "whereToFind": "Notes in the sidebar; Clients → a client → Notes",
          "appRoute": "/notes",
          "plans": "all",
          "links": [
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            },
            {
              "label": "Files and notes",
              "href": "/features/files"
            }
          ]
        },
        {
          "id": "notes-sharing",
          "title": "Share notes with teammates or publish one as a public link",
          "body": [
            "Share a note with specific people as a viewer or editor, find notes others shared with you under Shared with me, and add comments. Deleted notes can be restored from Trash.",
            "Publish a note as a public link you can turn off at any time."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-06-30-june-2026-roundup/notes-sharing.webp",
            "width": 1120,
            "height": 815,
            "alt": "Share sheet for a note with Share and Publish tabs, a field to add people by name or email, the owner with Full access, one teammate who can edit and one who can view, and Copy Link"
          },
          "imagePhone": null,
          "whereToFind": "Notes → note menu → Share",
          "appRoute": "/notes",
          "plans": "all",
          "links": [
            {
              "label": "Files and notes",
              "href": "/features/files"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I limit a team member to only their own clients?",
          "a": "Yes. Switch a team member from Full book to Scoped and they see only the clients assigned to them. Financial dashboards stay hidden from them. It works on Voyager, Specialist, Commander and Enterprise, the plans with room for teammates."
        },
        {
          "q": "Can I turn tracked time into invoice lines?",
          "a": "Yes. Turn billable time entries into invoice lines in one step, and unbill them if you change your mind. The time keeps its client and project context."
        },
        {
          "q": "Which plans can scan a receipt into an expense?",
          "a": "Specialist, Commander and Enterprise. Take a photo or choose a PDF up to 30 MB and the expense is pre-filled. Scanning counts toward your plan's AI usage."
        },
        {
          "q": "Can I share a note as a public link?",
          "a": "Yes. Publish a note as a public link and turn it off at any time. You can also share a note with specific people as a viewer or editor."
        }
      ]
    },
    {
      "slug": "2026-05-31-may-2026-roundup",
      "date": "2026-05-31",
      "updated": "2026-10-31",
      "title": "May 2026: email in your inbox, multiple phone numbers and clearer team permissions",
      "seoTitle": "Workspace369 May 2026 Updates",
      "summary": "Write and preview email from the inbox, run several email addresses and phone numbers, delete and block safely, and set team permissions with role presets.",
      "areas": [
        "inbox",
        "workspace"
      ],
      "hero": {
        "src": "/images/release-notes/2026-05-31-may-2026-roundup/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: envelopes sliding into an inbox tray, two telephone handsets and a small bin."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Workspace369 May 2026 updates",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "email-in-inbox",
          "title": "Write, preview and send email without leaving your inbox",
          "body": [
            "Compose an email with attachments, pick a branded template, and preview exactly how it will look to your client before you send. Mail you send lands in the client's conversation in the inbox, so the whole thread is in one place."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox.webp",
            "width": 2000,
            "height": 1414,
            "alt": "An email thread in the inbox titled \"Spring menu shoot: dates and deposit\": a client's question, the business's reply and the client's answer shown as one conversation, with Reply and Forward buttons."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "On a phone, an email conversation titled \"Your treatment plan\" shows a sent message to a client with a Treatment-plan.pdf attachment, and Reply and Forward buttons below it."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the inbox opens a new email to Dana Ruiz with the subject Your treatment plan. A saved template fills the message, a Treatment-plan.pdf file is attached, the Preview tab shows the email in the business's branding, and Send Email adds the sent message, with its attachment, to Dana's conversation.",
            "caption": "Write an email to a client, add a template and a file, preview it, then send it into their conversation. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Emails",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-desktop-light.mp4",
                "webm": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-desktop-light.webm",
                "poster": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-desktop-dark.webm",
                "poster": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-phone-light.mp4",
                "webm": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-phone-light.webm",
                "poster": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-phone-dark.mp4",
                "webm": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-phone-dark.webm",
                "poster": "/images/release-notes/2026-05-31-may-2026-roundup/email-in-inbox-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Emails and Inbox in the sidebar",
          "appRoute": "/emails",
          "plans": "all",
          "links": [
            {
              "label": "Inbox and communications",
              "href": "/features/communications"
            },
            {
              "label": "Connect your email tutorial",
              "href": "/tutorials/connect-your-email"
            },
            {
              "label": "Inbox overview",
              "href": "https://docs.workspace369.com/v/2026.3/communication/inbox-overview/"
            }
          ]
        },
        {
          "id": "email-channels",
          "title": "Several email addresses, each with its own auto-reply",
          "body": [
            "Add more than one email address to the inbox. Each address can have a catch-all, its own auto-reply and assigned owners, and outbound mail shows its delivery status.",
            "A signature builder lets you design signatures with embedded images."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-05-31-may-2026-roundup/email-address-settings.webp",
            "width": 1600,
            "height": 1109,
            "alt": "Settings for the support@ email address: General, Sending, Hours and rules and Access tabs, with the mailbox name and color, a default-for-new-conversations switch, a mailbox photo and the catch-all switch."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Email, SMS & phone → Email → Email addresses",
          "appRoute": "/settings/communications",
          "plans": "all",
          "links": [
            {
              "label": "Inbox and communications",
              "href": "/features/communications"
            },
            {
              "label": "Inbox tutorial",
              "href": "/tutorials/inbox"
            }
          ]
        },
        {
          "id": "inbox-trash-mute-block",
          "title": "Delete, mute and block without losing anything by accident",
          "body": [
            "Delete a conversation and it goes to a Trash you can restore from for 30 days by default, with a five-second undo right after. Mute noisy threads so they stop interrupting you.",
            "Block a sender across email, texts and calls from one blocked list. Blocking texts and calls needs a plan with texting and voice, which starts at Voyager."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-05-31-may-2026-roundup/blocked-senders.webp",
            "width": 1600,
            "height": 823,
            "alt": "The Blocked senders list: two email addresses and one phone number, each showing who blocked it, when and why, with an Unblock button and a Block a sender button above."
          },
          "imagePhone": null,
          "whereToFind": "Inbox → conversation menu; Trash folder",
          "appRoute": "/communications/inbox",
          "plans": "all",
          "links": [
            {
              "label": "Inbox and communications",
              "href": "/features/communications"
            },
            {
              "label": "Shared inbox",
              "href": "/solutions/shared-inbox-software"
            }
          ]
        },
        {
          "id": "multiple-numbers",
          "title": "Use more than one phone number for texts and calls",
          "body": [
            "Add more than one SMS and voice number, then pick which number to text or call from. Each number can have its own business hours and voicemail greeting, and on Specialist and above its own phone menu."
          ],
          "highlights": [
            "Choose the number to text or call from",
            "Hours, voicemail and phone menu per number"
          ],
          "image": {
            "src": "/images/release-notes/2026-05-31-may-2026-roundup/phone-numbers.webp",
            "width": 1600,
            "height": 851,
            "alt": "The Phone numbers settings page listing three workspace numbers: Main line for calls and texts set as the default, Detailing bookings for texts only and restricted, and Fleet accounts paused."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-05-31-may-2026-roundup/phone-numbers-phone.webp",
            "width": 780,
            "height": 900,
            "alt": "Phone numbers on a phone in dark mode: Main line, Detailing bookings and Fleet accounts with their numbers and status, and an Add number button."
          },
          "whereToFind": "Settings → Email, SMS & phone → Phone & SMS → Phone numbers",
          "appRoute": "/settings/communications",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Phone menus and routing",
              "href": "/features/auto-attendant-and-ivr"
            },
            {
              "label": "Calls and voicemail tutorial",
              "href": "/tutorials/calls-and-voicemail"
            },
            {
              "label": "Phone number and routing",
              "href": "https://docs.workspace369.com/v/2026.3/communication/voice-phone-number-and-routing/"
            }
          ]
        },
        {
          "id": "permissions-presets",
          "title": "Set what each team member can do with role presets",
          "body": [
            "Start from a role preset, then fine-tune a member's access in a Permissions tab written as plain sentences. The controls cover each main area of the app, from invoices and clients to tasks and files.",
            "A page a member cannot open now shows a friendly no-access message instead of a blank screen."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-05-31-may-2026-roundup/permissions-presets.webp",
            "width": 2000,
            "height": 1460,
            "alt": "A team member's Permissions tab with the Member role preset selected over Admin, Manager and Viewer, and plain-sentence controls below for clients, client stages, client portals, importing clients and lead sources."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Team & seats → a member → Permissions",
          "appRoute": "/settings/team-members",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Client-scoped access",
              "href": "/features/client-scoped-access"
            },
            {
              "label": "Team access and permissions",
              "href": "https://docs.workspace369.com/v/2026.3/admin/team-access-and-permissions/"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I connect more than one email address to the inbox?",
          "a": "Yes. Each address can have a catch-all, its own auto-reply and assigned owners, and outbound mail shows its delivery status."
        },
        {
          "q": "Can I get a deleted conversation back?",
          "a": "Yes. A deleted conversation goes to a Trash you can restore from for 30 days by default, and there is a five-second undo right after."
        },
        {
          "q": "Which plans can use more than one phone number?",
          "a": "Voyager, Specialist, Commander and Enterprise can add more than one SMS and voice number and pick which one to text or call from. On Specialist and above, each number can also have its own phone menu and a custom voicemail greeting."
        },
        {
          "q": "Can I set what each team member can do?",
          "a": "Yes. Start from a role preset, then fine-tune a member's access in a Permissions tab written as plain sentences, covering each main area of the app."
        }
      ]
    },
    {
      "slug": "2026-04-30-march-april-2026-roundup",
      "date": "2026-04-30",
      "title": "March and April 2026: a new proposal builder, intake forms and project profitability",
      "seoTitle": "Workspace369 March and April 2026 Updates",
      "summary": "A visual proposal builder with deposits and tracking, several intake forms with an inbound API, profitability and AR aging reports, calls, and an AI knowledge base.",
      "areas": [
        "proposals",
        "clients",
        "billing",
        "inbox",
        "ai",
        "work"
      ],
      "hero": {
        "src": "/images/release-notes/2026-04-30-march-april-2026-roundup/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration: an open proposal folio, a clipboard intake form and a small rising bar chart with a coin."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "Workspace369 March and April 2026 updates",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "intake-forms",
          "title": "Build several intake forms, each with its own design and follow-up",
          "body": [
            "Create more than one public request form for your business. Each form has its own fields, design, thank-you step and notifications, plus spam protection. Share a link or embed a form on your own website, and every submission arrives in Requests, ready to turn into a client.",
            "Forms hosted elsewhere can send leads in too: Requests settings has an inbound API with keys and field mapping. A new lead can also start a workflow, like a welcome email or a task for you."
          ],
          "highlights": [
            "Several forms, each with its own design and notifications",
            "Share a link or embed on your site",
            "Inbound API with keys and field mapping"
          ],
          "image": {
            "src": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms.webp",
            "width": 2432,
            "height": 1400,
            "alt": "The Requests list with a Forms button, weekly stats, status tabs and a table of submissions showing each person's message, the form it came from, its source, status, assignee and when it arrived."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The new patient intake form open on a phone, with the field list, Fields, Design, After submit and Share tabs, and a Where does it hurt? dropdown field being edited."
          },
          "motion": {
            "layout": "desktop-phone",
            "alt": "On a desktop and an iPhone, the Forms list shows Website contact, New patient intake and Exercise class sign-up. New patient intake opens and its Area of concern field is reworded to Where does it hurt?. The Design tab sets round corners, After submit shows the thank-you message, and Share shows the form link, a QR code and an inline embed code.",
            "caption": "Open a form, reword a field, round its corners, check the thank-you message, then see its share link and embed code. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "Forms",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-desktop-light.mp4",
                "webm": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-desktop-light.webm",
                "poster": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-desktop-dark.webm",
                "poster": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-phone-light.mp4",
                "webm": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-phone-light.webm",
                "poster": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-phone-dark.mp4",
                "webm": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-phone-dark.webm",
                "poster": "/images/release-notes/2026-04-30-march-april-2026-roundup/intake-forms-phone-dark-poster.webp"
              }
            }
          },
          "whereToFind": "Requests → Forms; Settings → Requests",
          "appRoute": "/requests",
          "plans": "all",
          "links": [
            {
              "label": "Client intake forms",
              "href": "/solutions/client-intake-form-software"
            },
            {
              "label": "Leads from your website tutorial",
              "href": "/tutorials/leads-from-your-website"
            }
          ]
        },
        {
          "id": "proposal-builder",
          "title": "A visual proposal builder with themes, deposits and tracking",
          "body": [
            "Build a proposal as a page your client scrolls: a cover, text, images, a timeline, terms and line items you pick from your catalog. Choose a theme and colors, start from a saved template, and look back through earlier versions in version history.",
            "Collect a deposit when the client accepts, and see when they open and engage with the proposal. An accepted proposal converts to an invoice in one step."
          ],
          "highlights": [
            "Cover, images, timeline, terms and catalog line items",
            "Themes, saved templates and version history",
            "Deposit on acceptance and engagement tracking"
          ],
          "image": {
            "src": "/images/release-notes/2026-04-30-march-april-2026-roundup/proposal-builder.webp",
            "width": 2880,
            "height": 1682,
            "alt": "The proposal builder: a proposal page with a cover image, title, client and studio details, and Scope & investment line items with a proposal total, beside an Appearance & details panel for the document theme, accent color, page background and cover image."
          },
          "imagePhone": null,
          "whereToFind": "Proposals in the sidebar → New Proposal",
          "appRoute": "/proposals",
          "plans": "all",
          "links": [
            {
              "label": "Proposals",
              "href": "/features/quoting"
            },
            {
              "label": "Proposal software",
              "href": "/solutions/proposal-software-for-agencies"
            },
            {
              "label": "Proposals tutorial",
              "href": "/tutorials/proposals-step-by-step"
            }
          ]
        },
        {
          "id": "profitability-ar-aging",
          "title": "See what each project earns and who owes you, by how late they are",
          "body": [
            "Job profitability shows revenue, costs and margin for each project, built from your invoices, expenses and tracked time. Customer profitability does the same for each client, so you can see which work and which clients earn their keep.",
            "AR aging groups unpaid invoices by how overdue they are, so you know who to chase first, and you can send a payment reminder from the report."
          ],
          "highlights": [
            "Margin per project and per client",
            "Unpaid invoices grouped by how overdue they are"
          ],
          "image": {
            "src": "/images/release-notes/2026-04-30-march-april-2026-roundup/profitability-ar-aging.webp",
            "width": 2360,
            "height": 800,
            "alt": "The AR aging report: total outstanding split into Current, 1-30, 31-60, 61-90 and 90+ day buckets, and a table of clients showing how much each owes in each bucket."
          },
          "imagePhone": null,
          "whereToFind": "Accounting → Reports",
          "appRoute": "/accounting",
          "plans": [
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Accounting",
              "href": "/features/accounting"
            },
            {
              "label": "Project profitability software",
              "href": "/solutions/project-profitability-software-for-agencies"
            }
          ]
        },
        {
          "id": "calls-and-inbox",
          "title": "Texts, calls and voicemail next to your email, with transfer and analytics",
          "body": [
            "Email, texts and phone calls land in one inbox, matched to the client they belong to. Email arrives through your workspace address or a mailbox you connect, and works on every plan. From Voyager you can answer calls on web and mobile, dial out from a client, listen to voicemail and chart your call volume and outcomes in call analytics.",
            "From Specialist, invite a teammate before you transfer a live call, merge into a three-way conference so the caller is never dropped, and set up phone menus, ring groups and business-hours routing."
          ],
          "highlights": [
            "Texts and calls from Voyager, email on every plan",
            "Invite a teammate before transferring a call",
            "Phone menus, ring groups and business-hours routing from Specialist"
          ],
          "image": {
            "src": "/images/release-notes/2026-04-30-march-april-2026-roundup/calls-and-inbox.webp",
            "width": 732,
            "height": 587,
            "alt": "A live call card for Jane Cooper during a transfer: it waits for teammate Ava Martinez while the caller stays on the line, with Cancel transfer and End call buttons."
          },
          "imagePhone": null,
          "whereToFind": "Inbox in the sidebar",
          "appRoute": "/communications/inbox",
          "plans": [
            "Voyager",
            "Specialist",
            "Commander",
            "Enterprise"
          ],
          "links": [
            {
              "label": "Inbox and communications",
              "href": "/features/communications"
            },
            {
              "label": "Phone menus and routing",
              "href": "/features/auto-attendant-and-ivr"
            },
            {
              "label": "Calls and voicemail tutorial",
              "href": "/tutorials/calls-and-voicemail"
            }
          ]
        },
        {
          "id": "ai-knowledge-base",
          "title": "Teach Workspace AI about your business with a knowledge base",
          "body": [
            "Add your pricing, policies, procedures, team rules and FAQs as knowledge base entries, sorted into categories. Workspace AI looks them up when it replies, so answers follow how your business actually works.",
            "Search finds entries by meaning, not just exact words. How much knowledge search you get depends on your plan's AI level."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-04-30-march-april-2026-roundup/ai-knowledge-base.webp",
            "width": 1920,
            "height": 1130,
            "alt": "The Knowledge base settings page with six entries, such as a refund policy, deposit terms and turnaround times, each tagged with a category like Policies, Pricing, Procedures, FAQ or Team rules, plus search and a Category filter."
          },
          "imagePhone": null,
          "whereToFind": "Settings → Knowledge base",
          "appRoute": "/settings/knowledge-base",
          "plans": "all",
          "links": [
            {
              "label": "Workspace AI",
              "href": "/features/ai-chat"
            },
            {
              "label": "Workspace AI tutorial",
              "href": "/tutorials/workspace-ai"
            }
          ]
        },
        {
          "id": "products-catalog",
          "title": "A rebuilt products and services catalog",
          "body": [
            "Products, services and packages now live in a cleaner catalog with list and card views, status tabs, filters and saved views. Each item has its own page for pricing, images and organization, and an activity timeline records what changed.",
            "Write a description yourself or let AI draft and refine it. Cadet includes up to 20 products and services; Voyager and above have no limit."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-04-30-march-april-2026-roundup/products-catalog.webp",
            "width": 2560,
            "height": 1492,
            "alt": "The Products catalog in list view with All, Active, Draft and Archived tabs, search, Category, Type and Stock filters, and rows for services, digital and physical items, each showing its type, status and price."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-04-30-march-april-2026-roundup/products-catalog-phone.webp",
            "width": 780,
            "height": 1490,
            "alt": "The Products catalog on a phone: search, a filter button, status tabs and a list of services, digital and physical items with their prices, one marked Draft."
          },
          "whereToFind": "Product Catalog in the sidebar",
          "appRoute": "/services",
          "plans": "all",
          "links": [
            {
              "label": "Products and catalog",
              "href": "/features/products"
            },
            {
              "label": "Product catalog tutorial",
              "href": "/tutorials/product-catalog"
            },
            {
              "label": "Product catalog docs",
              "href": "https://docs.workspace369.com/v/2026.3/catalog/product-catalog/"
            }
          ]
        },
        {
          "id": "task-filters-zoom",
          "title": "Faster task boards: filter chips, search and kanban zoom",
          "body": [
            "The Tasks header has filter chips and search, so you can combine status, assignee, tag and more to find the work in front of you.",
            "On larger screens a zoom control resizes the kanban board so more columns fit on screen."
          ],
          "highlights": [],
          "image": {
            "src": "/images/release-notes/2026-04-30-march-april-2026-roundup/task-filters-zoom.webp",
            "width": 2560,
            "height": 1160,
            "alt": "A kanban task board zoomed to 75%, with a search box and filter chips for views, priority, due date, tags, assignee, sort and starred above columns from To Do through Done."
          },
          "imagePhone": null,
          "whereToFind": "Tasks in the sidebar",
          "appRoute": "/tasks",
          "plans": "all",
          "links": [
            {
              "label": "Agency project management",
              "href": "/solutions/agency-project-management-software"
            },
            {
              "label": "Tasks tutorial",
              "href": "/tutorials/tasks"
            }
          ]
        }
      ],
      "answers": [
        {
          "q": "Can I have more than one intake form?",
          "a": "Yes. Each public request form has its own fields, design, thank-you step and notifications, plus spam protection. Every submission arrives in Requests, ready to turn into a client."
        },
        {
          "q": "Which plans include texts and calls in the inbox?",
          "a": "Voyager, Specialist, Commander and Enterprise. Email in the inbox works on every plan, and texts and calls from Voyager land in one inbox next to it."
        },
        {
          "q": "Which plans include job and customer profitability reports?",
          "a": "Specialist, Commander and Enterprise. They show revenue, costs and margin per project and per client, and AR aging groups unpaid invoices by how overdue they are."
        },
        {
          "q": "How many products and services can I add on Cadet?",
          "a": "Cadet includes up to 20 products and services. Voyager and above have no limit."
        },
        {
          "q": "Can I teach Workspace AI about my business?",
          "a": "Yes. Add pricing, policies, procedures and FAQs as knowledge base entries in Settings → AI → Knowledge base. Workspace AI looks them up when it replies."
        }
      ]
    },
    {
      "slug": "2026-11-03-a-tidier-new-email-window",
      "date": "2026-11-03",
      "title": "A tidier New email window, with every tool in one bar",
      "seoTitle": "A Tidier New Email Window",
      "summary": "Formatting, attachments, templates, Write with AI and scheduling now share one bar at the bottom of a new email, and on a phone the message uses the full width.",
      "areas": [
        "inbox"
      ],
      "hero": {
        "src": "/images/release-notes/2026-11-03-a-tidier-new-email-window/hero.webp",
        "width": 2400,
        "height": 1350,
        "alt": "Cut-paper illustration of an open envelope with a letter above one long teal strip of paper tabs ending in a small amber clock, beside two phone renders of the New email window: a light one with the formatting buttons above the tools and Send, and a dark one while typing, with the formatting buttons above the tools."
      },
      "video": {
        "status": "planned",
        "youtubeId": null,
        "title": "The tidier New email window in Workspace369",
        "duration": null,
        "uploadDate": null
      },
      "features": [
        {
          "id": "new-email-bar",
          "title": "One bar for formatting and tools, and Insert field on the Subject line",
          "body": [
            "When you write a new email, bold, italic, underline, bullet lists and links now sit in one bar at the bottom of the window, next to attachments, templates, your signature, Write with AI and scheduling. On a phone the formatting buttons join that bar only while you're typing in the message, so the rest of the time the screen stays clear. Insert field, for adding details such as the client's first name, now sits at the end of the Subject line, and the same icon in the bottom bar adds a field to the message.",
            "On a phone the message now uses the full width of the screen. The button reads Send, or Schedule send once you've picked a time, and on a computer you can remove the time to send straight away. Sending, scheduling, attachments and Write with AI work just as before, and the wide window and full screen on a computer are unchanged. The New email window is on every plan. It is on the web app now and comes to the iPhone app with its next update."
          ],
          "highlights": [
            "Formatting and tools in one bottom bar",
            "On a phone, formatting shows while you type",
            "Insert field on the Subject line",
            "Send, or Schedule send once a time is picked"
          ],
          "image": {
            "src": "/images/release-notes/2026-11-03-a-tidier-new-email-window/new-email.webp",
            "width": 1600,
            "height": 826,
            "alt": "The New email window on a computer: From Alex Rivera, To maya@maplerow.internal, the subject Round 2 of the homepage is ready with Insert field at the end of the Subject line and a short message. The bottom bar holds the formatting buttons, attachment, template and signature buttons, Write with AI, the schedule and field buttons, the time tomorrow at 9:00 AM and Schedule send."
          },
          "imagePhone": {
            "src": "/images/release-notes/2026-11-03-a-tidier-new-email-window/new-email-phone.webp",
            "width": 780,
            "height": 1696,
            "alt": "The New email window on a phone while typing: From, To, Bcc and Subject rows, a short message to Maya, and a bottom bar with bold, italic, underline, list and link buttons above the attachment, template, signature, Write with AI, schedule and field buttons and Send."
          },
          "whereToFind": "Communications → Emails → Compose",
          "appRoute": "/communications/inbox",
          "plans": "all",
          "links": [
            {
              "label": "Inbox and email",
              "href": "/features/communications"
            },
            {
              "label": "AI writing help and a bigger composer",
              "href": "/changelog/2026-10-29-email-composer-ai-writing-help"
            }
          ],
          "motion": {
            "layout": "desktop-phone",
            "alt": "The New email window on a computer and a phone, writing to maya@maplerow.internal with the subject Round 2 of the homepage is ready. The message is tapped and a short email is typed: Hi Maya, Round 2 of the homepage is up on the same link. I moved the testimonials higher. Best, Alex. On the phone, bold, italic, underline, list and link buttons show in the bottom bar while typing. Then the schedule button is pressed; on the computer the Schedule message dialog opens and Tomorrow morning is picked, and on both the button changes from Send to Schedule send.",
            "caption": "Type a short email, then pick a send time and the button reads Schedule send. Example data.",
            "duration": "PT8S",
            "large": {
              "width": 1280,
              "height": 660,
              "title": "New email",
              "sub": "Workspace369",
              "light": {
                "mp4": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-desktop-light.mp4",
                "webm": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-desktop-light.webm",
                "poster": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-desktop-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-desktop-dark.mp4",
                "webm": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-desktop-dark.webm",
                "poster": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-desktop-dark-poster.webp"
              }
            },
            "phone": {
              "width": 540,
              "height": 1174,
              "light": {
                "mp4": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-phone-light.mp4",
                "webm": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-phone-light.webm",
                "poster": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-phone-light-poster.webp"
              },
              "dark": {
                "mp4": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-phone-dark.mp4",
                "webm": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-phone-dark.webm",
                "poster": "/images/release-notes/2026-11-03-a-tidier-new-email-window/newemail-phone-dark-poster.webp"
              }
            }
          }
        }
      ],
      "answers": [
        {
          "q": "Where are the bold, italic and list buttons in the Workspace369 email composer?",
          "a": "In the bar at the bottom of the New email window, next to attachments, templates, your signature, Write with AI and scheduling. On a phone they show in that bar while you're typing in the message."
        },
        {
          "q": "Why don't I see the formatting buttons on my phone?",
          "a": "On a phone they appear only while you're typing in the message. Tap into the message and bold, italic, underline, bullet lists and links show above the other tools."
        },
        {
          "q": "Where is Insert field in a new email?",
          "a": "At the end of the Subject line, where it adds a field such as the client's first name to the subject. The same icon in the bottom bar adds a field to the message."
        },
        {
          "q": "How do I schedule an email to send later?",
          "a": "Choose the schedule button in the bottom bar and pick a time, such as Tomorrow morning or a custom date. The button then reads Schedule send. On a computer, remove the time to send straight away."
        },
        {
          "q": "Did sending or scheduling change with the new layout?",
          "a": "No. Only the layout changed. Sending, scheduling, attachments and Write with AI work as before, and the New email window is on every plan."
        }
      ]
    }
  ]
}
